import React, { useState, useRef, useEffect, useContext } from 'react';
import FullscreenVideoPlayer from './FullscreenVideoPlayer.js';
// import navarrow from "../assets/back_btn.png";
import { UserContext } from '../OEMChanges/OemAssetsImport.js';
import { isAndroid, isMobile, isTablet } from 'react-device-detect'
// import RedeemableLogo from '../assets/Redeem-revamp/RedeemableLogo.svg'
// import RedeemableRupee from '../assets/Redeem-revamp/RedeemableRupee.json'
// import RedeemRupee from '../assets/Redeem-revamp/RedeemRupee.json'
import Lottie from 'lottie-react'
// import viewPolicy from '../assets/Redeem-revamp/viewPolicy.svg'
import GreenLine from '../assets/Redeem-revamp/GreenLine.svg'
import PendingIcon from '../assets/Redeem-revamp/PendingIcon.svg'
import faqsIcon from "../assets/Redeem-revamp/faqsIcon.svg"
import GreyLine from '../assets/Redeem-revamp/GreyLine.svg'
import Numbering1 from '../assets/Redeem-revamp/Numbering1.svg'
import Numbering2 from '../assets/Redeem-revamp/Numbering2.svg'
import Numbering3 from '../assets/Redeem-revamp/Numbering3.svg'
import TickGreen from '../assets/Redeem-revamp/TIckGreen.svg'
// import Cross from '../assets/Redeem-revamp/Cross.svg'
import Cross2 from '../assets/Redeem-revamp/Cross2.svg'
import Loading from '../models/Loading';
import cancelRequesticon from '../assets/CancelRedeemRequesticon.svg'
import upiIcon from '../assets/Redeem-revamp/Upi.svg'
// import bankIcon from '../assets/Redeem-revamp/bank.svg'
import amazonPayIcon from '../assets/Redeem-revamp/amazonPay.svg'
import paytmIcon from '../assets/Redeem-revamp/paytm.svg'
import redeemFailed from "../assets/redeemFailed.json"
import pendingAnimation from '../assets/pendingAnimation.json'
// import RadioInactive from '../assets/Redeem-revamp/RadioInactive.svg'
// import RadioActive from '../assets/Redeem-revamp/RadioActive.svg'
// import CancelDeleteIcon from '../assets/Redeem-revamp/cancelDelete.svg'
// import tdsInfoIcon from '../assets/Redeem-revamp/tdsInfo.svg'
// import AddAccountIcon from '../assets/Redeem-revamp/AddAccountIcon.svg'
// import smartRedeemBanner from "../assets/smartRedeemBanner.png";
// import smartRedeemBanner from "../assets/updatedSmartBanner.png";
import smartRedeemBanner from "../assets/Banner.svg";
import { WebToNativeMessage, apiLogResponseStyle, createAdminPageURL, createOEMAdminPageURL, debugLogStyle } from '../Common/Utils';
// import './Redeem.scss'
import { ADD_BANK_PAGE_STRINGS, LINKWALLET_STRINGS, REDEEMPAGE_STRINGS, RUPEE_SYMBOL, VERIFY_KYC_ALERT } from '../Strings';
import axios, { notifyTokenReceived } from '../api/AxiosInstance.js'
import a23logo from '../assets/a23_avatar_logo.png'
import close from "../assets/close.png";
import LinkWallet from '../models/LinkWallet';
import RedeemStatus from './RedeemRequestSuccess';
// import processed from "../assets/tick.svg";
// import historyicon from "../assets/Redeem-revamp/History.svg";
// import historyicon1 from "../assets/historyTimerIcon.svg"
import needHelpIcon from '../assets/Redeem-revamp/needHelpIcon.svg'
import RadioDeactive from '../assets/Redeem-revamp/RadioDeactive.svg'
import { OtpInput, OtpInputWrapper, maxCharRestriction, onlyNumberInput } from './OTPInput';
import tdsTag from '../assets/tdsTag.svg';
// import proToolTip from "../assets/protip.png";
// import proToolTip from "../assets/tip.svg";
import proToolTip from "../assets/tipSvg.svg";
import NewClose from "../assets/revamp-assets/closeMark.png";
// import BlueClose from "../assets/blueClose.png";
// import PowerButton from "../assets/power.png";
// import TimerIcon from "../assets/time.png";
// import TimerIcon from "../assets/ticker.svg";
// import TimerIcon from "../assets/glasshour.svg"
// import PowerButton from "../assets/thunder.svg"
import PaidInstantIcon from "../assets/paidInstantI.svg"
// import arrowIcon from "../assets/Vector.png";
import OffersIcon from "../assets/offerIconNew.svg";
import ImformationRedIcon from "../assets/information.svg";
import warningIcon from '../assets/challenge/warning.svg'
// import ImformationOrgIcon from "../assets/informationOrg.svg";
// import ImformationBlueIcon from "../assets/informationBlue.svg";
import QuestionIcon from "../assets/question.svg";
import BlueCross from "../assets/blueCross.svg";
import "./GamePass.css"
import GamePassCard from './GamePassCard';
import MissionCard from './MissionCard';
import { staticIndividualMissionsData, staticSingleMissionData } from '../Common/StaticData';
import { connect } from 'react-redux';
// import RibbonImg from "../assets/rib.svg";
// import Gbank from "../assets/ban.svg";
// import Gbonus from "../assets/bon.svg";
// import GWallet from "../assets/wal.svg";
// import BlueInfo from "../assets/BlueInfo.svg"

// import PaidInstantProcessingFeeBadge from "../assets/GroupBadge.svg"
import Tooltip from '../Tooltip';
// import smartRedeemImg from "../assets/smartredeemIcon.png";
import subtract from "../assets/Subtract.png";
// import subtractGold from "../assets/subtractgold.png";
// import instantrupee from "../assets/instantrupee.png";
// import walletIcon1 from "../assets/wallet1.png";
// import plusIcon1 from "../assets/plus1.png";
// import Slider from "./../Slider/Slider.jsx"
import Slider from "./../Slider/Slider.js";
import upindicator from "../assets/upindicator.png";

// import SmartBanner from "../assets/Banner3.svg"
// import { Default } from 'react-awesome-spinners';
import ChallengeCard from './ChallengeCard.js';
import LockedBonusCard from './LockedBonusCard.js';
import KycBannerImage from '../assets/KycBannerImage.svg'
import KycQuetionMark from '../assets/KycQuetionMark.svg';

import BasicPointer from "../assets/pointers/pointer.png";
import MostSelectedPointer from "../assets/pointers/pointergoldPointer.png";
import USSelectedPointer from "../assets/pointers/Group 25984US.png"

import RedAlertIcon from "../assets/redAlert.png";
import UnionIcon from "../assets/Union3.png";
// import SmartIcon from "../assets/smart.png";
// import SmartIcon from "../assets/rocketIcon.png";
import SmartIcon from "../assets/rocketnew.png";
import InfooIcon from "../assets/pointers/information.png";
import ContAdd from "../assets/contAdd.png";
import Polygon from "../assets/Polygon.png";
// import NoTds from "../assets/NOTDS.png"
import NoTds from "../assets/notdsnew.png";
 import { VernacularContext } from '../OEMChanges/LanguageContext.js';
import AdBanner from '../Common/AdBanner.js';

//for testing purpose
// import { dummyData } from '../DummyFolder/dummydata.js';


function Redeem({ history, userState }) {
  // console.log("Dynamic imports",sessionStorage.getItem("channel"));
  // console.log("What is the channel",sessionStorage.getItem("channel"));
  const [isoemps, setIsOem] = useState(sessionStorage.getItem("channel") === "OEMAPS1");
  // let isoemps = sessionStorage.getItem("channel") === "APS"
  if (sessionStorage.getItem("channel") === "OEMAPS1") {
    // require('./redeemOEM.css');
    console.log("Dynamic imports", sessionStorage.getItem("channel"));
    // import('./RedeemOEM.scss');
    import('../models/RedeemCancelOEM.css');
    // import('./Redeem.scss') 

  } else {
    // require('./Redeem.css');
    // import ('./RedeemOEM.scss');
    // import('./Redeem.scss')
    import('../models/RedeemCancel.css');
  }


  const assets = useContext(UserContext);

  const VernacularContextData = useContext(VernacularContext);

  console.log("VernacularContextData in Redeem.js>>>", VernacularContextData);

  // const [redeemAssets, setRedeemAssets] = useState(null);
  // useEffect(()=>{
  console.log(assets.assets);
  // }
  //   if(redeemAssets){
  //     console.log("redeemAssets>>>",redeemAssets)
  //     historyicon1 = redeemAssets.historyIcon1;
  //     viewPolicy = redeemAssets.viewPolicy;
  //     navarrow = redeemAssets.navarrow;
  //     powerIcon = redeemAssets.powerIcon;
  //     AddAccountIcon = redeemAssets.AddAccountIcon;
  //     bankIcon = redeemAssets.bankIcon;
  //     Cross = redeemAssets.Cross;
  //     walletIcon1 = redeemAssets.walletIcon1;
  //     instantrupee = redeemAssets.instantrupee;
  //     TimerIcon = redeemAssets.TimerIcon;
  //     subtractGold= redeemAssets.subtractGold;
  //   }

  // },[])

  // useEffect(()=>{

  //   console.log(assets, "OEM is assets");
  //   // assets.assets.map((data,index)=>{


  //   // })
  // },[])

  const [redeemDetails, setRedeemDetails] = useState(undefined)
  const [profileData, setProfileData] = useState(undefined)

  const [panEmailMandatoryConfig, setPanEmailMandatoryConfig] = useState(undefined)

  const [selectedWithdrawtype, setSelectedWithdrawtype] = useState(REDEEMPAGE_STRINGS.KEY_WALLET_TV)

  const inputRef = useRef()
  const [amountEntered, setEnteredAmount] = useState('')
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [emailEntered, setEmailEntered] = useState('')
  const emailInputRef = useRef()
  const [openAddEmailPopUp, setOpenAddEmailPopUp] = useState(false)
  const [emailVerifyOtp, setEmailVerifyOtp] = useState(['', '', '', '', '', '']);
  const [emailValidationError, setEmailValidationError] = useState(undefined)
  const [sentEmailVerifyOtp, setSentEmailVerifyOtp] = useState(false)
  const [fetchRedeemDetails, setFetchRedeemDetails] = useState(0)
  const [openAddRedeemPopUp, setOpenAddRedeemPopUp] = useState(false)
  const [openAddBankAccountPopUp, setOpenBankAccountPopUp] = useState(false)
  const [openAddUpiPopUp, setOpenAddUpiPopUp] = useState(false)
  const [mobilenumber, setMobilenumber] = useState(window.sessionStorage['mobile'])
  const [selectedRedeemMethod, setSelectedRedeemMethod] = useState(undefined)
  const [activeRedeemMethod, setActiveRedeemMethod] = useState(undefined)
  const [bankDetailsLoading, setBankDetailsLoading] = useState(false)
  const [addBankAccountError, setAddBankAccountError] = useState(undefined)
  const [enableRedeemOTP, setEnableRedeemOTP] = useState(true)
  const [showTaxPopUp, setShowTaxPopUp] = useState(false)
  const [toastMessage, setToastMessage] = useState(undefined)
  const [addBankInfo, setAddBankInfo] = useState({
    accountNumber: '',
    reAccountNumber: '',
    ifscCode: ''
  })
  const otpRef = useRef();
  const basicRef = useRef();
  const saverRef = useRef();
  const usRef = useRef();

  const standardIconRef = useRef();
  const instantIconRef = useRef();
  const infooIconRef = useRef();
  const standardIconRef1 = useRef();
  const instantIconRef1 = useRef();


  const [isLoading, setLoading] = useState(false)
  const [showIframe, setShowIframe] = useState(false)
  const [bottom, setBottom] = useState('0%')
  const [upiIdEntered, setUpiIdEntered] = useState('')
  const upiInputRef = useRef()
  const [showBankAcntStatus, setShowBankAcntStatus] = useState(false)
  const [addBankResponse, setAddBankResponse] = useState(undefined)
  const [showAddUpiStatus, setShowAddUpiStatus] = useState(false)
  const [upiResponse, setUpiResponse] = useState(undefined)
  const [isIfscVerified, setIsIfscVerified] = useState(false)
  const [isUpiVerified, setIsUpiVerified] = useState(false)
  const [upiValidationError, setUpiValidationError] = useState(undefined)
  const [isUpiLoading, setIsUpiLoading] = useState(false)
  const [disableUpiButton, setDisableUpiButton] = useState(true)
  const [upiName, setUpiName] = useState(undefined)
  const emailOtpRef = useRef()
  const [tdsInfo, setTdsInfo] = useState({
    amount: -1,
    tds: -1,
    youGet: -1
  })
  const [showVerifyMobileAlert, setShowVerifyMobileAlert] = useState(false)
  const [openLinkWallet, setOpenLinkWallet] = useState(undefined)
  const [openAllRedeemOptions, setOpenAllRedeemOptions] = useState(false)
  const [showRedeemMethodError, setShowRedeemMethodError] = useState(undefined)
  const [emailLoading, setEmailLoading] = useState(false)
  const [showRedeemStatus, setShowRedeemStatus] = useState(false);
  const [showRedeemStatusData, setShowRedeemStatusData] = useState(undefined);
  const [isbtnEnable, setIsbtnEnable] = useState(false)
  const [validationError, setValidationError] = useState('')
  const [openRedeemRecommendation, setOpenRedeemRecommendation] = useState(false)
  const [openRemoveTag, setOpenRemoveTag] = useState(undefined)
  const acntNumberRef = useRef()
  const reacntNumberRef = useRef()
  const ifscRef = useRef()
  const [recommendationSelection, setRecommendationSelection] = useState(undefined)
  const [elRefs, setElRefs] = useState([]);
  const [value, setValue] = useState({});
  const [redeemOtpVerified, setRedeemOtpVerified] = useState(false)
  const [openOtpVerification, setOpenOtpVerification] = useState(false)
  const [pendingRedeems, setPendingRedeem] = useState([]);
  const [maxAllowedRedeem, setMaxAllowedRedeem] = useState([]);
  const [pendingRedeemsexceeded, setPendingRedeemsexceeded] = useState(false);
  const [toShowGSTPopup, setToShowGSTPopup] = useState(false);
  const [toShowRedeemFlowTwo, setRedeemFlowTwo] = useState(false);

  let pushNotificationEnable = window.sessionStorage["pushNotificationEnable"]
  const [checked, setChecked] = useState((pushNotificationEnable === "false" || pushNotificationEnable === false) ? false : (pushNotificationEnable === "true" || pushNotificationEnable === true) ? true : false);
  const [autoApprovalLimit, setAutoApprovalLimit] = useState();
  const [dailyInstant, setDailyInstant] = useState();
  const [dailyStandard, setDailyStandard] = useState();
  const [monthlyInstant, setMonthlyInstant] = useState();
  const [insantReedemFlag, setInsantReedemFlag] = useState(false);//standardLimit
  const [standardLimit, setStandardLimit] = useState();
  const [toShowStandardAndInstantBottomSheet, setToShowStandardAndInstantBottomSheet] = useState(false);
  const [showGSTOverLay, setShowGSTOverLay] = useState(false);
  const [showInstantErrorToolTip, setShowInstantErrorToolTip] = useState(false);

  const [standardSelected, setStandardSelected] = useState(true);
  const [instantSelected, setInstantSelected] = useState(false);
  // const [redeemLimits,setRedeemLimits] = useState();
  // const [acelevelLimits,setAcelevelLimits] = useState({});
  const [requestsPerDayLimits, setRequestsPerDay] = useState();
  const [userRequestsPerDayLimits, setUserRequestsPerDay] = useState();
  const [limitExhaustPopup, setLimitExhaustPopup] = useState(false);
  const [standardRedeemFlag, setStandardRedeemFlag] = useState(false);
  const [lifetimeInstantRedeemsLeft, setLifetimeInstantRedeemsLeft] = useState();
  const [lifetimeInstantRedeemsConfigCount, setLifetimeInstantRedeemsConfigCount] = useState();
  const [dailyStandardMsg, setDailyStandardMsg] = useState();
  const [redeemTypePopupFlag, setRedeemTypePopupFlag] = useState();

  const [xTime, setXTime] = useState(0);
  // const deadline = new Date("oct 12, 2023 1:37:25").getTime();

  const [deadline, setDeadLine] = useState(new Date("oct 12, 2023 1:37:25").getTime());
  const [timeLeftInHours, setTimeLeftInHours] = useState();
  const [timeLeftInMin, setTimeLeftInMin] = useState();

  const [hourlyDailyInstantFlag, setHourlyDailyInstantFlag] = useState();
  const [nextInstantRedeemAvailability, setNextInstantRedeemAvailability] = useState();
  const [nextAvailabilityHours, setNextAvailabilityHours] = useState();
  const [limitExceeded, setLimitExceededErrorMessage] = useState();
  const [monthlyExhausted, setMonthlyExhausted] = useState();


  const [instantLimitAmount, setInstantLimitAmount] = useState();
  const [standardLimitAmount, setStandardLimitAmount] = useState();
  const [monthlyStandard, setMonthlyStandard] = useState();
  const [nextStandardRedeemAvailability, setNextStandardRedeemAvailability] = useState();
  const [monthlyStandardExhausted, setMonthlyStandardExhausted] = useState();
  const [showStandardUnlocksIn, setShowStandardUnlocksIn] = useState();

  const [standardMessage, setStandardMessage] = useState();
  const [nextAvailabilityStandardHours, setNextAvailabilityStandardHours] = useState();

  const [rgLimitUpdated, setRgLimitUpdated] = useState();
  const [instantAvailabilityFlag, setInstantAvailabiltyFlag] = useState(true);
  const [instantAvailabilityMessage, setInstantAvailabilityMessage] = useState();
  const [showToolTip, setShowToolTip] = useState(false);

  const [showToolTipStd, setShowToolTipStd] = useState(false);


  const [toolTipTimer, setToolTipTimer] = useState(0);
  const [toolTipTimerStd, setToolTipTimerStd] = useState(0);

  const [InstantAmountCheck, setInstantAmountCheck] = useState(true);

  const [standardAmountCheck, setStandardAmountCheck] = useState(true);
  const [stdAndInstantCheck, setStdAndInstantCheck] = useState(true);
  const [disableRedeem, setDisableRedeem] = useState(false);
  const [disableMessage, setDisableMessage] = useState("");
  const [title, setTitle] = useState("");

  const [bonusReleasedLastXDaysAmt, setBonusReleasedLastXDaysAmt] = useState(undefined)
  const [enablebonusReleasedLastXDays, setEnablebonusReleasedLastXDays] = useState(false);


  const [dailyInstantFlag, setDailyInstantFlag] = useState(true);
  const [dailyStandardFlag, setDailyStandardFlag] = useState(true);
  const [redeemCountersType, setRedeemCounterType] = useState("daily");
  const [dailyStandardLeft, setDailyStandardLeft] = useState(1);
  const [dailyInstantLeft, setDailyInstantLeft] = useState(1);
  const [dailyStandardExhausted, setDailyStandardExhausted] = useState(true);
  const [dailyInstantExhausted, setDailyInstantExhausted] = useState(true);
  const [dailyStandardExhaustedMessage, setDailyStandardExhaustedMessage] = useState("Daily standard withdraws exhausted for the day.");
  const [dailyInstantExhaustedMessage, setDailyInstantExhaustedMessage] = useState("Daily Instant withdraws exhausted for the day.")


  const [instantDisable, setInstantDisable] = useState();

  const [toShowGamePassOverLay, setToShowGamePassOverLay] = useState(false);
  const [redeemGamePassData, setRedeemGamePassData] = useState(undefined);
  const [activeMissionsData, setActiveMissionsData] = useState()
  const [isBundledMission, setIsBundledMission] = useState(false);
  const [showPaidInstantConfirmation, setShowPaidInstantConfirmation] = useState(false);
  //Smart Redeem
  const [showSmartRedeem, setShowSmartRedeem] = useState(false);
  const [smartRedeemConfigs, setSmartRedeemConfigs] = useState();
  const [bonusConfig, setBonusConfig] = useState();
  const [smartRedeemEnabled, setSmartRedeemEnabled] = useState();
  const [smartRedeemForInstantOrStandard, setsmartRedeemForInstantOrStandard] = useState();
  const [smartRedeemPercentConfig, setSmartRedeemPercentConfig] = useState();
  const [mostSelected, setMostSelected] = useState();
  const [selectedSliderValue, setSelectedSliderValue] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [totalBonus, setTotalBonus] = useState();
  const [instantBonus, setInstantBonus] = useState();
  const [lockedBonus, setLockedBonus] = useState();
  const [maxLockedBonusAmount, setMaxLockedBonusAmount] = useState();
  const [maxBonus, setMaxBonus] = useState();
  const [maxInstantBonus, setMaxInstantBonus] = useState();
  const [maxLockedBonusPercentage, setMaxLockedBonusPercentage] = useState();
  const [playBalanceAmt, setPlayBalanceAmt] = useState();
  const [smartRedeemAmountArray, setSmartRedeemAmountArray] = useState([]);
  const [buttonText, setButtonText] = useState("");
  const [showSmartRedeemPopup, setShowSmartRedeemPopup] = useState(false);

  const [transferLayoutFlag, setTransferLayoutFlag] = useState(false);
  const [smartRedeemHeading, setSmartRedeemHeading] = useState("Wallet Booster")//useState("Smart Redeem");

  const [challengesData, setChallengesData] = useState()
  const [expiredLockedBonusData, setExpiredLockedBonusData] = useState(undefined)


  const isKYCVerificationPage = window.sessionStorage["clickLocation"] === "kycPanVerification" // add functionality 

  // console.log(isKYCVerificationPage, 'kycsid')
  // Paid instant redeem

  const [showPaidRedeems, setShowPaidRedeems] = useState();
  const [paidInstantLimitAmount, setPaidInstantLimitAmount] = useState();
  const [paidRedeemLimit, setPaidRedeemLimit] = useState();
  const [paidInstantSelected, setPaidInstantSelected] = useState(false);//setNextPaidInstantRedeemAvailability;
  const [nextPaidInstantRedeemAvailability, setNextPaidInstantRedeemAvailability] = useState();
  const [paidInstantLimitExhausted, setPaidInstantLimitExhausted] = useState();
  const [paidInstantAmountCheck, setPaidInstantAmountCheck] = useState(true);
  const [allRedeemAmountCheck, setAllRedeemAmountCheck] = useState(true);
  const [paidInstantRedeemProcessingFee, setPaidInstantRedeemProcessingFee] = useState();

  const [standardIsInCoolOff, setStandardIsInCoolOff] = useState();
  const [instantIsInCoolOff, setInstantIsInCoolOff] = useState();
  const [paidInstantIsInCoolOff, setPaidInstantIsInCoolOff] = useState();
  const [standardExhausted, setStandardExhausted] = useState();
  const [instantExhausted, setInstantExhausted] = useState();
  const [paidInstantExhausted, setPaidInstantExhausted] = useState();
  const [paidInstantMessage, setPaidInstantMessage] = useState();
  const [paidInstantYouGetValue, setPaidInstantYouGetValue] = useState();
  const [paidInstantRedeemEnableFlag, setPaidInstantRedeemEnableFlag] = useState();
  const [showPaidInstantWithdrawlConfPopup, setShowPaidInstantWithdrawlConfPopup] = useState(false);
  const [redeemOrder, setRedeemOrder] = useState();

  const [standardEnableFlag, setStandardEnableFlag] = useState();
  const [instantEnableFlag, setInstantEnableFlag] = useState();

  const [smartRedeemNewUIFlag, setSmartRedeemNewUIFlag] = useState();
  const [smartRedeemOnlineCountMessage, setSmartRedeemOnlineCountMessage] = useState()

  // const [tdsRed, setTdsRed] = useState();
  // const [tdsGreen, setTdsGreen] = useState();

  let redTDSAmount = "";
  let greesTDSAmount = "";
  let [newSmartRedeemValueArr, setSmartRedeemValueArr] = useState([])

  //For smart Redeem

  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);
  const [style1, setStyle1] = useState({});

  const [basicSelected, setBasicSelected] = useState(true);
  const [saverSelected, setSaverSelected] = useState(false);
  const [uSaverSelected, setUSaverSelected] = useState(false);
  const [newRedeemConf, setNewRedeemConf] = useState(["basic", "saver", "ultraSaver"]);
  const [showBonusMissOutPopup, setShowBonusMissOutPopup] = useState(false);
  const [lockedBonusArr, setLockedBonusArr] = useState([]);
  const [instantBonusArr, setInstantBonusArr] = useState([]);

  const [showStdToolTip, setStdShowToolTip] = useState(false);
  const [showInstToolTip, setInstShowToolTip] = useState(false);

  const [showStandardSmartRedeemIcon, setShowStandardSmartRedeemIcon] = useState();
  const [showInstantSmartRedeemIcon, setShowInstantSmartRedeemIcon] = useState();

  const [zeroTDSValueIndex, setZeroTDSValueIndex] = useState();

  //   tdsCashBackConfigData = {
  //     applicableForStandard: false,
  //     applicableForInstant: false,
  //     standardTypePercentage: 0,
  //     instantTypePercentage: 0,
  //     tdsMaxCapAmount: 0,
  //     tdsTnyWinningsEnabled: false,
  //     cummilativeTrnyWinnings: 0
  // }

  const [tdsCashBackConfigData, setTdsCashBackConfigData] = useState();
  const [applicableForStandard, setApplicableForStandard] = useState(false);
  const [applicableForInstant, setApplicableForInstant] = useState(false);
  const [standardTypePercentage, setStandardTypePercentage] = useState(0);
  const [instantTypePercentage, setInstantTypePercentage] = useState(0);
  const [tdsMaxCapAmount, setTdsMaxCapAmount] = useState(0);
  const [tdsTnyWinningsEnabled, setTdsTnyWinningsEnabled] = useState(false);
  const [cummilativeTrnyWinnings, setCummilativeTrnyWinnings] = useState(0);
  const [tdsCashbackAmount, setTdsCashbackAmount] = useState(0);

  const [showTdsCashbackBottomSheet, setShowTdsCashbackBottomSheet] = useState(false);

  const [finalCashbackValue, setFinalCashbackValue] = useState(0);
  const [finalTryCashbackValue, setFinalTryCashbackValue] = useState(0);

  const [tdsRefundUrl, setTdsRefundUrl] = useState("");
  const [tdsRefundFinYear, setTdsRefundFinYear] = useState("");

  const [tdsRefundConfig, setTdsRefundConfig] = useState(0);
  const [tdsRefundAmount, setTdsRefundAmount] = useState(0);
  const [tdsRefundEligibility, setTdsRefundEligibility] = useState(false);
  const [tdshistoryReportHyperlinkName, setTdshistoryReportHyperlinkName] = useState("TDS History Report");
  const [itrReportHyperlinkName, setItrReportHyperlinkName] = useState("ITR Report");

  const [adjustBtnClicked, setAdjustBtnClicked] = useState(false);

  const [knowMoreBottomUP, setKnowMoreBottomUp] = useState(false);

  const [newCTAFlag, setNewCTAFlag] = useState(false);
  const [ctaTdsTitle, setCtaTdsTitle] = useState("TDS will be deducted for this amount");
  const [ctaDesc, setCtaDesc] = useState("Withdrawal the amount to avoid TDS changes");
  const [onClickCTATitle, setOnClickCTATitle] = useState("No TDS on this amount");
  const [onClickCTADesc, setOnClickCTADesc] = useState("Withdrawal the amount without TDS deduction");
  const [fullTdsNoteFlag, setFullTdsNoteFlag] = useState(false);
  const [fullTDSNote, setFullTDSNote] = useState("No TDS applicable on add cash amount");



  const [sendBottomSheetAlert, setSendBottomSheetAlert] = useState(false);

  const [isNewVersion, setIsNewVersion] = useState(false);

  const resetProps = () => {

    // console.log("Came to Reset Props >>>");
    setEnteredAmount('')
    setEmailEntered('')
    setEmailVerifyOtp(['', '', '', '', '', ''])
    setSentEmailVerifyOtp(false)
    setOpenAddRedeemPopUp(false)
    setActiveRedeemMethod(undefined)
    setValidationError('')
    setAddBankInfo({ accountNumber: '', reAccountNumber: '', ifscCode: '' });
    setAddBankAccountError(undefined)
    setUpiValidationError(undefined)
    setEmailValidationError(undefined)
    setOpenAddEmailPopUp(false)
    setOpenLinkWallet(undefined)
    setSelectedRedeemMethod(undefined)
    setShowRedeemMethodError(undefined)
    setActiveRedeemMethod(undefined)
    setShowTaxPopUp(false);
    // setKnowMoreBottomUp(false)

  }

  useEffect(() => {
    console.log("smartredeemarray changed => ", smartRedeemAmountArray)
  }, [smartRedeemAmountArray])
  useEffect(() => {
    if (redeemDetails !== undefined && profileData !== undefined) {
      if (showVerificationPage() || isKYCVerificationPage) {
        callVerificationPage()
      }
      // if(redeemDetails?.panMandatory&& redeemDetails?.kycStatus!== 'approved'){
      // // if(true){
      //   WebToNativeMessage({
      //     type:"FraudUser",
      //     kycStatus: redeemDetails?.kycStatus,
      //   })
      // }
    }
  }, [redeemDetails, profileData])

  useEffect(() => {
    if (window.sessionStorage["reactLocation"] === "Redeem_History_Page") {
      let userDetails = userState.profileData;
      WebToNativeMessage(
        {
          type: "redeemCTEvent", eventName: "PF_c_RedeemHistory_pageload", eventProperties: {
            Click_Location: "NA",
            acelevel: window.sessionStorage["aceLevel"],
            channel: window.sessionStorage["channel"],
            subscriptionType: window.sessionStorage["subscriptionType"],
            username: window.sessionStorage["screenName"],
            count_pendingRedeem: userDetails.totalPendingRedeems,
            Source: window.sessionStorage['clickLocation']
          }

        })
      WebToNativeMessage(
        {
          type: "mixpanelEvent", eventName: "PF_c_RedeemHistory_pageload", eventProperties: {
            Click_Location: "NA",
            acelevel: window.sessionStorage["aceLevel"],
            channel: window.sessionStorage["channel"],
            subscriptionType: window.sessionStorage["subscriptionType"],
            username: window.sessionStorage["screenName"],
            count_pendingRedeem: userDetails.totalPendingRedeems,
            Source: window.sessionStorage['clickLocation']
          }

        })
      history.push("/redeemhistory/");
    }

  }, [])

  useEffect(() => {

    setElRefs((elRefs) =>
      Array(6)
        .fill()
        .map((_, i) => elRefs[i] || React.createRef())
    );
  }, []);

  useEffect(() => {
    // if (Object.values(emailVerifyOtp).join("").length === 6) {
    //     //   setIsDisabled(false);
    //     otpRef.current.value = Object.values(value).join("");
    // } else {
    //     //   setIsDisabled(true);
    // }
    setEmailValidationError('')
  }, [emailVerifyOtp]);

  useEffect(() => {
    let accountExist = redeemDetails?.allRedeemOptions.findIndex((o) => (o.upi === upiIdEntered.toLowerCase()))
    if (accountExist !== -1) {
      setUpiValidationError('UPI ID already exists in system.')
    }
    else {
      setUpiValidationError(undefined)
    }


  }, [upiIdEntered])
  const EnableVerifyId = () => {
    console.log("[EnableVerifyId] called. redeemDetails:", redeemDetails);

    if (!redeemDetails) {
      console.log("[EnableVerifyId] redeemDetails is null/undefined. Returning false.");
      return false;
    }
    if (!isNewVersion) {
      console.log(" here in isnewversion is true and pan not verified")
      
      const _isIdNotVerified = (redeemDetails?.kycStatus?.toLocaleLowerCase() === "not verified" || redeemDetails?.kycStatus?.toLocaleLowerCase() === "rejected");
      return _isIdNotVerified;
    } else {
      // If PAN is not mandatory, check if isIdVerified is "notverified"
      const isIdNotVerified = (redeemDetails?.isIdVerified?.toLocaleLowerCase() === "notverified" || redeemDetails?.isIdVerified?.toLocaleLowerCase() === "rejected") && (redeemDetails?.kycStatus?.toLocaleLowerCase() === "not verified" || redeemDetails?.kycStatus?.toLocaleLowerCase() === "rejected");
      console.log(`[EnableVerifyId] PAN is NOT mandatory. isIdVerified: ${redeemDetails?.isIdVerified}. Returning ${isIdNotVerified}.  and kyc status ${redeemDetails?.kycStatus}`);
      return isIdNotVerified;
    }



  }




  useEffect(() => {
    console.log(window.sessionStorage.getItem("isNewVersion"), " is new version in session storage")
    if (window.sessionStorage.getItem("isNewVersion") !== null) {
      console.log("is new version is ======> ", window.sessionStorage.getItem("isNewVersion"))
      setIsNewVersion(window.sessionStorage.getItem("isNewVersion") === "true" ? true : false)
    }
    try {
      window.dataToClient = async (message) => {
        let parsedMessage = JSON.parse(message)
        console.log("Came to redeem page>>", parsedMessage)
        if (parsedMessage.type && parsedMessage.type.toLowerCase() === "updatedtoken") {
          console.log("Updated Token received from Native: ", parsedMessage.token);
          let clientData = JSON.parse(window.sessionStorage.getItem("clientData"));
          console.log("clientData before setting token: ", clientData);
          if (clientData) {
            clientData.token = parsedMessage.token;
            clientData.a23Token = parsedMessage.a23Token;
            console.log("setting clientData in sessionStorage: ", JSON.stringify(clientData));
            window.sessionStorage.setItem("clientData", JSON.stringify(clientData))
          }
          window.sessionStorage.setItem("token", parsedMessage.token);
          window.sessionStorage.setItem("a23token", parsedMessage.a23Token);
          notifyTokenReceived(parsedMessage.token);
          return;
        }
        // window.sessionStorage.setItem("isNewVersion", parsedMessage?.isNewVersion);
        // console.log("is new version is ======> ", parsedMessage.isNewVersion)
        // setIsNewVersion(parsedMessage?.isNewVersion);

        setIsNewVersion(parsedMessage?.isNewVersion);
      console.log("is new version in datatoclient redeem is : ", parsedMessage.isNewVersion)

        if (parsedMessage && parsedMessage.pushNotificationEnable !== null && parsedMessage.pushNotificationEnable !== undefined) {
          window.sessionStorage.setItem("pushNotificationEnable", parsedMessage.pushNotificationEnable);
          setChecked((parsedMessage.pushNotificationEnable === false || parsedMessage.pushNotificationEnable === "false") ? false : (parsedMessage.pushNotificationEnable === true || parsedMessage.pushNotificationEnable === "true") ? true : false)
        }
        if (parsedMessage && parsedMessage?.type === 'onbackpressed') {
          handleInputBlur()
        }
        if (parsedMessage && parsedMessage?.type === 'reactOTPAck') {
          setOTP(parsedMessage.data.split(''))
          setEmailVerifyOtp(parsedMessage.data.split(''))
        }
        if (parsedMessage && parsedMessage?.type === 'kycStatus') {
          setFetchRedeemDetails(fetchRedeemDetails + 1)
        }
      }
    } catch (e) { }
    window.addEventListener("visibilitychange", (event) => {
      console.log("first visibility change event", event);
      setFetchRedeemDetails(prev => prev + 1)
    })
  }, [])



  useEffect(() => {
    window.addEventListener("dataToClient", dataFromNative);
  }, []);

  useEffect(() => {
    window.sessionStorage.setItem('policyBack', 'redeem')
  }, [])


  useEffect(() => {

    if (showSmartRedeem) {
      // console.log("What is component ref", basicRef);
      // console.log("What is component ref2", saverRef);
      // console.log("What is component ref3", usRef);//30
      if (smartRedeemNewUIFlag) {
        if (saverSelected) {
          setStyle1({ left: (Number(saverRef.current.offsetWidth) / 2 + Number(saverRef.current.offsetLeft)) - 20 })
        } else if (uSaverSelected) {
          setStyle1({ left: (Number(usRef.current.offsetWidth) / 2 + Number(usRef.current.offsetLeft)) - 20 })
        } else if (basicSelected) {
          setStyle1({ left: (Number(basicRef.current.offsetWidth) / 2 + Number(basicRef.current.offsetLeft)) - 20 })
        } else {
          setStyle1({ left: (Number(basicRef.current.offsetWidth) / 2 + Number(basicRef.current.offsetLeft)) - 20 })
        }
      }


    }


  }, [showSmartRedeem, saverSelected, uSaverSelected, basicSelected])

  const callVerificationPage = () => {
    let eventProperties = {
      acelevel: window.sessionStorage["aceLevel"],
      channel: window.sessionStorage["channel"],
      subscriptionType: window.sessionStorage["subscriptionType"],
      username: window.sessionStorage["screenName"],
      wallet_balance: window.sessionStorage["totalBalance"],
      Redeemable_amount: redeemDetails?.redeemableAmount,
    }
    WebToNativeMessage({
      type: "redeemCTEvent", eventName: "PF_c_RedeemVerificationPage_View", eventProperties: eventProperties
    })
    WebToNativeMessage({
      type: "mixpanelEvent", eventName: "PF_c_RedeemVerificationPage_View", eventProperties: eventProperties
    })
    WebToNativeMessage({
      type: "rstsData", rstsData: {
        eventData:
        {
          acelevel: window.sessionStorage["aceLevel"],
          channel: window.sessionStorage["channel"],
          subscription_type: window.sessionStorage["subscriptionType"],
          // username: window.sessionStorage["screenName"],
          player_id: window.sessionStorage["screenName"],
          wallet_balance: window.sessionStorage["totalBalance"],
          redeemable_amount: redeemDetails?.redeemableAmount,
        },
        isevent: "yes",
        tableName: "pf_c_redeemverificationpage_view"
      }
    })
  }

  const dataFromNative = (event) => {
    let date = new Date();
    console.log(`Message from Platform ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()} >>> ${event.data}`);
    let parsedMessage = JSON.parse(event.data)
    if (parsedMessage && parsedMessage?.type === 'onbackpressed') {
      handleInputBlur()
    }


  }
  const closeVideoScreen = () => {
    // console.log("came into closeVideoScreen>>>")
    setIsPlaying(false);
  }

  useEffect(() => {
    if (activeRedeemMethod === undefined || activeRedeemMethod === null) {
      setSelectedWithdrawtype('wallet')
    }
    else {
      setSelectedWithdrawtype(activeRedeemMethod.type)
    }
  }, [activeRedeemMethod])



  useEffect(() => {

    let stdSelected;
    let instSelected;
    let responseDataE;
    // let redeemData;
    let paidInstSelected;

    console.log("fetching redeem history ", window.sessionStorage["token"]);

    axios.get(process.env.REACT_APP_NEW_BASE_URL + 'redeem/redeem_details/', { headers: { 'Authorization': window.sessionStorage["token"] } })
      .then((response => {
        if (response?.data?.error?.statusCode === 1000) {
          WebToNativeMessage({ type: "closeClient", error: "got status code 1000", errorMessage: response.data.error.message, api: "get_profilev2" });
        }
        setRedeemDetails(response.data);
        // console.log(dummyData, " is dummy data");
        // setRedeemDetails(dummyData);
        // redeemData = response.data

        setPendingRedeem(response.data.pendingRedeems);
        setMaxAllowedRedeem(response.data.maxAllowedRedeem);
        setPendingRedeemsexceeded(response.data.pendingRedeemsexceeded);//For testing purpose


        if (response.data.pendingRedeemsexceeded && (Number(response.data.maxAllowedRedeem) > 0)) {
          setToShowGSTPopup(true)
        }

        setShowGSTOverLay(false);

        setAutoApprovalLimit(response.data.autoApprovalLimit);
        setDailyInstant(response.data.dailyInstant);
        setMonthlyInstant(response.data.monthlyInstant);
        setInsantReedemFlag(response.data.instantRedeemFlag);//instantRedeemFlag//instantRedeemFlag
        setStandardLimit(response.data.dailyStandard)//Need to remove static value when admin and backend added tot the response.


        setRequestsPerDay(response.data.requestsPerDay);
        setUserRequestsPerDay(response.data.userRequestsPerDay);
        setStandardRedeemFlag(response.data.standardRedeemFlag);
        setLifetimeInstantRedeemsLeft(response.data.lifetimeInstantRedeemsLeft);//lifetimeInstantRedeemsLeft
        setLifetimeInstantRedeemsConfigCount(response.data.lifetimeInstantRedeemsConfigCount);
        setDailyStandardMsg(response.data.dailyStandardMsg);

        setRedeemTypePopupFlag(response.data.redeemTypePopupFlag);
        setHourlyDailyInstantFlag(response.data.hourlyDailyInstantFlag);//2837 //"H"/"D"
        setNextInstantRedeemAvailability(response.data.nextInstantRedeemAvailability); // N / Time
        setNextAvailabilityHours(response.data.nextAvailabilityHours) //25


        setInstantLimitAmount(response.data.maxAmountInstant);
        setStandardLimitAmount(Number(response.data.maxAmountStandard));
        setMonthlyStandard(response.data.monthlyStandard);
        setNextStandardRedeemAvailability(response.data.nextStandardRedeemAvailability);
        setNextAvailabilityStandardHours(response.data.nextAvailabilityStandardHours);
        setStandardMessage(response.data.standardMessage);


        setRgLimitUpdated(response.data.rgLimitUpdated);
        setInstantAvailabiltyFlag(response.data.instantAvailabilityFlag);
        setInstantAvailabilityMessage(response.data.instantAvailabilityMessage);

        setDisableRedeem(response.data.disableRedeem);
        setDisableMessage(response.data.disableMessage);
        setTitle(response.data.title);


        setDailyInstantFlag(response.data.dailyInstantFlag)
        setDailyStandardFlag(response.data.dailyStandardFlag)
        setRedeemCounterType(response.data.redeemCountersType)
        setDailyStandardLeft(response.data.dailyStandardLeft)
        setDailyInstantLeft(response.data.dailyInstantLeft);


        //Dummy values 
        setDailyStandardExhausted(response.data.dailyStandardExhaustFlag);
        setDailyInstantExhausted(response.data.dailyInstantExhaustFlag);
        setDailyStandardExhaustedMessage("Daily standard redeems exhausted for the day.");
        setDailyInstantExhaustedMessage("Daily Instant redeems exhausted for the day.");
        // console.log("smartRedeemNewUIFlag >>>>>>", response.data);
        // console.log("smartRedeemNewUIFlag >>>>>>", response.data.smartRedeemNewUIFlag);
        if (response.data.smartRedeemNewUIFlag) {
          setSmartRedeemNewUIFlag(response.data.smartRedeemNewUIFlag)
          // setSmartRedeemNewUIFlag(true);
        } else {
          setSmartRedeemNewUIFlag(false)
        }

        if (response.data.smartRedeemOnlineCountMessage) { setSmartRedeemOnlineCountMessage(response.data.smartRedeemOnlineCountMessage) }

        if (response.data.paidInstantConfigData) {
          setShowPaidRedeems(response.data.paidInstantConfigData.paidInstantFlag); // replace with the response//paid
          setPaidInstantLimitAmount(response.data.paidInstantConfigData.paidInstantMaxAmount);// replace with the response
          setPaidRedeemLimit(response.data.redeemCountersType.toLowerCase() === "monthly" ? response.data.paidInstantConfigData.monthlyPaidInstantLeft : response.data.paidInstantConfigData.dailyPaidInstantLeft);// replace with the response
          setNextPaidInstantRedeemAvailability(response.data.paidInstantConfigData.nextpaidInstantAvailability); // N / Time// replace with the response//paidInstantRedeemProcessingFee//paidInstantRedeemProcessingFee//nextpaidInstantAvailability
          setPaidInstantRedeemProcessingFee(response.data.paidInstantConfigData.paidInstantProcessingFee);
          setPaidInstantMessage(response.data.paidInstantConfigData.paidInstantMessage);
          // setPaidInstantRedeemEnableFlag(response.data.paidinstantEnableFlag);
          setPaidInstantRedeemEnableFlag(response.data.paidInstantEnableFlag);
          setRedeemOrder(response.data.redeemOrder);
        }
        //NEw requirement
        setStandardEnableFlag(response.data.standardEnableFlag);
        setInstantEnableFlag(response.data.instantEnableFlag);

        if (response.data.smartRedeemConfigs && response.data.smartRedeemConfigs.smartRedeemEnabled) {
          setSmartRedeemEnabled(response.data.smartRedeemConfigs.smartRedeemEnabled)
          setsmartRedeemForInstantOrStandard(response.data.smartRedeemConfigs.smartRedeemForStandardOrInstant);
          setSmartRedeemConfigs(response.data.smartRedeemConfigs);
          setBonusConfig(response.data.smartRedeemConfigs.bonusConfig);
          // console.log("Smart redeem >>>>>>>> nee", response.data.smartRedeemConfigs.smartRedeemEnabled);
          window.sessionStorage.setItem("smartRedeemEnabled 123456789", response.data.smartRedeemConfigs.smartRedeemEnabled);
          window.sessionStorage.setItem("smartRedeemForInstantOrStandard", response.data.smartRedeemConfigs.smartRedeemForStandardOrInstant);

        } else {
          setSmartRedeemEnabled(response.data.smartRedeemConfigs.smartRedeemEnabled)
        }



        if (response.data.smartRedeemConfigs && response.data.smartRedeemConfigs.smartRedeemForStandardOrInstant && (response.data.smartRedeemConfigs.smartRedeemForStandardOrInstant === "both" || response.data.smartRedeemConfigs.smartRedeemForStandardOrInstant.toLowerCase() === "instant")) {
          setShowInstantSmartRedeemIcon(true)
        } else {
          setShowInstantSmartRedeemIcon(false)
        }

        if (response.data.smartRedeemConfigs && response.data.smartRedeemConfigs.smartRedeemForStandardOrInstant && (response.data.smartRedeemConfigs.smartRedeemForStandardOrInstant === "both" || response.data.smartRedeemConfigs.smartRedeemForStandardOrInstant.toLowerCase() === "standard")) {
          setShowStandardSmartRedeemIcon(true)
        } else {
          setShowStandardSmartRedeemIcon(false)
        }


        if (response.data.tdsCashBackConfigData) {
          setTdsCashBackConfigData(response.data.tdsCashBackConfigData);
          setApplicableForStandard(response.data.tdsCashBackConfigData.applicableForStandard);
          setApplicableForInstant(response.data.tdsCashBackConfigData.applicableForInstant);
          setStandardTypePercentage(response.data.tdsCashBackConfigData.standardTypePercentage);
          setInstantTypePercentage(response.data.tdsCashBackConfigData.instantTypePercentage);
          setTdsMaxCapAmount(response.data.tdsCashBackConfigData.tdsMaxCapAmount);
          setTdsTnyWinningsEnabled(response.data.tdsCashBackConfigData.tdsTnyWinningsEnabled);
          setCummilativeTrnyWinnings(response.data.tdsCashBackConfigData.cummilativeTrnyWinnings);

        }

        setTdsRefundUrl(response.data.tdsRefundUrl ? response.data.tdsRefundUrl : "")
        setTdsRefundFinYear(response.data.tdsRefundFinYear ? response.data.tdsRefundFinYear : "");


        setTdsRefundConfig(response.data.tdsRefundConfig ? response.data.tdsRefundConfig : 0);
        setTdsRefundAmount(response.data.tdsRefundAmount ? response.data.tdsRefundAmount : 0);
        setTdsRefundEligibility(response.data.tdsRefundEligibility ? response.data.tdsRefundEligibility : false);


        setTdshistoryReportHyperlinkName(response.data.tdshistoryReportHyperlinkName)//itrReportHyperlinkName
        setItrReportHyperlinkName(response.data.itrReportHyperlinkName)//itrReportHyperlinkName


        setTransferLayoutFlag(response.data.transferLayoutFlag);
        // setSmartRedeemHeading(response.data.smartRedeemHeading);
        setSmartRedeemHeading("Wallet Booster");



        setNewCTAFlag(response.data.newCTAFlag);
        setCtaTdsTitle(response.data.ctaTdsTitle);
        setCtaDesc(response.data.ctaDesc);
        setOnClickCTATitle(response.data.onClickCTATitle);
        setOnClickCTADesc(response.data.onClickCTADesc);
        setFullTdsNoteFlag(response.data.fullTdsNoteFlag);
        setFullTDSNote(response.data.fullTDSNote);




        let arr = []

        if (response.data.smartRedeemConfigs && response.data.smartRedeemConfigs.percentageSplit) {
          for (let index = 0; index < response.data.smartRedeemConfigs.percentageSplit.length; index++) {
            let elem = response.data.smartRedeemConfigs.percentageSplit[index];
            // console.log("Final output of config", elem.value, index);

            if (elem.default) {
              console.log("What is the default >>>>>", index);
              setSelectedIndex(index)
            }

            // else {
            //   setSelectedIndex(0)
            // }

            if (elem.mostSelected) {
              setMostSelected(index);
            }
            arr.push(elem.value)
          }

          console.log("default configs", arr);

          setSmartRedeemPercentConfig(arr)
        }


        if ((!response.data.standardRedeemFlag)) {
          setInstantSelected(true);
          setStandardSelected(false)
          stdSelected = false;
          instSelected = true;
        }

        if ((Number(response.data.requestsPerDay) - Number(response.data.userRequestsPerDay)) <= 0) {
          setLimitExhaustPopup(true);
          setToShowGSTPopup(true);
        }

        if (Number(response.data.monthlyInstant) <= 0) {
          setMonthlyExhausted(true);
          setInstantSelected(false);
          setStandardSelected(true);
          stdSelected = true;
          instSelected = false;
        } else {
          setMonthlyExhausted(false);
        }


        if (Number(response.data.monthlyStandard) <= 0) {
          setMonthlyStandardExhausted(true);
          setInstantSelected(true);
          setStandardSelected(false);
          stdSelected = false;
          instSelected = true;
        } else {
          setMonthlyStandardExhausted(false);
        }




        if (Number(response.data.monthlyInstant) <= 0 && Number(response.data.monthlyStandard) <= 0) {
          setMonthlyStandardExhausted(true);
          setMonthlyExhausted(true);
          setInstantSelected(false);
          setStandardSelected(false);
          stdSelected = false;
          instSelected = false;
        }


        if (Number(response.data.lifetimeInstantRedeemsLeft) > 0) {
          setInstantSelected(true);
          setStandardSelected(false);
          stdSelected = false;
          instSelected = true;
        }

        if ((response.data.nextInstantRedeemAvailability !== "N")) {


          setStandardSelected(false);
          stdSelected = false


        }
        if ((response.data.nextStandardRedeemAvailability !== "N")) {
          // console.log("KKKKKKKKKKKKKHHHHHHHHHHHHHHHHHH", response.data.nextInstantRedeemAvailability);
          setShowStandardUnlocksIn(true);
          setStandardSelected(false);
          stdSelected = false
          // setInstantSelected(true);
          if (Number(response.data.monthlyInstant) > 0 || response.data.dailyInstantLeft > 0) {
            console.log("std 2", response.data.monthlyInstant);
            setInstantSelected(true);
            setStandardSelected(false);
            stdSelected = false;
            instSelected = true;
          }
          else if (Number(response.data.monthlyInstant) <= 0 || response.data.dailyInstantLeft <= 0) {
            setInstantSelected(false);
            setStandardSelected(false);
            stdSelected = false;
            instSelected = false;
          }




        } else {

          setShowStandardUnlocksIn(false)

        }


        if ((response.data.monthlyStandard > 0 && (response.data.nextInstantRedeemAvailability !== "N")) || (response.data.dailyStandardLeft > 0 && (response.data.nextInstantRedeemAvailability !== "N"))) {
          setInstantSelected(false);
          setStandardSelected(true);
          stdSelected = true;
          instSelected = false;
        } else if ((response.data.monthlyInstant > 0 && (response.data.nextStandardRedeemAvailability !== "N") || (response.data.dailyInstantLeft > 0 && (response.data.nextStandardRedeemAvailability !== "N")))) {
          setInstantSelected(true);
          setStandardSelected(false);
          stdSelected = false;
          instSelected = true;
        }
        else if ((response.data.monthlyStandard > 0 && (response.data.nextStandardRedeemAvailability === "N") || (response.data.dailyStandardLeft > 0 && (response.data.nextStandardRedeemAvailability === "N")))) {
          stdSelected = true;
          instSelected = false;
        } else if ((response.data.monthlyInstant > 0 && (response.data.nextInstantRedeemAvailability === "N") || (response.data.dailyInstantLeft > 0 && (response.data.nextInstantRedeemAvailability === "N")))) {
          stdSelected = false;
          instSelected = true;
        } else if (response.data.lifetimeInstantRedeemsLeft > 0 && response.data.nextInstantRedeemAvailability === "N") {

          stdSelected = false;
          instSelected = true;
          // setMonthlyExhausted(false);

        }

        if (response.data.monthlyStandard > 0 && !instantAvailabilityFlag) {
          setStandardSelected(true);
          setInstantSelected(false);
          stdSelected = true;
          instSelected = false;
        }

        if (response.data.monthlyStandard <= 0 && (response.data.nextInstantRedeemAvailability !== "N") || (response.data.monthlyInstant <= 0 && (response.data.nextStandardRedeemAvailability !== "N"))) {
          setInstantSelected(false);
          setStandardSelected(false);

          stdSelected = false;
          instSelected = false;
        }



        if (!instantAvailabilityFlag) {
          setInstantSelected(false);
          instSelected = false
        }


        if (response.data.monthlyInstant <= 0 && response.data.lifetimeInstantRedeemsLeft > 0 && response.data.nextInstantRedeemAvailability === "N") {
          setInstantSelected(true);
          setStandardSelected(false);
          stdSelected = false;
          instSelected = true;

        } else if (response.data.monthlyInstant <= 0 && response.data.lifetimeInstantRedeemsLeft > 0 && response.data.nextStandardRedeemAvailability !== "N") {
          setInstantSelected(false);
          setStandardSelected(true);
          stdSelected = true;
          instSelected = false;
        }

        if (response.data.nextStandardRedeemAvailability !== "N" && response.data.nextInstantRedeemAvailability !== "N") {
          setInstantSelected(false);
          setStandardSelected(false);
          stdSelected = false;
          instSelected = false;
        }


        if ((Number(response.data.requestsPerDay) - Number(response.data.userRequestsPerDay)) <= 0) {
          setLimitExhaustPopup(true);
          setToShowGSTPopup(true);
        }

        let minAmountValue = response.data.walletMinAmount ? response.data.walletMinAmount : response.data.minAmount;
        let instantMaxValue = Math.min(Number(response.data.maxAmountInstant), Number(response.data.redeemableAmount));
        let standardMaxValue = Math.min(Number(response.data.maxAmountStandard), Number(response.data.redeemableAmount));
        let paidInstantMaxValue = Math.min(Number(response.data.paidInstantConfigData.paidInstantMaxAmount), Number(response.data.redeemableAmount));


        if (!response.data.paidInstantConfigData.paidInstantFlag) {
          if ((minAmountValue > instantMaxValue) && (minAmountValue > standardMaxValue)) {
            // console.log("DUM gg 1");
            setStandardAmountCheck(false);
            setInstantAmountCheck(false);
            setStdAndInstantCheck(false);
            setInstantSelected(false);
            setStandardSelected(false);
            stdSelected = false;
            instSelected = false;
          } else if ((minAmountValue < instantMaxValue) && (minAmountValue > standardMaxValue)) {
            // console.log("DUM gg 2");
            setStandardAmountCheck(false);
            setInstantAmountCheck(true);
            setStdAndInstantCheck(true);
            setInstantSelected(true);
            setStandardSelected(false);
            stdSelected = false;
            instSelected = true;
            if (response.data.nextInstantRedeemAvailability !== "N" || response.data.monthlyInstant <= 0) {
              setInstantSelected(false);
              setStdAndInstantCheck(false);
              stdSelected = false;
              instSelected = false;
            }
          }
          else if ((minAmountValue < standardMaxValue) && (minAmountValue > instantMaxValue)) {
            // console.log("DUM gg 3");
            setStandardAmountCheck(true);
            setInstantAmountCheck(false);
            setStdAndInstantCheck(true);
            setInstantSelected(false);
            setStandardSelected(true);
            stdSelected = true;
            instSelected = false;
            if (response.data.nextStandardRedeemAvailability !== "N" || response.data.monthlyStandard <= 0) {
              setStandardSelected(false);
              setStdAndInstantCheck(false);
              stdSelected = false;
              instSelected = false;
            }
          }
          else if ((minAmountValue < instantMaxValue) && (minAmountValue < standardMaxValue)) {
            // console.log("dum 89");
            setStandardAmountCheck(true);
            setInstantAmountCheck(true);
            // setStdAndInstantCheck(true);
            setStdAndInstantCheck(true);
            // stdSelected = true;
            // instSelected = false;


          }
        } else {
          // console.log(">>>>>>>> KKKKKK")

          if ((minAmountValue > standardMaxValue) && (minAmountValue > instantMaxValue) && (minAmountValue > paidInstantMaxValue)) {

            // console.log("1 fffff");

            setStandardAmountCheck(false);
            setInstantAmountCheck(false);
            setStdAndInstantCheck(false);
            setPaidInstantAmountCheck(false);
            setInstantSelected(false);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = false;
            paidInstSelected = false;

            setInstantIsInCoolOff(false)
            setStandardIsInCoolOff(false)
            setPaidInstantIsInCoolOff(false)



          }
          else if ((minAmountValue > standardMaxValue) && (minAmountValue > instantMaxValue) && (minAmountValue < paidInstantMaxValue)) {
            // console.log("2 fffff");
            setStandardAmountCheck(false);
            setInstantAmountCheck(false);
            setStdAndInstantCheck(true);
            setPaidInstantAmountCheck(true);
            setInstantSelected(false);
            setStandardSelected(false);
            setPaidInstantSelected(true);
            stdSelected = false;
            instSelected = false;
            paidInstSelected = true;
          }
          else if ((minAmountValue > standardMaxValue) && (minAmountValue < instantMaxValue) && (minAmountValue < paidInstantMaxValue)) {
            // console.log("3 fffff");
            setStandardAmountCheck(false);
            setInstantAmountCheck(true);
            setStdAndInstantCheck(true);
            setPaidInstantAmountCheck(true);
            setInstantSelected(true);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = true;
            paidInstSelected = false;
          }
          else if ((minAmountValue > standardMaxValue) && (minAmountValue < instantMaxValue) && (minAmountValue > paidInstantMaxValue)) {
            // console.log("4 fffff");
            setStandardAmountCheck(false);
            setInstantAmountCheck(true);
            setStdAndInstantCheck(true);
            setPaidInstantAmountCheck(false);
            setInstantSelected(true);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = true;
            paidInstSelected = false;
          }
          else if ((minAmountValue < standardMaxValue) && (minAmountValue > instantMaxValue) && (minAmountValue > paidInstantMaxValue)) {
            // console.log("5 fffff");
            setStandardAmountCheck(true);
            setInstantAmountCheck(false);
            setStdAndInstantCheck(true);
            setPaidInstantAmountCheck(false);
            setInstantSelected(false);
            setStandardSelected(true);
            setPaidInstantSelected(false);
            stdSelected = true;
            instSelected = false;
            paidInstSelected = false;
          } else if ((minAmountValue < standardMaxValue) && (minAmountValue > instantMaxValue) && (minAmountValue < paidInstantMaxValue)) {
            // console.log("6 fffff");
            setStandardAmountCheck(true);
            setInstantAmountCheck(false);
            setStdAndInstantCheck(true);
            setPaidInstantAmountCheck(false);
            setInstantSelected(false);
            setStandardSelected(true);
            setPaidInstantSelected(false);
            stdSelected = true;
            instSelected = false;
            paidInstSelected = false;
          }
          else if ((minAmountValue < standardMaxValue) && (minAmountValue < instantMaxValue) && (minAmountValue > paidInstantMaxValue)) {
            // console.log("7 fffff");
            setStandardAmountCheck(true);
            setInstantAmountCheck(false);
            setStdAndInstantCheck(true);
            setPaidInstantAmountCheck(false);
            setInstantSelected(false);
            setStandardSelected(true);
            setPaidInstantSelected(false);
            stdSelected = true;
            instSelected = false;
            paidInstSelected = false;
          }
          else if ((minAmountValue < standardMaxValue) && (minAmountValue < instantMaxValue) && (minAmountValue < paidInstantMaxValue)) {
            // console.log("8 fffff");
            setStandardAmountCheck(true);
            setInstantAmountCheck(true);
            setStdAndInstantCheck(true);
            setPaidInstantAmountCheck(true);
            setInstantSelected(false);
            setStandardSelected(true);
            setPaidInstantSelected(false);
            stdSelected = true;
            instSelected = false;
            paidInstSelected = false;
          }


        }

        //Actual logic starts//
        // paidInstantConfigData.paidInstantFlag

        // console.log("paid undha ledha >>>>>>", response.data.standardRedeemFlag, response.data.instantRedeemFlag, response.data.paidInstantEnableFlag);

        // if (response.data.standardRedeemFlag && response.data.instantRedeemFlag && showPaidRedeems) {
        if (response.data.standardRedeemFlag && response.data.instantRedeemFlag && response.data.paidInstantEnableFlag) {//response.data.paidInstantRedeemFlag

          // console.log("11 fffffff fghfghtrhh >>>>>>>>>>>>>>>>>>>>>>11111")/
          setInstantSelected(false);
          setStandardSelected(true);
          setPaidInstantSelected(false);
          stdSelected = true;
          instSelected = false;
          paidInstSelected = false;


          if (response.data.nextStandardRedeemAvailability !== "N" && response.data.nextInstantRedeemAvailability !== "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability === "N") {
            // console.log("step 1 t hgchfghgvhgvhgv")
            setInstantSelected(false);
            setStandardSelected(false);
            setPaidInstantSelected(true);
            setInstantIsInCoolOff(true);
            setStandardIsInCoolOff(true);
            setPaidInstantIsInCoolOff(false);
            stdSelected = false;
            instSelected = false;
            paidInstSelected = true;
          } else if ((response.data.nextStandardRedeemAvailability !== "N" && response.data.nextInstantRedeemAvailability === "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability !== "N")) {
            // console.log("step 1 1 t hgchfghgvhgvhgv")
            setInstantSelected(true);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = true;
            paidInstSelected = false;
            setInstantIsInCoolOff(false);
            setStandardIsInCoolOff(true);
            setPaidInstantIsInCoolOff(true)
          }
          else if ((response.data.nextStandardRedeemAvailability !== "N" && response.data.nextInstantRedeemAvailability === "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability === "N")) {
            // console.log("step 1 2 3 3 t hgchfghgvhgvhgv")
            setInstantSelected(true);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = true;
            paidInstSelected = false;
            setInstantIsInCoolOff(false);
            setStandardIsInCoolOff(true);
            setPaidInstantIsInCoolOff(false)
          }

          else if ((response.data.nextStandardRedeemAvailability === "N" && response.data.nextInstantRedeemAvailability === "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability === "N")) {
            // console.log("step 1 23456 t hgchfghgvhgvhgv")
            setInstantSelected(false);
            setStandardSelected(true);
            setPaidInstantSelected(false);
            stdSelected = true;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(false);
            setStandardIsInCoolOff(false);
            setPaidInstantIsInCoolOff(false);
          }
          else if ((response.data.nextStandardRedeemAvailability === "N" && response.data.nextInstantRedeemAvailability !== "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability !== "N")) {
            // console.log("step 1 2345667 >>>>>>>> t hgchfghgvhgvhgv")
            setInstantSelected(false);
            setStandardSelected(true);
            setPaidInstantSelected(false);
            stdSelected = true;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(true);
            setStandardIsInCoolOff(false);
            setPaidInstantIsInCoolOff(true);
          }

          else if ((response.data.nextStandardRedeemAvailability === "N" && response.data.nextInstantRedeemAvailability !== "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability === "N")) {
            // console.log("step 1 erttyuyuiuyi t hgchfghgvhgvhgv")
            setInstantSelected(false);
            setStandardSelected(true);
            setPaidInstantSelected(false);
            stdSelected = true;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(true);
            setStandardIsInCoolOff(false);
            setPaidInstantIsInCoolOff(false);
          }

          else if ((response.data.nextStandardRedeemAvailability === "N" && response.data.nextInstantRedeemAvailability === "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability !== "N")) {

            // console.log("step 1 neee xxxxxxxxxxxxxxxxxx t hgchfghgvhgvhgv")
            setInstantSelected(false);
            setStandardSelected(true);
            setPaidInstantSelected(false);
            stdSelected = true;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(false);
            setStandardIsInCoolOff(false);
            setPaidInstantIsInCoolOff(true);
          }


          else if (response.data.nextStandardRedeemAvailability !== "N" && response.data.nextInstantRedeemAvailability !== "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability !== "N") {
            // console.log("step 1 ktgkjgfkfgkfgbjfjmfgjfgjnfgjngf t hgchfghgvhgvhgv")
            setInstantSelected(false);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(true);
            setStandardIsInCoolOff(true);
            setPaidInstantIsInCoolOff(true)
          }




        } else if (!response.data.standardRedeemFlag && response.data.instantRedeemFlag && response.data.paidInstantEnableFlag) {
          setInstantSelected(true);
          setStandardSelected(false);
          setPaidInstantSelected(false);
          stdSelected = false;
          instSelected = true;
          paidInstSelected = false
          // console.log("bkjhkjdjkndfkjngkjndglkdg step 2 t hgchfghgvhgvhgv");

          if (response.data.nextInstantRedeemAvailability === "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability === "N") {
            setInstantSelected(true);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = true;
            paidInstSelected = false;
            setInstantIsInCoolOff(false)
            setStandardIsInCoolOff(false)
            setPaidInstantIsInCoolOff(false)
          } else if (response.data.nextInstantRedeemAvailability !== "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability === "N") {
            setInstantSelected(false);
            setStandardSelected(false);
            setPaidInstantSelected(true);
            stdSelected = false;
            instSelected = false;
            paidInstSelected = true;
            setInstantIsInCoolOff(true)
            setStandardIsInCoolOff(false)
            setPaidInstantIsInCoolOff(false)
          } else if (response.data.nextInstantRedeemAvailability !== "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability !== "N") {
            setInstantSelected(false);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(true)
            setStandardIsInCoolOff(false)
            setPaidInstantIsInCoolOff(true)

          } else if (response.data.nextInstantRedeemAvailability === "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability !== "N") {
            setInstantSelected(true);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = true;
            paidInstSelected = false;
            setInstantIsInCoolOff(false)
            setStandardIsInCoolOff(false)
            setPaidInstantIsInCoolOff(true)
          }



        } else if (!response.data.standardRedeemFlag && !response.data.instantRedeemFlag && response.data.paidInstantEnableFlag) {
          // console.log("Devudaaaaa t hgchfghgvhgvhgv");
          setInstantSelected(false);
          setStandardSelected(false);
          setPaidInstantSelected(true);
          stdSelected = false;
          instSelected = false;
          paidInstSelected = true;

          if (response.data.paidInstantConfigData.nextpaidInstantAvailability === "N") {
            setInstantSelected(false);
            setStandardSelected(false);
            setPaidInstantSelected(true);
            stdSelected = false;
            instSelected = false;
            paidInstSelected = true;
            setInstantIsInCoolOff(false)
            setStandardIsInCoolOff(false)
            setPaidInstantIsInCoolOff(false)
          } else if (response.data.paidInstantConfigData.nextpaidInstantAvailability !== "N") {
            setInstantSelected(false);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(false)
            setStandardIsInCoolOff(false)
            setPaidInstantIsInCoolOff(true)
          }

          if (!response.data.paidInstantConfigData.paidInstantFlag) {
            setInstantSelected(false);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(false)
            setStandardIsInCoolOff(false)
            setPaidInstantIsInCoolOff(false)
            // console.log("donga >>> 1")
            setPaidInstantExhausted(true)
          }

          if (response.data.monthlyStandard <= 0) {
            setStandardExhausted(true)
          } if (response.data.monthlyInstant <= 0) {
            setInstantExhausted(true)
          } if (response.data.redeemCountersType.toLowerCase() === "monthly" && response.data.monthlyPaidInstantRedeemLeft <= 0) {
            // console.log("donga 2 ");
            setPaidInstantExhausted(true)
          }


        } else if (!response.data.standardRedeemFlag && !response.data.instantRedeemFlag && !response.data.paidInstantEnableFlag) {
          setInstantSelected(false);
          setStandardSelected(false);
          setPaidInstantSelected(false);
          stdSelected = false;
          instSelected = false;
          paidInstSelected = false;
          // console.log("t hgchfghgvhgvhgv llllllll")
          setMonthlyStandardExhausted(true);
          setMonthlyExhausted(true);
          setInstantIsInCoolOff(false);
          setStandardIsInCoolOff(false);
          setPaidInstantIsInCoolOff(false);
          setStandardExhausted(true);
          setInstantExhausted(true);
          paidInstantExhausted(true)

        } else if (response.data.standardRedeemFlag && response.data.instantRedeemFlag && !response.data.paidInstantEnableFlag) {
          // console.log("11 fffffff fdrerrefterrerfter refergertretet t hgchfghgvhgvhgv")
          setInstantSelected(false);
          setStandardSelected(true);
          setPaidInstantSelected(false);
          stdSelected = true;
          instSelected = false;
          paidInstSelected = false;

          // if (Number(response.data.monthlyStandard) > 0 && Number(response.data.monthlyInstant) > 0 ) {

          if (response.data.nextStandardRedeemAvailability !== "N" && response.data.nextInstantRedeemAvailability !== "N") {
            setInstantSelected(false);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(true)
            setStandardIsInCoolOff(true)
            setPaidInstantIsInCoolOff(false)
          }
          else if (response.data.nextStandardRedeemAvailability !== "N" && response.data.nextInstantRedeemAvailability === "N") {
            setInstantSelected(true);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = true;
            paidInstSelected = false;
            setInstantIsInCoolOff(false)
            setStandardIsInCoolOff(true)
            setPaidInstantIsInCoolOff(false)

          }

          else if (response.data.nextStandardRedeemAvailability === "N" && response.data.nextInstantRedeemAvailability !== "N") {
            setInstantSelected(false);
            setStandardSelected(true);
            setPaidInstantSelected(false);
            stdSelected = true;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(true)
            setStandardIsInCoolOff(false)
            setPaidInstantIsInCoolOff(false)
          }

          else if (response.data.nextStandardRedeemAvailability === "N" && response.data.nextInstantRedeemAvailability === "N") {
            setInstantSelected(false);
            setStandardSelected(true);
            setPaidInstantSelected(false);
            stdSelected = true;
            instSelected = false;
            paidInstSelected = false;

            // setMonthlyStandardExhausted(true);
            // setMonthlyExhausted(true);
            setInstantIsInCoolOff(false)
            setStandardIsInCoolOff(false)
            setPaidInstantIsInCoolOff(false)
          }

          // }



        } else if (response.data.standardRedeemFlag && !response.data.instantRedeemFlag && !response.data.paidInstantEnableFlag) {
          setInstantSelected(false);
          setStandardSelected(true);
          setPaidInstantSelected(false);
          stdSelected = true;
          instSelected = false;
          paidInstSelected = false;

          // console.log("t hgchfghgvhgvhgv klklklklkl")
          if (response.data.nextStandardRedeemAvailability !== "N") {
            setInstantSelected(false);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(false)
            setStandardIsInCoolOff(true)
            setPaidInstantIsInCoolOff(false)
          } else if (response.data.nextStandardRedeemAvailability === "N") {
            setInstantSelected(false);
            setStandardSelected(true);
            setPaidInstantSelected(false);
            stdSelected = true;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(false)
            setStandardIsInCoolOff(false)
            setPaidInstantIsInCoolOff(false)
          }




        } else if (response.data.standardRedeemFlag && !response.data.instantRedeemFlag && response.data.paidInstantEnableFlag) {
          setInstantSelected(false);
          setStandardSelected(true);
          setPaidInstantSelected(false);
          stdSelected = true;
          instSelected = false;
          paidInstSelected = false;
          // console.log("t hgchfghgvhgvhgv paydi >>>> KKKKKKKKKKKKKKK", response.data.nextStandardRedeemAvailability, response.data.paidInstantConfigData.nextpaidInstantAvailability)

          if (response.data.nextStandardRedeemAvailability === "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability === "N") {
            setInstantSelected(false);
            setStandardSelected(true);
            setPaidInstantSelected(false);
            stdSelected = true;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(false)
            setStandardIsInCoolOff(false)
            setPaidInstantIsInCoolOff(false)
          } else if (response.data.nextStandardRedeemAvailability !== "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability === "N") {
            setInstantSelected(false);
            setStandardSelected(false);
            setPaidInstantSelected(true);
            stdSelected = false;
            instSelected = false;
            paidInstSelected = true;
            setInstantIsInCoolOff(false);
            setStandardIsInCoolOff(true);
            setPaidInstantIsInCoolOff(false);

          } else if (response.data.nextStandardRedeemAvailability !== "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability !== "N") {
            setInstantSelected(false);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(false)
            setStandardIsInCoolOff(true)
            setPaidInstantIsInCoolOff(true)

          } else if (response.data.nextStandardRedeemAvailability === "N" && response.data.paidInstantConfigData.nextpaidInstantAvailability !== "N") {
            setInstantSelected(false);
            setStandardSelected(true);
            setPaidInstantSelected(false);
            stdSelected = true;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(false)
            setStandardIsInCoolOff(false)
            setPaidInstantIsInCoolOff(true);
          }


          //Finally issue is here

        } else if (!response.data.standardRedeemFlag && response.data.instantRedeemFlag && !response.data.paidInstantEnableFlag) {
          setInstantSelected(true);
          setStandardSelected(false);
          setPaidInstantSelected(false);
          stdSelected = false;
          instSelected = true;
          paidInstSelected = false

          // console.log("t hgchfghgvhgvhgv ooooooooo");

          if (response.data.nextInstantRedeemAvailability !== "N") {
            setInstantSelected(false);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = false;
            paidInstSelected = false;
            setInstantIsInCoolOff(true)
            setStandardIsInCoolOff(false)
            setPaidInstantIsInCoolOff(false)
          } else if (response.data.nextInstantRedeemAvailability === "N") {
            setInstantSelected(true);
            setStandardSelected(false);
            setPaidInstantSelected(false);
            stdSelected = false;
            instSelected = true;
            paidInstSelected = false;
            setInstantIsInCoolOff(false)
            setStandardIsInCoolOff(false)
            setPaidInstantIsInCoolOff(false)
          }

        }

        if (Number(response.data.lifetimeInstantRedeemsLeft) > 0) {
          setInstantSelected(true);
          setStandardSelected(false);
          setPaidInstantSelected(false)
          stdSelected = false;
          instSelected = true;
          paidInstSelected = false
        }


        //redeemCountersType//|| response.data.monthlyPaidInstantRedeemLeft <= 0
        // console.log("Amma donga ", response.data.monthlyPaidInstantRedeemLeft);
        // console.log("response.data.paidInstantConfigData.paidInstantFlag", response.data.paidInstantConfigData.paidInstantFlag);
        if (response.data.monthlyStandard <= 0 || !response.data.standardRedeemFlag) {
          setStandardExhausted(true);
          setStandardSelected(false);
        } if (response.data.monthlyInstant <= 0 || !response.data.instantRedeemFlag) {
          // console.log("IYIYIY")
          setInstantExhausted(true)
          setInstantSelected(false)
        } if (!response.data.paidInstantConfigData.paidInstantFlag || (response.data.redeemCountersType.toLowerCase() === "monthly" && response.data.monthlyPaidInstantRedeemLeft)) {
          // console.log("donga >>>>");
          setPaidInstantExhausted(true);//Need to change
          // setPaidInstantExhausted(false);
          setPaidInstantSelected(false)
        }



        if (response.data.dailyStandardExhaustFlag && !response.data.dailyInstantExhaustFlag) {
          setInstantSelected(true);
          setStandardSelected(false)
        } else if (response.data.dailyInstantExhaustFlag && !response.data.dailyStandardExhaustFlag) {
          setInstantSelected(false);
          setStandardSelected(true)
        } else if (response.data.dailyStandardExhaustFlag && response.data.dailyInstantExhaustFlag) {
          setInstantSelected(false);
          setStandardSelected(false)
        }

        WebToNativeMessage({ "type": "trackTime", "pageName": "Redeem page" })


      }))
      .catch((e) => {
        console.log('error in getting redeem details', e)
        WebToNativeMessage({ "type": "trackTime", "pageName": "Redeem page error" })
      })
    // process.env.REACT_APP_NEW_BASE_URL + 'profile/get_profilev2?appType=react'
    axios.get(process.env.REACT_APP_NEW_BASE_URL + 'a23user/get_profilev2?appType=react', { headers: { 'Authorization': window.sessionStorage["token"] } })
      .then((response => {

        if (response?.data?.error?.statusCode === 1000) {
          WebToNativeMessage({ type: "closeClient", error: "got status code 1000", errorMessage: response.data.error.message, api: "get_profilev2" });
        }

        setProfileData(response.data)
        setPanEmailMandatoryConfig(response?.data?.panEmailMandatoryConfig)
        setEnablebonusReleasedLastXDays(response.data.enablebonusReleasedLastXDays)
        setBonusReleasedLastXDaysAmt(response.data.bonusReleasedLastXDaysAmt)
        // console.log(redeemData, 'profiledata sfsffdgdghfgh');
        console.log(profileData, " is profile data");
      }))
      .catch((e) => {
        console.log('error in getting profile details', e)
      })


    if (process.env.REACT_APP_ENVIRONMENT === "QA") {
      axios.post(process.env.REACT_APP_BASE_GP_URL + 'gamepass/getAll', { "type": "redeem" }, { headers: { 'Authorization': window.sessionStorage["token"] } })
        .then((response => {
          console.log(response.data.length, 'gamepassdetails')
          setRedeemGamePassData(response.data);
        }))
        .catch((e) => {
          console.log('error in getting game pass  details', e)
        })
    } else {
      axios.post(process.env.REACT_APP_BASE_ACE_POINT_URL + 'gamepass/getAll', { "type": "redeem" }, { headers: { 'Authorization': window.sessionStorage["token"] } })
        .then((response => {
          console.log(response.data.length, 'gamepassdetails')
          setRedeemGamePassData(response.data);
        }))
        .catch((e) => {
          console.log('error in getting game pass  details', e)
        })
    }

    fetchActiveMissions()
    fetchChallengesData();




    resetProps()



  }, [fetchRedeemDetails]);

  const checkTotalLockedBonusAmountFlag = () => {
    let flag = false;
    if (expiredLockedBonusData) {
      let bonusToBeExpired = Number(expiredLockedBonusData.bonusToBeExpired)
      bonusToBeExpired = isNaN(bonusToBeExpired) ? 0 : bonusToBeExpired
      if (bonusToBeExpired > 0) {
        flag = true
      }
    }
    return flag
  }
  // const IsIdNotVerified = EnableVerifyId();
  // useEffect(() => {setIsIdNotVerified(EnableVerifyId())},[IsIdNotVerified]);

  const createLockedBonusComponents = () => {
    if (expiredLockedBonusData) {
      return <LockedBonusCard data={expiredLockedBonusData} />
    }
  }

  const createChallengeCards = () => {
    // console.log(`Challenges Data >>> at create challenge Cards >> `, challengesData)
    let challengesContainer = <>
      {challengesData?.length > 0 ?
        challengesData.map((challenge, index) => {
          // console.log(`%c At Challenges Render >>> ITem >>> `, debugLogStyle, challenge)
          return (
            <ChallengeCard key={index + 'challenge'} challengeData={challenge} />
          )
        })
        : ''}

    </>

    return challengesContainer;
  }

  const fetchChallengesData = () => {

    let token = window.sessionStorage["token"];
    let configData = { headers: { Authorization: token } };

    let sampleResponse = {
      "challengeData": [{
        "challengeName": "201 pool challenge",
        "player": "6P",
        "entry": 10000,
        "challengeType": "3 day challenge",
        "duration": "15 Sep -17 Sep",
        "challengeDescription": "Win 3 games",
        "progressBarText": "2/3 games won",
        "gameWon": 1,
        "gameCount": 3,
        "winningAmount": "3000",

      }]
    }
    // console.log(`process.env.REACT_APP_CHALLENGE_EXPIRED_DATA >>> `, process.env.REACT_APP_CHALLENGE_EXPIRED_DATA)

    axios
      .post(process.env.REACT_APP_CHALLENGE_EXPIRED_DATA, {}, configData)
      .then((response) => {

        // console.log(`%c fetchvChallenges Data Response >>> `, apiLogResponseStyle, response);

        if (response?.data && response?.data !== "") {

          let responseData = JSON.parse(JSON.stringify(response.data));
          setChallengesData(responseData.challengeData)
          // setChallengesData(sampleResponse.challengeData)

          if (Number(responseData?.lockedBonusData?.bonusToBeExpired) > 0) {
            setExpiredLockedBonusData(responseData.lockedBonusData);
          }


          // console.log(`Came fetchvChallenges For Response >>> `, responseData)

        }


      })
      .catch((error) => {
        console.log(`Sample Response >>> `, sampleResponse.challengeData)
        // setChallengesData(sampleResponse.challengeData)
        console.error(`Error at Challenges API   `, error);

      });
  };



  const fetchActiveMissions = () => {

    console.log("active missions")
    let token = window.sessionStorage["token"];
    let channel = window.sessionStorage["channel"]

    let configData = { headers: { Authorization: token } };
    console.log("https://javapi.qapfgames.com/missions/activeMissions/APS/redeem", process.env.REACT_APP_ACTIVE_MISSIONS)
    axios
      .get(process.env.REACT_APP_ACTIVE_MISSIONS + '/' + channel + '/redeem', configData)
      .then((response) => {

        console.log(`%c Fetch Active Missions Response >>> `, apiLogResponseStyle, response);

        if (response?.data && response?.data !== "") {

          let responseData = JSON.parse(JSON.stringify(response.data));

          // responseData = staticActiveMissionsData
          // responseData = staticIndividualMissionsData;
          // responseData = issueBundle;
          // responseData = staticSingleMissionData;

          console.log(`Came For Response >>> `, responseData)
          if (responseData.activeMission?.length <= 0) {
            // console.log('no missions');
            // setShowNoMisisonsAvailablePage(true);
          } else {
            let isBundle = responseData.activeMission[0]?.isBundled?.toLowerCase() === 'y' ? true : false;
            // isBundle = false
            setIsBundledMission(isBundle);
            console.log(`
              IsBundle >>> 
              `, isBundle)
            if (isBundle) {
              if (responseData.activeMission[0].bundleTags.length <= 0) {
                // setShowNoMisisonsAvailablePage(true);
              } else {
                setActiveMissionsData(responseData);
                // missionData.activeMission[0]
              }
            } else {
              setActiveMissionsData(responseData);
              console.log(`
                Missions Indivudal >>> `,
                responseData)
            }


          }

        } else {
          // setShowNoMisisonsAvailablePage(true);
        }


      })
      .catch((error) => {
        console.error(`Error at Active Missions API  `, error);
        // setShowNoMisisonsAvailablePage(true);
      });
  };



  useEffect(() => {

    // console.log("paid champuthundi ????", standardSelected);
    if (profileData && redeemDetails) {

      let stdSelected;
      let instSelected;
      if ((!redeemDetails.standardRedeemFlag)) {

        stdSelected = false;
        instSelected = true;
      }





      if (Number(redeemDetails.monthlyInstant) <= 0) {

        stdSelected = true;
        instSelected = false;
      } else {

      }


      if (Number(redeemDetails.monthlyStandard) <= 0) {

        stdSelected = false;
        instSelected = true;
      } else {

      }




      if (Number(redeemDetails.monthlyInstant) <= 0 && Number(redeemDetails.monthlyStandard) <= 0) {

        stdSelected = false;
        instSelected = false;
      }


      if (Number(redeemDetails.lifetimeInstantRedeemsLeft) > 0) {

        stdSelected = false;
        instSelected = true;
      }

      if ((redeemDetails.nextInstantRedeemAvailability !== "N")) {


        stdSelected = false
        if (Number(monthlyStandard) > 0) {

          stdSelected = true;
          instSelected = false;
        }
        else if (Number(monthlyStandard) <= 0) {

          stdSelected = false;
          instSelected = false;
        }

      } else {
        // if(Number(response.data.monthlyStandard) > 0 && (response.data.nextStandardRedeemAvailability !== "N") ){
        //   setInstantSelected(false);
        //   setStandardSelected(false);
        // }
      }




      if ((redeemDetails.nextStandardRedeemAvailability !== "N")) {

        stdSelected = false
        // setInstantSelected(true);
        if (Number(redeemDetails.monthlyInstant) > 0) {

          stdSelected = false;
          instSelected = true;
        }
        else if (Number(redeemDetails.monthlyInstant) <= 0) {

          stdSelected = false;
          instSelected = false;
        }




      } else {



        // if(Number(response.data.monthlyInstant) > 0 && (response.data.nextInstantRedeemAvailability !== "N") ){
        //   setInstantSelected(false);
        //   setStandardSelected(false);
        // }


      }

      // console.log("nextInstantRedeemAvailability >>>>>>>>>",nextInstantRedeemAvailability);


      if (redeemDetails.monthlyStandard > 0 && (redeemDetails.nextInstantRedeemAvailability !== "N")) {

        stdSelected = true;
        instSelected = false;
      } else if (redeemDetails.monthlyInstant > 0 && (redeemDetails.nextStandardRedeemAvailability !== "N")) {

        stdSelected = false;
        instSelected = true;
      }
      else if (redeemDetails.monthlyStandard > 0 && (redeemDetails.nextStandardRedeemAvailability === "N")) {
        stdSelected = true;
        instSelected = false;
      } else if (redeemDetails.monthlyInstant > 0 && (redeemDetails.nextInstantRedeemAvailability === "N")) {
        stdSelected = false;
        instSelected = true;
      } else if (redeemDetails.lifetimeInstantRedeemsLeft > 0 && redeemDetails.nextInstantRedeemAvailability === "N") {

        stdSelected = false;
        instSelected = true;
        // setMonthlyExhausted(false);

      }

      if (redeemDetails.monthlyStandard > 0 && !instantAvailabilityFlag) {

        stdSelected = true;
        instSelected = false;
      }

      //Need to check this

      // else if(response.data.monthlyStandard <= 0 && !instantAvailabilityFlag){
      //   setStandardSelected(false);
      //   setInstantSelected(false);
      // }


      // if(response.data.monthlyInstant > 0 && (response.data.nextInstantRedeemAvailability !== "N") &&  response.data.monthlyStandard > 0 && (response.data.nextStandardRedeemAvailability !== "N") ){

      // }




      if (redeemDetails.monthlyStandard <= 0 && (redeemDetails.nextInstantRedeemAvailability !== "N") || (redeemDetails.monthlyInstant <= 0 && (redeemDetails.nextStandardRedeemAvailability !== "N"))) {


        stdSelected = false;
        instSelected = false;
      }


      // if ((response.data.nextStandardRedeemAvailability !== "N") && (response.data.nextInstantRedeemAvailability !== "N")) {
      //   setInstantSelected(false);
      //   setStandardSelected(false);
      // }


      if (!instantAvailabilityFlag) {
        instSelected = false
      }


      if (redeemDetails.monthlyInstant <= 0 && redeemDetails.lifetimeInstantRedeemsLeft > 0 && redeemDetails.nextInstantRedeemAvailability === "N") {
        stdSelected = false;
        instSelected = true;
        // setMonthlyExhausted(false);

      } else if (redeemDetails.monthlyInstant <= 0 && redeemDetails.lifetimeInstantRedeemsLeft > 0 && redeemDetails.nextStandardRedeemAvailability !== "N") {
        stdSelected = true;
        instSelected = false;
      }

      if (redeemDetails.nextStandardRedeemAvailability !== "N" && redeemDetails.nextInstantRedeemAvailability !== "N") {
        stdSelected = false;
        instSelected = false;
      }

      else if (redeemDetails.nextStandardRedeemAvailability !== "N" && redeemDetails.monthlyInstant <= 0) {
        stdSelected = false;
        instSelected = false;
      }
      else if (redeemDetails.nextInstantRedeemAvailability !== "N" && redeemDetails.monthlyStandard <= 0) {
        stdSelected = false;
        instSelected = false;
      }




      let minAmountValue = redeemDetails.walletMinAmount ? redeemDetails.walletMinAmount : redeemDetails.minAmount;
      let instantMaxValue = Math.min(Number(redeemDetails.maxAmountInstant), Number(redeemDetails.redeemableAmount));
      let standardMaxValue = Math.min(Number(redeemDetails.maxAmountStandard), Number(redeemDetails.redeemableAmount));


      if ((minAmountValue > instantMaxValue) && (minAmountValue > standardMaxValue)) {

        stdSelected = false;
        instSelected = false;
      } else if ((minAmountValue < instantMaxValue) && (minAmountValue > standardMaxValue)) {

        stdSelected = false;
        instSelected = true;
        if (redeemDetails.nextInstantRedeemAvailability !== "N" || redeemDetails.monthlyInstant <= 0) {

          stdSelected = false;
          instSelected = false;
        }
      }
      else if ((minAmountValue < standardMaxValue) && (minAmountValue > instantMaxValue)) {

        stdSelected = true;
        instSelected = false;
        if (redeemDetails.nextStandardRedeemAvailability !== "N" || redeemDetails.monthlyStandard <= 0) {
          stdSelected = false;
          instSelected = false;
        }
      }
      else if ((minAmountValue < instantMaxValue) && (minAmountValue < standardMaxValue)) {
        console.log("dum 89 fgnghjhgjgh");

        if ((redeemDetails.nextInstantRedeemAvailability !== "N")) {
          console.log("dum 89 fhfghfg");
          // stdSelected = false
          instSelected = false

        }

        else if ((redeemDetails.nextStandardRedeemAvailability !== "N")) {
          stdSelected = false
          // setInstantSelected(true);
        }

        else if ((redeemDetails.nextInstantRedeemAvailability !== "N") && (redeemDetails.nextStandardRedeemAvailability !== "N")) {
          stdSelected = false
          instSelected = false
        }

        else if (!profileData.emailVerified ||
          !EnableVerifyId()) {
          stdSelected = false
          instSelected = false
        }

      }


      // if (response.data.paidInstantConfigData) {
      //   setShowPaidRedeems(response.data.paidInstantConfigData.paidInstantFlag); // replace with the response//paid
      //   setPaidInstantLimitAmount(response.data.paidInstantConfigData.paidInstantMaxAmount);// replace with the response
      //   setPaidRedeemLimit(response.data.redeemCountersType.toLowerCase() === "monthly" ? response.data.paidInstantConfigData.monthlyPaidInstantLeft : response.data.paidInstantConfigData.dailyPaidInstantLeft);// replace with the response
      //   setNextPaidInstantRedeemAvailability(response.data.paidInstantConfigData.nextpaidInstantAvailability); // N / Time// replace with the response//paidInstantRedeemProcessingFee//paidInstantRedeemProcessingFee//nextpaidInstantAvailability
      //   setPaidInstantRedeemProcessingFee(response.data.paidInstantConfigData.paidInstantProcessingFee);
      //   setPaidInstantMessage(response.data.paidInstantConfigData.paidInstantMessage);
      //   // console.log("dgdgdfgdfdfhfghfd neeee", response.data.paidinstantEnableFlag);
      //   // setPaidInstantRedeemEnableFlag(response.data.paidinstantEnableFlag);
      //   console.log("dgdgdfgdfdfhfghfd neeee", response.data.paidInstantEnableFlag);
      //   setPaidInstantRedeemEnableFlag(response.data.paidInstantEnableFlag);
      //   setRedeemOrder(response.data.redeemOrder);
      // }
      // //NEw requirement
      // console.log("response.data.instantEnableFlag >>>>>>", response.data.instantEnableFlag);
      // setStandardEnableFlag(response.data.standardEnableFlag);
      // setInstantEnableFlag(response.data.instantEnableFlag);

      // console.log("hbjfghfgfgcfgfgdfgfgfgfgx 123456 xxxxxxxxxxx", smartRedeemEnabled);
      // console.log("hbjfghfgfgcfgfgdfgfgfgfgx 1223455", paidInstantRedeemProcessingFee);
      let eventProperties = {
        acelevel: window.sessionStorage["aceLevel"],
        channel: window.sessionStorage["channel"],
        subscriptionType: window.sessionStorage["subscriptionType"],
        username: window.sessionStorage["screenName"],
        wallet_balance: window.sessionStorage["totalBalance"],
        Redeemable_amount: redeemDetails.redeemableAmount,
        default_type: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan",//standardSelected && !instantLimitAmount ? "standard" : instantSelected && !standardSelected ? "instant" : !instantSelected && !standardSelected ? "both" : "nan",

        Locked_type:
          redeemDetails.nextInstantRedeemAvailability !== "N" && redeemDetails.nextStandardRedeemAvailability !== "N" ? "both"
            : redeemDetails.nextStandardRedeemAvailability !== "N" && redeemDetails.nextInstantRedeemAvailability === "N" ? "standard"
              : redeemDetails.nextInstantRedeemAvailability !== "N" && redeemDetails.nextStandardRedeemAvailability === "N" ? "instant"
                : redeemDetails.nextInstantRedeemAvailability === "N" && redeemDetails.nextStandardRedeemAvailability === "N" ? "nan" : "nan",

        standardIsInCoolOff: standardIsInCoolOff,
        instantIsInCoolOff: instantIsInCoolOff,
        paidInstantIsInCoolOff: paidInstantIsInCoolOff,
        standardExhausted: standardExhausted,
        instantExhausted: instantExhausted,
        paidInstantExhausted: paidInstantExhausted,
        standardEnableFlag: standardEnableFlag,
        instantEnableFlag: instantEnableFlag,
        paidInstantRedeemEnableFlag: paidInstantRedeemEnableFlag,




        monthly_exhausted_type: (redeemDetails.monthlyStandard === 0 && redeemDetails.monthlyInstant > 0) ? "standard" : (redeemDetails.monthlyInstant === 0 && redeemDetails.monthlyStandard > 0) ? "instant" : (redeemDetails?.monthlyInstant === 0 && redeemDetails?.monthlyStandard === 0) ? "both" : "nan",
        standard_monthly_count: redeemDetails.monthlyStandard,
        instant_monthly_count: redeemDetails.monthlyInstant,
        paid_monthly_count: paidRedeemLimit,
        Lifetime_instant_redeem: redeemDetails.lifetimeInstantRedeemsLeft > 0 ? "Yes" : "No",
        Standard_amt_Limit: redeemDetails.maxAmountStandard,
        instant_not_available_player_check: redeemDetails.instantAvailabilityFlag ? "No" : "Yes",
        Instand_amt_Limit: redeemDetails.maxAmountInstant,
        emailVerified: profileData.emailVerified,
        panVerified: profileData.panApproved,
        redeemOrder: redeemOrder ? redeemOrder.toString() : "standard,Instant",
        paidInstantProcessingFee: paidInstantRedeemProcessingFee,
        isSmartRedeemEnabled: smartRedeemEnabled,
        redeemTypeForSmartRedeem: smartRedeemForInstantOrStandard,
        smartUI: smartRedeemNewUIFlag ? "New" : "Old",
        TDSCashbackAmount: (Number(tdsCashbackAmount) > Number(tdsMaxCapAmount)) ? tdsMaxCapAmount : tdsCashbackAmount,
        redeemableBalanceEligibilty: redeemDetails?.minAmount > redeemDetails.redeemableAmount ? "Yes" : "No",
        redeemableBalanceConfigValue: redeemDetails?.minAmount ? redeemDetails?.minAmount : 0,
      }
      WebToNativeMessage({
        type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_PageLoad", eventProperties: eventProperties
      })
      WebToNativeMessage({
        type: "mixpanelEvent", eventName: "PF_c_RedeemPlacement_PageLoad", eventProperties: eventProperties
      })
      WebToNativeMessage({
        type: "rstsData", rstsData: {
          eventData:
          {
            acelevel: window.sessionStorage["aceLevel"],
            channel: window.sessionStorage["channel"],
            subscription_type: window.sessionStorage["subscriptionType"],
            // username: window.sessionStorage["screenName"],
            player_id: window.sessionStorage["screenName"],
            wallet_balance: window.sessionStorage["totalBalance"],
            redeemable_amount: redeemDetails.redeemableAmount,
            TDSCashbackAmount: Number(tdsCashbackAmount) > 0 ? ((Number(tdsCashbackAmount) > Number(tdsMaxCapAmount)) ? tdsMaxCapAmount : tdsCashbackAmount) : 0,
            redeemableBalanceEligibilty: redeemDetails?.minAmount > redeemDetails.redeemableAmount ? "Yes" : "No",
            redeemableBalanceConfigValue: redeemDetails?.minAmount ? redeemDetails?.minAmount : 0,
          },
          isevent: "yes",
          tableName: "pf_c_redeemplacement_pageload"
        }
      })
      //   type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_PageLoad", eventProperties: {
      //     acelevel: window.sessionStorage["aceLevel"],
      //     channel: window.sessionStorage["channel"],
      //     subscriptionType: window.sessionStorage["subscriptionType"],
      //     username: window.sessionStorage["screenName"],
      //     wallet_balance: window.sessionStorage["totalBalance"],
      //     Redeemable_amount: redeemDetails.redeemableAmount,
      //     default_type: stdSelected ? "standard" : instSelected ? "instant" : "nan",//standardSelected && !instantLimitAmount ? "standard" : instantSelected && !standardSelected ? "instant" : !instantSelected && !standardSelected ? "both" : "nan",
      //     Locked_type:
      //       redeemDetails.nextInstantRedeemAvailability !== "N" && redeemDetails.nextStandardRedeemAvailability !== "N" ? "both"
      //         : redeemDetails.nextStandardRedeemAvailability !== "N" && redeemDetails.nextInstantRedeemAvailability === "N" ? "standard"
      //           : redeemDetails.nextInstantRedeemAvailability !== "N" && redeemDetails.nextStandardRedeemAvailability === "N" ? "instant"
      //             : redeemDetails.nextInstantRedeemAvailability === "N" && redeemDetails.nextStandardRedeemAvailability === "N" ? "nan" : "nan",
      //     monthly_exhausted_type: (redeemDetails.monthlyStandard === 0 && redeemDetails.monthlyInstant > 0) ? "standard" : (redeemDetails.monthlyInstant === 0 && redeemDetails.monthlyStandard > 0) ? "instant" : (redeemDetails?.monthlyInstant === 0 && redeemDetails?.monthlyStandard === 0) ? "both" : "nan",
      //     standard_monthly_count: redeemDetails.monthlyStandard,
      //     instant_monthly_count: redeemDetails.monthlyInstant,
      //     paid_monthly_count:redeemDetails,
      //     Lifetime_instant_redeem: redeemDetails.lifetimeInstantRedeemsLeft > 0 ? "Yes" : "No",
      //     Standard_amt_Limit: redeemDetails.maxAmountStandard,
      //     instant_not_available_player_check: redeemDetails.instantAvailabilityFlag ? "No" : "Yes",
      //     Instand_amt_Limit: redeemDetails.maxAmountInstant,
      //     emailVerified: profileData.emailVerified,
      //     panVerified: profileData.panApproved
      //   }
      // })

    }

    // return () => {
    //   setRedeemDetails(undefined)
    //   setProfileData(undefined)
    // }
    // EnableVerifyId();

  }, [profileData, redeemDetails])


  useEffect(() => {
    // console.log("What is amount entered ", lifetimeInstantRedeemsLeft);

    calculateTDS(amountEntered);
    handleValidation();
    setErrorMessage();


    if (Number(amountEntered) > Number(autoApprovalLimit)) {
      // setShowInstantErrorToolTip(true);
      // setLimitExceededErrorMessage(true)
      setInstantSelected(false);
      setStandardSelected(true);
    } else if (Number(amountEntered) < Number(autoApprovalLimit)) {
      // setShowInstantErrorToolTip(false);
      // setLimitExceededErrorMessage(false)

    }


    // setRecommendationSelection(amountEntered)
  }, [amountEntered, selectedWithdrawtype])



  useEffect(() => {
    if (showRedeemMethodError !== undefined) {
      const timer = setTimeout(() => {
        setShowRedeemMethodError(undefined);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [showRedeemMethodError])

  useEffect(() => {
    if (toastMessage !== undefined) {
      const timer = setTimeout(() => {
        setToastMessage(undefined);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [toastMessage])

  useEffect(() => {
    console.log(redeemDetails?.allRedeemOptions.findIndex((o) => (o.accountNumber === addBankInfo.accountNumber || o.accountNumber === addBankInfo.reAccountNumber)), 'ssssss')
    let accountExist = redeemDetails?.allRedeemOptions.findIndex((o) => (o.accountNumber === addBankInfo.accountNumber || o.accountNumber === addBankInfo.reAccountNumber))
    if (accountExist !== -1 && accountExist !== undefined) {
      setAddBankAccountError('Bank Account Number already exists in system. Please enter a different Bank Account Number.')
    }
    if (addBankInfo.ifscCode.length < 11) {
      setIsIfscVerified(false)
    }
    else if (addBankInfo.ifscCode.length > 10 && isIfscVerified === false) {
      verifyIfscCode()
    }
  }, [addBankInfo])


  useEffect(() => {
    if (profileData && redeemDetails) {

      let stdSelected;
      let instSelected;
      if ((!redeemDetails.standardRedeemFlag)) {

        stdSelected = false;
        instSelected = true;
      }





      if (Number(redeemDetails.monthlyInstant) <= 0) {

        stdSelected = true;
        instSelected = false;
      } else {

      }


      if (Number(redeemDetails.monthlyStandard) <= 0) {

        stdSelected = false;
        instSelected = true;
      } else {

      }




      if (Number(redeemDetails.monthlyInstant) <= 0 && Number(redeemDetails.monthlyStandard) <= 0) {

        stdSelected = false;
        instSelected = false;
      }


      if (Number(redeemDetails.lifetimeInstantRedeemsLeft) > 0) {

        stdSelected = false;
        instSelected = true;
      }

      if ((redeemDetails.nextInstantRedeemAvailability !== "N")) {


        stdSelected = false
        if (Number(monthlyStandard) > 0) {

          stdSelected = true;
          instSelected = false;
        }
        else if (Number(monthlyStandard) <= 0) {

          stdSelected = false;
          instSelected = false;
        }

      } else {
        // if(Number(response.data.monthlyStandard) > 0 && (response.data.nextStandardRedeemAvailability !== "N") ){
        //   setInstantSelected(false);
        //   setStandardSelected(false);
        // }
      }




      if ((redeemDetails.nextStandardRedeemAvailability !== "N")) {

        stdSelected = false
        // setInstantSelected(true);
        if (Number(redeemDetails.monthlyInstant) > 0) {

          stdSelected = false;
          instSelected = true;
        }
        else if (Number(redeemDetails.monthlyInstant) <= 0) {

          stdSelected = false;
          instSelected = false;
        }




      } else {



        // if(Number(response.data.monthlyInstant) > 0 && (response.data.nextInstantRedeemAvailability !== "N") ){
        //   setInstantSelected(false);
        //   setStandardSelected(false);
        // }


      }

      // console.log("nextInstantRedeemAvailability >>>>>>>>>",nextInstantRedeemAvailability);


      if (redeemDetails.monthlyStandard > 0 && (redeemDetails.nextInstantRedeemAvailability !== "N")) {

        stdSelected = true;
        instSelected = false;
      } else if (redeemDetails.monthlyInstant > 0 && (redeemDetails.nextStandardRedeemAvailability !== "N")) {

        stdSelected = false;
        instSelected = true;
      }
      else if (redeemDetails.monthlyStandard > 0 && (redeemDetails.nextStandardRedeemAvailability === "N")) {
        stdSelected = true;
        instSelected = false;
      } else if (redeemDetails.monthlyInstant > 0 && (redeemDetails.nextInstantRedeemAvailability === "N")) {
        stdSelected = false;
        instSelected = true;
      } else if (redeemDetails.lifetimeInstantRedeemsLeft > 0 && redeemDetails.nextInstantRedeemAvailability === "N") {

        stdSelected = false;
        instSelected = true;
        // setMonthlyExhausted(false);

      }

      if (redeemDetails.monthlyStandard > 0 && !instantAvailabilityFlag) {

        stdSelected = true;
        instSelected = false;
      }

      //Need to check this

      // else if(response.data.monthlyStandard <= 0 && !instantAvailabilityFlag){
      //   setStandardSelected(false);
      //   setInstantSelected(false);
      // }


      // if(response.data.monthlyInstant > 0 && (response.data.nextInstantRedeemAvailability !== "N") &&  response.data.monthlyStandard > 0 && (response.data.nextStandardRedeemAvailability !== "N") ){

      // }




      if (redeemDetails.monthlyStandard <= 0 && (redeemDetails.nextInstantRedeemAvailability !== "N") || (redeemDetails.monthlyInstant <= 0 && (redeemDetails.nextStandardRedeemAvailability !== "N"))) {


        stdSelected = false;
        instSelected = false;
      }


      // if ((response.data.nextStandardRedeemAvailability !== "N") && (response.data.nextInstantRedeemAvailability !== "N")) {
      //   setInstantSelected(false);
      //   setStandardSelected(false);
      // }


      if (!instantAvailabilityFlag) {
        instSelected = false
      }


      if (redeemDetails.monthlyInstant <= 0 && redeemDetails.lifetimeInstantRedeemsLeft > 0 && redeemDetails.nextInstantRedeemAvailability === "N") {
        stdSelected = false;
        instSelected = true;
        // setMonthlyExhausted(false);

      } else if (redeemDetails.monthlyInstant <= 0 && redeemDetails.lifetimeInstantRedeemsLeft > 0 && redeemDetails.nextStandardRedeemAvailability !== "N") {
        stdSelected = true;
        instSelected = false;
      }

      if (redeemDetails.nextStandardRedeemAvailability !== "N" && redeemDetails.nextInstantRedeemAvailability !== "N") {
        stdSelected = false;
        instSelected = false;
      }

      else if (redeemDetails.nextStandardRedeemAvailability !== "N" && redeemDetails.monthlyInstant <= 0) {
        stdSelected = false;
        instSelected = false;
      }
      else if (redeemDetails.nextInstantRedeemAvailability !== "N" && redeemDetails.monthlyStandard <= 0) {
        stdSelected = false;
        instSelected = false;
      }




      let minAmountValue = redeemDetails.walletMinAmount ? redeemDetails.walletMinAmount : redeemDetails.minAmount;
      let instantMaxValue = Math.min(Number(redeemDetails.maxAmountInstant), Number(redeemDetails.redeemableAmount));
      let standardMaxValue = Math.min(Number(redeemDetails.maxAmountStandard), Number(redeemDetails.redeemableAmount));


      if ((minAmountValue > instantMaxValue) && (minAmountValue > standardMaxValue)) {

        stdSelected = false;
        instSelected = false;
      } else if ((minAmountValue < instantMaxValue) && (minAmountValue > standardMaxValue)) {

        stdSelected = false;
        instSelected = true;
        if (redeemDetails.nextInstantRedeemAvailability !== "N" || redeemDetails.monthlyInstant <= 0) {

          stdSelected = false;
          instSelected = false;
        }
      }
      else if ((minAmountValue < standardMaxValue) && (minAmountValue > instantMaxValue)) {

        stdSelected = true;
        instSelected = false;
        if (redeemDetails.nextStandardRedeemAvailability !== "N" || redeemDetails.monthlyStandard <= 0) {
          stdSelected = false;
          instSelected = false;
        }
      }
      else if ((minAmountValue < instantMaxValue) && (minAmountValue < standardMaxValue)) {
        // console.log("dum 89 fgnghjhgjgh");

        if ((redeemDetails.nextInstantRedeemAvailability !== "N")) {
          // console.log("dum 89 fhfghfg");
          // stdSelected = false
          instSelected = false

        }

        else if ((redeemDetails.nextStandardRedeemAvailability !== "N")) {
          stdSelected = false
          // setInstantSelected(true);
        }

        else if ((redeemDetails.nextInstantRedeemAvailability !== "N") && (redeemDetails.nextStandardRedeemAvailability !== "N")) {
          stdSelected = false
          instSelected = false
        }

        else if (!profileData.emailVerified || !EnableVerifyId()) {
          stdSelected = false
          instSelected = false
        }

      }

      // console.log("hbjfghfgfgcfgfgdfgfgfgfgx  dgfthfgjgjfg xxxxxxxxxxxxx", smartRedeemEnabled);
      // console.log("hbjfghfgfgcfgfgdfgfgfgfgx 1223455", smartRedeemForInstantOrStandard);
      // let eventProperties = {
      //   acelevel: window.sessionStorage["aceLevel"],
      //   channel: window.sessionStorage["channel"],
      //   subscriptionType: window.sessionStorage["subscriptionType"],
      //   username: window.sessionStorage["screenName"],
      //   wallet_balance: window.sessionStorage["totalBalance"],
      //   Redeemable_amount: redeemDetails.redeemableAmount,
      //   default_type: stdSelected ? "standard" : instSelected ? "instant" : "nan",//standardSelected && !instantLimitAmount ? "standard" : instantSelected && !standardSelected ? "instant" : !instantSelected && !standardSelected ? "both" : "nan",
      //   Locked_type:
      //     redeemDetails.nextInstantRedeemAvailability !== "N" && redeemDetails.nextStandardRedeemAvailability !== "N" ? "both"
      //       : redeemDetails.nextStandardRedeemAvailability !== "N" && redeemDetails.nextInstantRedeemAvailability === "N" ? "standard"
      //         : redeemDetails.nextInstantRedeemAvailability !== "N" && redeemDetails.nextStandardRedeemAvailability === "N" ? "instant"
      //           : redeemDetails.nextInstantRedeemAvailability === "N" && redeemDetails.nextStandardRedeemAvailability === "N" ? "nan" : "nan",
      //   monthly_exhausted_type: (redeemDetails.monthlyStandard === 0 && redeemDetails.monthlyInstant > 0) ? "standard" : (redeemDetails.monthlyInstant === 0 && redeemDetails.monthlyStandard > 0) ? "instant" : (redeemDetails?.monthlyInstant === 0 && redeemDetails?.monthlyStandard === 0) ? "both" : "nan",
      //   standard_monthly_count: redeemDetails.monthlyStandard,
      //   instant_monthly_count: redeemDetails.monthlyInstant,
      //   Lifetime_instant_redeem: redeemDetails.lifetimeInstantRedeemsLeft > 0 ? "Yes" : "No",
      //   Standard_amt_Limit: redeemDetails.maxAmountStandard,
      //   instant_not_available_player_check: redeemDetails.instantAvailabilityFlag ? "No" : "Yes",
      //   Instand_amt_Limit: redeemDetails.maxAmountInstant,
      //   emailVerified: profileData.emailVerified,
      //   panVerified: profileData.panApproved,
      //   isSmartRedeemEnabled: smartRedeemEnabled,
      //   redeemTypeForSmartRedeem: smartRedeemForInstantOrStandard,
      // }
      // WebToNativeMessage({
      //   type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_PageLoad", eventProperties: eventProperties 
      // })
      // WebToNativeMessage({
      //   type: "mixpanelEvent", eventName: "PF_c_RedeemPlacement_PageLoad", eventProperties: eventProperties 
      // })

    }


  }, [profileData, redeemDetails])

  useEffect(() => {
    console.log("got redeemDetails", redeemDetails)
    if (redeemDetails !== undefined) {


      if (redeemDetails.allRedeemOptions?.length > 0) {
        let index = redeemDetails.allRedeemOptions?.findIndex((o) => o.default === true)
        if (index !== -1) {
          setSelectedRedeemMethod(redeemDetails.allRedeemOptions[index])
          setActiveRedeemMethod(redeemDetails.allRedeemOptions[index])
        }
      }
      if (redeemDetails.allRedeemOptions?.length === 0) {
        setOpenAllRedeemOptions(false)
      }
      setRecommendationSelection(redeemDetails.tdsFreeAmount)

      {/** Update below state to enable redeem otp  */ }
      setEnableRedeemOTP(redeemDetails.enableOtpVerification)

      if (isKYCVerificationPage) {
        WebToNativeMessage(
          {
            type: "redeemCTEvent", eventName: "Pf_c_Tkyc_kycpageview", eventProperties: {
              acelevel: window.sessionStorage["aceLevel"],
              channel: window.sessionStorage["channel"],
              subscriptionType: window.sessionStorage["subscriptionType"],
              username: window.sessionStorage["screenName"],
              panverificationstatus: redeemDetails?.kycStatus === 'approved' ? 'completed' : redeemDetails?.kycStatus === 'processing' ? 'pending' : 'not uploaded',
              bankverificationstatus: redeemDetails?.allRedeemOptions?.findIndex((o) => o.upiState === 'approved' || o.bankStatus === 'approved' || o.name.toLowerCase() === 'amazonpay' || o.name.toLowerCase() === 'amazon pay' || o.name.toLowerCase() === 'paytmwallet' || o.name.toLowerCase() === 'paytm wallet') !== -1 ? 'completed' : redeemDetails?.allRedeemOptions?.findIndex((o) => o.upiState === 'processing' || o.bankStatus === 'processing') !== -1 ? 'pending' : 'not uploaded'
            }

          })
      }

      if (isKYCVerificationPage && !EnableVerifyId() && redeemDetails.allRedeemOptions.findIndex((o) => o.upiState === 'approved' || o.bankStatus === 'approved' || o.name.toLowerCase() === 'amazonpay' || o.name.toLowerCase() === 'amazon pay' || o.name.toLowerCase() === 'paytmwallet' || o.name.toLowerCase() === 'paytm wallet') !== -1) {
        WebToNativeMessage({ type: 'addBankSuccess' })
      }
    }
  }, [redeemDetails])


  const createTdsIframe = () => {
    let tdsIframe;
    tdsIframe = <div className="tdsIframeModel">
      <div className="tdsIframeModelBG" onClick={() => setShowIframe(false)}></div>
      <div className="tdsIframeContent">
        <div className="tdsIframeHeader">
          TDS
          <img className="tdsIframeClose" src={assets?.assets?.Cross} alt="close" onClick={() => setShowIframe(false)} />
        </div>
        <div className="tdsIframeCont">
          <iframe
            className="tdsIframeMain"
            title=""
            src={createOEMAdminPageURL(process.env.REACT_APP_REAL_STATIC_WEB_URL, process.env.REACT_APP_OEMWEB_BASE_URL, "tds.html?src=mapp&&header=N&t=" + Math.random(), isoemps)}
          ></iframe>
        </div>
      </div>
    </div>
    // <div className="tdsIframeModel" style={{ position: "absolute", width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    //   <div className='tdsIframeModelBG' style={{ position: 'absolute', width: '100%', height: '100%', background: "rgba(0,0,0,0.5)" }} onClick={() => setShowIframe(false)}></div>
    //   <div className='tdsIframeContent' style={{ display: "flex", flexDirection: 'column', position: "absolute", width: "95%", height: "75%", justifyContent: "center", alignItems: "center", overflow: "hidden", backgroundColor: 'white' }}>
    //     <div className='tdsIframeHeader' style={{ width: "100%", background: "#032146", color: "#FFFFFF", height: "7%", display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem', fontWeight: '700' }}>TDS
    //       <img className='tdsIframeClose' src={Cross} alt='close' style={{ position: "absolute", right: "5%" }} onClick={() => setShowIframe(false)} />
    //     </div>
    //     <div className='tdsIframeCont' style={{ width: '100%', height: '93%' }}>
    //       <iframe className='tdsIframeMain' style={{ paddingTop: "", marginTop: "", marginBottom: "", height: "100%", width: "100%", overflow: "scroll" }} height="100%" width="100%" title="" overflowy="scroll" src={process.env.REACT_APP_REAL_STATIC_WEB_URL + "tds.html?src=mapp&&header=N&t=" + Math.random()}>
    //       </iframe>
    //     </div>
    //   </div>

    // </div>






    return tdsIframe
  }

  const calculateProcessingFee = (value) => {
    // console.log("sdfsdfsdfsdfsdfdsv ty", paidInstantRedeemProcessingFee)
    let redeemAmtEntered = value;
    let calculatedProcessingFee = "--";// = ((Number(redeemAmtEntered)/100)*paidInstantRedeemProcessingFee);
    if (redeemAmtEntered === 0 || redeemAmtEntered === '') {
      // console.log("fgfghfhtfhdfghgfh step 1");
      calculatedProcessingFee = "--"
    } else {
      // console.log("fgfghfhtfhdfghgfh fghfghfghfghh step 2");
      calculatedProcessingFee = ((Number(redeemAmtEntered) / 100) * paidInstantRedeemProcessingFee);
    }
    // console.log("calculatedProcessingFee",calculatedProcessingFee);
    setPaidInstantYouGetValue((calculatedProcessingFee))
    // setPaidInstantYouGetValue(Number(redeemAmtEntered) - Number(calculatedProcessingFee))
  }

  const handleInputBlur = () => {
    // try {
    //     inputRef.blur()
    // } catch (e) { console.log(e) }
    // try {
    //     emailInputRef.blur()
    // } catch (e) { }
    // try {
    //     emailOtpRef.blur()
    // } catch (e) { }
    // try {
    //     upiInputRef.current.blur()
    // } catch (e) { }
    // try {
    //     acntNumberRef.current.blur()
    // } catch (e) { }
    // try {
    //     reacntNumberRef.current.blur()
    // } catch (e) { }
    // try {
    //     ifscRef.current.blur()
    // } catch (e) { }
    // inputRef.current.blur()
    if (emailInputRef) {
      emailInputRef.current.blur()
    }


  }

  const calculateSmartTDS = (val) => {
    // console.log("VAlue is nee yebaaa", val);
    let finalValue = 0
    let redeemAmtEntered = val
    let taxValue = (redeemDetails.taxableRunningNetWinnings === undefined || !isNaN(redeemDetails.taxableRunningNetWinnings)) ? 0 : redeemDetails.taxableRunningNetWinnings;
    let totalRedeem = Number(redeemDetails.cummulativeRedeemFinyear) + Number(redeemAmtEntered)
    let totalDetuctions = Number(redeemDetails.cummulativePurchaseFinyear) + Number(redeemDetails.taxedNetWinnings) + Number(redeemDetails.openingBalanceFinyear)
    let newNetWinnings = totalRedeem - totalDetuctions
    // console.log("new tds calculation >>>>>>>>>>>>>>>", newNetWinnings, totalDetuctions, totalRedeem);
    let calculatedTDSValue;
    let youGetAmountValue;
    // console.log(newNetWinnings, "newNetWinnings>>")
    if (newNetWinnings > 0) {
      calculatedTDSValue = ((newNetWinnings / 100) * redeemDetails.tdsPercentage).toFixed(2);

      calculatedTDSValue = (calculatedTDSValue < 1) ? 0 : calculatedTDSValue;
      // console.log(calculatedTDSValue, "calculatedTDSValue")

      youGetAmountValue = (redeemAmtEntered - calculatedTDSValue).toFixed(2);


      finalValue = calculatedTDSValue

      // console.log("slider value >>>>", selectedSliderValue);
      redTDSAmount = selectedSliderValue
      // setTdsRed(selectedSliderValue);

    }
    else {
      // finalValue = 0;
      greesTDSAmount = selectedSliderValue;
      // console.log("slider value >>>> xxxxx", selectedSliderValue);
    }

    return finalValue
  }

  const calculateTdsCashback = (newNetWinnings, calculatedTDSValue, redeemAmtEntered) => {

    let netWinnings = newNetWinnings;
    let tdsValue = calculatedTDSValue;
    let redeemAmount = redeemAmtEntered;
    let tourneyNetWinnings = (redeemAmtEntered > cummilativeTrnyWinnings) ? cummilativeTrnyWinnings : redeemAmtEntered;
    let tdsBonusPercentage = standardSelected ? standardTypePercentage : instantSelected ? instantTypePercentage : 0;
    console.log("netWinnings, tdsValue, redeemAmount", netWinnings, tdsValue, redeemAmount);
    // 43.75,  13.13 , 200
    let cashbackValue = (tdsValue * ((netWinnings - tourneyNetWinnings) / netWinnings) * (tdsBonusPercentage) / 100) > 0 ? (tdsValue * ((netWinnings - tourneyNetWinnings) / netWinnings) * (tdsBonusPercentage) / 100) : 0;

    let finalCashbackValue = (tdsValue * ((netWinnings - tourneyNetWinnings) / netWinnings)) > 0 ? (tdsValue * ((netWinnings - tourneyNetWinnings) / netWinnings)) : 0;

    console.log("cashbackValue >?>?>?>?>?>", finalCashbackValue);
    setFinalCashbackValue(finalCashbackValue.toFixed(2));

    setTdsCashbackAmount(cashbackValue.toFixed(2));


  }
  const highlightItem = () => {
    if (redeemDetails?.emailVerified === false && panEmailMandatoryConfig === true) {
      console.log("Issue 1")
      return 'email'
    }
    if (EnableVerifyId()) {
      console.log("Enable Verify Id is ", EnableVerifyId());
      return "id";
    } else {
      if (redeemDetails?.allRedeemOptions?.length === 0 || redeemDetails?.allRedeemOptions?.findIndex((o) => o.upiState === 'processing' || o.bankStatus === 'processing') !== -1) {
        console.log("in redeem method");
        return 'redeemMethod'
      }
    }

    return 'NA'
  }
  const calculateTDS = (value) => {
    // console.log("already calculated")
    if (value === 0 || value === '') {
      setTdsInfo({
        amount: -1,
        tds: -1,
        youGet: -1
      })
      calculateProcessingFee(0);
    }
    else {
      let redeemAmtEntered = value
      let taxValue = (redeemDetails.taxableRunningNetWinnings === undefined || !isNaN(redeemDetails.taxableRunningNetWinnings)) ? 0 : redeemDetails.taxableRunningNetWinnings;
      let totalRedeem = Number(redeemDetails.cummulativeRedeemFinyear) + Number(redeemAmtEntered)
      let totalDetuctions = Number(redeemDetails.cummulativePurchaseFinyear) + Number(redeemDetails.taxedNetWinnings) + Number(redeemDetails.openingBalanceFinyear)
      let newNetWinnings = totalRedeem - totalDetuctions
      // console.log("new tds calculation >>>>>>>>>>>>>>>", newNetWinnings, totalDetuctions, totalRedeem);
      let calculatedTDSValue;
      let youGetAmountValue;
      console.log(newNetWinnings, "newNetWinnings>>")
      if (newNetWinnings > 0) {
        calculatedTDSValue = ((newNetWinnings / 100) * redeemDetails.tdsPercentage).toFixed(2);

        calculatedTDSValue = (calculatedTDSValue < 1) ? 0 : calculatedTDSValue;
        // console.log(calculatedTDSValue,  "calculatedTDSValue")

        youGetAmountValue = (redeemAmtEntered - calculatedTDSValue).toFixed(2);

      } else {
        calculatedTDSValue = 0;
        youGetAmountValue = parseInt(redeemAmtEntered).toFixed(2);
      }
      // console.log("yuyuuyiuuiuiuiuiui nnnnnnnnnnnnn ", calculatedTDSValue, youGetAmountValue)
      setTdsInfo({
        amount: redeemAmtEntered,
        tds: calculatedTDSValue,
        youGet: youGetAmountValue > 0 ? youGetAmountValue : 0
      })
      //  console.log("calculated TDS value",calculatedTDSValue);
      calculateProcessingFee(youGetAmountValue);

      calculateTdsCashback(newNetWinnings, calculatedTDSValue, redeemAmtEntered)
      // console.log("calculated TDS value 1", redeemDetails.tdsFreeAmount);
      // console.log("calculated TDS value 2", Number(redeemDetails.redeemableAmount));//Number(redeemDetails.tdsFreeAmount) > Number(redeemDetails.redeemableAmount)

      if (redeemDetails !== undefined) {
        let eventProperties = {
          TDS_free_amt: redeemDetails?.tdsFreeAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan",
          tds_deducted: tdsInfo.tds
          , username: profileData?.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData?.currentAceLevelName, subscription_type: profileData?.subscriptionType,
          amount_entered: amountEntered, FeatureFlag: newCTAFlag, PercentTDSAmountOutOfEnteredAmount: Number(redeemDetails.tdsFreeAmount) / Number(amountEntered) * 100,
        }
        if (Number(redeemDetails.tdsFreeAmount) > 0 && calculatedTDSValue > 0) {
          // console.log("dcbdkjdfjdfjndfjndfnbfdfdng");


          WebToNativeMessage({
            type: "redeemCTEvent", eventName: "PF_c_viewTDSnote", eventProperties: eventProperties
          })
          WebToNativeMessage({
            type: "mixpanelEvent", eventName: "PF_c_viewTDSnote", eventProperties: eventProperties
          })
          WebToNativeMessage({
            type: "plotLineEvent", eventName: "PF_c_viewTDSnote", eventProperties: eventProperties
          })
        }

        else if (Number(redeemDetails.tdsFreeAmount) <= 0 && calculatedTDSValue > 0) {
          WebToNativeMessage({
            type: "redeemCTEvent", eventName: "TDStipnudge_displayed", eventProperties: eventProperties
          })
          WebToNativeMessage({
            type: "mixpanelEvent", eventName: "TDStipnudge_displayed", eventProperties: eventProperties
          })
          WebToNativeMessage({
            type: "plotLineEvent", eventName: "TDStipnudge_displayed", eventProperties: eventProperties
          })
        }
      }
    }
  }

  const createNewUserRedeemPage = () => {
    const createItem = ({ item, description, type, status, number, highlight }) => {
      console.log("----------------------------- create new user redeem-------------------------------")
      console.log("Issue 2")

      console.log("pan status is : ", status, "   : type is : ", type);
      return <div className='newuserRedeem1' >
        {/* style={{ width: '100%', height: '20%', display: 'flex', justifyContent: "space-between", alignItems: 'center' }}> */}
        <div className='newuserRedeem2'
        // style={{ width: '10%', height: "100%", display: 'flex', alignItems: 'center', justifyContent: "center" }}
        ><img style={{ width: '50%' }} src={(isNewVersion?(status?.kycStatus === 'approved' || status?.isIdVerified === 'approved' || status === 'approved'):status?.kycStatus === 'approved')
          ? assets?.assets?.TickGreen
          : (status?.kycStatus === 'processing' || status?.isIdVerified === 'processing' || status === 'processing')
            ? PendingIcon
            : number === 1
              ? assets?.assets?.Numbering1
              : number === 2
                ? assets?.assets?.Numbering2
                : number === 3
                  ? assets?.assets?.Numbering3
                  : ''} alt='numbering' /></div>
        <div style={{ width: '88%', height: "100%", display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}
          onClick={() => {
            if (showCta()) {
              console.log("Issue 3")
              if (type === 'email' && highlightItem() === 'email') {
                WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_clickin_RedeemVerificationPage", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_type: 'EmailID', Redeemable_amount: profileData.win } })
                setOpenAddEmailPopUp(true)
              }
              else if (type === 'id' && highlightItem() === 'id') {

                WebToNativeMessage({

                  type: "openMyAccount"//New changes

                })
                if (isKYCVerificationPage) {
                  WebToNativeMessage(
                    {
                      type: "redeemCTEvent", eventName: "Pf_c_Tkyc_verifyctaclick", eventProperties: {
                        acelevel: window.sessionStorage["aceLevel"],
                        channel: window.sessionStorage["channel"],
                        subscriptionType: window.sessionStorage["subscriptionType"],
                        username: window.sessionStorage["screenName"],
                        cta_name: 'verify id'
                      }

                    })
                }
                else {
                  WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_clickin_RedeemVerificationPage", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_type: 'PAN', Redeemable_amount: profileData.win } })
                }
              }
              else if (type === 'redeemMethod' && highlightItem() === 'redeemMethod') {
                if (isKYCVerificationPage) {
                  WebToNativeMessage(
                    {
                      type: "redeemCTEvent", eventName: "Pf_c_Tkyc_verifyctaclick", eventProperties: {
                        acelevel: window.sessionStorage["aceLevel"],
                        channel: window.sessionStorage["channel"],
                        subscriptionType: window.sessionStorage["subscriptionType"],
                        username: window.sessionStorage["screenName"],
                        cta_name: 'addaccount'
                      }

                    })
                }
                else {
                  WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_clickin_RedeemVerificationPage", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_type: 'RedeemAccount', Redeemable_amount: profileData.win } })
                }
                WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_View_RedeemMode_bottomsheet", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Verification Page' } })
                setOpenAddRedeemPopUp(true)
              }
            }
          }}
        >
          <div className={highlight ? "itemEnabled" : "itemDisabled"}>
            {item}
          </div>
          {console.log(type, "type ", redeemDetails?.panMandatory, " is pan mandatory", redeemDetails?.kycStatus, " is kyc status", redeemDetails?.isIdVerified?.toLocaleLowerCase(), " is id verified")}
          {type === 'id' && (EnableVerifyId()) && (
            <div className='itemDes'>
              Note: ID Proof name and Bank Account name should match
            </div>
          )}
          {(type === 'id') && ((redeemDetails.kycStatus === 'processing') || (redeemDetails?.isIdVerified === "processing")) && (
            <div className={highlight ? "itemDesEnabled" : "itemDesDisabled"}>
              {redeemDetails.kycStatus === 'processing' || redeemDetails?.isIdVerified === 'processing'
                ? 'Verification in process'
                : redeemDetails.kycStatus === 'rejected' || redeemDetails?.isIdVerified === 'rejected'
                  ? 'Verification failed. Please try again'
                  : ''}
            </div>
          )}
          {(type === 'redeemMethod' && redeemDetails?.allRedeemOptions?.length > 0 && (redeemDetails?.kycStatus === 'approved') || (!EnableVerifyId()) && redeemDetails.allRedeemOptions.findIndex((o) => o.upiState === 'approved' || o.bankStatus === 'approved' || o.name.toLowerCase() === 'amazonpay' || o.name.toLowerCase() === 'amazon pay' || o.name.toLowerCase() === 'paytmwallet' || o.name.toLowerCase() === 'paytm wallet') === -1) && (
            <div className={highlight ? "itemDesEnabled" : "itemDesDisabled"}>
              {redeemDetails.allRedeemOptions.findIndex((o) => o.upiState === 'processing' || o.bankStatus === 'processing') !== -1
                ? 'Verification in process'
                : ''}
            </div>
          )}
          {(type === 'redeemMethod' && redeemDetails?.allRedeemOptions?.length > 0 &&
            redeemDetails.allRedeemOptions.findIndex((o) =>
            (o.upiState === 'approved' || o.bankStatus === 'approved' ||
              o.name.toLowerCase() === 'amazonpay' ||
              o.name.toLowerCase() === 'amazon pay' ||
              o.name.toLowerCase() === 'paytmwallet' ||
              o.name.toLowerCase() === 'paytm wallet')
            ) === -1 &&
            redeemDetails.allRedeemOptions.findIndex((o) =>
              (o.upiState === 'processing' || o.bankStatus === 'processing')
            ) === -1
          ) && (
              <div className={highlight ? "itemDesEnabled" : "itemDesDisabled"}>
                Verification failed due to name mismatch between your Bank Account name and KYC name. Please try again.
              </div>
            )}
          {/**<div style={highlight ? itemDesEnabled : itemDesDisabled} >
           {description}
           </div> */}
        </div>
      </div>
    }

    const showCta = () => {
      // return true
      console.log("issue 4 ", redeemDetails.kycStatus, " is kyc ", redeemDetails.isIdVerified, "is id verified ", EnableVerifyId(), " is id not verified");
      // if (redeemDetails.kycStatus === 'processing') {
      //   console.log("issue 4 4 ", redeemDetails.kycStatus);
      //   return false
      // } 
      if (EnableVerifyId()) {
        console.log("issue 4 4 ", redeemDetails.isIdVerified);
        return true
      }
      // if (redeemDetails.kycStatus === 'approved') {

      console.log("ShowCTA-----------> IsIdNotVerified is ", EnableVerifyId(), " and pan status is : ", redeemDetails?.kycStatus)
      if (!EnableVerifyId()) {
        console.log("issue 4 4 4 ", redeemDetails.isIdVerified);
        if (redeemDetails.allRedeemOptions.length > 0) {
          console.log("issue 4 4 4 4", redeemDetails.isIdVerified);
          if (redeemDetails.allRedeemOptions.findIndex((o) => o.upiState === 'processing' || o.bankStatus === 'processing') !== -1 || redeemDetails.allRedeemOptions.findIndex((o) => o.upiState === 'approved' || o.bankStatus === 'approved' || o.name.toLowerCase() === 'amazonpay' || o.name.toLowerCase() === 'amazon pay' || o.name.toLowerCase() === 'paytmwallet' || o.name.toLowerCase() === 'paytm wallet') !== -1) {
            console.log("issue 4 4 4 4 5555", redeemDetails.isIdVerified);
            // if (redeemDetails?.emailVerified === false && panEmailMandatoryConfig === true) {
            //   return true
            // } else {
            //   return false
            // }

          }
          else {
            return true
          }
        }
        else {
          return true
        }
      }
      return true

    }

    return <>
      <div className='redeemBody' style={{ width: "100%", height: "84%", display: 'flex', flexDirection: 'column' }}>
        {isKYCVerificationPage ?
          <>
            <img src={KycBannerImage} style={{ width: "100%" }} />
            {/* <img src={KycQuetionMark} style={{ position: "absolute", width: '22px', bottom: "11%", right: '5%' }} /> */}
          </>


          : <div
            // style={styles.redeemableAmountSection}
            style={{ "background": isoemps ? "linear-gradient(180deg, #141920 0%, #232A35 100%)" : "linear-gradient(180deg, #2C5391 0%, #4A75BC 100%), linear-gradient(0deg, rgba(44, 83, 145, 0.25), rgba(44, 83, 145, 0.25))" }}
            className='rBody1'
          >
            <div
              className='redeemAmountDetails'
            // className='rBody2'
            >
              <div id="view_policy" onClick={() => {
                window.sessionStorage.setItem('policyBack', 'redeem');
                WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPolicy_PageView", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Redeem Placement Page' } })
                  ;
                WebToNativeMessage({ type: 'openRedeemPolicy' });
                // history.push("/redeeminfo/")
              }}
                className='view_policy1'
                style={{ position: "absolute", right: '3%', top: '0%', fontSize: '0.85rem', display: 'flex', alignItems: 'center', justifyContent: "end", width: "20%" }}
              ><img style={{ width: "0.7rem", marginRight: "2%" }} src={assets?.assets?.viewPolicy} alt='viewPolicy' /><span style={{ paddingLeft: '2%', whiteSpace: "nowrap", marginRight: "2%" }}>{VernacularContextData.getTransalatedKey("viewpolicy")}</span></div>
              <img src={assets?.assets?.RedeemableLogo} alt="redeemableLogo" style={{ width: "35%" }} />
              {/* <span className="redeemableAmountText" >Redeemable Amount</span> */}
              <span className="redeemableAmountText" >Winnings</span>
              <div className="redeemableAmountDisplay">
                {/**<div style={{ height: '120%', ...(isAndroid ? '' : { width: "22%" }) }}>
    <Lottie style={{ width: "100%", height: '100%' }} animationData={RedeemRupee} loop={true} autoPlay={true} />
    </div> */}
                <div id="redeemable_amount" style={{}}> &#8377; {redeemDetails ? redeemDetails.redeemableAmount?.toLocaleString('en-IN') : 0}</div>
              </div>
            </div>
          </div>}
        <div className='redeemStatus'>
          <div className='redeemStatusHeader'>{isKYCVerificationPage ? 'Verify Your KYC to Register for any Tourney' : 'Verify your profile to withdraw'}</div>
          <div style={{ width: "95%", height: "60%", marginLeft: "2.5%", display: 'flex', alignItems: "center" }}>
            <div style={{ width: '100%', height: '90%', display: "flex", flexDirection: "column", justifyContent: 'flex-start' }}>
              {panEmailMandatoryConfig === true &&
                <>
                  {createItem({ item: 'Verify Email ID', type: 'email', description: 'email', status: redeemDetails?.emailVerified ? 'approved' : 'not verified', number: 1, highlight: highlightItem() === 'email' })}
                  <div style={{ width: '100%', height: '20%', display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
                    <div style={{ width: '10%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                      <img style={{ width: '50%' }} src={redeemDetails?.emailVerified ? assets?.assets?.GreenLine : GreyLine} alt='line' />
                    </div>
                  </div>
                </>

              }
              {createItem({
                item: 'Upload ID Proof',
                type: "id",
                description: 'id',
                status: {
                  kycStatus: redeemDetails?.kycStatus?.toLocaleLowerCase(),
                  isIdVerified: redeemDetails?.isIdVerified?.toLocaleLowerCase()
                },
                number: panEmailMandatoryConfig === true ? 2 : 1,
                highlight: highlightItem() === 'id'
              })}
              <div style={{ width: '100%', height: '20%', display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
                <div style={{ width: '10%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: "center" }}>

                  <img style={{ width: '50%' }} src={((isNewVersion?(redeemDetails?.kycStatus === 'approved' || redeemDetails?.isIdVerified?.toLocaleLowerCase() === "approved"):redeemDetails?.kycStatus === 'approved') && (redeemDetails?.emailVerified || panEmailMandatoryConfig === false)) ? assets?.assets?.GreenLine : GreyLine} alt='line' />
                </div>
              </div>
              {createItem({ item: `${isKYCVerificationPage ? VernacularContextData.getTransalatedKey("addbankaccount") : VernacularContextData.getTransalatedKey("addwithdrawaccount")}`, type: 'redeemMethod', description: `${isKYCVerificationPage ? VernacularContextData.getTransalatedKey("addbankaccount") : VernacularContextData.getTransalatedKey("addwithdrawaccount")}`, status: redeemDetails?.allRedeemOptions?.findIndex((o) => o.upiState === 'processing' || o.bankStatus === 'processing') !== -1 ? 'processing' : redeemDetails?.allRedeemOptions?.findIndex((o) => o.upiState === 'approved' || o.bankStatus === 'approved' || o.name.toLowerCase() === 'amazonpay' || o.name.toLowerCase() === 'amazon pay' || o.name.toLowerCase() === 'paytmwallet' || o.name.toLowerCase() === 'paytm wallet') !== -1 ? 'approved' : false, number: panEmailMandatoryConfig === true ? 3 : 2, highlight: highlightItem() === 'redeemMethod' })}
            </div>
          </div>
        </div>
      </div>

      {/* AdSense Video Ad */}
      <AdBanner divId="redeem-video-ad" />

      {console.log(highlightItem(), " is highlight item above showcta")}
      {showCta() &&
        <div className='showCTADiv1'
          // style={{ width: "100%", height: "10%", display: 'flex', alignItems: "center", justifyContent: 'center', background: "#F9F9F9" }}
          onClick={() => {
            if (highlightItem() === 'email') {
              WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_clickin_RedeemVerificationPage", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_type: 'EmailID', Redeemable_amount: profileData.win } })
              setOpenAddEmailPopUp(true)
            }

            if (highlightItem() === 'id') {
              WebToNativeMessage({
                type: "openMyAccount"
              })
              if (isKYCVerificationPage) {
                WebToNativeMessage(
                  {
                    type: "redeemCTEvent", eventName: "Pf_c_Tkyc_verifyctaclick", eventProperties: {
                      acelevel: window.sessionStorage["aceLevel"],
                      channel: window.sessionStorage["channel"],
                      subscriptionType: window.sessionStorage["subscriptionType"],
                      username: window.sessionStorage["screenName"],
                      cta_name: 'verify id'
                    }

                  })
              }
              else {
                WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_clickin_RedeemVerificationPage", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_type: 'ID', Redeemable_amount: profileData.win } })
              }
            }

            else if (highlightItem() === 'redeemMethod') {
              if (isKYCVerificationPage) {
                WebToNativeMessage(
                  {
                    type: "redeemCTEvent", eventName: "Pf_c_Tkyc_verifyctaclick", eventProperties: {
                      acelevel: window.sessionStorage["aceLevel"],
                      channel: window.sessionStorage["channel"],
                      subscriptionType: window.sessionStorage["subscriptionType"],
                      username: window.sessionStorage["screenName"],
                      cta_name: 'addaccount'
                    }

                  })
              }
              else {
                WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_clickin_RedeemVerificationPage", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_type: 'RedeemAccount', Redeemable_amount: profileData.win } })
              }
              WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_View_RedeemMode_bottomsheet", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Verification Page' } })
              setOpenAddRedeemPopUp(true)
            }
          }}
        >
          {/**{(redeemDetails.kycStatus !== 'pending' && redeemDetails?.allRedeemOptions?.findIndex((o) => (o.bankApproved === true || o.status === true) !== -1)) &&
   <div onClick={() => handleRedeemRequestSent()} style={{ width: '90%', height: '55%', background: "linear-gradient(180deg, #42BE40 0%, #196A29 100%)", borderRadius: "4px", color: '#FFFFFF', fontSize: '1rem', fontWeight: '700', display: "flex", alignItems: "center", justifyContent: "center" }}>
   {redeemDetails?.allRedeemOptions?.length !== 0 ? 'Redeem' : 'Setup Redeem Method'}
   </div>
   } */}

          {console.log("highlightItem >>>>>>", highlightItem())}

          <div className='highlightItemEmailDiv'>
            {highlightItem() === 'email' ? 'Verify Email ID' : highlightItem() === 'id' ? 'Upload ID Proof' : highlightItem() === 'redeemMethod' ? isKYCVerificationPage ? 'Add Bank Account' : 'Add Withdraw Account' : 'Verify Email ID'}
          </div>

        </div>
      }

    </>
  }

  const getMinMaxValues = () => {
    var min = 0
    var max = 0
    if (selectedWithdrawtype === LINKWALLET_STRINGS.KEY_AMAZONPAY_TV || selectedWithdrawtype === LINKWALLET_STRINGS.KEY_PAYTMWALLET_TV) {
      min = redeemDetails.walletMinAmount ? redeemDetails?.walletMinAmount : redeemDetails?.minAmount
      max = Math.min(redeemDetails?.walletMaxAmount, redeemDetails?.redeemableAmount);
      // console.log("standard limit amount >>>>>>>>",standardLimitAmount);
      if (standardSelected) {
        max = Math.min(Number(redeemDetails?.redeemableAmount), Number(standardLimitAmount));
        // console.log("Step 1 ");

      }
      else if (instantSelected) {
        // console.log("Step 2 ");
        max = Math.min(Number(redeemDetails?.redeemableAmount), Number(instantLimitAmount));
      } else if (paidInstantSelected) {
        max = Math.min(Number(redeemDetails?.redeemableAmount), Number(paidInstantLimitAmount));
        // console.log("ysdgvdshvdsbdfbhdfbdfgbdfgbdfg", max);
        // max = Number(standardLimitAmount)//Math.min(redeemDetails?.walletMaxAmount, redeemDetails?.redeemableAmount);
      } else {
        max = Number(standardLimitAmount)
      }
    }
    else {
      min = redeemDetails?.minAmount
      max = Math.min(Number(redeemDetails?.maxAmount), Number(redeemDetails?.redeemableAmount))

      if (standardSelected) {
        // console.log("Step 3 ");
        max = Math.min(Number(redeemDetails?.redeemableAmount), Number(standardLimitAmount));
      }
      else if (instantSelected) {
        // console.log("Step 4 ");
        max = Math.min(Number(instantLimitAmount), Number(redeemDetails?.redeemableAmount));
      }
      else if (paidInstantSelected) {
        // console.log("Step 4 ");
        max = Math.min(Number(paidInstantLimitAmount), Number(redeemDetails?.redeemableAmount));
      }
      else {
        max = Number(standardLimitAmount)//Math.min(redeemDetails?.maxAmount, redeemDetails?.redeemableAmount)
      }
    }

    return {
      min: min,
      max: max
    }
  }

  const setErrorMessage = () => {
    // return
    const minMaxValues = getMinMaxValues()
    var min = minMaxValues.min
    var max = minMaxValues.max
    setValidationError('')
    if (isNaN(amountEntered) || amountEntered === '' || amountEntered === undefined) {
      setValidationError('')
    }
    else if (min > max && redeemDetails?.redeemableAmount !== 0) {
      setValidationError("You don't have sufficient redeemable balance.")
    }
    else if (redeemDetails?.redeemableAmount < amountEntered) {
      if (redeemDetails?.redeemableAmount === 0) {
        setValidationError("You don't have any winnings to withdrawable at the moment.")
      }
      else {
        setValidationError('Please enter an amount less than or equal to withdrawable balance.')
      }

    }
    else if (amountEntered > max || amountEntered < min) {
      setValidationError(`Please enter an amount between ${min} and ${max.toFixed(0)}`);
    }

  }


  const handleValidation = () => {
    const minMaxValues = getMinMaxValues()
    var min = minMaxValues.min
    var max = minMaxValues.max
    console.log("min and max values >>>>>", min, max);
    console.log("amountEntered >>>>>", amountEntered);

    try {
      if (amountEntered.length === 0 || (amountEntered < min) || (amountEntered > max) || isNaN(amountEntered) || amountEntered > redeemDetails?.redeemableAmount || (amountEntered?.indexOf('.') !== -1)) {
        setIsbtnEnable(false)

        return false;

      } else {
        setIsbtnEnable(true)
      }
    } catch (err) {
      console.error(err);
    }
  };

  const onContinueClick = (val) => {
    console.log('onContinueClick', val)
    setButtonText(val)
    setToShowStandardAndInstantBottomSheet(false);
    setXTime(clearInterval(xTime));
    // setStandardSelected(true);
    // setInstantSelected(false);
    setShowInstantErrorToolTip(false);
    if (enableRedeemOTP) {
      setOpenLinkWallet('redeem')
    }
    else {

      handleRedeemRequestSent(amountEntered, val);

    }

  }
  const instantContainerClick = () => {
    // console.log("baboi 1234567876543456765432", insantReedemFlag)

    if ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D")) {
      // console.log("1111111 baboi");
      if (showInstantErrorToolTip || Number(dailyInstant) <= 0 || !insantReedemFlag) {
        return
      }
    } else {
      if (!insantReedemFlag || !InstantAmountCheck || !stdAndInstantCheck || !instantAvailabilityFlag || limitExceeded || showInstantErrorToolTip || (hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability)) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0)) {
        return
      }
    }

    setStandardSelected(false);
    setInstantSelected(true);

    setPaidInstantSelected(false)

    // if (validationError !== "") {
    setErrorMessage("");
    setEnteredAmount("")
    // }
  }

  const paidInstantContainerClick = () => {
    // console.log("nee yenkama >>>", paidInstantIsInCoolOff, paidInstantExhausted, showPaidRedeems, paidInstantAmountCheck, stdAndInstantCheck, paidInstantAmountCheck)
    if (!paidInstantRedeemEnableFlag || !showPaidRedeems || paidInstantIsInCoolOff || paidInstantExhausted || !showPaidRedeems || !paidInstantAmountCheck || (!stdAndInstantCheck && !paidInstantAmountCheck)) {
      return;
    }
    setStandardSelected(false);
    setInstantSelected(false);
    setPaidInstantSelected(true)

    // if (validationError !== "") {
    setErrorMessage("");
    setEnteredAmount("")
  }

  const standardContainerClick = () => {
    // alert()
    // console.log("stand >>>>>>", standardIsInCoolOff);
    if (standardIsInCoolOff || (!standardAmountCheck) || (!stdAndInstantCheck) || !standardRedeemFlag || (Number(monthlyStandard) <= 0) || showStandardUnlocksIn) {

      return
    }
    setStandardSelected(true);
    setInstantSelected(false);
    setPaidInstantSelected(false)

    // if ((validationError !== "")) {
    setErrorMessage("");
    setEnteredAmount("")
    // }
  }

  const calculateZeroTDSMarkerValue = (value) => {
    for (let index = 0; index < value.length; index++) {
      let element = value[index];

      console.log("Amount array >>>>>>>>>", element);
      if ((amountEntered - element) <= redeemDetails?.tdsFreeAmount) {
        console.log("Amount array 123 >>>>>>>>>", element, index);
        setZeroTDSValueIndex(index)
        break;
      }

    }
  }
  // Use a ref to persist the "clicked" state across renders
  const isClickedRef = useRef(false);

  const handleRedeemButtonClick = (e) => {
    // if (isClickedRef.current) return;
    isClickedRef.current = true;

    console.log(redeemDetails?.panMandatory, "is pan mandatory and ", redeemDetails?.kycStatus);
    if (validationError !== "") {
      isClickedRef.current = false;
      return;
    }

    if (activeRedeemMethod === undefined) {
      setOpenAddRedeemPopUp(true);
      WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_View_RedeemMode_bottomsheet", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Redeem Placement Page' } })
      isClickedRef.current = false;
      return;
    }

    else if (e && e.target.innerHTML.toLowerCase() === "go to lobby") {
      WebToNativeMessage({ type: 'goToLobby' });
      WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_clickGotoLobby", eventProperties: { Redeemable_amount: profileData.win, username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType } })
      WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_RedeemPlacement_clickGotoLobby", eventProperties: { Redeemable_amount: profileData.win, username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType } })
      isClickedRef.current = false;
      return;
    }

    else if (amountEntered === '' || isNaN(amountEntered) || amountEntered === undefined) {
      setValidationError('Please enter the amount')
      isClickedRef.current = false;
      return;
    }
    else {
      if (!shouldRedeemDisabled()) {
        if (paidInstantSelected) {
          setShowPaidInstantConfirmation(true);
          WebToNativeMessage({
            type: "redeemCTEvent", eventName: "PF_c_viewpaidinstantpop-up_redeem",
            eventProperties: {
              username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered === '' ? "NA" : amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], tds_deducted: tdsInfo.tds === -1 ? "NA" : tdsInfo.tds, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", paidProcessingFee: paidInstantRedeemProcessingFee, redeem_expiry_type: "Yes", timestamp: new Date().getTime()
            }
          })
        }

        let amountArray = [];
        setSmartRedeemAmountArray([]);
        setSmartRedeemValueArr([]);
        setInstantBonusArr([]);
        setLockedBonusArr([]);
        if (smartRedeemPercentConfig) {
          for (let index = 0; index < smartRedeemPercentConfig.length; index++) {
            const element1 = smartRedeemPercentConfig[index];
            amountArray.push((parseInt(amountEntered) <= 1000) ? parseInt(amountEntered) >= 100 ? Math.round(parseInt(amountEntered * element1 / 100) / 10) * 10 : parseInt(amountEntered * element1 / 100) : Math.round(parseInt(amountEntered * element1 / 100) / 100) * 100);
          }
          amountArray.pop();
          amountArray.push(parseInt(amountEntered));
          setSmartRedeemAmountArray(amountArray)
          setSelectedSliderValue(amountArray[selectedIndex]);
          setPlayBalanceAmt(Number(amountArray[selectedIndex]) > Number(amountEntered) ? Number(amountEntered) : Number(amountArray[selectedIndex]));
        }

        let totalBonus;
        let totalInstantBonus;
        let totalLockedBonus;

        if (bonusConfig) {
          totalBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.bonusPercent) / 100) * (parseInt(amountArray[selectedIndex])), parseInt(bonusConfig.maxBonus));
          totalInstantBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.instantBonusPercentage) / 100) * totalBonus, parseInt(bonusConfig.maxInstantBonus));
          totalLockedBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.lockedBonusPercentage) / 100) * totalBonus, parseInt(bonusConfig.maxLockedBonusAmount));
        }

        setTotalBonus(totalBonus);
        setInstantBonus(totalInstantBonus);
        setLockedBonus(totalLockedBonus);

        if (smartRedeemNewUIFlag) {
          let bonusArr = [];
          for (let index = 0; index < amountArray.length; index++) {
            let el = amountArray[index];
            bonusArr.push(calculateBonus(el))
          }
          setLockedBonusArr(lockedBonusArr);
          setInstantBonusArr(instantBonusArr);
          setSmartRedeemValueArr(bonusArr);

          if (newRedeemConf[selectedIndex].toLowerCase() === "basic") {
            setBasicSelected(true);
            setSaverSelected(false);
            setUSaverSelected(false);
            setPlayBalanceAmt(0)
          } else if (newRedeemConf[selectedIndex].toLowerCase() === "saver") {
            setBasicSelected(false);
            setSaverSelected(true);
            setUSaverSelected(false);
            setPlayBalanceAmt(amountArray[1]);
          } else if (newRedeemConf[selectedIndex].toLowerCase() === "ultrasaver") {
            setBasicSelected(false);
            setSaverSelected(false);
            setUSaverSelected(true);
            setPlayBalanceAmt(amountArray[2])
          } else {
            setBasicSelected(true);
            setSaverSelected(false);
            setUSaverSelected(false);
            setPlayBalanceAmt(0)
          }
        }

        if (tdsInfo.tds > 0 && Number(redeemDetails.tdsFreeAmount) > 0) {
          calculateZeroTDSMarkerValue(amountArray);
        }

        if (paidInstantSelected) {
          setShowSmartRedeem(false);
        }
        else if (smartRedeemEnabled && smartRedeemForInstantOrStandard && smartRedeemForInstantOrStandard.toLowerCase() === "instant" && instantSelected) {
          setShowSmartRedeem(true)
        }
        else if (smartRedeemEnabled && smartRedeemForInstantOrStandard && smartRedeemForInstantOrStandard.toLowerCase() === "standard" && standardSelected) {
          setShowSmartRedeem(true)
        } else if (smartRedeemEnabled && smartRedeemForInstantOrStandard && smartRedeemForInstantOrStandard.toLowerCase() === "both") {
          setShowSmartRedeem(true)
        }
        else {
          setShowSmartRedeem(false);
          setShowSmartRedeemPopup(false)

          if (redeemGamePassData?.length > 0 || activeMissionsData?.activeMission?.length > 0
            || challengesData?.length > 0 || expiredLockedBonusData !== undefined) {
            setToShowGamePassOverLay(true);
            if (redeemGamePassData?.length > 0) {
              WebToNativeMessage({
                type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_clickRedeem",
                eventProperties:
                {
                  Redeem_mode: (activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? "wallet" : activeRedeemMethod.type === 'bankAccount' ? "bank account" : activeRedeemMethod.type === 'upi' ? "upi" : "",
                  username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered === '' ? "NA" : amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], tds_deducted: tdsInfo.tds === -1 ? "NA" : tdsInfo.tds, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", paidProcessingFee: paidInstantRedeemProcessingFee, redeem_expiry_type: "Yes", timestamp: new Date().getTime(), TDSCashbackAmount: (Number(tdsCashbackAmount) > Number(tdsMaxCapAmount)) ? tdsMaxCapAmount : tdsCashbackAmount,
                }
              })
              WebToNativeMessage({
                type: "mixpanelEvent", eventName: "PF_c_RedeemPlacement_clickRedeem",
                eventProperties:
                {
                  Redeem_mode: (activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? "wallet" : activeRedeemMethod.type === 'bankAccount' ? "bank account" : activeRedeemMethod.type === 'upi' ? "upi" : "",
                  username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered === '' ? "NA" : amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], tds_deducted: tdsInfo.tds === -1 ? "NA" : tdsInfo.tds, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", paidProcessingFee: paidInstantRedeemProcessingFee, redeem_expiry_type: "Yes", timestamp: new Date().getTime(), TDSCashbackAmount: (Number(tdsCashbackAmount) > Number(tdsMaxCapAmount)) ? tdsMaxCapAmount : tdsCashbackAmount,
                }
              })
              WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_viewgamepass_redeem", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime() } })
              WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_viewgamepass_redeem", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime() } })
            }
          }
          else {
            onContinueClick();
            setShowSmartRedeem(false);
            setShowSmartRedeemPopup(false)
            WebToNativeMessage({
              type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_clickRedeem",
              eventProperties:
              {
                Redeem_mode: (activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? "wallet" : activeRedeemMethod.type === 'bankAccount' ? "bank account" : activeRedeemMethod.type === 'upi' ? "upi" : "",
                username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered === '' ? "NA" : amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], tds_deducted: tdsInfo.tds === -1 ? "NA" : tdsInfo.tds, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", paidProcessingFee: paidInstantRedeemProcessingFee, redeem_expiry_type: "No", timestamp: new Date().getTime(), TDSCashbackAmount: (Number(tdsCashbackAmount) > Number(tdsMaxCapAmount)) ? tdsMaxCapAmount : tdsCashbackAmount,
              }
            })
            WebToNativeMessage({
              type: "mixpanelEvent", eventName: "PF_c_RedeemPlacement_clickRedeem",
              eventProperties:
              {
                Redeem_mode: (activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? "wallet" : activeRedeemMethod.type === 'bankAccount' ? "bank account" : activeRedeemMethod.type === 'upi' ? "upi" : "",
                username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered === '' ? "NA" : amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], tds_deducted: tdsInfo.tds === -1 ? "NA" : tdsInfo.tds, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", paidProcessingFee: paidInstantRedeemProcessingFee, redeem_expiry_type: "No", timestamp: new Date().getTime(), TDSCashbackAmount: (Number(tdsCashbackAmount) > Number(tdsMaxCapAmount)) ? tdsMaxCapAmount : tdsCashbackAmount,
              }
            })
          }
        }

        WebToNativeMessage({
          type: "redeemCTEvent", eventName: "PF_c_smartredeem_pageload", eventProperties: {
            DefaultSplit: smartRedeemPercentConfig?.[selectedIndex], TotalBonusPercentage: bonusConfig?.levelDetails[0]?.bonusPercent,
            InstantBonusPercentage: bonusConfig?.levelDetails?.[0]?.instantBonusPercentage,
            LockedBonusPercentage: bonusConfig?.levelDetails?.[0]?.lockedBonusPercentage,
            Redeem_Amount: amountEntered,
            MostSelectedAmount: smartRedeemPercentConfig?.[mostSelected],
            BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
            AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? amountArray[0] : saverSelected ? amountArray[1] : amountArray[2]),
            AmountToBank: !smartRedeemNewUIFlag ? ((amountEntered) - selectedSliderValue) : basicSelected ? (Number(amountEntered) - amountArray[0]) : saverSelected ? (Number(amountEntered) - amountArray[1]) : (Number(amountEntered) - amountArray[2]),
            TDSAmount: calculateSmartTDS(amountEntered - selectedSliderValue) > 0 ? calculateSmartTDS(amountEntered - selectedSliderValue) : 0,
            Redeem_type_selected: standardSelected ? "Standard" : instantSelected ? "Instant" : "Others",
            Redeem_mode: activeRedeemMethod?.type,
            subscription_type: window.sessionStorage['subscriptionType'],
            username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime(),
            UIconfig: smartRedeemNewUIFlag ? "New" : "Old"
          }
        })

        WebToNativeMessage({
          type: "plotLineEvent", eventName: "PF_c_smartredeem_pageload", eventProperties: {
            DefaultSplit: smartRedeemPercentConfig?.[selectedIndex], TotalBonusPercentage: bonusConfig?.levelDetails?.[0]?.bonusPercent,
            InstantBonusPercentage: bonusConfig?.levelDetails?.[0]?.instantBonusPercentage,
            LockedBonusPercentage: bonusConfig?.levelDetails?.[0]?.lockedBonusPercentage,
            Redeem_Amount: amountEntered,
            MostSelectedAmount: smartRedeemPercentConfig?.[mostSelected],
            BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
            AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? amountArray[0] : saverSelected ? amountArray[1] : amountArray[2]),
            AmountToBank: !smartRedeemNewUIFlag ? ((amountEntered) - selectedSliderValue) : basicSelected ? (Number(amountEntered) - amountArray[0]) : saverSelected ? (Number(amountEntered) - amountArray[1]) : (Number(amountEntered) - amountArray[2]),
            TDSAmount: calculateSmartTDS(amountEntered - selectedSliderValue) > 0 ? calculateSmartTDS(amountEntered - selectedSliderValue) : 0,
            Redeem_type_selected: standardSelected ? "Standard" : instantSelected ? "Instant" : "Others",
            Redeem_mode: activeRedeemMethod?.type,
            subscription_type: window.sessionStorage['subscriptionType'],
            username: profileData?.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData?.currentAceLevelName, timestamp: new Date().getTime(),
            UIconfig: smartRedeemNewUIFlag ? "New" : "Old"
          }
        })

        WebToNativeMessage({
          type: "mixpanelEvent", eventName: "PF_c_smartredeem_pageload", eventProperties: {
            DefaultSplit: smartRedeemPercentConfig?.[selectedIndex], TotalBonusPercentage: bonusConfig?.levelDetails?.[0]?.bonusPercent,
            InstantBonusPercentage: bonusConfig?.levelDetails?.[0]?.instantBonusPercentage,
            LockedBonusPercentage: bonusConfig?.levelDetails?.[0]?.lockedBonusPercentage,
            Redeem_Amount: amountEntered,
            MostSelectedAmount: smartRedeemPercentConfig?.[mostSelected],
            BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
            AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? amountArray[0] : saverSelected ? amountArray[1] : amountArray[2]),
            AmountToBank: !smartRedeemNewUIFlag ? ((amountEntered) - selectedSliderValue) : basicSelected ? (Number(amountEntered) - amountArray[0]) : saverSelected ? (Number(amountEntered) - amountArray[1]) : (Number(amountEntered) - amountArray[2]),
            TDSAmount: calculateSmartTDS(amountEntered - selectedSliderValue) > 0 ? calculateSmartTDS(amountEntered - selectedSliderValue) : 0,
            Redeem_type_selected: standardSelected ? "Standard" : instantSelected ? "Instant" : "Others",
            Redeem_mode: activeRedeemMethod?.type,
            subscription_type: window.sessionStorage['subscriptionType'],
            username: profileData?.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData?.currentAceLevelName, timestamp: new Date().getTime(),
            UIconfig: smartRedeemNewUIFlag ? "New" : "Old"
          }
        })
      }
    }

    // isClickedRef.current = false;
  }

  const shouldRedeemDisabled = () => {
    if (redeemDetails?.allRedeemOptions?.length === 0) {
      return false
    }
    else if (activeRedeemMethod === undefined || (activeRedeemMethod?.bankStatus === 'processing' || activeRedeemMethod?.upiState === 'processing')) {
      return true
      // if ((standardSelected && amountEntered <= standardLimitAmount) || (instantSelected && amountEntered <= instantLimitAmount)) {
      //   return false
      // } else {
      //   return true
      // }

    }
    if (amountEntered === '' || isNaN(amountEntered) || amountEntered === undefined || validationError !== '') {
      return true
    }
    if ((standardSelected && amountEntered <= standardLimitAmount) || (instantSelected && amountEntered <= instantLimitAmount) || (dailyInstantExhausted && dailyStandardExhausted) || !stdAndInstantCheck || (!instantAvailabilityFlag && monthlyStandard <= 0) || (nextStandardRedeemAvailability !== "N") && (nextInstantRedeemAvailability !== "N") || (monthlyStandardExhausted && nextInstantRedeemAvailability !== "N") || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && nextStandardRedeemAvailability !== "N") || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted)) {
      return false
    }

    else
      return false
  }

  const createRedeemPage = () => {
    const minMaxValues = getMinMaxValues()
    var min = minMaxValues.min
    var max = minMaxValues.max
    // console.log("dfjbdfbjdfjkdfjkndfgjkndfgjkndfgkjndfgjkndfgjkdgfjkdfgjkd");
    const exceptThisSymbols = ["e", "E", "+", "-", ".", ","]
    // const highlightItem = () => {
    //   if (redeemDetails?.emailVerified === false && panEmailMandatoryConfig === true) {
    //     return 'email'
    //   }
    //   if (redeemDetails?.kycStatus !== 'approved') {
    //     return 'pan'
    //   }
    //   if (redeemDetails?.allRedeemOptions.length === 0) {
    //     return 'redeemMethod'
    //   }
    //   return 'NA'
    // }



    const onClickofChangeRedeemMethod = () => {
      // console.log("Redeem details >>>>>>>>>>", redeemDetails.allRedeemOptions);
      let index = redeemDetails?.allRedeemOptions?.findIndex((o) => o.default === true)
      let eventProperties = {
        acelevel: window.sessionStorage["aceLevel"],
        channel: window.sessionStorage["channel"],
        subscriptionType: window.sessionStorage["subscriptionType"],
        username: window.sessionStorage["screenName"],
        Auto_selected_RedeemMode: index !== -1 ? redeemDetails.allRedeemOptions[index].type : "NA"
      }
      WebToNativeMessage(
        {
          type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_clickChange", eventProperties: eventProperties
        })
      WebToNativeMessage(
        {
          type: "mixpanelEvent", eventName: "PF_c_RedeemPlacement_clickChange", eventProperties: eventProperties
        })
    }

    const createOEMContainerForStandardAndInstant = () => {

      let standard;
      let instant;
      let instant1;
      let paidInstant;
      // console.log("reder array >>>>>>", redeemOrder);
      let componentNameArray = redeemOrder

      // console.log("Component array", componentNameArray);
      let components = []



      // { console.log("Nee ttttttttttttt", (monthlyExhausted), (standardAmountCheck), (stdAndInstantCheck), (standardRedeemFlag), (Number(monthlyStandard) <= 0)) }

      {
        //   standard = <div id="standard" className="standard-container1">

        //   <div id="standardConatiner" className="standard-inner-container1" onClick={standardContainerClick}>
        //     <div id="standard_redeem" className="standard-redeem1" onClick={() => { /* handle click */ }}>
        //       <div id="radioButton1" className="radio-button-container1">
        //         <div className="radio-button1">
        //           <div className="radio-button-inner1" />
        //         </div>
        //       </div>

        //       <div className="standard-redeem-text1">
        //         <div className="standard-title1">
        //           <span className="standard-title-text1">Standard</span>
        //           <img src={TimerIcon} className="timer-icon1" />
        //         </div>
        //       </div>
        //     </div>

        //     <div className="standard-limit1">
        //       {!standardIsInCoolOff ? (
        //         <span className="limit-text1">
        //           Limit : {RUPEE_SYMBOL}
        //           <span className="limit-amount1">{standardLimitAmount}</span>
        //         </span>
        //       ) : (
        //         <span className="unlock-text1">
        //           Unlocks in <span className="unlock-time1">{nextStandardRedeemAvailability && nextStandardRedeemAvailability.split(":")[0]} hr : {nextStandardRedeemAvailability && nextStandardRedeemAvailability.split(":")[1]} min</span>
        //         </span>
        //       )}
        //     </div>

        //     <div className="standard-info1">
        //       <div className="info-container1">
        //         <div className="info-text1">
        //           {!standardEnableFlag ? (
        //             <span className="not-available1">Not Available</span>
        //           ) : (
        //             <div className="available-info1">
        //               {redeemCountersType.toLowerCase() === "monthly" ? (
        //                 <span className="monthly-info1">
        //                   <span className="monthly-amount1">{monthlyStandard}</span> left for {new Date().toLocaleString("en-US", { month: "long" }).substring(0, 3)}
        //                 </span>
        //               ) : (
        //                 <span className="daily-info1">
        //                   <span className="daily-amount1">{dailyStandardLeft}</span> left for today
        //                 </span>
        //               )}
        //             </div>
        //           )}
        //         </div>

        //         <div className="message-container1">
        //           <span className="standard-message1">{standardMessage}</span>
        //         </div>
        //       </div>
        //     </div>
        //   </div>

        // </div>

        // {console.log(" standard ref ",standardIconRef)}
        // {console.log(" standard ref 1",instantIconRef)}

        standard = <div id="standard" ref={standardIconRef} style={{ minWidth: paidInstantRedeemEnableFlag ? "42%" : "45%", height: "100%", borderRadius: "5px" }} onTouchMove={(e) => {
          // console.log("Edi move avtundi>> yuyuyuyuyuy 1", e);
          setStdShowToolTip(false);
          setInstShowToolTip(false);
          if (standardIconRef) {
            { console.log(" standard ref sdfrgregtre ", standardIconRef.current.getBoundingClientRect()) }
            { console.log(" standard ref 1 drgererterter", instantIconRef) }
          }


        }}>

          <div id="standardConatiner" className={isoemps ? ((standardIsInCoolOff) || (standardExhausted) || (!standardAmountCheck) || (!stdAndInstantCheck) || (!standardSelected) || (Number(monthlyStandard) <= 0) || showStandardUnlocksIn ? "standardConatiner" : "standardConatinerselect") : "standardConatiner"}
            style={{ border: !isoemps && ((standardIsInCoolOff) || (standardExhausted) || (!standardAmountCheck) || (!stdAndInstantCheck) || (!standardSelected) || (Number(monthlyStandard) <= 0) || showStandardUnlocksIn ? "1px solid #bababa" : "1px solid #032146") }} onClick={() => {
              // instantContainerClick
              standardContainerClick();
              // setStdShowToolTip(false);
              setInstShowToolTip(false);
            }}
            onTouchMove={(e) => {
              // console.log("Edi move avtundi>> yuyuyuyuyuy 4", e);
              setStdShowToolTip(false);
              setInstShowToolTip(false);

            }}
          >


            <div id="standard_redeem" style={{ width: "100%", height: "30%", display: "flex", alignItems: 'center', opacity: (standardIsInCoolOff) || (standardExhausted) || (!standardAmountCheck) || (!stdAndInstantCheck) || (!standardRedeemFlag) || (Number(monthlyStandard) <= 0) || showStandardUnlocksIn ? "0.4" : "1", paddingLeft: "1%" }} onClick={() => {//, opacity: standardSelected ? "1" : "0.4"
            }}>

              <div id="radioButton1" style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className='radioButtoncss1' style={{ width: "15px", height: "15px", borderRadius: "18px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <div className='radioButtoncss2' style={{ width: "10px", height: "10px", borderRadius: "15px", display: standardSelected ? ((!standardAmountCheck) || (!stdAndInstantCheck)) ? "none" : "flex" : "none", justifyContent: "center", alignItems: "center" }}>

                  </div>
                </div>
              </div>

              <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ fontSize: "14px", fontWeight: standardSelected ? "600" : "400" }} className='standardText'>Standard</span>
                  <img src={assets?.assets?.TimerIcon} style={{ width: "13px", height: "13px", paddingLeft: "5px" }}>
                  </img>

                  {/* smartRedeemForStandardOrInstant */}


                  {showStandardSmartRedeemIcon &&
                    <img src={assets?.assets?.SmartIcon} ref={standardIconRef1} style={{ width: "18px", height: "18px", paddingLeft: "5px" }} onClick={() => {

                      if ((standardIsInCoolOff) || (standardExhausted) || (!standardAmountCheck) || (!stdAndInstantCheck) || (!standardRedeemFlag) || (Number(monthlyStandard) <= 0) || showStandardUnlocksIn) {
                        return
                      }
                      setToolTipTimer(clearInterval(toolTipTimer));
                      setStdShowToolTip(true);
                      setInstShowToolTip(false);
                      setToolTipTimer(setTimeout(() => {
                        setStdShowToolTip(false);
                      }, 3000))



                    }}>
                    </img>

                    // <Tooltip
                    //   // redeemProcessingFee={true}
                    //   smartRedeemFee={true}
                    //   tooltipArrow="tooltip-arrow"
                    //   direction={"left"}
                    //   content={"Smart Redeem Available"}
                    // >
                    //   <img src={SmartIcon} style={{ marginLeft: "5px", width: "16px", height: "16px" }}></img>
                    // </Tooltip>
                  }

                  <div style={{
                    backgroundColor: "#E6C683", display: showStdToolTip ? "flex" : "none", justifyContent: "center", alignItems: "center", padding: "10px", height: "40px", position: "absolute", marginTop: "75px", borderRadius: "5px", textAlign: "left", flexDirection: "column", left:
                      // standardIconRef.current ? (standardIconRef.current.offsetLeft) / 1.5 + "px" : ""
                      standardIconRef.current ? standardIconRef.current.getBoundingClientRect().left + 5 + "px" : ""

                  }}>
                    {/* {console.log("standardIconRef1.current.getBoundingClientRect().left", standardIconRef1.current && standardIconRef1.current.getBoundingClientRect())} */}
                    <img src={Polygon} style={{
                      width: "30px", height: "15px", top: "-7px", position: "absolute",
                      left: "60%"
                      // left: standardIconRef.current ? (standardIconRef.current.offsetLeft)/2-20+"px" :""
                    }}></img>
                    {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700", width: "100%", whiteSpace: "nowrap" }}>Smart Redeem Available</span> */}
                    <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700", width: "100%", whiteSpace: "nowrap" }}>{VernacularContextData.getTransalatedKey("walletboosteravailable")}</span>
                  </div>
                </div>

              </div>


            </div>

            <div style={{ width: "100%", height: "20%", backgroundColor: "", display: "flex", alignItems: "center" }}>
              <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

              </div>
              {/* (nextStandardRedeemAvailability === "N" || !nextStandardRedeemAvailability)  */}
              {!standardIsInCoolOff ? <span className='limitText' style={{ fontSize: "12px", fontWeight: "400", paddingRight: "5px", opacity: ((standardExhausted) || (!standardAmountCheck) || (!stdAndInstantCheck)) || (!standardRedeemFlag) || (Number(monthlyStandard) <= 0) ? "0.4" : "1" }}>{VernacularContextData.getTransalatedKey("limit")} :   {RUPEE_SYMBOL}<span className='limitText' style={{ fontSize: "12px", fontWeight: "700", paddingRight: "5px" }}> {standardLimitAmount}</span></span> :
                <span className='limitText' style={{ fontSize: "0.7rem", fontWeight: "600" }}>Unlocks in <span className='colorRedOEM' style={{ fontSize: "0.7rem", fontWeight: "600" }}>{nextStandardRedeemAvailability && nextStandardRedeemAvailability.split(":")[0] === "1" ? nextStandardRedeemAvailability && nextStandardRedeemAvailability.split(":")[0] + " hr" + " : " : nextStandardRedeemAvailability && nextStandardRedeemAvailability.split(":")[0] + " hrs" + " : "}</span><span className='colorRedOEM' style={{ fontSize: "0.7rem", fontWeight: "600" }}>{(nextStandardRedeemAvailability && nextStandardRedeemAvailability.toString().split(":")[1] === "1") ? (nextStandardRedeemAvailability && nextStandardRedeemAvailability.toString().split(":")[1] + " min") : (nextStandardRedeemAvailability && nextStandardRedeemAvailability.toString().split(":")[1] + " mins")}</span></span>}

            </div>


            <div style={{ width: "100%", height: "50%", backgroundColor: "", display: "flex", marginTop: "5%", flexDirection: "column" }}>

              <div style={{ display: "flex", alignItems: "center", height: '50%', flexDirection: "column" }}>


                <div style={{ width: "100%", marginBottom: "6%", display: "flex" }}>
                  <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

                  </div>
                  {!standardEnableFlag ? <div style={{ width: "90%", height: "100%", display: "flex", alignItems: "center" }}> <span className='colorRedOEM' style={{ fontSize: "12px", fontWeight: "500" }}>Not Available</span>
                  </div> :
                    <div>
                      {redeemCountersType.toLowerCase() === "monthly" ? <span className='leftForText' style={{ fontSize: "12px", fontWeight: "400", opacity: ((monthlyExhausted) || (!standardEnableFlag) || (!standardRedeemFlag) || (standardIsInCoolOff) || (standardExhausted) || (!standardAmountCheck) || (!stdAndInstantCheck)) || (showStandardUnlocksIn) ? "0.4" : "1" }}> <span className='leftForText' style={{ fontSize: "12px", fontWeight: "700", opacity: (standardIsInCoolOff) || (standardExhausted) || (!stdAndInstantCheck) || (showStandardUnlocksIn) ? "0.4" : "1" }}>{monthlyStandard}</span> left for {new Date().toLocaleString("en-US", { month: "long", }).substring(0, 3)}</span> :
                        <span className='leftForText' style={{ fontSize: "12px", fontWeight: "400", opacity: ((!standardEnableFlag) || (!standardRedeemFlag) || (standardIsInCoolOff) || (standardExhausted) || (!standardAmountCheck) || (!stdAndInstantCheck)) || (showStandardUnlocksIn) ? "0.4" : "1" }}> <span className='leftForText' style={{ fontSize: "12px", fontWeight: "700", opacity: (dailyStandardExhausted) || (standardExhausted) || (!standardEnableFlag) || (!standardRedeemFlag) || (standardIsInCoolOff) || (standardExhausted) || (!stdAndInstantCheck) || (showStandardUnlocksIn) ? "0.4" : "1" }}>{dailyStandardLeft}</span> left for today</span>}
                    </div>
                  }

                </div>

                <div style={{ width: "100%", height: "50%", display: "flex", justifyContent: "", alignItems: "center", opacity: ((!standardAmountCheck) || (!stdAndInstantCheck)) || (!standardRedeemFlag) || (Number(monthlyStandard) <= 0) || showStandardUnlocksIn ? "0.8" : "1" }}>
                  <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

                  </div>
                  <span className='processedText' style={{ fontSize: "12px", fontWeight: "400", textAlign: "left" }}>{standardMessage}</span>
                </div>

              </div>




            </div>

          </div>

        </div>

      }


      // { console.log("nee yenkama very imp", instantExhausted) }
      {
        //   instant = <div id="instant" className="instant-container2">

        //   <div id="instantConatiner" className="instant-inner-container2" onClick={instantContainerClick}>
        //     <div id="instant_redeem" className="instant-redeem2" onClick={() => { /* handle click */ }}>
        //       <div id="radioButton2" className="radio-button-container2">
        //         <div className="radio-button2">
        //           <div className="radio-button-inner2" />
        //         </div>
        //       </div>

        //       <div className="instant-redeem-text2">
        //         <div className="instant-title2">
        //           <span className="instant-title-text2">Instant</span>
        //           <img src={PowerButton} className="power-button-icon2" />
        //         </div>
        //       </div>
        //     </div>

        //     <div className="instant-limit2">
        //       {nextInstantRedeemAvailability === "N" || !nextInstantRedeemAvailability ? (
        //         <span className="limit-text2">
        //           Limit : {RUPEE_SYMBOL}
        //           <span className="limit-amount2">{instantLimitAmount}</span>
        //         </span>
        //       ) : (
        //         <span className="unlock-text2">
        //           Unlocks in <span className="unlock-time2">{nextInstantRedeemAvailability}</span>
        //         </span>
        //       )}
        //     </div>

        //     <div className="instant-info2">
        //       {Number(lifetimeInstantRedeemsLeft) <= 0 && (
        //         <div className="no-redeem-available2">
        //           {!instantEnableFlag ? (
        //             <span className="not-available2">Not Available</span>
        //           ) : (
        //             <div className="available-info2">
        //               {redeemCountersType.toLowerCase() === "monthly" ? (
        //                 <span className="monthly-info2">
        //                   <span className="monthly-amount2">{monthlyInstant}</span> left for{" "}
        //                   {new Date().toLocaleString("en-US", { month: "long" }).substring(0, 3)}
        //                 </span>
        //               ) : (
        //                 <span className="daily-info2">
        //                   <span className="daily-amount2">{dailyInstantLeft}</span> left for today
        //                 </span>
        //               )}
        //             </div>
        //           )}
        //         </div>
        //       )}

        //       <div className="info-message2">
        //         <span className="instant-message2">Immediately</span>
        //       </div>
        //     </div>

        //   </div>

        // </div>
        instant1 = <div className='instantOEMContainer'>
          <div className='RedeemTypeInfo'>
            <div className='RedeemInfoType'>Withdraw Type : Instant</div>
            {(nextInstantRedeemAvailability === "N" || !nextInstantRedeemAvailability) ?
              <div className='LimitInfoText'>Limit:

                <span >{RUPEE_SYMBOL}{instantLimitAmount?.toLocaleString("en-IN")}</span>
              </div> :
              <span className='limitText' style={{ fontSize: "0.688rem", fontWeight: "600", marginTop: "6px" }}>
                Unlocks in:
                <span className='colorRedOEM' style={{ fontSize: "0.688rem", fontWeight: "600", marginLeft: "2px" }}>
                  {nextInstantRedeemAvailability && nextInstantRedeemAvailability.split(":")[0] === "1" ? nextInstantRedeemAvailability && nextInstantRedeemAvailability.split(":")[0] + " hr" + " : " : nextInstantRedeemAvailability && nextInstantRedeemAvailability.split(":")[0] + " hrs" + " : "}
                </span>
                <span className='colorRedOEM' style={{ fontSize: "0.7rem", fontWeight: "600" }}>{(nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] === "1") ? (nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] + " min") : (nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] + " mins")}
                </span>
              </span>}

          </div>
          <div className='ProcessTypeInfo'>
            <div className='processedInfoText'>
              Processed immediately
            </div>
            <div className='leftData'>
              {redeemCountersType.toLowerCase() === "monthly" ? monthlyInstant : dailyInstantLeft}
              <span>
                {redeemCountersType.toLowerCase() === "monthly" ? `left for ${new Date().toLocaleString("en-US", { month: "long", }).substring(0, 3)} ` : "left for today"}

              </span>
            </div>
          </div>
        </div>
        instant = <div id="instant" ref={instantIconRef} style={{ minWidth: paidInstantRedeemEnableFlag ? "42%" : "45%", height: "100%", borderRadius: "5px" }} onTouchMove={(e) => {
          // console.log("Edi move avtundi>> yuyuyuyuyuy 2", e);
          setStdShowToolTip(false);
          setInstShowToolTip(false);

        }}>
          <div className={isoemps ? (!insantReedemFlag || !instantSelected || (instantIsInCoolOff) || (instantExhausted) || !InstantAmountCheck || !stdAndInstantCheck || !instantAvailabilityFlag || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted) || standardSelected || paidInstantSelected || (hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability)) ? "standardConatiner" : "standardConatinerselect") : ""} id="instantConatiner" style={{ width: "100%", height: "100%", padding: "4%", border: !isoemps && (!insantReedemFlag || !instantSelected || (instantIsInCoolOff) || (instantExhausted) || !InstantAmountCheck || !stdAndInstantCheck || !instantAvailabilityFlag || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted) || standardSelected || paidInstantSelected || (hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability)) ? "1px solid #bababa" : "1px solid #032146"), borderRadius: "6px", display: "flex", flexDirection: "column" }} onClick={() => {
            instantContainerClick();
            setStdShowToolTip(false);
            // setInstShowToolTip(false);
          }}>
            <div id="instant_redeem" style={{ width: "100%", height: "30%", display: "flex", alignItems: 'center' }} onClick={() => {//, opacity: instantSelected ? "1" : "0.4"


            }}>
              {/* {console.log("instantIsInCoolOff LLLLL", instantIsInCoolOff)} */}
              <div id="radioButton2" style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "center", opacity: !insantReedemFlag || !InstantAmountCheck || !stdAndInstantCheck || !instantAvailabilityFlag || limitExceeded || ((instantIsInCoolOff)) || (instantExhausted) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0) || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0) ? "0.4" : "1" }}>
                <div className='radioButtoncss1' style={{ width: "15px", height: "15px", borderRadius: "18px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <div className='radioButtoncss2' style={{ width: "10px", height: "10px", borderRadius: "15px", display: instantSelected ? instantIsInCoolOff ? "none" : "flex" : "none", justifyContent: "center", alignItems: "center", }}>

                  </div>
                </div>
              </div>
              <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>

                <div style={{ display: "flex", alignItems: "center", opacity: !insantReedemFlag || !InstantAmountCheck || !stdAndInstantCheck || !instantAvailabilityFlag || limitExceeded || (instantIsInCoolOff) || (instantExhausted) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0) || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0) ? "0.4" : "1" }}>

                  <span className='standardText' style={{ fontSize: "14px", fontWeight: instantSelected ? "600" : "400" }}>Instant</span>

                  <img src={assets?.assets?.powerIcon} style={{ width: "10px", height: "20px", paddingLeft: "5px" }}>
                  </img>

                  {showInstantSmartRedeemIcon &&
                    <img src={assets?.assets?.SmartIcon} style={{ width: "18px", height: "18px", paddingLeft: "5px" }} onClick={() => {

                      if (!insantReedemFlag || !InstantAmountCheck || !stdAndInstantCheck || !instantAvailabilityFlag || limitExceeded || ((instantIsInCoolOff)) || (instantExhausted) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0) || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0)) {
                        return
                      }

                      setToolTipTimer(clearInterval(toolTipTimer));
                      setInstShowToolTip(true);
                      setStdShowToolTip(false);
                      setToolTipTimer(setTimeout(() => {
                        setInstShowToolTip(false);
                      }, 3000))



                    }}>
                    </img>
                    // <Tooltip
                    //     // redeemProcessingFee={true}
                    //     smartRedeemFee={true}
                    //     // pending={true}
                    //     // redeem={true}
                    //     // redeemEducate={true}
                    //     // redeemAcePoints={true}
                    //     // redeemProcessingFee={true}
                    //     tooltipArrow="tooltip-arrow"
                    //     direction={"right"}
                    //     content={"Smart Redeem Available"}
                    //   >
                    //     <img src={SmartIcon} style={{ marginLeft: "5px", width: "16px", height: "16px" }}></img>
                    //   </Tooltip>
                  }
                  <div style={{
                    backgroundColor: "#E6C683", display: (showInstToolTip) ? "flex" : "none", justifyContent: "center", alignItems: "center", padding: "10px", height: "40px", position: "absolute", marginTop: "75px", borderRadius: "5px", textAlign: "left", flexDirection: "column", left:
                      //  instantIconRef.current ? (instantIconRef.current.offsetLeft) / 1.5 + "px" : ""
                      instantIconRef.current ? (instantIconRef.current.getBoundingClientRect().left) + 5 + "px" : ""
                  }}>
                    <img src={Polygon} style={{
                      width: "30px", height: "15px", top: "-7px", position: "absolute",
                      left: "60%"
                    }}></img>
                    {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700", width: "100%", whiteSpace: "nowrap" }}>Smart Redeem Available</span> */}
                    <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700", width: "100%", whiteSpace: "nowrap" }}>{VernacularContextData.getTransalatedKey("walletboosteravailable")}</span>

                  </div>
                </div>

              </div>

            </div>

            <div style={{ width: "100%", height: "20%", backgroundColor: "", display: "flex", alignItems: "center", opacity: !insantReedemFlag || !InstantAmountCheck || !stdAndInstantCheck || !instantAvailabilityFlag || limitExceeded || (instantExhausted) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0) || showInstantErrorToolTip || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0) ? "0.4" : "1" }}>
              <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

              </div>
              {(nextInstantRedeemAvailability === "N" || !nextInstantRedeemAvailability) ? <span className='limitText' style={{ fontSize: "12px", fontWeight: "400", paddingRight: "5px" }}> {VernacularContextData.getTransalatedKey("limit")} :   {RUPEE_SYMBOL}<span className='limitText' style={{ fontSize: "12px", fontWeight: "700", paddingRight: "5px" }}> {instantLimitAmount}</span></span> :
                <span className='limitText' style={{ fontSize: "0.7rem", fontWeight: "600" }}>Unlocks in <span className='colorRedOEM' style={{ fontSize: "0.7rem", fontWeight: "600" }}>{nextInstantRedeemAvailability && nextInstantRedeemAvailability.split(":")[0] === "1" ? nextInstantRedeemAvailability && nextInstantRedeemAvailability.split(":")[0] + " hr" + " : " : nextInstantRedeemAvailability && nextInstantRedeemAvailability.split(":")[0] + " hrs" + " : "}</span><span className='colorRedOEM' style={{ fontSize: "0.7rem", fontWeight: "600" }}>{(nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] === "1") ? (nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] + " min") : (nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] + " mins")}</span></span>}
            </div>

            <div style={{ width: "100%", height: "50%", backgroundColor: "", display: "flex", marginTop: "5%", flexDirection: "column" }}>

              {Number(lifetimeInstantRedeemsLeft) <= 0 && <div style={{ display: "flex", alignItems: "center", height: '50%' }}>
                <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

                </div>

                {!instantEnableFlag ? <div style={{ width: "90%", height: "100%", display: "flex", alignItems: "center" }}> <span className='colorRedOEM' style={{ fontSize: "12px", fontWeight: "500" }}>Not Available</span>



                </div> :
                  <div>
                    {redeemCountersType.toLowerCase() === "monthly" ? <span className='leftForText' style={{ fontSize: "12px", fontWeight: "400", opacity: !insantReedemFlag || !InstantAmountCheck || !stdAndInstantCheck || limitExceeded || (instantIsInCoolOff) || (instantExhausted) || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0) ? "0.4" : "1" }}> <span className='leftForText' style={{ fontSize: "12px", fontWeight: "700" }}>{monthlyInstant}</span> left for {new Date().toLocaleString("en-US", { month: "long", }).substring(0, 3)}</span>
                      :
                      <span className='leftForText' style={{ fontSize: "12px", fontWeight: "400", opacity: !insantReedemFlag || dailyInstantExhausted || !InstantAmountCheck || !stdAndInstantCheck || limitExceeded || (instantIsInCoolOff) || (instantExhausted) || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0) ? "0.4" : "1" }}>{redeemCountersType.toLowerCase() === "monthly" ? "" : ""} <span className='leftForText' style={{ fontSize: "12px", fontWeight: "700" }}>{dailyInstantLeft}</span> left for today</span>}
                  </div>

                }
              </div>}

              <div style={{ width: "100%", height: "50%", display: "flex", justifyContent: "", alignItems: "center", opacity: !insantReedemFlag || !InstantAmountCheck || !stdAndInstantCheck || !instantAvailabilityFlag || limitExceeded || (instantIsInCoolOff) || (instantExhausted) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0) || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0) ? "0.8" : "1" }}>
                <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

                </div>
                <span className='processedText' style={{ fontSize: "12px", fontWeight: "400", textAlign: "left" }}>Immediately</span>
              </div>

            </div>


          </div>


        </div>
      }

      // paid in cooloff >>>>> xxxxx false true true true undefined
      // { console.log("paid in cooloff >>>>> xxxxx", paidInstantIsInCoolOff, showPaidRedeems, paidInstantAmountCheck, paidInstantSelected, paidInstantExhausted) }
      // { console.log("444444444444 >>>> ", (paidInstantIsInCoolOff), paidInstantExhausted, paidInstantAmountCheck) }
      {
        paidInstant = <div id='paidInstant' style={{ minWidth: paidInstantRedeemEnableFlag ? "42%" : "45%", height: "100%", borderRadius: "5px", marginRight: "5px" }} onTouchMove={(e) => {
          // console.log("Edi move avtundi>> yuyuyuyuyuy 3", e);
          setStdShowToolTip(false);
          setInstShowToolTip(false);

        }}>
          <div id="paidInstantConatiner" className={isoemps ? ((paidInstantIsInCoolOff) || !paidInstantAmountCheck || !paidInstantSelected || paidInstantExhausted ? "standardConatiner" : "standardConatinerselect") : "standardConatiner"}
            style={{ width: "100%", height: "100%", border: !isoemps && ((paidInstantIsInCoolOff) || !paidInstantAmountCheck || !paidInstantSelected || paidInstantExhausted ? "1px solid #bababa" : "1px solid #032146"), borderRadius: "6px", display: "flex", flexDirection: "column", paddingBottom: "2%", paddingLeft: "2%" }}//Need to change in OEM1
            onClick={() => {
              paidInstantContainerClick();
              setStdShowToolTip(false);
              setInstShowToolTip(false);
            }}>

            <div className='paidinstanttag' style={{ width: "100%", height: "25px", backgroundColor: "", display: "flex", justifyContent: "center", backgroundImage: "url(" + assets?.assets?.PaidInstantProcessingFeeBadge + ")", backgroundPosition: "center", backgroundRepeat: "no-repeat", textAlign: "center", fontSize: "9px", color: !isoemps ? "#ffffff" : " #000000", fontWeight: "600", paddingTop: "2.5%", backgroundSize: "75%" }}>{paidInstantRedeemProcessingFee}% Processing Fee</div>
            <div id="paid_instant_redeem" style={{ width: "100%", height: "30%", display: "flex", alignItems: 'center' }} onClick={() => {//, opacity: instantSelected ? "1" : "0.4"


            }}>
              <div id="radioButton3" style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "center", opacity: (paidInstantIsInCoolOff) || paidInstantExhausted || !paidInstantAmountCheck ? "0.4" : "1" }}>
                <div className='radioButtoncss1' style={{ width: "15px", height: "15px", borderRadius: "18px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <div className='radioButtoncss2' style={{ width: "10px", height: "10px", borderRadius: "15px", display: paidInstantSelected ? "flex" : "none", justifyContent: "center", alignItems: "center", }}>

                  </div>
                </div>
              </div>
              <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>

                <div style={{ display: "flex", alignItems: "center", opacity: (paidInstantIsInCoolOff) || paidInstantExhausted || !paidInstantAmountCheck ? "0.4" : "1" }}>
                  {/* Paid Instant */}
                  <span className='standardText' style={{ fontSize: "14px", fontWeight: paidInstantSelected ? "600" : "400" }}>Prime Instant</span>

                  <img src={assets?.assets?.PaidInstantIcon} style={{ width: "15px", height: "20px", paddingLeft: "5px" }}>
                  </img>
                </div>

              </div>

            </div>

            <div style={{ width: "100%", height: "20%", backgroundColor: "", display: "flex", alignItems: "center", opacity: paidInstantExhausted || !paidInstantAmountCheck ? "0.4" : "1" }}>
              <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

              </div>
              {(nextPaidInstantRedeemAvailability === "N" || !nextPaidInstantRedeemAvailability) ? <span className='limitText' style={{ fontSize: "12px", fontWeight: "400", paddingRight: "5px" }}>{VernacularContextData.getTransalatedKey("limit")} :   {RUPEE_SYMBOL}<span className='limitText' style={{ fontSize: "12px", fontWeight: "700", paddingRight: "5px" }}> {paidInstantLimitAmount}</span></span> :
                <span className='standardText' style={{ fontSize: "0.7rem", fontWeight: "600" }}>Unlocks in <span className='colorRedOEM' style={{ fontSize: "0.7rem", fontWeight: "600" }}>{nextPaidInstantRedeemAvailability && nextPaidInstantRedeemAvailability.split(":")[0] === "1" ? nextPaidInstantRedeemAvailability && nextPaidInstantRedeemAvailability.split(":")[0] + " hr" + " : " : nextPaidInstantRedeemAvailability && nextPaidInstantRedeemAvailability.split(":")[0] + " hrs" + " : "}</span><span className='colorRedOEM' style={{ fontSize: "0.7rem", fontWeight: "600" }}>{(nextPaidInstantRedeemAvailability && nextPaidInstantRedeemAvailability.toString().split(":")[1] === "1") ? (nextPaidInstantRedeemAvailability && nextPaidInstantRedeemAvailability.toString().split(":")[1] + " min") : (nextPaidInstantRedeemAvailability && nextPaidInstantRedeemAvailability.toString().split(":")[1] + " mins")}</span></span>}
            </div>

            <div style={{ width: "100%", height: "50%", backgroundColor: "", display: "flex", marginTop: "5%", flexDirection: "column" }}>
              {<div style={{ display: "flex", alignItems: "center", height: '50%' }}>
                <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

                </div>
                {!paidInstantRedeemEnableFlag ? <div style={{ width: "90%", height: "100%", display: "flex", alignItems: "center" }}> <span className='colorRedOEM' style={{ fontSize: "12px", fontWeight: "500" }}>Not Available</span>

                  <div style={{ backgroundColor: "", display: "flex", flexDirection: "column" }}>

                    <img src={QuestionIcon} style={{ width: "20px", height: "20px", marginLeft: "10px" }} onClick={() => {
                      setToolTipTimer(clearInterval(toolTipTimer));
                      setShowToolTip(true);
                      setToolTipTimer(setTimeout(() => {
                        setShowToolTip(false);
                      }, 3000))

                    }}></img>
                    <div style={{ backgroundColor: "#E6C683", display: showToolTip ? "flex" : "none", justifyContent: "center", alignItems: "center", width: "230px", height: "55px", position: "absolute", zIndex: "2", marginTop: "25px", marginLeft: "-150px", borderRadius: "5px", textAlign: "left" }}>
                      <span className='standardText' style={{ fontSize: "12px", fontWeight: "400", width: "80%" }}>{instantAvailabilityMessage}</span>
                      <img src={BlueCross} style={{ marginTop: "-20px", marginLeft: "10px" }} onClick={() => {
                        setToolTipTimer(clearInterval(toolTipTimer));
                        setShowToolTip(false);


                      }}></img>
                    </div>
                  </div>

                </div> :

                  paidRedeemLimit < 0 ? <span className='standardText' style={{ fontSize: "12px", fontWeight: "400", opacity: (paidInstantIsInCoolOff) || paidInstantExhausted || !paidInstantAmountCheck ? "0.4" : "1" }}> <span className='standardText' style={{ fontSize: "12px", fontWeight: "700" }}>{"Unlimited"}</span></span> :
                    redeemCountersType.toLocaleLowerCase() === 'monthly' ? <span className='leftForText' style={{ fontSize: "12px", fontWeight: "400", opacity: (paidInstantIsInCoolOff) || paidInstantExhausted || !paidInstantAmountCheck ? "0.4" : "1" }}> <span className='leftForText' style={{ fontSize: "12px", fontWeight: "700" }}>{paidRedeemLimit}</span> left for {new Date().toLocaleString("en-US", { month: "long", }).substring(0, 3)}</span> :
                      <span className='leftForText' style={{ fontSize: "12px", fontWeight: "400", opacity: (paidInstantIsInCoolOff) || paidInstantExhausted || !paidInstantAmountCheck ? "0.4" : "1" }}> <span className='leftForText' style={{ fontSize: "12px", fontWeight: "700" }}>{paidRedeemLimit}</span> left for today</span>}

              </div>}

              <div style={{ width: "100%", height: "50%", display: "flex", justifyContent: "", alignItems: "center", opacity: (paidInstantIsInCoolOff) || paidInstantExhausted || !paidInstantAmountCheck ? "0.8" : "1" }}>
                <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

                </div>
                <span className='processedText' style={{ fontSize: "12px", fontWeight: "400", textAlign: "left" }}>{paidInstantMessage}</span>
              </div>

            </div>

          </div>

        </div>
      }

      if (componentNameArray) {
        componentNameArray.forEach(componentName => {
          //paidInstant', 'instant', 'standard
          // console.log("compu name ", componentName);
          if (componentName.toLowerCase() === 'paidinstant') {
            // console.log("bdsnndsfndsfkjnsf");
            components.push(paidInstant)

          } else if (componentName.toLowerCase() === 'instant') {
            components.push(instant)
          }
          else if (componentName.toLowerCase() === 'standard') {
            components.push(standard)
          }
        });
      }
      if (!standardRedeemFlag && insantReedemFlag && !paidInstantRedeemEnableFlag) {
        return instant1;
      }
      return components
    }
    const createContainerForStandardAndInstant = () => {

      let standard;
      let instant;
      let paidInstant;
      // console.log("reder array >>>>>>", redeemOrder);
      let componentNameArray = redeemOrder

      // console.log("Component array", componentNameArray);
      let components = []



      // { console.log("Nee ttttttttttttt", (monthlyExhausted), (standardAmountCheck), (stdAndInstantCheck), (standardRedeemFlag), (Number(monthlyStandard) <= 0)) }

      {


        standard = <div id="standard" ref={standardIconRef} style={{ minWidth: paidInstantRedeemEnableFlag ? "42%" : "45%", height: "100%", borderRadius: "5px" }} onTouchMove={(e) => {
          // console.log("Edi move avtundi>> yuyuyuyuyuy 1", e);
          setStdShowToolTip(false);
          setInstShowToolTip(false);
          if (standardIconRef) {
            { console.log(" standard ref sdfrgregtre ", standardIconRef.current.getBoundingClientRect()) }
            { console.log(" standard ref 1 drgererterter", instantIconRef) }
          }


        }}>

          <div id="standardConatiner" className={isoemps ? ((standardIsInCoolOff) || (standardExhausted) || (!standardAmountCheck) || (!stdAndInstantCheck) || (!standardSelected) || (Number(monthlyStandard) <= 0) || showStandardUnlocksIn ? "standardConatiner" : "standardConatinerselect") : "standardConatiner"}
            style={{ border: !isoemps && ((standardIsInCoolOff) || (standardExhausted) || (!standardAmountCheck) || (!stdAndInstantCheck) || (!standardSelected) || (Number(monthlyStandard) <= 0) || showStandardUnlocksIn ? "1px solid #bababa" : "1px solid #032146") }} onClick={() => {
              // instantContainerClick
              standardContainerClick();
              // setStdShowToolTip(false);
              setInstShowToolTip(false);
            }}
            onTouchMove={(e) => {
              // console.log("Edi move avtundi>> yuyuyuyuyuy 4", e);
              setStdShowToolTip(false);
              setInstShowToolTip(false);

            }}
          >
            {applicableForStandard && <div className='paidinstanttag' style={{ width: "100%", height: "25px", backgroundColor: "", display: "flex", justifyContent: "center", backgroundImage: "url(" + assets?.assets?.tdsCashbackTag + ")", backgroundPosition: "center", backgroundRepeat: "no-repeat", textAlign: "center", fontSize: "9px", color: !isoemps ? "#ffffff" : " #000000", fontWeight: "600", paddingTop: "2.5%", backgroundSize: "75%" }}></div>}
            <div id="standard_redeem" style={{ width: "100%", height: "30%", display: "flex", alignItems: 'center', opacity: (standardIsInCoolOff) || (standardExhausted) || (!standardAmountCheck) || (!stdAndInstantCheck) || (!standardRedeemFlag) || (Number(monthlyStandard) <= 0) || showStandardUnlocksIn ? "0.4" : "1", paddingLeft: "1%" }} onClick={() => {//, opacity: standardSelected ? "1" : "0.4"
            }}>

              <div id="radioButton1" style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className='radioButtoncss1' style={{ width: "15px", height: "15px", borderRadius: "18px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <div className='radioButtoncss2' style={{ width: "10px", height: "10px", borderRadius: "15px", display: standardSelected ? ((!standardAmountCheck) || (!stdAndInstantCheck)) ? "none" : "flex" : "none", justifyContent: "center", alignItems: "center" }}>

                  </div>
                </div>
              </div>

              <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ fontSize: "14px", fontWeight: standardSelected ? "600" : "400" }} className='standardText'>{VernacularContextData.getTransalatedKey("standard")}</span>
                  <img src={assets?.assets?.TimerIcon} style={{ width: "13px", height: "13px", paddingLeft: "5px" }}>
                  </img>

                  {/* smartRedeemForStandardOrInstant */}


                  {showStandardSmartRedeemIcon &&
                    <img src={assets?.assets?.SmartIcon} ref={standardIconRef1} style={{ width: "18px", height: "18px", paddingLeft: "5px" }} onClick={() => {

                      if ((standardIsInCoolOff) || (standardExhausted) || (!standardAmountCheck) || (!stdAndInstantCheck) || (!standardRedeemFlag) || (Number(monthlyStandard) <= 0) || showStandardUnlocksIn) {
                        return
                      }
                      setToolTipTimer(clearInterval(toolTipTimer));
                      setStdShowToolTip(true);
                      setInstShowToolTip(false);
                      setToolTipTimer(setTimeout(() => {
                        setStdShowToolTip(false);
                      }, 3000))



                    }}>
                    </img>

                    // <Tooltip
                    //   // redeemProcessingFee={true}
                    //   smartRedeemFee={true}
                    //   tooltipArrow="tooltip-arrow"
                    //   direction={"left"}
                    //   content={"Smart Redeem Available"}
                    // >
                    //   <img src={SmartIcon} style={{ marginLeft: "5px", width: "16px", height: "16px" }}></img>
                    // </Tooltip>
                  }

                  <div style={{
                    backgroundColor: "#E6C683", display: showStdToolTip ? "flex" : "none", justifyContent: "center", alignItems: "center", padding: "10px", height: "40px", position: "absolute", marginTop: "75px", borderRadius: "5px", textAlign: "left", flexDirection: "column", left:
                      // standardIconRef.current ? (standardIconRef.current.offsetLeft) / 1.5 + "px" : ""
                      standardIconRef.current ? standardIconRef.current.getBoundingClientRect().left + 5 + "px" : ""

                  }}>
                    {/* {console.log("standardIconRef1.current.getBoundingClientRect().left", standardIconRef1.current && standardIconRef1.current.getBoundingClientRect())} */}
                    <img src={Polygon} style={{
                      width: "30px", height: "15px", top: "-7px", position: "absolute",
                      left: "60%"
                      // left: standardIconRef.current ? (standardIconRef.current.offsetLeft)/2-20+"px" :""
                    }}></img>
                    {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700", width: "100%", whiteSpace: "nowrap" }}>Smart Redeem Available</span> */}
                    <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700", width: "100%", whiteSpace: "nowrap" }}>{VernacularContextData.getTransalatedKey("walletboosteravailable")}</span>

                  </div>
                </div>

              </div>


            </div>

            <div style={{ width: "100%", height: "20%", backgroundColor: "", display: "flex", alignItems: "center" }}>
              <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

              </div>
              {/* (nextStandardRedeemAvailability === "N" || !nextStandardRedeemAvailability)  */}
              {!standardIsInCoolOff ? <span className='limitText' style={{ fontSize: "12px", fontWeight: "400", paddingRight: "5px", opacity: ((standardExhausted) || (!standardAmountCheck) || (!stdAndInstantCheck)) || (!standardRedeemFlag) || (Number(monthlyStandard) <= 0) ? "0.4" : "1" }}>{VernacularContextData.getTransalatedKey("limit")} :   {RUPEE_SYMBOL}<span className='limitText' style={{ fontSize: "12px", fontWeight: "700", paddingRight: "5px" }}> {standardLimitAmount}</span></span> :
                <span className='limitText' style={{ fontSize: "0.7rem", fontWeight: "600" }}>{VernacularContextData.getTransalatedKey("unlocksin")} <span className='colorRedOEM' style={{ fontSize: "0.7rem", fontWeight: "600" }}>{nextStandardRedeemAvailability && nextStandardRedeemAvailability.split(":")[0] === "1" ? nextStandardRedeemAvailability && nextStandardRedeemAvailability.split(":")[0] + " hr" + " : " : nextStandardRedeemAvailability && nextStandardRedeemAvailability.split(":")[0] + " hrs" + " : "}</span><span className='colorRedOEM' style={{ fontSize: "0.7rem", fontWeight: "600" }}>{(nextStandardRedeemAvailability && nextStandardRedeemAvailability.toString().split(":")[1] === "1") ? (nextStandardRedeemAvailability && nextStandardRedeemAvailability.toString().split(":")[1] + " min") : (nextStandardRedeemAvailability && nextStandardRedeemAvailability.toString().split(":")[1] + " mins")}</span></span>}

            </div>


            <div style={{ width: "100%", height: "50%", backgroundColor: "", display: "flex", marginTop: "5%", flexDirection: "column" }}>

              <div style={{ display: "flex", alignItems: "center", height: '50%', flexDirection: "column" }}>


                <div style={{ width: "100%", marginBottom: "6%", display: "flex" }}>
                  <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

                  </div>
                  {!standardEnableFlag ? <div style={{ width: "90%", height: "100%", display: "flex", alignItems: "center" }}> <span className='colorRedOEM' style={{ fontSize: "12px", fontWeight: "500" }}>{VernacularContextData.getTransalatedKey("notavailable")}</span>
                  </div> :
                    <div>
                      {redeemCountersType.toLowerCase() === "monthly" ? <span className='leftForText' style={{ fontSize: "12px", fontWeight: "400", opacity: ((monthlyExhausted) || (!standardEnableFlag) || (!standardRedeemFlag) || (standardIsInCoolOff) || (standardExhausted) || (!standardAmountCheck) || (!stdAndInstantCheck)) || (showStandardUnlocksIn) ? "0.4" : "1" }}> <span className='leftForText' style={{ fontSize: "12px", fontWeight: "700", opacity: (standardIsInCoolOff) || (standardExhausted) || (!stdAndInstantCheck) || (showStandardUnlocksIn) ? "0.4" : "1" }}>{monthlyStandard}</span> left for {new Date().toLocaleString("en-US", { month: "long", }).substring(0, 3)}</span> :
                        <span className='leftForText' style={{ fontSize: "12px", fontWeight: "400", opacity: ((!standardEnableFlag) || (!standardRedeemFlag) || (standardIsInCoolOff) || (standardExhausted) || (!standardAmountCheck) || (!stdAndInstantCheck)) || (showStandardUnlocksIn) ? "0.4" : "1" }}> <span className='leftForText' style={{ fontSize: "12px", fontWeight: "700", opacity: (dailyStandardExhausted) || (standardExhausted) || (!standardEnableFlag) || (!standardRedeemFlag) || (standardIsInCoolOff) || (standardExhausted) || (!stdAndInstantCheck) || (showStandardUnlocksIn) ? "0.4" : "1" }}>{dailyStandardLeft}</span> left for today</span>}
                    </div>
                  }

                </div>

                <div style={{ width: "100%", height: "50%", display: "flex", justifyContent: "", alignItems: "center", opacity: ((!standardAmountCheck) || (!stdAndInstantCheck)) || (!standardRedeemFlag) || (Number(monthlyStandard) <= 0) || showStandardUnlocksIn ? "0.8" : "1" }}>
                  <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

                  </div>
                  <span className='processedText' style={{ fontSize: "12px", fontWeight: "400", textAlign: "left" }}>{standardMessage}</span>
                </div>

              </div>




            </div>

          </div>

        </div>

      }


      // { console.log("nee yenkama very imp", instantExhausted) }
      {
        //   instant = <div id="instant" className="instant-container2">

        //   <div id="instantConatiner" className="instant-inner-container2" onClick={instantContainerClick}>
        //     <div id="instant_redeem" className="instant-redeem2" onClick={() => { /* handle click */ }}>
        //       <div id="radioButton2" className="radio-button-container2">
        //         <div className="radio-button2">
        //           <div className="radio-button-inner2" />
        //         </div>
        //       </div>

        //       <div className="instant-redeem-text2">
        //         <div className="instant-title2">
        //           <span className="instant-title-text2">Instant</span>
        //           <img src={PowerButton} className="power-button-icon2" />
        //         </div>
        //       </div>
        //     </div>

        //     <div className="instant-limit2">
        //       {nextInstantRedeemAvailability === "N" || !nextInstantRedeemAvailability ? (
        //         <span className="limit-text2">
        //           Limit : {RUPEE_SYMBOL}
        //           <span className="limit-amount2">{instantLimitAmount}</span>
        //         </span>
        //       ) : (
        //         <span className="unlock-text2">
        //           Unlocks in <span className="unlock-time2">{nextInstantRedeemAvailability}</span>
        //         </span>
        //       )}
        //     </div>

        //     <div className="instant-info2">
        //       {Number(lifetimeInstantRedeemsLeft) <= 0 && (
        //         <div className="no-redeem-available2">
        //           {!instantEnableFlag ? (
        //             <span className="not-available2">Not Available</span>
        //           ) : (
        //             <div className="available-info2">
        //               {redeemCountersType.toLowerCase() === "monthly" ? (
        //                 <span className="monthly-info2">
        //                   <span className="monthly-amount2">{monthlyInstant}</span> left for{" "}
        //                   {new Date().toLocaleString("en-US", { month: "long" }).substring(0, 3)}
        //                 </span>
        //               ) : (
        //                 <span className="daily-info2">
        //                   <span className="daily-amount2">{dailyInstantLeft}</span> left for today
        //                 </span>
        //               )}
        //             </div>
        //           )}
        //         </div>
        //       )}

        //       <div className="info-message2">
        //         <span className="instant-message2">Immediately</span>
        //       </div>
        //     </div>

        //   </div>

        // </div>

        instant = <div id="instant" ref={instantIconRef} style={{ minWidth: paidInstantRedeemEnableFlag ? "42%" : "45%", height: "100%", borderRadius: "5px" }} onTouchMove={(e) => {
          // console.log("Edi move avtundi>> yuyuyuyuyuy 2", e);
          setStdShowToolTip(false);
          setInstShowToolTip(false);

        }}>

          <div className={isoemps ? (!insantReedemFlag || !instantSelected || (instantIsInCoolOff) || (instantExhausted) || !InstantAmountCheck || !stdAndInstantCheck || !instantAvailabilityFlag || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted) || standardSelected || paidInstantSelected || (hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability)) ? "standardConatiner" : "standardConatinerselect") : ""} id="instantConatiner" style={{ width: "100%", height: "100%", padding: "4%", border: !isoemps && (!insantReedemFlag || !instantSelected || (instantIsInCoolOff) || (instantExhausted) || !InstantAmountCheck || !stdAndInstantCheck || !instantAvailabilityFlag || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted) || standardSelected || paidInstantSelected || (hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability)) ? "1px solid #bababa" : "1px solid #032146"), borderRadius: "6px", display: "flex", flexDirection: "column" }} onClick={() => {
            instantContainerClick();
            setStdShowToolTip(false);
            // setInstShowToolTip(false);
          }}>
            {applicableForInstant && <div className='paidinstanttag' style={{ width: "100%", height: "25px", backgroundColor: "", display: "flex", justifyContent: "center", backgroundImage: "url(" + assets?.assets?.tdsCashbackTag + ")", backgroundPosition: "center", backgroundRepeat: "no-repeat", textAlign: "center", fontSize: "9px", color: !isoemps ? "#ffffff" : " #000000", fontWeight: "600", paddingTop: "2.5%", backgroundSize: "75%" }}></div>}
            <div id="instant_redeem" style={{ width: "100%", height: "30%", display: "flex", alignItems: 'center' }} onClick={() => {//, opacity: instantSelected ? "1" : "0.4"


            }}>
              {/* {console.log("instantIsInCoolOff LLLLL", instantIsInCoolOff)} */}
              <div id="radioButton2" style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "center", opacity: !insantReedemFlag || !InstantAmountCheck || !stdAndInstantCheck || !instantAvailabilityFlag || limitExceeded || ((instantIsInCoolOff)) || (instantExhausted) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0) || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0) ? "0.4" : "1" }}>
                <div className='radioButtoncss1' style={{ width: "15px", height: "15px", borderRadius: "18px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <div className='radioButtoncss2' style={{ width: "10px", height: "10px", borderRadius: "15px", display: instantSelected ? instantIsInCoolOff ? "none" : "flex" : "none", justifyContent: "center", alignItems: "center", }}>

                  </div>
                </div>
              </div>
              <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>

                <div style={{ display: "flex", alignItems: "center", opacity: !insantReedemFlag || !InstantAmountCheck || !stdAndInstantCheck || !instantAvailabilityFlag || limitExceeded || (instantIsInCoolOff) || (instantExhausted) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0) || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0) ? "0.4" : "1" }}>

                  <span className='standardText' style={{ fontSize: "14px", fontWeight: instantSelected ? "600" : "400" }}>{VernacularContextData.getTransalatedKey("instant")}</span>

                  <img src={assets?.assets?.powerIcon} style={{ width: "10px", height: "20px", paddingLeft: "5px" }}>
                  </img>

                  {showInstantSmartRedeemIcon &&
                    <img src={assets?.assets?.SmartIcon} style={{ width: "18px", height: "18px", paddingLeft: "5px" }} onClick={() => {

                      if (!insantReedemFlag || !InstantAmountCheck || !stdAndInstantCheck || !instantAvailabilityFlag || limitExceeded || ((instantIsInCoolOff)) || (instantExhausted) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0) || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0)) {
                        return
                      }

                      setToolTipTimer(clearInterval(toolTipTimer));
                      setInstShowToolTip(true);
                      setStdShowToolTip(false);
                      setToolTipTimer(setTimeout(() => {
                        setInstShowToolTip(false);
                      }, 3000))



                    }}>
                    </img>
                    // <Tooltip
                    //     // redeemProcessingFee={true}
                    //     smartRedeemFee={true}
                    //     // pending={true}
                    //     // redeem={true}
                    //     // redeemEducate={true}
                    //     // redeemAcePoints={true}
                    //     // redeemProcessingFee={true}
                    //     tooltipArrow="tooltip-arrow"
                    //     direction={"right"}
                    //     content={"Smart Redeem Available"}
                    //   >
                    //     <img src={SmartIcon} style={{ marginLeft: "5px", width: "16px", height: "16px" }}></img>
                    //   </Tooltip>
                  }
                  <div style={{
                    backgroundColor: "#E6C683", display: (showInstToolTip) ? "flex" : "none", justifyContent: "center", alignItems: "center", padding: "10px", height: "40px", position: "absolute", marginTop: "75px", borderRadius: "5px", textAlign: "left", flexDirection: "column", left:
                      //  instantIconRef.current ? (instantIconRef.current.offsetLeft) / 1.5 + "px" : ""
                      instantIconRef.current ? (instantIconRef.current.getBoundingClientRect().left) + 5 + "px" : ""
                  }}>
                    <img src={Polygon} style={{
                      width: "30px", height: "15px", top: "-7px", position: "absolute",
                      left: "60%"
                    }}></img>
                    {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700", width: "100%", whiteSpace: "nowrap" }}>Smart Redeem Available</span> */}
                    <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700", width: "100%", whiteSpace: "nowrap" }}>{VernacularContextData.getTransalatedKey("walletboosteravailable")}</span>

                  </div>
                </div>

              </div>

            </div>

            <div style={{ width: "100%", height: "20%", backgroundColor: "", display: "flex", alignItems: "center", opacity: !insantReedemFlag || !InstantAmountCheck || !stdAndInstantCheck || !instantAvailabilityFlag || limitExceeded || (instantExhausted) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0) || showInstantErrorToolTip || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0) ? "0.4" : "1" }}>
              <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

              </div>
              {(nextInstantRedeemAvailability === "N" || !nextInstantRedeemAvailability) ? <span className='limitText' style={{ fontSize: "12px", fontWeight: "400", paddingRight: "5px" }}>{VernacularContextData.getTransalatedKey("limit")} :   {RUPEE_SYMBOL}<span className='limitText' style={{ fontSize: "12px", fontWeight: "700", paddingRight: "5px" }}> {instantLimitAmount}</span></span> :
                <span className='limitText' style={{ fontSize: "0.7rem", fontWeight: "600" }}>Unlocks in <span className='colorRedOEM' style={{ fontSize: "0.7rem", fontWeight: "600" }}>{nextInstantRedeemAvailability && nextInstantRedeemAvailability.split(":")[0] === "1" ? nextInstantRedeemAvailability && nextInstantRedeemAvailability.split(":")[0] + " hr" + " : " : nextInstantRedeemAvailability && nextInstantRedeemAvailability.split(":")[0] + " hrs" + " : "}</span><span className='colorRedOEM' style={{ fontSize: "0.7rem", fontWeight: "600" }}>{(nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] === "1") ? (nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] + " min") : (nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] + " mins")}</span></span>}
            </div>

            <div style={{ width: "100%", height: "50%", backgroundColor: "", display: "flex", marginTop: "5%", flexDirection: "column" }}>

              {Number(lifetimeInstantRedeemsLeft) <= 0 && <div style={{ display: "flex", alignItems: "center", height: '50%' }}>
                <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

                </div>

                {!instantEnableFlag ? <div style={{ width: "90%", height: "100%", display: "flex", alignItems: "center" }}> <span className='colorRedOEM' style={{ fontSize: "12px", fontWeight: "500" }}>Not Available</span>



                </div> :
                  <div>
                    {redeemCountersType.toLowerCase() === "monthly" ? <span className='leftForText' style={{ fontSize: "12px", fontWeight: "400", opacity: !insantReedemFlag || !InstantAmountCheck || !stdAndInstantCheck || limitExceeded || (instantIsInCoolOff) || (instantExhausted) || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0) ? "0.4" : "1" }}> <span className='leftForText' style={{ fontSize: "12px", fontWeight: "700" }}>{monthlyInstant}</span> left for {new Date().toLocaleString("en-US", { month: "long", }).substring(0, 3)}</span>
                      :
                      <span className='leftForText' style={{ fontSize: "12px", fontWeight: "400", opacity: !insantReedemFlag || dailyInstantExhausted || !InstantAmountCheck || !stdAndInstantCheck || limitExceeded || (instantIsInCoolOff) || (instantExhausted) || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0) ? "0.4" : "1" }}>{redeemCountersType.toLowerCase() === "monthly" ? "" : ""} <span className='leftForText' style={{ fontSize: "12px", fontWeight: "700" }}>{dailyInstantLeft}</span> left for today</span>}
                  </div>

                }
              </div>}

              <div style={{ width: "100%", height: "50%", display: "flex", justifyContent: "", alignItems: "center", opacity: !insantReedemFlag || !InstantAmountCheck || !stdAndInstantCheck || !instantAvailabilityFlag || limitExceeded || (instantIsInCoolOff) || (instantExhausted) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0) || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0) ? "0.8" : "1" }}>
                <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

                </div>
                <span className='processedText' style={{ fontSize: "12px", fontWeight: "400", textAlign: "left" }}>Immediately</span>
              </div>

            </div>


          </div>


        </div>
      }

      // paid in cooloff >>>>> xxxxx false true true true undefined
      // { console.log("paid in cooloff >>>>> xxxxx", paidInstantIsInCoolOff, showPaidRedeems, paidInstantAmountCheck, paidInstantSelected, paidInstantExhausted) }
      // { console.log("444444444444 >>>> ", (paidInstantIsInCoolOff), paidInstantExhausted, paidInstantAmountCheck) }
      {
        paidInstant = <div id='paidInstant' style={{ minWidth: paidInstantRedeemEnableFlag ? "42%" : "45%", height: "100%", borderRadius: "5px", marginRight: "5px" }} onTouchMove={(e) => {
          // console.log("Edi move avtundi>> yuyuyuyuyuy 3", e);
          setStdShowToolTip(false);
          setInstShowToolTip(false);

        }}>
          <div id="paidInstantConatiner" className={isoemps ? ((paidInstantIsInCoolOff) || !paidInstantAmountCheck || !paidInstantSelected || paidInstantExhausted ? "standardConatiner" : "standardConatinerselect") : "standardConatiner"}
            style={{ width: "100%", height: "100%", border: !isoemps && ((paidInstantIsInCoolOff) || !paidInstantAmountCheck || !paidInstantSelected || paidInstantExhausted ? "1px solid #bababa" : "1px solid #032146"), borderRadius: "6px", display: "flex", flexDirection: "column", paddingBottom: "2%", paddingLeft: "2%" }}//Need to change in OEM1
            onClick={() => {
              paidInstantContainerClick();
              setStdShowToolTip(false);
              setInstShowToolTip(false);
            }}>

            <div className='paidinstanttag' style={{ width: "100%", height: "25px", backgroundColor: "", display: "flex", justifyContent: "center", backgroundImage: "url(" + assets?.assets?.PaidInstantProcessingFeeBadge + ")", backgroundPosition: "center", backgroundRepeat: "no-repeat", textAlign: "center", fontSize: "9px", color: !isoemps ? "#ffffff" : " #000000", fontWeight: "600", paddingTop: "2.5%", backgroundSize: "75%" }}>{paidInstantRedeemProcessingFee}% Processing Fee</div>
            <div id="paid_instant_redeem" style={{ width: "100%", height: "30%", display: "flex", alignItems: 'center' }} onClick={() => {//, opacity: instantSelected ? "1" : "0.4"


            }}>
              <div id="radioButton3" style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "center", opacity: (paidInstantIsInCoolOff) || paidInstantExhausted || !paidInstantAmountCheck ? "0.4" : "1" }}>
                <div className='radioButtoncss1' style={{ width: "15px", height: "15px", borderRadius: "18px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <div className='radioButtoncss2' style={{ width: "10px", height: "10px", borderRadius: "15px", display: paidInstantSelected ? "flex" : "none", justifyContent: "center", alignItems: "center", }}>

                  </div>
                </div>
              </div>
              <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>

                <div style={{ display: "flex", alignItems: "center", opacity: (paidInstantIsInCoolOff) || paidInstantExhausted || !paidInstantAmountCheck ? "0.4" : "1" }}>
                  {/* Paid Instant */}
                  <span className='standardText' style={{ fontSize: "14px", fontWeight: paidInstantSelected ? "600" : "400" }}>Prime Instant</span>

                  <img src={assets?.assets?.PaidInstantIcon} style={{ width: "15px", height: "20px", paddingLeft: "5px" }}>
                  </img>
                </div>

              </div>

            </div>

            <div style={{ width: "100%", height: "20%", backgroundColor: "", display: "flex", alignItems: "center", opacity: paidInstantExhausted || !paidInstantAmountCheck ? "0.4" : "1" }}>
              <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

              </div>
              {(nextPaidInstantRedeemAvailability === "N" || !nextPaidInstantRedeemAvailability) ? <span className='limitText' style={{ fontSize: "12px", fontWeight: "400", paddingRight: "5px" }}>{VernacularContextData.getTransalatedKey("walletboosteravailable")} :   {RUPEE_SYMBOL}<span className='limitText' style={{ fontSize: "12px", fontWeight: "700", paddingRight: "5px" }}> {paidInstantLimitAmount}</span></span> :
                <span className='standardText' style={{ fontSize: "0.7rem", fontWeight: "600" }}>Unlocks in <span className='colorRedOEM' style={{ fontSize: "0.7rem", fontWeight: "600" }}>{nextPaidInstantRedeemAvailability && nextPaidInstantRedeemAvailability.split(":")[0] === "1" ? nextPaidInstantRedeemAvailability && nextPaidInstantRedeemAvailability.split(":")[0] + " hr" + " : " : nextPaidInstantRedeemAvailability && nextPaidInstantRedeemAvailability.split(":")[0] + " hrs" + " : "}</span><span className='colorRedOEM' style={{ fontSize: "0.7rem", fontWeight: "600" }}>{(nextPaidInstantRedeemAvailability && nextPaidInstantRedeemAvailability.toString().split(":")[1] === "1") ? (nextPaidInstantRedeemAvailability && nextPaidInstantRedeemAvailability.toString().split(":")[1] + " min") : (nextPaidInstantRedeemAvailability && nextPaidInstantRedeemAvailability.toString().split(":")[1] + " mins")}</span></span>}
            </div>

            <div style={{ width: "100%", height: "50%", backgroundColor: "", display: "flex", marginTop: "5%", flexDirection: "column" }}>
              {<div style={{ display: "flex", alignItems: "center", height: '50%' }}>
                <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

                </div>
                {!paidInstantRedeemEnableFlag ? <div style={{ width: "90%", height: "100%", display: "flex", alignItems: "center" }}> <span className='colorRedOEM' style={{ fontSize: "12px", fontWeight: "500" }}>Not Available</span>

                  <div style={{ backgroundColor: "", display: "flex", flexDirection: "column" }}>

                    <img src={QuestionIcon} style={{ width: "20px", height: "20px", marginLeft: "10px" }} onClick={() => {
                      setToolTipTimer(clearInterval(toolTipTimer));
                      setShowToolTip(true);
                      setToolTipTimer(setTimeout(() => {
                        setShowToolTip(false);
                      }, 3000))

                    }}></img>
                    <div style={{ backgroundColor: "#E6C683", display: showToolTip ? "flex" : "none", justifyContent: "center", alignItems: "center", width: "230px", height: "55px", position: "absolute", zIndex: "2", marginTop: "25px", marginLeft: "-150px", borderRadius: "5px", textAlign: "left" }}>
                      <span className='standardText' style={{ fontSize: "12px", fontWeight: "400", width: "80%" }}>{instantAvailabilityMessage}</span>
                      <img src={BlueCross} style={{ marginTop: "-20px", marginLeft: "10px" }} onClick={() => {
                        setToolTipTimer(clearInterval(toolTipTimer));
                        setShowToolTip(false);


                      }}></img>
                    </div>
                  </div>

                </div> :

                  paidRedeemLimit < 0 ? <span className='standardText' style={{ fontSize: "12px", fontWeight: "400", opacity: (paidInstantIsInCoolOff) || paidInstantExhausted || !paidInstantAmountCheck ? "0.4" : "1" }}> <span className='standardText' style={{ fontSize: "12px", fontWeight: "700" }}>{"Unlimited"}</span></span> :
                    redeemCountersType.toLocaleLowerCase() === 'monthly' ? <span className='leftForText' style={{ fontSize: "12px", fontWeight: "400", opacity: (paidInstantIsInCoolOff) || paidInstantExhausted || !paidInstantAmountCheck ? "0.4" : "1" }}> <span className='leftForText' style={{ fontSize: "12px", fontWeight: "700" }}>{paidRedeemLimit}</span> left for {new Date().toLocaleString("en-US", { month: "long", }).substring(0, 3)}</span> :
                      <span className='leftForText' style={{ fontSize: "12px", fontWeight: "400", opacity: (paidInstantIsInCoolOff) || paidInstantExhausted || !paidInstantAmountCheck ? "0.4" : "1" }}> <span className='leftForText' style={{ fontSize: "12px", fontWeight: "700" }}>{paidRedeemLimit}</span> left for today</span>}

              </div>}

              <div style={{ width: "100%", height: "50%", display: "flex", justifyContent: "", alignItems: "center", opacity: (paidInstantIsInCoolOff) || paidInstantExhausted || !paidInstantAmountCheck ? "0.8" : "1" }}>
                <div style={{ width: "25px", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>

                </div>
                <span className='processedText' style={{ fontSize: "12px", fontWeight: "400", textAlign: "left" }}>{paidInstantMessage}</span>
              </div>

            </div>

          </div>

        </div>
      }

      if (componentNameArray) {
        componentNameArray.forEach(componentName => {
          //paidInstant', 'instant', 'standard
          // console.log("compu name ", componentName);
          if (componentName.toLowerCase() === 'paidinstant') {
            // console.log("bdsnndsfndsfkjnsf");
            components.push(paidInstant)

          } else if (componentName.toLowerCase() === 'instant') {
            components.push(instant)
          }
          else if (componentName.toLowerCase() === 'standard') {
            components.push(standard)
          }
        });
      }



      // console.log("nee jivetham ", components);


      return components;
    }

    return <>
      <div id="requestRedeemPage" className='requestRedeemPage'>
        <div className='redeemDetailsData' style={{
          ...(Number(redeemDetails.tdsFreeAmount) > 0 ? { height: "20%" } : { height: "20%" }),
        }}>
          <div
            // style={styles.redeemAmountDetails}
            className='rBody2'
          >
            {/* <div onClick={() => {
              window.sessionStorage.setItem('policyBack', 'redeem');
              WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPolicy_PageView", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Redeem Placement Page' } })
                ; history.push("/redeeminfo/")
            }} style={{ position: "absolute", right: '3%', top: '0%', fontSize: '0.85rem', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: "end", width: "20%" }}><img style={{ width: "0.7rem", marginRight: "2%" }} src={viewPolicy} alt='viewPolicy' /><span className="nowrap" style={{ paddingLeft: '2%', marginRight: '2%' }}>View Policy</span></div> */}
            {/* Comment for new requirement */}
            {/* <img src={RedeemableLogo} style={{ width: "35%" }} /> */}
            {/* { color: 'rgba(242, 242, 242, 1)', fontSize: "1.15rem", fontWeight: "400" } */}
            {/* <span style={styles.redeemableAmountText}>Redeemable Amount</span> */}
            <span
              className='rBody1'
            //  style={styles.redeemableAmountText}//Will see
            // >Winnings</span>
            // VernacularContextData.getTransalatedKey("welcome")
             >{VernacularContextData.getTransalatedKey("winnings")}</span>
            <div
              //  style={styles.redeemableAmountDisplay}
              className='redeemableAmountSection4' >
              {/* <div style={{ height: '120%', ...(isAndroid ? '' : { width: "22%" }) }}>
                <Lottie style={{ width: "100%", height: '100%' }} animationData={RedeemableRupee} loop={true} autoPlay={true} />
              </div>
              <div style={{ position: 'relative', left: '-6%' }}>{redeemDetails ? redeemDetails.redeemableAmount : 0}</div> */
              }

              {/* <div style={{ height: '120%', ...(isAndroid ? '' : { width: "22%" }) }}>
                                <Lottie style={{ width: "100%", height: '100%' }} animationData={RedeemableRupee} loop={true} autoPlay={true} />
                            </div>
                            <div style={{ position: 'relative', left: '-6%' }}>{redeemDetails ? redeemDetails.redeemableAmount : 0}</div> */}
              <div style={{ width: "100%", height: "100%", backgroundColor: "", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <div id="redeemable_amount" className='redeemable_amount_data' style={{ marginTop: "2%" }}> &#8377; {redeemDetails ? redeemDetails.redeemableAmount?.toLocaleString('en-IN') : 0}</div>

                <div id="viewPolicyandHistory" style={{ width: "100%", height: "70%", backgroundColor: "", display: "flex", justifyContent: "center", alignItems: "flex-end" }}>




                  <div onClick={() => {
                    window.sessionStorage.setItem('policyBack', 'redeem');
                    WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPolicy_PageView", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Redeem Placement Page' } });
                    WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_RedeemPolicy_PageView", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Redeem Placement Page' } });
                    //  history.push("/redeeminfo/")
                    WebToNativeMessage({ type: 'openRedeemPolicy' });
                  }} className='view_policy_text' style={{ position: "", height: "40%", right: '3%', top: '0%', fontSize: '0.85rem', display: 'flex', alignItems: 'center', justifyContent: "center" }}><img style={{ width: "0.7rem", marginRight: "2%" }} src={assets?.assets?.viewPolicy} alt='viewPolicy' /><span className="nowrap" style={{ paddingLeft: '2%', marginRight: '2%' }}>{VernacularContextData.getTransalatedKey("viewpolicy")}</span></div>


                  {
                    redeemDetails !== undefined && redeemDetails.showHistoryIcon === true &&
                    <div className='view_policy_text' style={{ height: "40%", display: "flex", marginLeft: "10%", fontSize: "0.85rem", justifyContent: "center", alignItems: "center" }} onClick={() => RedeemHistoryPageLoadCT()}>
                      <img
                        // className='backBtn'
                        id="history_icon"
                        alt="history_icon"
                        src={assets?.assets?.historyIcon1}
                        style={{ position: "", right: '3%' }}
                        onClick={() => RedeemHistoryPageLoadCT()}
                      />
                      {VernacularContextData.getTransalatedKey("viewhistory")}</div>}
                </div>
              </div>


            </div>
          </div>
        </div>

        {/* New requirement */}



        {/* Comment for new requirement */}

        {/* {Number(redeemDetails.tdsFreeAmount) > 0 && <div style={{ width: "100%", height: "6%", backgroundColor: "#1E3964", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <div id="tds_redeem_free_amount" style={{ width: "95%", height: "100%", backgroundColor: "", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <img src={proToolTip} style={{ height: "18px" }}></img> */}
        {/* old comment <span style={{ fontSize: "0.8rem", color: "#ffffff", marginLeft: "1%" }}> TDS free withdraw amount available - &#8377;{redeemDetails.tdsFreeAmount}</span> */}
        {/* {Number(redeemDetails.tdsFreeAmount) > Number(redeemDetails.redeemableAmount) ? <span style={{ fontSize: "0.8rem", color: "#ffffff", marginLeft: "1%" }}> No TDS applicable for you</span> : <span style={{ fontSize: "0.8rem", color: "#ffffff", marginLeft: "1%" }}> No TDS on redeem amount upto &#8377;{redeemDetails.tdsFreeAmount}</span>}
            <span style={{ textDecoration: "underline", color: "#58B6C6", marginLeft: "2%", fontSize: "0.8rem" }} onClick={() => {
              setShowTaxPopUp(true)
            }}>Learn More</span>
          </div>
        </div>} */}

        {/* {console.log("jhgdfhjbdfjhbdfkhjdfjbhdf", paidInstantRedeemEnableFlag)} */}

        <div className='requestRedeemBody' style={{ height: "80%" }}>

          {/* new redeem changes 100%*/}
          <div style={{ width: "100%", height: "100%", backgroundColor: "", display: "flex", flexDirection: "column", justifyContent: "", alignItems: "" }} onClick={() => {
            // alert();
            // setToolTipTimer(clearInterval(toolTipTimer));
            // setShowToolTip(false);
            // setStdShowToolTip(false);
            // setInstShowToolTip(false);
          }}
            onTouchMove={(e) => {
              // console.log("Edi move avtundi>> yuyuyuyuyuy", e);
              setStdShowToolTip(false);
              setInstShowToolTip(false);

            }}
          >
            <div style={{ width: "100%", backgroundColor: "", display: "flex", flexDirection: "column" }}>
              <div className='enterAmountText' style={{ display: (!standardRedeemFlag && insantReedemFlag && !paidInstantRedeemEnableFlag && isoemps) && "none", fontWeight: "600", minHeight: "40px", marginLeft: "5%" }}>{VernacularContextData.getTransalatedKey("selectwithdrawaltype")}</div>

              {redeemCountersType === "daily" ?



                <div id="containerForStandardAndInstant"
                  // style={{ height: "25%", backgroundColor: "", minWidth: "99%", overflowX: "scroll", overflowY: "hidden", display: "flex", gap: "10px", paddingLeft: "5px", justifyContent: showPaidRedeems ? "" : "center" }}>
                  style={{ height: "100%", backgroundColor: "", minWidth: "99%", minHeight: !(!standardRedeemFlag && insantReedemFlag && !paidInstantRedeemEnableFlag && isoemps) && "120px", overflowX: "scroll", overflowY: "hidden", display: "flex", gap: "10px", paddingLeft: paidInstantRedeemEnableFlag ? "2.5%" : "0px", justifyContent: paidInstantRedeemEnableFlag ? "" : "center", paddingRight: !(!standardRedeemFlag && insantReedemFlag && !paidInstantRedeemEnableFlag && isoemps) && "2.5%", paddingTop: paidInstantRedeemEnableFlag ? "2.5%" : "2%" }} onClick={() => {

                    //  alert(); 
                  }} >


                  {/* will see */}

                  {isoemps ? createOEMContainerForStandardAndInstant() : createContainerForStandardAndInstant()}
                </div>

                :

                <div id="containerForStandardAndInstant"
                  // style={{ height: "25%", backgroundColor: "", minWidth: "99%", overflowX: "scroll", overflowY: "hidden", display: "flex", gap: "10px", paddingLeft: "5px", justifyContent: showPaidRedeems ? "" : "center" }}>
                  style={{ height: "100%", backgroundColor: "", minWidth: "99%", minHeight: !(!standardRedeemFlag && insantReedemFlag && !paidInstantRedeemEnableFlag && isoemps) && "120px", overflowX: "scroll", overflowY: "hidden", display: "flex", gap: "10px", paddingLeft: paidInstantRedeemEnableFlag ? "2.5%" : "0px", justifyContent: paidInstantRedeemEnableFlag ? "" : "center", paddingRight: !(!standardRedeemFlag && insantReedemFlag && !paidInstantRedeemEnableFlag && isoemps) && "2.5%", paddingTop: paidInstantRedeemEnableFlag ? "2.5%" : "2%" }} onTouchMove={(e) => {
                    console.log("Edi move avtundi>>", e);
                  }}>
                  {isoemps ? createOEMContainerForStandardAndInstant() : createContainerForStandardAndInstant()}
                </div>
                // style={{ height: paidInstantSelected ? "32%" : "30%", backgroundColor: "", minWidth: "99%", overflowX: "scroll", overflowY: "hidden", display: "flex", gap: "10px", paddingLeft: "5px", justifyContent: paidInstantRedeemEnableFlag ? "" : "center", paddingTop: "2.5%" }}

              }
              {/* Web */}

              {/* && (showPaidRedeems && (!paidInstantIsInCoolOff || paidInstantExhausted  || paidInstantLimitAmount <= 0 || paidRedeemLimit <= 0)) */}

            </div>





            {(Number(lifetimeInstantRedeemsLeft) > 0 && instantSelected) || limitExceeded || (paidInstantRedeemEnableFlag ? (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted && paidInstantExhausted) : (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted)) || (paidInstantRedeemEnableFlag ? (((nextInstantRedeemAvailability !== "N") && (nextStandardRedeemAvailability !== "N" && paidInstantIsInCoolOff)) || ((nextInstantRedeemAvailability !== "N") && (nextStandardRedeemAvailability !== "N") && paidInstantExhausted)) : ((nextInstantRedeemAvailability !== "N") && (nextStandardRedeemAvailability !== "N")))

              ?
              <div id="errorDiv" style={{ width: "100%", height: "2rem", backgroundColor: "", marginTop: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                {/* Lifetimeinstants is >0 */}
                {(Number(lifetimeInstantRedeemsLeft) > 0 && instantSelected) ? <div className='errorNoteDiv' style={{ width: "90%", height: "100%", borderRadius: "5px", display: "flex" }}>
                  <div className='leftborderror' style={{ width: "2%", height: "100%" }}></div>

                  <div style={{ width: "98%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>
                    <img src={OffersIcon} style={{ width: "16px", height: "16px", paddingLeft: "5px" }} />
                    <span className='standardText' style={{ fontSize: "0.7rem", fontWeight: "600", marginLeft: "5px" }}>You have unlocked instant processing on this reddem</span>

                  </div>
                </div> : ""}
                {/* Limit exceed */}
                {limitExceeded ? <div className='errorNoteDiv1' style={{ width: "90%", height: "100%", borderRadius: "5px", display: "flex" }}>
                  <div className='leftborderror1' style={{ width: "2%", height: "100%" }}></div>

                  <div style={{ width: "98%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>
                    <img src={assets?.assets?.ImformationRedIcon} style={{ width: "16px", height: "16px", paddingLeft: "5px" }} />
                    <span className='errorNoteDivText' style={{ fontSize: "0.7rem", fontWeight: "600", marginLeft: "5px", paddingTop: "10px", paddingBottom: "10px" }}>Instant withdraw request limit exceeds {RUPEE_SYMBOL} {autoApprovalLimit}</span>

                  </div>
                </div> : ""}

                {/* Monthly check */}

                {/* {console.log("paid instant enable flag xxxxxx >>>>>>> 123456", instantExhausted, lifetimeInstantRedeemsLeft, standardExhausted)} */}
                {(paidInstantRedeemEnableFlag ? (instantExhausted && lifetimeInstantRedeemsLeft <= 0 && standardExhausted && paidInstantExhausted) : (!insantReedemFlag && !standardRedeemFlag) || (instantExhausted && lifetimeInstantRedeemsLeft <= 0 && standardExhausted)) ? <div className='errorNoteDiv1' style={{ width: "90%", height: "100%", borderRadius: "5px", display: "flex" }}>
                  <div className='leftborderror1' style={{ width: "2%", height: "100%" }}></div>

                  <div style={{ width: "98%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>
                    <img src={assets?.assets?.ImformationRedIcon} style={{ width: "16px", height: "16px", paddingLeft: "5px" }} />
                    <span className='errorNoteDivText' style={{ fontSize: "0.7rem", fontWeight: "600", marginLeft: "5px", paddingTop: "10px", paddingBottom: "10px" }}>You have exhausted your withdraw requests for the month</span>

                  </div>
                </div> : ""}


                {/* Next hourly timer */}
                {/* && (!paidInstantIsInCoolOff || paidInstantExhausted  || paidInstantLimitAmount <= 0 || paidRedeemLimit <= 0) */}
                {!paidInstantRedeemEnableFlag ? (nextInstantRedeemAvailability !== "N") && (nextStandardRedeemAvailability !== "N") ?

                  //  <div style={{ display: "flex", alignItems: "center" }}>
                  //         <span style={{ fontSize: "12px", color: "#032146", fontWeight: "600", paddingRight: "5px" }}>Unlocks in <span style={{ fontSize: "12px", color: "red", fontWeight: "600" }}>{nextInstantRedeemAvailability && nextInstantRedeemAvailability.split(":")[0] + " hrs" + " : "}</span><span style={{ fontSize: "12px", color: "red", fontWeight: "600" }}>{(nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] === "1") ? (nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] + " min") : (nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] + " mins")}</span>
                  //         </span>
                  //       </div>

                  <div className='errorNoteDiv1' style={{ width: "90%", height: "100%", borderRadius: "5px", display: "flex" }}>
                    <div className='leftborderror1' style={{ width: "2%", height: "100%" }}></div>

                    <div style={{ width: "98%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>
                      <img src={assets?.assets?.ImformationRedIcon} style={{ width: "16px", height: "16px", paddingLeft: "5px" }} />
                      <span className='errorNoteDivText' style={{ fontSize: "0.7rem", fontWeight: "600", marginLeft: "5px", paddingTop: "10px", paddingBottom: "10px" }}>Please wait for your next withdraw to unlock</span>

                    </div>
                  </div> : "" :

                  (nextInstantRedeemAvailability !== "N") && (nextStandardRedeemAvailability !== "N") && ((paidInstantIsInCoolOff || paidInstantExhausted || paidInstantLimitAmount <= 0 || paidRedeemLimit <= 0)) ?

                    //  <div style={{ display: "flex", alignItems: "center" }}>
                    //         <span style={{ fontSize: "12px", color: "#032146", fontWeight: "600", paddingRight: "5px" }}>Unlocks in <span style={{ fontSize: "12px", color: "red", fontWeight: "600" }}>{nextInstantRedeemAvailability && nextInstantRedeemAvailability.split(":")[0] + " hrs" + " : "}</span><span style={{ fontSize: "12px", color: "red", fontWeight: "600" }}>{(nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] === "1") ? (nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] + " min") : (nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] + " mins")}</span>
                    //         </span>
                    //       </div>

                    <div className='errorNoteDiv1' style={{ width: "90%", height: "100%", borderRadius: "5px", display: "flex" }}>
                      <div className='leftborderror1' style={{ width: "2%", height: "100%" }}></div>

                      <div style={{ width: "98%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>
                        <img src={assets?.assets?.ImformationRedIcon} style={{ width: "16px", height: "16px", paddingLeft: "5px" }} />
                        <span className='errorNoteDivText' style={{ fontSize: "0.7rem", fontWeight: "600", marginLeft: "5px", paddingTop: "10px", paddingBottom: "10px" }}>Please wait for your next withdraw to unlock</span>

                      </div>
                    </div> : ""

                }




                {/*  */}

                {/* {rgLimitUpdated ? <div style={{ width: "90%", height: "100%", border: "1px solid #032146", borderRadius: "5px", display: "flex" }}>
<div style={{ width: "2%", height: "100%", backgroundColor: "#032146" }}></div>

<div style={{ width: "98%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>
<img src={ImformationBlueIcon} style={{ width: "16px", height: "16px", paddingLeft: "5px" }} />
<span style={{ fontSize: "0.7rem", color: "#032146", fontWeight: "600", marginLeft: "5px" }}>As per RG Policy, your Redeem Limits are updated.</span>

</div>
</div> : ""} */}

              </div>

              :
              ""}

            <div className='DividerDiv' style={{ width: "95%", height: "2px", marginTop: "1rem", display: (!standardRedeemFlag && insantReedemFlag && !paidInstantRedeemEnableFlag && isoemps) && "none", marginLeft: "2.5%" }}></div>


            <div id="mainDDDDDD" style={{ backgroundColor: "", width: "100%", maxHeight: paidInstantSelected ? "35%":"50%", overflow: "scroll", display: "flex", flexDirection: "column", justifyContent: "" }}>
              {/* , minHeight: "50%" */}
              {/* <div className='enterAmountText' style={{ width: "90%", minHeight: "40px", opacity: (dailyInstantExhausted && dailyStandardExhausted) || (!stdAndInstantCheck) || (!instantAvailabilityFlag && monthlyStandard <= 0) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted) || ((nextInstantRedeemAvailability !== "N") && (nextStandardRedeemAvailability !== "N")) || (monthlyStandardExhausted && nextInstantRedeemAvailability !== "N") || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && nextStandardRedeemAvailability !== "N") ? "0.5" : "1", fontWeight: "bold" }}>Enter the Amount</div> */}
              <div className='enterAmountText' style={{
                width: "90%", minHeight: "40px", marginLeft: "5%", opacity:

                  (paidInstantRedeemEnableFlag ? (
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantExhausted && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantExhausted) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantExhausted) ||
                    (!stdAndInstantCheck && !paidInstantAmountCheck) ||
                    (!standardEnableFlag && !instantEnableFlag && paidInstantExhausted) ||
                    (standardExhausted && !instantEnableFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && !insantReedemFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantIsInCoolOff) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantExhausted)


                  ) :

                    ((!standardEnableFlag && !instantEnableFlag) || (standardExhausted && !instantEnableFlag) || (!standardEnableFlag && insantReedemFlag) ||
                      (!standardEnableFlag && instantIsInCoolOff) || (standardExhausted && instantIsInCoolOff) || (standardIsInCoolOff && !instantEnableFlag) ||
                      (standardIsInCoolOff && !insantReedemFlag) ||
                      (standardIsInCoolOff && instantIsInCoolOff) ||
                      (standardExhausted && instantExhausted) ||

                      (standardIsInCoolOff && instantIsInCoolOff) || !stdAndInstantCheck))

                    ? "0.5" : "1"

                , fontWeight: "bold"
              }}>{VernacularContextData.getTransalatedKey("entertheamount")}</div>
              <div id="enter_amount" className='customInputSection' style={{
                width: "90%", height: "50px", marginTop: "0%", marginLeft: "5%", marginBottom: "10px", opacity:

                  (paidInstantRedeemEnableFlag ? (
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantExhausted && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantExhausted) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantExhausted) ||
                    (!stdAndInstantCheck && !paidInstantAmountCheck) ||
                    (!standardEnableFlag && !instantEnableFlag && paidInstantExhausted) ||
                    (standardExhausted && !instantEnableFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && !insantReedemFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantIsInCoolOff) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantExhausted)


                  ) :

                    ((!standardEnableFlag && !instantEnableFlag) || (standardExhausted && !instantEnableFlag) || (!standardEnableFlag && !insantReedemFlag) ||
                      (!standardEnableFlag && instantIsInCoolOff) || (standardExhausted && instantIsInCoolOff) || (standardIsInCoolOff && !instantEnableFlag) || (standardIsInCoolOff && !insantReedemFlag) ||
                      (standardIsInCoolOff && instantIsInCoolOff) ||
                      (standardExhausted && instantExhausted) ||

                      (standardIsInCoolOff && instantIsInCoolOff) || !stdAndInstantCheck))

                    ? "0.5" : "1",
                pointerEvents:
                  (paidInstantRedeemEnableFlag ? (
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantExhausted && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantExhausted) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantExhausted) ||
                    (!stdAndInstantCheck && !paidInstantAmountCheck) ||
                    (!standardEnableFlag && !instantEnableFlag && paidInstantExhausted) ||
                    (standardExhausted && !instantEnableFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && !insantReedemFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantIsInCoolOff) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantExhausted)


                  ) :

                    ((!standardEnableFlag && !instantEnableFlag) || (standardExhausted && !instantEnableFlag) || (!standardEnableFlag && !insantReedemFlag) ||
                      (!standardEnableFlag && instantIsInCoolOff) || (standardExhausted && instantIsInCoolOff) || (standardIsInCoolOff && !instantEnableFlag) || (standardIsInCoolOff && !insantReedemFlag) ||
                      (standardIsInCoolOff && instantIsInCoolOff) ||
                      (standardExhausted && instantExhausted) ||

                      (standardIsInCoolOff && instantIsInCoolOff) || !stdAndInstantCheck)) && "none"
              }} onClick={() =>

                //  if((monthlyExhausted && monthlyStandardExhausted) || ((nextInstantRedeemAvailability !== "N") && (nextStandardRedeemAvailability !== "N"))){

                //  }
                // (!stdAndInstantCheck) || (!instantAvailabilityFlag && monthlyStandard <= 0) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted) || ((!paidInstantRedeemEnableFlag ? ((nextInstantRedeemAvailability !== "N") && (nextStandardRedeemAvailability !== "N")) : ((nextInstantRedeemAvailability !== "N") && (nextStandardRedeemAvailability !== "N") && (!showPaidRedeems || paidInstantIsInCoolOff || paidInstantExhausted || paidInstantLimitAmount <= 0 || paidRedeemLimit <= 0)))) || (monthlyStandardExhausted && nextInstantRedeemAvailability !== "N") || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && nextStandardRedeemAvailability !== "N")
                (paidInstantRedeemEnableFlag ? (
                  (standardIsInCoolOff && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                  (standardExhausted && instantExhausted && paidInstantExhausted) ||
                  (standardIsInCoolOff && instantIsInCoolOff && paidInstantExhausted) ||
                  (standardIsInCoolOff && instantExhausted && paidInstantIsInCoolOff) ||
                  (standardExhausted && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                  (standardIsInCoolOff && instantExhausted && paidInstantExhausted) ||
                  (standardExhausted && instantIsInCoolOff && paidInstantExhausted) ||
                  (!stdAndInstantCheck && !paidInstantAmountCheck) ||
                  (!standardEnableFlag && !instantEnableFlag && paidInstantExhausted) ||
                  (standardExhausted && !instantEnableFlag && paidInstantExhausted) ||
                  (!standardEnableFlag && !insantReedemFlag && paidInstantExhausted)

                ) :

                  ((!standardEnableFlag && !instantEnableFlag) || (standardExhausted && !instantEnableFlag) || (!standardEnableFlag && !insantReedemFlag) || (standardIsInCoolOff && instantIsInCoolOff) ||
                    (standardExhausted && instantExhausted) ||

                    (standardIsInCoolOff && instantIsInCoolOff) || !stdAndInstantCheck)
                )

                  ? inputRef.current.blur() : inputRef.current.focus()

              }>
                <div className='customInput'>
                  <div className='inputSection' style={{ marginTop: "0%", display: "flex" }}> {RUPEE_SYMBOL} <input ref={inputRef} value={amountEntered} type='tel' onKeyUp={(e) => {
                    if (e.key === 'Enter') {
                      inputRef.current.blur()
                    }
                  }} placeholder={VernacularContextData.getTransalatedKey("enteramount")} onFocus={() => {
                    if (openLinkWallet !== undefined) {
                      inputRef.current.blur()
                    }
                  }}
                    onChange={(e) => {

                      const re = /^\d+$/

                      if (re.test(e.target.value) || e.target.value === '') {
                        // const value = e.target.value.replace(/^0+/, '').slice(0, max.toString().length <= 0 ? 2 : max.toString().length);
                        // setEnteredAmount(value)

                        const value = e.target.value.replace(/^0+/, '').slice(0, max.toString().length <= 0 ? 2 : max.toString().length);
                        setEnteredAmount(value)
                      }

                    }} />
                  </div>
                  <div id="minMaxValues" className='minMaxValues'>{((min === undefined || min === 0 || min === "") && (max === undefined || max === 0 || max === "") || redeemDetails.redeemableAmount === 0) ? '' : min > max ? `Minimum ${RUPEE_SYMBOL}${min} ` : `${RUPEE_SYMBOL}${min} to ${RUPEE_SYMBOL}${max ? max.toFixed(0) : ""}`}</div>
                </div>
              </div>

              {/* , height: "5%" */}
              <div className='colorRedOEM' style={{ width: "95%", display: 'flex', alignItems: 'center', fontSize: '0.8rem', textAlign: "start", marginLeft: "5%" }}>{validationError}</div>

              {/* Tds enhancement  */}
              {(tdsInfo.tds > 0 && Number(redeemDetails.tdsFreeAmount) > 0 && newCTAFlag && (Number(amountEntered) <= redeemDetails?.redeemableAmount)) && <div className='tdsCashbackEnhancement' >
                <img src={assets?.assets?.warningIcon} style={{ marginTop: "-16%" }} ></img>
                <div className='subTdsCashbackEnhancement'>

                  <div className='tdsCashbackEnhancementTextDiv'>
                    <span className='tdsCashbackEnhancementText'>{ctaTdsTitle}</span>
                    {/* <img src={assets?.assets?.InformationBlueIcon} onClick={() => {
                      setShowTaxPopUp(true);
                    }}></img> */}
                  </div>

                  <span className='tdsCashbackEnhancementText1'>{ctaDesc}</span>

                  {/* <span className='tdsCashbackEnhancementText1'>Withdrawal up to  {RUPEE_SYMBOL}{redeemDetails.tdsFreeAmount} to avoid TDS charges</span> */}

                  <button className='tdsCashbackEnhancementButton' onClick={() => {

                    console.log(" inputRef.current.value", inputRef);
                    setEnteredAmount((redeemDetails.tdsFreeAmount).toString());
                    inputRef.current.value = redeemDetails.tdsFreeAmount;
                    setAdjustBtnClicked(true);


                    let eventProperties = {
                      TDS_free_amt: redeemDetails?.tdsFreeAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan",

                      tds_deducted: tdsInfo.tds
                      , username: profileData?.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData?.currentAceLevelName, subscription_type: profileData?.subscriptionType,
                      amount_entered: amountEntered, FeatureFlag: newCTAFlag, PercentTDSAmountOutOfEnteredAmount: Number(redeemDetails.tdsFreeAmount) / Number(amountEntered) * 100,
                    }
                    WebToNativeMessage({
                      type: "redeemCTEvent", eventName: "TDSnote_click", eventProperties: eventProperties
                    })
                    WebToNativeMessage({
                      type: "mixpanelEvent", eventName: "TDSnote_click", eventProperties: eventProperties
                    })
                    WebToNativeMessage({
                      type: "plotLineEvent", eventName: "TDSnote_click", eventProperties: eventProperties
                    })


                  }}>Adjust  to  {RUPEE_SYMBOL}{redeemDetails.tdsFreeAmount}</button>

                </div>


              </div>}

              {console.log("adjustBtnClicked", adjustBtnClicked, amountEntered, redeemDetails.tdsFreeAmount)}

              {adjustBtnClicked && newCTAFlag && Number(amountEntered) === redeemDetails.tdsFreeAmount && <div className='tdsCashbackEnhancementSuccess' >
                <img src={assets?.assets?.TickGreen} style={{ marginTop: "-6%" }} ></img>
                <div className='subTdsCashbackEnhancement'>

                  <div className='tdsCashbackEnhancementTextDiv'>
                    <span className='tdsCashbackEnhancementText'>{onClickCTATitle}</span>
                    {/* <img src={assets?.assets?.InformationBlueIcon} onClick={() => {
                      setShowTaxPopUp(true);
                    }}></img> */}
                  </div>


                  <span className='tdsCashbackEnhancementText1'>{onClickCTADesc}</span>



                </div>
              </div>
              }
              {/* adjustBtnClicked && Number(amountEntered) === redeemDetails.tdsFreeAmount */}
              {/* tdsInfo.tds > 0 && Number(redeemDetails.tdsFreeAmount) <= 0 */}
              {(tdsInfo.tds > 0 && Number(redeemDetails.tdsFreeAmount) <= 0 && fullTdsNoteFlag) && <div className='tdsCashbackEnhancementOnAll' >
                <div id="tds_redeem_free_amount" style={{ width: "100%", height: "100%", backgroundColor: "", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "5px", marginBottom: "5px" }}>
                  <img src={assets?.assets?.proToolTip} style={{ height: "18px" }}></img>
                  {/* {Number(redeemDetails.tdsFreeAmount) > Number(redeemDetails.redeemableAmount) ? <span className="tds-text" style={{ fontSize: "0.8rem", marginLeft: "1%" }}> No TDS applicable for you</span> : <span className="tds-text" style={{ fontSize: "0.8rem", marginLeft: "1%" }}> {fullTDSNote}{amountEntered}</span>}
                  <span className='LearnMoreDiv' style={{
                    textDecoration: "underline"
                    , marginLeft: "5%", fontSize: "0.8rem"
                  }} onClick={() => {
                    // setShowTaxPopUp(true);
                    // alert();
                    // setKnowMoreBottomUp(true);
                    WebToNativeMessage({
                      type: "redeemCTEvent", eventName: "TDStipnudge_knowmore_click", eventProperties: {}
                    })
                    WebToNativeMessage({
                      type: "mixpanelEvent", eventName: "TDStipnudge_knowmore_click", eventProperties: {}
                    })
                    WebToNativeMessage({
                      type: "plotLineEvent", eventName: "TDStipnudge_knowmore_click", eventProperties: {}
                    })


                  }}>Know More</span> */}
                </div>
              </div>}


              {/* , height: "10%" */}
              <div className='redeemDetailsItem' style={{
                width: "90%", height: "30px", marginLeft: "5%", display: "flex", alignItems: "center", opacity:
                  // (!stdAndInstantCheck) || (!instantAvailabilityFlag && monthlyStandard <= 0) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted) || ((!paidInstantLimitExhausted ? ((nextInstantRedeemAvailability !== "N") && (nextStandardRedeemAvailability !== "N")) : ((nextInstantRedeemAvailability !== "N") && (nextStandardRedeemAvailability !== "N") && ( !showPaidRedeems || paidInstantIsInCoolOff || paidInstantExhausted || paidInstantLimitAmount <= 0 || paidRedeemLimit <= 0)))) || (monthlyStandardExhausted && nextInstantRedeemAvailability !== "N") || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && nextStandardRedeemAvailability !== "N") 
                  (paidInstantRedeemEnableFlag ? (
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantExhausted && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantExhausted) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantExhausted) ||
                    (!stdAndInstantCheck && !paidInstantAmountCheck) ||
                    (!standardEnableFlag && !instantEnableFlag && paidInstantExhausted) ||
                    (standardExhausted && !instantEnableFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && !insantReedemFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantIsInCoolOff) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantExhausted)


                  ) :

                    ((!standardEnableFlag && !instantEnableFlag) || (standardExhausted && !instantEnableFlag) || (!standardEnableFlag && !insantReedemFlag) ||
                      (!standardEnableFlag && instantIsInCoolOff) || (standardExhausted && instantIsInCoolOff) || (standardIsInCoolOff && !instantEnableFlag) || (standardIsInCoolOff && !insantReedemFlag) ||
                      (standardIsInCoolOff && instantIsInCoolOff) ||
                      (standardExhausted && instantExhausted) ||

                      (standardIsInCoolOff && instantIsInCoolOff) || !stdAndInstantCheck))
                    ? "0.5" : "1"
              }}>
                <div className="tds-text" style={{ fontSize: "1rem", fontWeight: "500", width: "50%" }}>TDS </div>

                {/* <img style={{ marginLeft: '3%', height: "100%" }} alt='tdsinfo' src={tdsInfoIcon} onClick={() => {
                setShowIframe(true);
                WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_TDS_ViewPolicyPopUp", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_location: 'Redeem Placement Page' } })


              }} /> */}
                <div className='colorRedOEM' style={{ fontSize: '1rem', width: "50%", fontWeight: "500", display: 'flex', justifyContent: "flex-end" }}>{tdsInfo.tds <= 0 ? '' : '-'}<span id = "tdsAmount">{RUPEE_SYMBOL}{tdsInfo.tds <= 0 && amountEntered === '' ? '--' : tdsInfo.tds}</span></div>
              </div>
              {/* tds free amount  text new changes pap-7606 */}
              {(tdsInfo.tds > 0 && Number(redeemDetails.tdsFreeAmount) > 0 && !newCTAFlag) ? <div id='goldBox' className='LearnMoreBox' style={{ width: "90%", height: "10%", marginLeft: "5%", minHeight: "25px", borderRadius: "5px", display: "flex", justifyContent: "center", alignItems: "center", paddingTop: "5%", paddingBottom: "5%" }}>

                <div id="tds_redeem_free_amount" style={{ width: "100%", height: "100%", backgroundColor: "", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "5px", marginBottom: "5px" }}>
                  <img src={assets?.assets?.proToolTip} style={{ height: "18px" }}></img>
                  {Number(redeemDetails.tdsFreeAmount) > Number(redeemDetails.redeemableAmount) ? <span className="tds-text" style={{ fontSize: "0.8rem", marginLeft: "1%" }}> No TDS applicable for you</span> : <span className="tds-text" style={{ fontSize: "0.8rem", marginLeft: "1%" }}> No TDS on withdraw amount upto &#8377;{redeemDetails.tdsFreeAmount}</span>}
                  {/* <span className='LearnMoreDiv' style={{
                    textDecoration: "underline"
                    , marginLeft: "5%", fontSize: "0.8rem"
                  }} onClick={() => {
                    setShowTaxPopUp(true);
                    WebToNativeMessage({
                      type: "redeemCTEvent", eventName: "PF_taxablewinnings_bottomsheet_viewed", eventProperties: {
                        Source: "Redeem",
                        acelevel: window.sessionStorage["aceLevel"],
                        channel: window.sessionStorage["channel"],
                        subscriptionType: window.sessionStorage["subscriptionType"],
                        username: window.sessionStorage["screenName"],
                        count_pendingRedeem: profileData.totalPendingRedeems,

                        tdsRefundConfig: tdsRefundConfig,
                        tdsRefundEligibility: tdsRefundEligibility,
                        tdsRefundAmount: tdsRefundAmount,
                        timestamp: new Date().getTime()
                      }
                    })

                    WebToNativeMessage({
                      type: "plotlineEvent", eventName: "PF_taxablewinnings_bottomsheet_viewed", eventProperties: {
                        Source: "Redeem",
                        acelevel: window.sessionStorage["aceLevel"],
                        channel: window.sessionStorage["channel"],
                        subscriptionType: window.sessionStorage["subscriptionType"],
                        username: window.sessionStorage["screenName"],
                        count_pendingRedeem: profileData.totalPendingRedeems,

                        tdsRefundConfig: tdsRefundConfig,
                        tdsRefundEligibility: tdsRefundEligibility,
                        tdsRefundAmount: tdsRefundAmount,
                        timestamp: new Date().getTime()
                      }
                    })

                    WebToNativeMessage({
                      type: "mixpanelEvent", eventName: "PF_taxablewinnings_bottomsheet_viewed", eventProperties: {
                        Source: "Redeem",
                        acelevel: window.sessionStorage["aceLevel"],
                        channel: window.sessionStorage["channel"],
                        subscriptionType: window.sessionStorage["subscriptionType"],
                        username: window.sessionStorage["screenName"],
                        count_pendingRedeem: profileData.totalPendingRedeems,

                        tdsRefundConfig: tdsRefundConfig,
                        tdsRefundEligibility: tdsRefundEligibility,
                        tdsRefundAmount: tdsRefundAmount,
                        timestamp: new Date().getTime()
                      }
                    })


                    WebToNativeMessage({
                      type: "redeemCTEvent", eventName: "PF_taxablewinnings_viewdetails_click", eventProperties: {
                        Source: "Redeem",
                        acelevel: window.sessionStorage["aceLevel"],
                        channel: window.sessionStorage["channel"],
                        subscriptionType: window.sessionStorage["subscriptionType"],
                        username: window.sessionStorage["screenName"],
                        count_pendingRedeem: profileData.totalPendingRedeems,

                        tdsRefundConfig: tdsRefundConfig,
                        tdsRefundEligibility: tdsRefundEligibility,
                        tdsRefundAmount: tdsRefundAmount,
                        timestamp: new Date().getTime()
                      }
                    })

                    WebToNativeMessage({
                      type: "plotlineEvent", eventName: "PF_taxablewinnings_viewdetails_click", eventProperties: {
                        Source: "Redeem",
                        acelevel: window.sessionStorage["aceLevel"],
                        channel: window.sessionStorage["channel"],
                        subscriptionType: window.sessionStorage["subscriptionType"],
                        username: window.sessionStorage["screenName"],
                        count_pendingRedeem: profileData.totalPendingRedeems,

                        tdsRefundConfig: tdsRefundConfig,
                        tdsRefundEligibility: tdsRefundEligibility,
                        tdsRefundAmount: tdsRefundAmount,
                        timestamp: new Date().getTime()
                      }
                    })

                    WebToNativeMessage({
                      type: "mixpanelEvent", eventName: "PF_taxablewinnings_viewdetails_click", eventProperties: {
                        Source: "Redeem",
                        acelevel: window.sessionStorage["aceLevel"],
                        channel: window.sessionStorage["channel"],
                        subscriptionType: window.sessionStorage["subscriptionType"],
                        username: window.sessionStorage["screenName"],
                        count_pendingRedeem: profileData.totalPendingRedeems,

                        tdsRefundConfig: tdsRefundConfig,
                        tdsRefundEligibility: tdsRefundEligibility,
                        tdsRefundAmount: tdsRefundAmount,
                        timestamp: new Date().getTime()
                      }
                    })
                  }}>Learn More</span> */}
                </div>
              </div> : ""}



              {(showPaidRedeems && paidInstantSelected) && <div className='redeemDetailsItemNetRedeemable' style={{
                width: "90%", height: "50px", marginBottom: "3%", marginLeft: "5%", display: "flex", alignItems: "center", opacity:
                  (paidInstantRedeemEnableFlag ? (
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantExhausted && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantExhausted) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantExhausted) ||
                    (!stdAndInstantCheck && !paidInstantAmountCheck) ||
                    (!standardEnableFlag && !instantEnableFlag && paidInstantExhausted) ||
                    (standardExhausted && !instantEnableFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && !insantReedemFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantIsInCoolOff) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantExhausted)


                  ) :

                    ((!standardEnableFlag && !instantEnableFlag) || (standardExhausted && !instantEnableFlag) || (!standardEnableFlag && !insantReedemFlag) ||
                      (!standardEnableFlag && instantIsInCoolOff) || (standardExhausted && instantIsInCoolOff) || (standardIsInCoolOff && !instantEnableFlag) || (standardIsInCoolOff && !insantReedemFlag) ||
                      (standardIsInCoolOff && instantIsInCoolOff) ||
                      (standardExhausted && instantExhausted) ||

                      (standardIsInCoolOff && instantIsInCoolOff) || !stdAndInstantCheck))
                    ? "0.5" : "1"
              }}>
                <div className='netRedeemableText' style={{ fontSize: "1rem", fontWeight: "500", width: "50%", display: "flex" }}>Net Redeemable  </div>
                <div className='netRedeemableData' style={{ fontSize: '1rem', width: "50%", fontWeight: "500", display: 'flex', justifyContent: "flex-end" }}><span id="netRedeemableAmount">{RUPEE_SYMBOL}{(parseInt(amountEntered) - parseInt(tdsInfo.tds) > 0) ? ((amountEntered) - (tdsInfo.tds)).toFixed(2) : "--"}</span> </div>
              </div>}

              {(showPaidRedeems && paidInstantSelected) && <div className='redeemDetailsItem' style={{
                width: "90%", height: "30px", marginLeft: "5%", display: "flex", alignItems: "center", opacity:
                  (paidInstantRedeemEnableFlag ? (
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantExhausted && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantExhausted) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantExhausted) ||
                    (!stdAndInstantCheck && !paidInstantAmountCheck) ||
                    (!standardEnableFlag && !instantEnableFlag && paidInstantExhausted) ||
                    (standardExhausted && !instantEnableFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && !insantReedemFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantIsInCoolOff) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantExhausted)


                  ) :

                    ((!standardEnableFlag && !instantEnableFlag) || (standardExhausted && !instantEnableFlag) || (!standardEnableFlag && !insantReedemFlag) ||
                      (!standardEnableFlag && instantIsInCoolOff) || (standardExhausted && instantIsInCoolOff) || (standardIsInCoolOff && !instantEnableFlag) || (standardIsInCoolOff && !insantReedemFlag) ||
                      (standardIsInCoolOff && instantIsInCoolOff) ||
                      (standardExhausted && instantExhausted) ||

                      (standardIsInCoolOff && instantIsInCoolOff) || !stdAndInstantCheck))
                    ? "0.5" : "1"
              }}>
                <div className='processingFeeText' style={{ fontSize: "1rem", fontWeight: "500", width: "60%", display: "flex" }}>Processing Fee ({paidInstantRedeemProcessingFee}%)
                  <Tooltip
                    redeemProcessingFee={true}
                    tooltipArrow="tooltip-arrow"
                    direction={"bottom"}
                    content={`${paidInstantRedeemProcessingFee ? paidInstantRedeemProcessingFee.toFixed() : paidInstantRedeemProcessingFee}% of Net withdrawable amount`}
                  >
                    <img src={assets?.assets?.BlueInfo} style={{ marginLeft: "5px" }}></img>
                  </Tooltip>
                </div>
                <div className='colorRedOEM' style={{ fontSize: '1rem', width: "50%", fontWeight: "500", display: 'flex', justifyContent: "flex-end" }}><span>{paidInstantYouGetValue > 0 ? "-" : ""}</span><span id="processingAmount">{RUPEE_SYMBOL}{paidInstantYouGetValue > 0 ? paidInstantYouGetValue.toFixed(2) : paidInstantYouGetValue}</span></div>
              </div>}


              {(tdsCashBackConfigData) && ((standardSelected && applicableForStandard) || (instantSelected && applicableForInstant)) && <div className='redeemDetailsItem' style={{
                width: "90%", height: "30px", marginLeft: "5%", display: "flex", marginTop: "2%", alignItems: "center", opacity:
                  (paidInstantRedeemEnableFlag ? (
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantExhausted && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantExhausted) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantExhausted) ||
                    (!stdAndInstantCheck && !paidInstantAmountCheck) ||
                    (!standardEnableFlag && !instantEnableFlag && paidInstantExhausted) ||
                    (standardExhausted && !instantEnableFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && !insantReedemFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantIsInCoolOff) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantExhausted)


                  ) :

                    ((!standardEnableFlag && !instantEnableFlag) || (standardExhausted && !instantEnableFlag) || (!standardEnableFlag && !insantReedemFlag) ||
                      (!standardEnableFlag && instantIsInCoolOff) || (standardExhausted && instantIsInCoolOff) || (standardIsInCoolOff && !instantEnableFlag) || (standardIsInCoolOff && !insantReedemFlag) ||
                      (standardIsInCoolOff && instantIsInCoolOff) ||
                      (standardExhausted && instantExhausted) ||

                      (standardIsInCoolOff && instantIsInCoolOff) || !stdAndInstantCheck))
                    ? "0.5" : "1"
              }}>
                {/* <div className='processingFeeText' style={{ fontSize: "1rem", fontWeight: "500", width: "60%", display: "flex" }}>TDS Cashback
                  <Tooltip
                    redeemProcessingFee={true}
                    tooltipArrow="tooltip-arrow"
                    direction={"bottom"}
                    content={`${paidInstantRedeemProcessingFee ? paidInstantRedeemProcessingFee.toFixed() : paidInstantRedeemProcessingFee}% of Net redeemable amount`}
                  >
                    <img src={assets?.assets?.BlueInfo} style={{ marginLeft: "5px" }}></img>
                  </Tooltip>
                </div> */}

                <div style={{ width: "50%" }} >TDS Cashback
                  {<img src={assets?.assets?.BlueInfo} style={{ marginLeft: '5px' }} onClick={() => {

                    ((!standardEnableFlag && !instantEnableFlag) || (standardExhausted && !instantEnableFlag) || (!standardEnableFlag && !insantReedemFlag) ||
                      (!standardEnableFlag && instantIsInCoolOff) || (standardExhausted && instantIsInCoolOff) || (standardIsInCoolOff && !instantEnableFlag) || (standardIsInCoolOff && !insantReedemFlag) ||
                      (standardIsInCoolOff && instantIsInCoolOff) ||
                      (standardExhausted && instantExhausted) ||

                      (standardIsInCoolOff && instantIsInCoolOff) || !stdAndInstantCheck) ? setShowTdsCashbackBottomSheet(false) : setShowTdsCashbackBottomSheet(true)


                    //    fetch("your PDF File.pdf").then((response) => {
                    //     response.blob().then((blob) => {
                    //         const fileURL =
                    //             window.URL.createObjectURL(blob);
                    //         let alink = document.createElement("a");
                    //         alink.href = fileURL;
                    //         alink.download = "SamplePDF.pdf";
                    //         alink.click();
                    //     });
                    // });
                    // const pdfUrl = "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf";
                    // const link = document.createElement("a");
                    // link.href = pdfUrl;
                    // link.download = "dum.pdf";
                    // document.body.appendChild(link);
                    // link.click();
                    // document.body.removeChild(link);
                    // alert()

                    //  WebToNativeMessage({ downloadUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf" })

                    // redirectTo({
                    //   downloadUrl: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
                    // });//plotLineEvent
                    WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_TDSCashback_infoclick", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", applicableForStandard: applicableForStandard, applicableForInstant: applicableForInstant, standardTypePercentage: standardTypePercentage, instantTypePercentage: instantTypePercentage, tdsMaxCapAmount: tdsMaxCapAmount, tdsTnyWinningsEnabled: tdsTnyWinningsEnabled, cummilativeTrnyWinnings: cummilativeTrnyWinnings, timestamp: new Date().getTime() } })
                    WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_TDSCashback_infoclick", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", applicableForStandard: applicableForStandard, applicableForInstant: applicableForInstant, standardTypePercentage: standardTypePercentage, instantTypePercentage: instantTypePercentage, tdsMaxCapAmount: tdsMaxCapAmount, tdsTnyWinningsEnabled: tdsTnyWinningsEnabled, cummilativeTrnyWinnings: cummilativeTrnyWinnings, timestamp: new Date().getTime() } })
                    WebToNativeMessage({ type: "plotLineEvent", eventName: "PF_c_TDSCashback_infoclick", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", applicableForStandard: applicableForStandard, applicableForInstant: applicableForInstant, standardTypePercentage: standardTypePercentage, instantTypePercentage: instantTypePercentage, tdsMaxCapAmount: tdsMaxCapAmount, tdsTnyWinningsEnabled: tdsTnyWinningsEnabled, cummilativeTrnyWinnings: cummilativeTrnyWinnings, timestamp: new Date().getTime() } })
                  }}></img>}
                </div>


                <div className='colorGreenOEM' style={{ fontSize: '1rem', width: "50%", fontWeight: "500", display: 'flex', justifyContent: "flex-end" }}>
                  {/* <span>{paidInstantYouGetValue > 0 ? "-" : ""}</span> */}
                  {(Number(tdsCashbackAmount) > 0 && amountEntered > 0) ? "+" : amountEntered > 0 ? "+" : ""}

                  {console.log("Devuda cashback amount >>>>>>", tdsCashbackAmount, amountEntered, tdsMaxCapAmount, amountEntered, tdsInfo.amount)}

                  <span className='colorGreenOEM' style={{}}>


                    {tdsTnyWinningsEnabled ? <span >{RUPEE_SYMBOL} <span id = "cashbackAmount">{
                      ((standardSelected && finalCashbackValue > 0) ? ((finalCashbackValue * standardTypePercentage) / 100) > tdsMaxCapAmount ? (amountEntered > 0) ? tdsMaxCapAmount.toFixed(2) : "--" : amountEntered > 0 ? ((finalCashbackValue * standardTypePercentage) / 100).toFixed(2) : "--" :

                        (instantSelected && finalCashbackValue > 0) ? ((finalCashbackValue * instantTypePercentage) / 100) > tdsMaxCapAmount ? (amountEntered > 0) ? tdsMaxCapAmount.toFixed(2) : "--" : (amountEntered > 0) ? ((finalCashbackValue * instantTypePercentage) / 100).toFixed(2) : "--" :

                          (tdsInfo.amount > 0) ? 0 : "--")}
                    </span></span>

                      :
                      <span id = "cashbackAmount">{RUPEE_SYMBOL} <span>{
                        ((standardSelected && tdsInfo.tds > 0) ? ((tdsInfo.tds * standardTypePercentage) / 100) > tdsMaxCapAmount ? (amountEntered > 0) ? tdsMaxCapAmount.toFixed(2) : "--" : (amountEntered > 0) ? ((tdsInfo.tds * standardTypePercentage) / 100).toFixed(2) : "--" : (instantSelected && tdsInfo.tds > 0) ? ((tdsInfo.tds * instantTypePercentage) / 100).toFixed(2) > tdsMaxCapAmount ? (amountEntered > 0) ? tdsMaxCapAmount.toFixed(2) : "--" : (amountEntered > 0) ? ((tdsInfo.tds * instantTypePercentage) / 100).toFixed(2) : "--" : (tdsInfo.amount > 0) ? 0 : "--")
                      }</span></span>
                    }
                    {/* 
                    {RUPEE_SYMBOL}{ (tdsTnyWinningsEnabled ? tdsCashbackAmount > 0 : finalCashbackValue > 0) ?
                      ((tdsTnyWinningsEnabled ? Number(tdsCashbackAmount) : Number(finalCashbackValue) ) > Number(tdsMaxCapAmount)) ? amountEntered > 0 ? Number(tdsMaxCapAmount) : "--" :
                        amountEntered > 0 ? (tdsTnyWinningsEnabled ? Number(tdsCashbackAmount) : Number(finalCashbackValue) ) : (tdsInfo.amount > 0) ? 0 : "--" : (tdsInfo.amount > 0) ? 0 : "--"} */}


                  </span>
                  {/* <span>{RUPEE_SYMBOL}{paidInstantYouGetValue > 0 ? paidInstantYouGetValue.toFixed(2) : paidInstantYouGetValue}</span> */}
                </div>
              </div>}


              {/* <div className='redeemDetailsItem' style={{ width: "90%", height: "10%", display: "flex", alignItems: "center", marginTop: '2%', opacity: (dailyInstantExhausted && dailyStandardExhausted) || (!stdAndInstantCheck) || (!instantAvailabilityFlag && monthlyStandard <= 0) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted) || ((nextInstantRedeemAvailability !== "N") && (nextStandardRedeemAvailability !== "N")) || (monthlyStandardExhausted && nextInstantRedeemAvailability !== "N") || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && nextStandardRedeemAvailability !== "N") ? "0.5" : "1" }}>
              <div style={{ fontSize: "1rem", fontWeight: "500", color: "#032146", width: "50%" }}>You Get</div>
              <div style={{ fontSize: '1rem', fontWeight: "700", color: '#032146', width: "50%", display: "flex", justifyContent: "flex-end" }}><span>{RUPEE_SYMBOL}{tdsInfo.youGet <= 0 ? '--' : tdsInfo.youGet}</span></div>
            </div> */}

              {/* , height: "10%" */}
              <div className='redeemDetailsItem' style={{
                width: "90%", height: "30px", marginLeft: "5%", display: "flex", alignItems: "center", marginTop: '2%', opacity:
                  //  (!stdAndInstantCheck) || (!instantAvailabilityFlag && monthlyStandard <= 0) || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted) || ((!paidInstantRedeemEnableFlag ? ((nextInstantRedeemAvailability !== "N") && (nextStandardRedeemAvailability !== "N")) : ((nextInstantRedeemAvailability !== "N") && (nextStandardRedeemAvailability !== "N") && (!showPaidRedeems ||paidInstantIsInCoolOff || paidInstantExhausted || paidInstantLimitAmount <= 0 || paidRedeemLimit <= 0)))) || (monthlyStandardExhausted && nextInstantRedeemAvailability !== "N") || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && nextStandardRedeemAvailability !== "N") 
                  (paidInstantRedeemEnableFlag ? (
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantExhausted && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantExhausted) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantExhausted) ||
                    (!stdAndInstantCheck && !paidInstantAmountCheck) ||
                    (!standardEnableFlag && !instantEnableFlag && paidInstantExhausted) ||
                    (standardExhausted && !instantEnableFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && !insantReedemFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantIsInCoolOff) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantExhausted)


                  ) :

                    ((!standardEnableFlag && !instantEnableFlag) || (standardExhausted && !instantEnableFlag) || (!standardEnableFlag && !insantReedemFlag) ||
                      (!standardEnableFlag && instantIsInCoolOff) || (standardExhausted && instantIsInCoolOff) || (standardIsInCoolOff && !instantEnableFlag) || (standardIsInCoolOff && !insantReedemFlag) ||
                      (standardIsInCoolOff && instantIsInCoolOff) ||
                      (standardExhausted && instantExhausted) ||

                      (standardIsInCoolOff && instantIsInCoolOff) || !stdAndInstantCheck))
                    ? "0.5" : "1"
              }}>

                {/* (tdsTnyWinningsEnabled ? Number(tdsCashbackAmount) : Number(finalCashbackValue) ) */}
                {console.log("tdsInfo.youGet MMMMMMMMM", tdsInfo.youGet, paidInstantSelected, paidInstantYouGetValue, tdsCashbackAmount, amountEntered, tdsMaxCapAmount)}
                {console.log("xxxxxxxxxxx", standardSelected, tdsInfo.tds, standardTypePercentage, tdsMaxCapAmount, finalCashbackValue, Number(tdsInfo.youGet))}
                <div className='yougettext' style={{ fontSize: "1rem", fontWeight: "500", width: "50%" }}>{VernacularContextData.getTransalatedKey("youget")}</div>
                <div className='yougetdata' style={{ fontSize: '1rem', fontWeight: "700", width: "50%", display: "flex", justifyContent: "flex-end" }}><span>{RUPEE_SYMBOL}{tdsInfo.youGet <= 0 ? amountEntered <= 0 ? '--' :

                  (tdsTnyWinningsEnabled ?
                    (standardSelected > 0 && applicableForStandard) ? ((finalCashbackValue * standardTypePercentage) / 100) > tdsMaxCapAmount ? (amountEntered > 0) ? Number(tdsMaxCapAmount) : 0 : amountEntered > 0 ? Number((finalCashbackValue * standardTypePercentage) / 100) : 0 :

                      (instantSelected > 0 && applicableForInstant) ? ((finalCashbackValue * instantTypePercentage) / 100) > tdsMaxCapAmount ? (amountEntered > 0) ? Number(tdsMaxCapAmount) : 0 : (amountEntered > 0) ? Number((finalCashbackValue * instantTypePercentage) / 100) : 0 : 0

                    :

                    Number((standardSelected && tdsInfo.tds > 0) ? ((tdsInfo.tds * standardTypePercentage) / 100) > tdsMaxCapAmount ? (amountEntered > 0) ? Number(tdsMaxCapAmount) : 0 : (amountEntered > 0) ? Number((tdsInfo.tds * standardTypePercentage) / 100) : 0 : (instantSelected && tdsInfo.tds > 0) ? Number((tdsInfo.tds * instantTypePercentage) / 100) > tdsMaxCapAmount ? (amountEntered > 0) ? Number(tdsMaxCapAmount) : 0 : (amountEntered > 0) ? Number((tdsInfo.tds * instantTypePercentage) / 100) : 0 : (tdsInfo.amount > 0) ? 0 : 0)
                  )

                  : (paidInstantSelected && paidInstantYouGetValue !== "--") ? (tdsInfo.youGet - Number(paidInstantYouGetValue)).toFixed(2) : (Number(tdsInfo.youGet) +
                    (tdsTnyWinningsEnabled ?
                      (standardSelected > 0 && applicableForStandard) ? ((finalCashbackValue * standardTypePercentage) / 100) > tdsMaxCapAmount ? (amountEntered > 0) ? Number(tdsMaxCapAmount) : 0 : amountEntered > 0 ? Number((finalCashbackValue * standardTypePercentage) / 100) : 0 :

                        (instantSelected > 0 && applicableForInstant) ? ((finalCashbackValue * instantTypePercentage) / 100) > tdsMaxCapAmount ? (amountEntered > 0) ? Number(tdsMaxCapAmount) : 0 : (amountEntered > 0) ? Number((finalCashbackValue * instantTypePercentage) / 100) : 0 : 0

                      :

                      Number((standardSelected && tdsInfo.tds > 0) ? ((tdsInfo.tds * standardTypePercentage) / 100) > tdsMaxCapAmount ? (amountEntered > 0) ? Number(tdsMaxCapAmount) : 0 : (amountEntered > 0) ? Number((tdsInfo.tds * standardTypePercentage) / 100) : 0 : (instantSelected && tdsInfo.tds > 0) ? Number((tdsInfo.tds * instantTypePercentage) / 100) > tdsMaxCapAmount ? (amountEntered > 0) ? Number(tdsMaxCapAmount) : 0 : (amountEntered > 0) ? Number((tdsInfo.tds * instantTypePercentage) / 100) : 0 : (tdsInfo.amount > 0) ? 0 : 0)
                    )
                    // ((tdsTnyWinningsEnabled ? Number(tdsCashbackAmount) : Number(finalCashbackValue)) > Number(tdsMaxCapAmount) ? Number(tdsMaxCapAmount) <= 0 ? 0 : Number(tdsMaxCapAmount) : (tdsTnyWinningsEnabled ? Number(tdsCashbackAmount) <= 0 : Number(finalCashbackValue) <= 0) ? 0 : tdsTnyWinningsEnabled ? Number(tdsCashbackAmount) : Number(finalCashbackValue))

                  ).toFixed(2)}</span></div>
              </div>


              {/* New changes need to check baboi */}

              {(!paidInstantRedeemEnableFlag ? (!stdAndInstantCheck && (!standardSelected && !instantSelected ? !standardAmountCheck : (!standardAmountCheck || !InstantAmountCheck))) : (!stdAndInstantCheck && !paidInstantAmountCheck && (!standardSelected && !instantSelected ? !standardAmountCheck : (!standardAmountCheck || !InstantAmountCheck)))) ? <div className="errorNoteDiv1"
                // style={{ width: "95%", height: "10%", borderRadius: "5px", display: "flex", marginBottom: "10%", marginLeft: "2%" }}
                style={{ width: "90%", height: "2rem", borderRadius: "5px", display: "flex", marginLeft: "5%", marginTop: "2%" }}
              >
                <div className='leftborderror1' style={{ width: "2%", height: "100%" }}></div>

                <div style={{ width: "98%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>
                  <img src={assets?.assets?.ImformationRedIcon} style={{ width: "16px", height: "16px", paddingLeft: "5px" }} />
                  <span className='errorNoteDivText' style={{ fontSize: "0.7rem", fontWeight: "600", marginLeft: "5px", paddingTop: "10px", paddingBottom: "10px" }}>Your withdraw amount should be more than {RUPEE_SYMBOL} {min}</span>
                </div>
              </div> :
                (tdsTnyWinningsEnabled && (Number(cummilativeTrnyWinnings) > 0 && amountEntered > 0 && (finalCashbackValue <= 0 || tdsCashbackAmount <= 0)) && ((standardSelected && applicableForStandard) || (instantSelected && applicableForInstant))) ? <div className='errorNoteDiv1' style={{ width: "90%", height: "2rem", borderRadius: "5px", display: "flex", marginLeft: "5%", marginTop: "2%" }}>
                  <div className='leftborderror1' style={{ width: "2%", height: "100%" }}></div>

                  <div style={{ width: "98%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>
                    <img src={assets?.assets?.ImformationRedIcon} style={{ width: "16px", height: "16px", paddingLeft: "5px" }} />
                    <span className='errorNoteDivTextTDS' style={{ fontSize: "0.7rem", fontWeight: "600", marginLeft: "5px" }}>TDS Cashback not applicable on Tourney Winnings</span>

                  </div>
                </div> : ""}



            </div>





            <div id="ento" className='FooterRedeemDiv' style={{ width: "100%", height: "20%", display: 'flex', alignItems: "center", justifyContent: '', flexDirection: "column", position: "absolute", bottom: "5px" }}

            >


              <div className='redeemAccountDetails2' style={{
                width: "100%",height: "50%",
                paddingTop: "10%",
                paddingBottom: "8%",
                // height: "50%",
                borderRadius: "12px 12px 0px 0px", boxShadow: "0px -2px 4px 0px rgba(0, 0, 0, 0.25)", display:
                  // (!stdAndInstantCheck) || (!instantAvailabilityFlag && monthlyStandard <= 0) || ((nextStandardRedeemAvailability !== "N") && (nextInstantRedeemAvailability !== "N")) || (monthlyStandardExhausted && nextInstantRedeemAvailability !== "N") || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && nextStandardRedeemAvailability !== "N") || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted) 
                  (paidInstantRedeemEnableFlag ? (
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantExhausted && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantExhausted) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantExhausted) ||
                    (!stdAndInstantCheck && !paidInstantAmountCheck) ||
                    (!standardEnableFlag && !instantEnableFlag && paidInstantExhausted) ||
                    (standardExhausted && !instantEnableFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && !insantReedemFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantIsInCoolOff) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantExhausted)


                  ) :

                    ((!standardEnableFlag && !instantEnableFlag) || (standardExhausted && !instantEnableFlag) || (!standardEnableFlag && !insantReedemFlag) ||
                      (!standardEnableFlag && instantIsInCoolOff) || (standardExhausted && instantIsInCoolOff) || (standardIsInCoolOff && !instantEnableFlag) || (standardIsInCoolOff && !insantReedemFlag) ||
                      (standardIsInCoolOff && instantIsInCoolOff) ||
                      (standardExhausted && instantExhausted) ||

                      (standardIsInCoolOff && instantIsInCoolOff) || !stdAndInstantCheck))
                    ? "none" : "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"
              }}>
                {/* , height: '35%' */}
                <div className='redeemToText' style={{ width: "92%", display: 'flex', alignItems: 'center', fontSize: "0.9rem", fontWeight: '700' }}>
                  <span style={{ position: 'relative', bottom: '0' }}>{VernacularContextData.getTransalatedKey("withdrawto")}</span>
                </div>
                {selectedRedeemMethod !== undefined && redeemDetails.allRedeemOptions?.length > 0 ?

                  <div style={{ width: "92%", display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingTop: "5px" }}>
                    <div className='redeemMethodText' style={{ display: 'flex', width: '80%', height: "50%", fontWeight: "700", fontSize: "0.85rem", alignItems: 'center' }}>
                      <img src={activeRedeemMethod.type === 'upi' ? upiIcon : activeRedeemMethod.type === 'amazonPay' ? amazonPayIcon : activeRedeemMethod.type === 'bankAccount' ? assets.assets.bankIcon : activeRedeemMethod.type === 'paytmWallet' ? paytmIcon : ''} />
                      <div style={{ display: 'flex', marginLeft: "5%", flexDirection: "column" }}>
                        <div>{activeRedeemMethod.type === 'bankAccount' ? activeRedeemMethod.bankName : activeRedeemMethod.type === 'upi' ? activeRedeemMethod.upi : `${activeRedeemMethod.name + ' ' + 'xxxxxx' + activeRedeemMethod.id.slice(6)}`}</div>
                        {activeRedeemMethod.type === 'bankAccount' && <div>{'x'.repeat(activeRedeemMethod.accountNumber.length - 4) + activeRedeemMethod.accountNumber.slice(activeRedeemMethod.accountNumber.length - 4)}</div>}
                      </div>
                      {(activeRedeemMethod?.bankStatus === 'processing' || activeRedeemMethod?.upiState === 'processing') &&
                        <div className='nowrap' style={{ width: '30%', height: '50%', marginLeft: '2%', display: 'flex', fontSize: '0.55rem', alignItems: "center", justifyContent: "center", color: '#CD7F32', fontWeight: '700', borderRadius: '24px', background: '#FFB30033' }}>
                          <span style={{ width: '95%', height: '100%', display: "flex", alignItems: 'center', justifyContent: "center" }}>{VernacularContextData.getTransalatedKey("validationpending")}</span>
                        </div>}
                    </div>
                    <div id="change" className='changeAction' style={{ textDecoration: 'underline', fontSize: "0.85rem" }}
                      onClick={() => { setOpenAllRedeemOptions(true); onClickofChangeRedeemMethod() }}>{VernacularContextData.getTransalatedKey("change")}</div>
                  </div>
                  :
                  <div style={{ width: "92%", height: "65%", display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: "0.9rem", fontWeight: '500', color: "#9C9D9F",paddingBottom:"2%" }}>{VernacularContextData.getTransalatedKey("nowithdrawaccountavailable")}</div>
                }





              </div>


              <div id="deni" style={{ width: "100%", height: "35%", display: "flex", justifyContent: "center", alignItems: "center", position: "absolute", bottom: "1%" }}>
                <div id={activeRedeemMethod !== undefined ?
                  // (!stdAndInstantCheck) || (!instantAvailabilityFlag && monthlyStandard <= 0) || ((nextStandardRedeemAvailability !== "N") && (nextInstantRedeemAvailability !== "N")) || (monthlyStandardExhausted && nextInstantRedeemAvailability !== "N") || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && nextStandardRedeemAvailability !== "N") || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted) 
                  (paidInstantRedeemEnableFlag ? (
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantExhausted && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantIsInCoolOff) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && instantExhausted && paidInstantExhausted) ||
                    (standardExhausted && instantIsInCoolOff && paidInstantExhausted) ||
                    (!stdAndInstantCheck && !paidInstantAmountCheck) ||
                    (!standardEnableFlag && !instantEnableFlag && paidInstantExhausted) ||
                    (standardExhausted && !instantEnableFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && !insantReedemFlag && paidInstantExhausted) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantIsInCoolOff) ||
                    (!standardEnableFlag && instantIsInCoolOff && paidInstantExhausted) ||
                    (standardIsInCoolOff && !instantEnableFlag && paidInstantExhausted)


                  ) :

                    ((!standardEnableFlag && !instantEnableFlag) || (standardExhausted && !instantEnableFlag) || (!standardEnableFlag && !insantReedemFlag) ||
                      (!standardEnableFlag && instantIsInCoolOff) || (standardExhausted && instantIsInCoolOff) || (standardIsInCoolOff && !instantEnableFlag) || (standardIsInCoolOff && !insantReedemFlag) ||
                      (standardIsInCoolOff && instantIsInCoolOff) ||
                      (standardExhausted && instantExhausted) ||

                      (standardIsInCoolOff && instantIsInCoolOff) || !stdAndInstantCheck))
                    ? "redeem_button" : 'Redeem_placement' : "redeem_button"}//"redeem_button"//height: '55%'
                  className={(!shouldRedeemDisabled() ?
                    isoemps ? "RedeemActionButtonYellow" : "RedeemActionButtonGreen" :
                    (paidInstantRedeemEnableFlag ? (
                      (standardIsInCoolOff && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                      (standardExhausted && instantExhausted && paidInstantExhausted) ||
                      (standardIsInCoolOff && instantIsInCoolOff && paidInstantExhausted) ||
                      (standardIsInCoolOff && instantExhausted && paidInstantIsInCoolOff) ||
                      (standardExhausted && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                      (standardIsInCoolOff && instantExhausted && paidInstantExhausted) ||
                      (standardExhausted && instantIsInCoolOff && paidInstantExhausted) ||
                      (!stdAndInstantCheck && !paidInstantAmountCheck) ||
                      (!standardEnableFlag && !instantEnableFlag && paidInstantExhausted) ||
                      (standardExhausted && !instantEnableFlag && paidInstantExhausted) ||
                      (!standardEnableFlag && !insantReedemFlag && paidInstantExhausted) ||
                      (!standardEnableFlag && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                      (standardIsInCoolOff && !instantEnableFlag && paidInstantIsInCoolOff) ||
                      (!standardEnableFlag && instantIsInCoolOff && paidInstantExhausted) ||
                      (standardIsInCoolOff && !instantEnableFlag && paidInstantExhausted)


                    ) :

                      ((!standardEnableFlag && !instantEnableFlag) || (standardExhausted && !instantEnableFlag) || (!standardEnableFlag && !insantReedemFlag) ||
                        (!standardEnableFlag && instantIsInCoolOff) || (standardExhausted && instantIsInCoolOff) || (standardIsInCoolOff && !instantEnableFlag) || (standardIsInCoolOff && !insantReedemFlag) ||
                        (standardIsInCoolOff && instantIsInCoolOff) ||
                        (standardExhausted && instantExhausted) ||

                        (standardIsInCoolOff && instantIsInCoolOff) || !stdAndInstantCheck)) ? isoemps ? "RedeemActionButtonYellow" : "RedeemActionButtonGreen" : "RedeemActionButtonGrey")}
                  style={{
                    width: '90%', height: '45px',
                    borderRadius: "4px", fontSize: '1rem', fontWeight: '700', display: "flex", alignItems: "center", justifyContent: "center",
                  }}
                  //New changes need to check baboi
                  onClick={(event) => handleRedeemButtonClick(event)}//when button is disabled it should not be clicked
                >
                  {/* {console.log(" what happened >>>>>>>> 12345654345654", smartRedeemEnabled, showSmartRedeem, insantReedemFlag, paidInstantRedeemEnableFlag)} */}
                  {activeRedeemMethod !== undefined ?
                    //  (!stdAndInstantCheck && (showPaidRedeems && (paidInstantIsInCoolOff || paidInstantExhausted))) ||
                    //   (!instantAvailabilityFlag && monthlyStandard <= 0 && (showPaidRedeems && (paidInstantIsInCoolOff || paidInstantExhausted))) ||
                    //   ((nextStandardRedeemAvailability !== "N") && (nextInstantRedeemAvailability !== "N") && (showPaidRedeems && (paidInstantIsInCoolOff || paidInstantExhausted))) ||
                    //   (monthlyStandardExhausted && nextInstantRedeemAvailability !== "N" && (showPaidRedeems && (paidInstantIsInCoolOff || paidInstantExhausted))) ||
                    //   (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && nextStandardRedeemAvailability !== "N" && (showPaidRedeems && (paidInstantIsInCoolOff || paidInstantExhausted))) ||
                    //   (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted && (showPaidRedeems && (paidInstantIsInCoolOff || paidInstantExhausted)))

                    (paidInstantRedeemEnableFlag ? (
                      (standardIsInCoolOff && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                      (standardExhausted && instantExhausted && paidInstantExhausted) ||
                      (standardIsInCoolOff && instantIsInCoolOff && paidInstantExhausted) ||
                      (standardIsInCoolOff && instantExhausted && paidInstantIsInCoolOff) ||
                      (standardExhausted && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                      (standardIsInCoolOff && instantExhausted && paidInstantExhausted) ||
                      (standardExhausted && instantIsInCoolOff && paidInstantExhausted) ||
                      (!stdAndInstantCheck && !paidInstantAmountCheck)
                      ||
                      (!standardEnableFlag && !instantEnableFlag && paidInstantExhausted) ||
                      (standardExhausted && !instantEnableFlag && paidInstantExhausted) ||
                      (!standardEnableFlag && !insantReedemFlag && paidInstantExhausted) ||
                      (!standardEnableFlag && instantIsInCoolOff && paidInstantIsInCoolOff) ||
                      (standardIsInCoolOff && !instantEnableFlag && paidInstantIsInCoolOff) ||
                      (!standardEnableFlag && instantIsInCoolOff && paidInstantExhausted) ||
                      (standardIsInCoolOff && !instantEnableFlag && paidInstantExhausted)


                    ) :

                      ((!standardEnableFlag && !instantEnableFlag) || (standardExhausted && !instantEnableFlag) || (!standardEnableFlag && !insantReedemFlag) ||
                        (!standardEnableFlag && instantIsInCoolOff) || (standardExhausted && instantIsInCoolOff) || (standardIsInCoolOff && !instantEnableFlag) || (standardIsInCoolOff && !insantReedemFlag) ||
                        (standardIsInCoolOff && instantIsInCoolOff) ||
                        (standardExhausted && instantExhausted) ||

                        (standardIsInCoolOff && instantIsInCoolOff) || !stdAndInstantCheck))
                      ? "Go To Lobby" : ((smartRedeemEnabled && standardSelected && (smartRedeemForInstantOrStandard === "standard" || smartRedeemForInstantOrStandard === "both")) || (smartRedeemEnabled && instantSelected && (smartRedeemForInstantOrStandard === "instant" || smartRedeemForInstantOrStandard === "both"))) ? VernacularContextData.getTransalatedKey("continue") : VernacularContextData.getTransalatedKey("withdraw") : VernacularContextData.getTransalatedKey("setupwithdrawaccount")}
                </div>
              </div>
            </div>




            {/* {(!stdAndInstantCheck && (!standardSelected && !instantSelected ? !standardAmountCheck : (!standardAmountCheck || !InstantAmountCheck))) ? <div style={{ width: "95%", height: "10%", border: "1px solid #c62828", borderRadius: "5px", display: "flex", marginBottom: "10%" }}>
              <div style={{ width: "2%", height: "100%", backgroundColor: "#c62828" }}></div>

              <div style={{ width: "98%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>
                <img src={ImformationRedIcon} style={{ width: "16px", height: "16px", paddingLeft: "5px" }} />
                <span style={{ fontSize: "0.7rem", color: "#c62828", fontWeight: "600", marginLeft: "5px" }}>Your redeem amount should be more than {RUPEE_SYMBOL} {min}</span>

              </div>
            </div> : ""} */}


            {/* Need to check >>>>>>>> baboi */}
            {/* 
            {(!paidInstantRedeemEnableFlag ? (!stdAndInstantCheck && (!standardSelected && !instantSelected ? !standardAmountCheck : (!standardAmountCheck || !InstantAmountCheck))) : (!stdAndInstantCheck && !paidInstantAmountCheck && (!standardSelected && !instantSelected ? !standardAmountCheck : (!standardAmountCheck || !InstantAmountCheck)))) ? <div className="errorNoteDiv1" style={{ width: "95%", height: "10%", borderRadius: "5px", display: "flex", marginBottom: "10%", marginLeft: "2%" }}>
              <div className='leftborderror1' style={{ width: "2%", height: "100%" }}></div>

              <div style={{ width: "98%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>
                <img src={assets?.assets?.ImformationRedIcon} style={{ width: "16px", height: "16px", paddingLeft: "5px" }} />
                <span className='errorNoteDivText' style={{ fontSize: "0.7rem", fontWeight: "600", marginLeft: "5px", paddingTop: "10px", paddingBottom: "10px" }}>Your redeem amount should be more than {RUPEE_SYMBOL} {min}</span>
              </div>
            </div> :
              (tdsTnyWinningsEnabled && (Number(cummilativeTrnyWinnings) > 0) && (applicableForStandard || applicableForInstant)) ? <div className='errorNoteDiv1' style={{ width: "90%", height: "2.5rem", borderRadius: "5px", display: "flex", marginLeft: "5%" }}>
                <div className='leftborderror1' style={{ width: "2%", height: "100%" }}></div>

            <div style={{ width: "98%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>
              <img src={assets?.assets?.ImformationRedIcon} style={{ width: "16px", height: "16px", paddingLeft: "5px" }} />
              <span className='errorNoteDivTextTDS' style={{ fontSize: "0.7rem", fontWeight: "600", marginLeft: "5px" }}>TDS Cashback not applicable on Tourney Winnings</span>

                </div>
              </div> : ""} */}

          </div>
          {/* Error tds cashback note */}
          {/* {(tdsTnyWinningsEnabled && (Number(cummilativeTrnyWinnings) > 0) ) && <div className='errorNoteDiv1' style={{ width: "90%", height: "2.5rem", borderRadius: "5px", display: "flex" }}>
            <div className='leftborderror1' style={{ width: "2%", height: "100%" }}></div>

            <div style={{ width: "98%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>
              <img src={assets?.assets?.ImformationRedIcon} style={{ width: "16px", height: "16px", paddingLeft: "5px" }} />
              <span className='errorNoteDivText' style={{ fontSize: "0.7rem", fontWeight: "600", marginLeft: "5px" }}>TDS Cashback not applicable on Tourney Winnings</span>

            </div>
          </div>} */}



          {/* 
          {console.log("hhhhhhhhh", instantAvailabilityFlag)}

          {console.log("hhhhhhhhh 1", monthlyStandard)}


          {console.log("sdfsfsdfgdfgdfg ", monthlyStandardExhausted, monthlyInstant)} */}


          {/* {(!minAmountCheck) ? <div style={{ width: "95%", height: "10%", border: "1px solid #c62828", borderRadius: "5px", display: "flex", marginBottom: "10%" }}>
            <div style={{ width: "2%", height: "100%", backgroundColor: "#c62828" }}></div>

            <div style={{ width: "98%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center" }}>
              <img src={ImformationRedIcon} style={{ width: "16px", height: "16px", paddingLeft: "5px" }} />
              <span style={{ fontSize: "0.7rem", color: "#c62828", fontWeight: "600", marginLeft: "5px" }}>Your winnings should be greater than {RUPEE_SYMBOL} {min} to place a redeem.</span>

            </div>
          </div> : ""} */}

          {/* <div className='redeemAccountDetails' style={{}}>
            <div style={{ width: "92%", height: '35%', display: 'flex', alignItems: 'end', fontSize: "0.9rem", fontWeight: '700', color: "#032146" }}>
              <span style={{ position: 'relative', bottom: '0' }}>Redeem to</span>
            </div>
            {selectedRedeemMethod !== undefined && redeemDetails?.allRedeemOptions?.length > 0 ?

              <div style={{ width: "92%", height: "65%", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', width: '80%', height: "50%", color: "#032146", fontWeight: "700", fontSize: "0.85rem", alignItems: 'center' }}>
                  <img src={activeRedeemMethod.type === 'upi' ? upiIcon : activeRedeemMethod.type === 'amazonPay' ? amazonPayIcon : activeRedeemMethod.type === 'bankAccount' ? bankIcon : activeRedeemMethod.type === 'paytmWallet' ? paytmIcon : ''} />
                  <div style={{ display: 'flex', marginLeft: "5%", flexDirection: "column" }}>
                    <div>{activeRedeemMethod.type === 'bankAccount' ? activeRedeemMethod.bankName : activeRedeemMethod.type === 'upi' ? activeRedeemMethod.upi : `${activeRedeemMethod.name + ' ' + 'xxxxxx' + activeRedeemMethod.id.slice(6)}`}</div>
                    {activeRedeemMethod.type === 'bankAccount' && <div>{'x'.repeat(activeRedeemMethod.accountNumber.length - 4) + activeRedeemMethod.accountNumber.slice(activeRedeemMethod.accountNumber.length - 4)}</div>}
                  </div>
                  {(activeRedeemMethod?.bankStatus === 'processing' || activeRedeemMethod?.upiState === 'processing') &&
                    <div className='nowrap' style={{ width: '30%', height: '50%', marginLeft: '2%', display: 'flex', fontSize: '0.55rem', alignItems: "center", justifyContent: "center", color: '#CD7F32', fontWeight: '700', borderRadius: '24px', background: '#FFB30033' }}>
                      <span style={{ width: '95%', height: '100%', display: "flex", alignItems: 'center', justifyContent: "center" }}>Validation Pending</span>
                    </div>}
                </div>
                <div id="change" style={{ color: '#58B6C6', textDecoration: 'underline', fontSize: "0.85rem" }}
                  onClick={() => { setOpenAllRedeemOptions(true); onClickofChangeRedeemMethod() }}>Change</div>
              </div>
              :
              <div style={{ width: "92%", height: "65%", display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: "0.9rem", fontWeight: '500', color: "#9C9D9F" }}>No Redeem Account available</div>
            }

          </div> */}
        </div>
      </div>


      {/* <div id="redeemAccountDetails2" className='redeemAccountDetails2' style={{ width: "100%", height: "12%", borderRadius: "10px 10px 0px 0px", boxShadow: "0px -2px 4px 0px rgba(0, 0, 0, 0.25)", display: (!stdAndInstantCheck) || (!instantAvailabilityFlag && monthlyStandard <= 0) || ((nextStandardRedeemAvailability !== "N") && (nextInstantRedeemAvailability !== "N")) || (monthlyStandardExhausted && nextInstantRedeemAvailability !== "N") || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && nextStandardRedeemAvailability !== "N") || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted) ? "none" : "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        <div style={{ width: "92%", height: '35%', display: 'flex', alignItems: 'end', fontSize: "0.9rem", fontWeight: '700', color: "#032146" }}>
          <span style={{ position: 'relative', bottom: '0' }}>Redeem to</span>
        </div>
        {selectedRedeemMethod !== undefined && redeemDetails?.allRedeemOptions?.length > 0 ?

          <div style={{ width: "92%", height: "65%", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', width: '80%', height: "50%", color: "#032146", fontWeight: "700", fontSize: "0.85rem", alignItems: 'center' }}>
              <img src={activeRedeemMethod.type === 'upi' ? upiIcon : activeRedeemMethod.type === 'amazonPay' ? amazonPayIcon : activeRedeemMethod.type === 'bankAccount' ? bankIcon : activeRedeemMethod.type === 'paytmWallet' ? paytmIcon : ''} />
              <div style={{ display: 'flex', marginLeft: "5%", flexDirection: "column" }}>
                <div>{activeRedeemMethod.type === 'bankAccount' ? activeRedeemMethod.bankName : activeRedeemMethod.type === 'upi' ? activeRedeemMethod.upi : `${activeRedeemMethod.name + ' ' + 'xxxxxx' + activeRedeemMethod.id.slice(6)}`}</div>
                {activeRedeemMethod.type === 'bankAccount' && <div>{'x'.repeat(activeRedeemMethod.accountNumber.length - 4) + activeRedeemMethod.accountNumber.slice(activeRedeemMethod.accountNumber.length - 4)}</div>}
              </div>
              {(activeRedeemMethod?.bankStatus === 'processing' || activeRedeemMethod?.upiState === 'processing') &&
                <div className='nowrap' style={{ width: '30%', height: '50%', marginLeft: '2%', display: 'flex', fontSize: '0.55rem', alignItems: "center", justifyContent: "center", color: '#CD7F32', fontWeight: '700', borderRadius: '24px', background: '#FFB30033' }}>
                  <span style={{ width: '95%', height: '100%', display: "flex", alignItems: 'center', justifyContent: "center" }}>Validation Pending</span>
                </div>}
            </div>
            <div id="change" style={{ color: '#58B6C6', textDecoration: 'underline', fontSize: "0.85rem" }}
              onClick={() => { setOpenAllRedeemOptions(true); onClickofChangeRedeemMethod() }}>Change</div>
          </div>
          :
          <div style={{ width: "92%", height: "65%", display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: "0.9rem", fontWeight: '500', color: "#9C9D9F" }}>No Redeem Account available</div>
        }

      </div> */}

      {/* Removed from here baboi */}

    </>


  }

  const isIdOrKycApproved = () => {
    const idStatus = redeemDetails?.isIdVerified?.toLowerCase();
    const kycStatus = redeemDetails?.kycStatus?.toLowerCase();
    return idStatus === "approved" || kycStatus === "approved";
  };

  const hasVerifiedEmailRequirement = () => {
    // This helper checks if email is NOT verified AND it IS mandatory
    return redeemDetails?.emailVerified === false && panEmailMandatoryConfig === true;
  };

  const shouldShowForNewUser = () => {
    console.log("-----------------> shouldShowForUser start-------------------->");
    if (!redeemDetails?.newUser) {
      console.log("[shouldShowForNewUser] Not a new user. Returning FALSE.");
      console.log("-----------------> shouldShowForUser end (not new user)-------------------->");
      return false;
    }

    const options = redeemDetails.allRedeemOptions || [];
    console.log("[shouldShowForNewUser] New user flow. allRedeemOptions.length:", options.length);

    // If new user and no redeem options available, we need to show verification
    if (options.length === 0) {
      console.log("[shouldShowForNewUser] New user, but no redeem options. Returning TRUE.");
      console.log("-----------------> shouldShowForUser end (no options)-------------------->");
      return true;
    }

    // If any option is approved or is a known wallet, no need to show verification
    const approvedOrKnownWalletIndex = options.findIndex((o) =>
      o.upiState === 'approved' ||
      o.bankStatus === 'approved' ||
      ["amazonpay", "amazon pay", "paytmwallet", "paytm wallet"].includes(o.name?.toLowerCase())
    );
    if (approvedOrKnownWalletIndex !== -1) {
      console.log("[shouldShowForNewUser] Found approved/known wallet. Returning FALSE.");
      console.log("-----------------> shouldShowForUser end (approved/known)-------------------->");
      return false;
    }

    // If any option is processing (and none are approved/known), show verification
    const processingIndex = options.findIndex((o) => o.upiState === 'processing' || o.bankStatus === 'processing');
    if (processingIndex !== -1) {
      console.log("[shouldShowForNewUser] Found processing, but no approved/known wallet. Returning TRUE.");
      console.log("-----------------> shouldShowForUser end (processing)-------------------->");
      return true;
    }

    // Default for new user with other redeem option states (e.g., pending, failed, or unknown)
    console.log("[shouldShowForNewUser] New user, but no specific reason to show based on redeem options. Returning FALSE.");
    console.log("-----------------> shouldShowForUser end (default new user)-------------------->");
    return false;
  };


  const showVerificationPage = () => {
    console.log("-----------------------show verification page----------------------------------");
    console.log("[showVerificationPage] emailVerified:", redeemDetails?.emailVerified,
      "| panEmailMandatoryConfig:", panEmailMandatoryConfig,
      "| isIdOrKycApproved:", isIdOrKycApproved());

    // 1. Check if email verification is mandatory and not yet done.
    if (hasVerifiedEmailRequirement()) {
      console.log("[showVerificationPage] Email verification is required. Showing verification page.");
      window.sessionStorage.setItem('reloadPageInRedeem', false); // No reload needed after email verification
      return true;
    }

    // 2. If email is verified OR not mandatory, then check ID/KYC status.
    // If ID/KYC is APPROVED:
    if (isIdOrKycApproved()) {
      console.log("[showVerificationPage] ID or KYC is approved. Checking new user status for final decision.");
      // If ID/KYC is approved, but it's a new user who still needs to go through a verification flow based on redeem options
      if (shouldShowForNewUser()) {
        console.log("[showVerificationPage] New user flow dictates showing verification despite ID/KYC approval.");
        window.sessionStorage.setItem('reloadPageInRedeem', true); // Potentially a reload needed after this flow
        return true;
      } else {
        // If ID/KYC is approved, and new user conditions don't warrant showing the page
        console.log("[showVerificationPage] ID or KYC approved, and no new user specific verification needed. NOT showing verification page.");
        window.sessionStorage.setItem('reloadPageInRedeem', true); // No reload needed if not showing page, but might be for redemption flow
        return false;
      }
    }
    // If ID/KYC is NOT APPROVED (and email is already fine):
    else {
      console.log("[showVerificationPage] ID or KYC is NOT approved (and email is ok). Showing verification page.");
      window.sessionStorage.setItem('reloadPageInRedeem', true); // Potentially a reload needed after this flow
      return true;
    }
  };

  const handleRedeemOptionChange = (option, task) => {
    setActiveRedeemMethod(option)
    setOpenAllRedeemOptions(false)
    setOpenRemoveTag(undefined)
  }

  const handleRedeemRequestSent = async (val, issue) => {

    console.log("came here once 1", playBalanceAmt)
    setLoading(true)
   
    isClickedRef.current = true;
    console.log("came here once", buttonText, issue);
  
    await axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "redeem/withdrawal_request/",

      headers: {
        Authorization: window.sessionStorage["token"]
      },
      data: {
        amount: val,
        withdrawType: activeRedeemMethod.type,
        channel: window.sessionStorage['channel'],
        bankAccountNumber: (activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? activeRedeemMethod.id : activeRedeemMethod.type === 'bankAccount' ? activeRedeemMethod.accountNumber : activeRedeemMethod.type === 'upi' ? activeRedeemMethod.upi : "",
        name: activeRedeemMethod.name,
        // transactionType: standardSelected ? "standard" : "instant",
        transactionType: standardSelected ? "standard" : instantSelected ? "instant" : "paidInstant",
        bonusReleasedLastXDaysAmtClient: bonusReleasedLastXDaysAmt !== undefined ? bonusReleasedLastXDaysAmt : 0,
        smartRedeem: !smartRedeemNewUIFlag ? ((playBalanceAmt > 0 && (issue && issue.toLowerCase()) === "redeemwithbonus") ? true : false) : ((smartRedeemAmountArray && (basicSelected ? smartRedeemAmountArray[0] > 0 : saverSelected ? smartRedeemAmountArray[1] > 0 : smartRedeemAmountArray[2] > 0) && (issue && issue.toLowerCase()) === "redeemwithbonus") ? true : false),
        smartRedeemObject: {
          playBalanceAmount: !smartRedeemNewUIFlag ? playBalanceAmt : smartRedeemAmountArray ? (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]) : playBalanceAmt,
          lockedBonus: !smartRedeemNewUIFlag ? lockedBonus : lockedBonusArr ? basicSelected ? lockedBonusArr[0] : saverSelected ? lockedBonusArr[1] : lockedBonusArr[2] : lockedBonus,
          instantBonus: !smartRedeemNewUIFlag ? instantBonus : instantBonusArr ? basicSelected ? instantBonusArr[0] : saverSelected ? instantBonusArr[1] : instantBonusArr[2] : instantBonus,
          totalAmountEntered: amountEntered,

        },
       
      },
    }).then(async (res) => {
      // console.log('came here dummy')
      if (res.data.error) {
        console.log("here in error : ", isNewVersion , " is new version");
        if (isNewVersion) { //this is added for backward compatibility
          if (res?.data?.error?.statusCode === 1231) {
            WebToNativeMessage({
              type: "FraudUser",
              kycStatus: redeemDetails?.kycStatus,
            });
             isClickedRef.current = false;
             setLoading(false);
            // return;
          }
        }
console.log("error in redeem request sent 1", res.data.error.message);
        if (res.data.error.message) {
          console.log(
            "error message in redeem request sent",res.data.error.message
          )
          // if(!isNewVersion){

            setToastMessage({ message: res.data.error.message, status: false })
          // }
        }
        else {
         
          setToastMessage({ message: 'DB Error', status: false })
        }
        isClickedRef.current = false;
      }
      else {
        console.log("Response after redeem request sent", res.data)
        await setShowRedeemStatusData(res.data);
        setShowRedeemStatus(true);
        setShowIframe(false)
isClickedRef.current = false;
      }
      console.log("standard selected nedeed", res)
      setOpenRedeemRecommendation(false)
      // setFetchRedeemDetails(fetchRedeemDetails + 1)
      // console.log("standard selected", standardSelected)
      setLoading(false);
      setToShowStandardAndInstantBottomSheet(false);
isClickedRef.current = false;
    }).catch((e) => {
      console.log('handleRedeemRequestSent')
    })
    //   history.push('/redeemStatus/')

  }



  const handleRemoveRedeemMethod = (account) => {
    setDeleteLoading(true)
    if (account.type === 'paytmWallet') {
      axios({
        method: "POST",
        url: process.env.REACT_APP_NEW_BASE_URL + "redeem/remove_wallet/",
        headers: {
          Authorization: window.sessionStorage['token']
        },
        data: {
          walletType: 'paytm',
          channel: window.sessionStorage['channel']
        },
      }).then((res) => {
        if (res.data.error) {
          if (res.data.error.message && res.data.error.message !== '') {
            if (res.data.error.statusCode !== 1000 && res.data.error.statusCode !== 1224) {
              setToastMessage({ message: res.data.error.message, status: false })
            }
          }
          else {
            setToastMessage({ message: 'DB Error', status: false })
          }
        }
        else {

          if (res.data.message && res.data.message !== '') {
            setToastMessage({ message: res.data.message, status: false })
          }
          if (res.data.statusCode === 1211) {
            WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemAccountDeleted", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, mode_selected: account.type } })
          }
        }
        setDeleteLoading(false)

        setFetchRedeemDetails(fetchRedeemDetails + 1)
      }).catch((e) => {
        setDeleteLoading(false)

        console.log('error in removing paytm wallet')
      })
    }
    else if (account.type === 'amazonPay') {
      axios({
        method: "POST",
        url: process.env.REACT_APP_NEW_BASE_URL + "redeem/remove_wallet/",
        headers: {
          Authorization: window.sessionStorage['token']
        },
        data: {
          walletType: 'amazonPay',
          channel: window.sessionStorage['channel']
        },
      }).then((res) => {
        if (res.data.error) {
          if (res.data.error.message && res.data.error.message !== '') {
            if (res.data.error.statusCode !== 1000 && res.data.error.statusCode !== 1224) {
              setToastMessage({ message: res.data.error.message, status: false })
            }
          }
          else {
            setToastMessage({ message: 'DB Error', status: false })
          }
        }
        else {
          if (res.data.message && res.data.message !== '') {
            setToastMessage({ message: res.data.message, status: false })
          }
          if (res.data.statusCode === 1211) {
            WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemAccountDeleted", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, mode_selected: account.type } })
          }

        }
        setDeleteLoading(false)

        setFetchRedeemDetails(fetchRedeemDetails + 1)
      }).catch((e) => {
        setDeleteLoading(false)

        console.log('error in removing amazon pay wallet')
      })
    }
    else if (account.type === 'bankAccount') {
      axios({
        method: "POST",
        url: process.env.REACT_APP_NEW_BASE_URL + "redeem/bank_delink",
        headers: {
          Authorization: window.sessionStorage['token']
        },
        data: {
          account_number: account.accountNumber
        },
      }).then((res) => {
        if (res.data.error) {
          if (res.data.error.message && res.data.error.message !== '') {
            if (res.data.error.statusCode !== 1000 && res.data.error.statusCode !== 1224) {
              setToastMessage({ message: res.data.error.message, status: false })
            }
          }
          else {
            setToastMessage({ message: 'DB Error', status: false })
          }
        }
        else {
          if (res.data.message && res.data.message !== '') {
            setToastMessage({ message: res.data.message, status: false })
          }
          WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemAccountDeleted", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, mode_selected: account.type } })

        }
        setDeleteLoading(false)

        setFetchRedeemDetails(fetchRedeemDetails + 1)
      }).catch((e) => {
        setDeleteLoading(false)

        console.log('error in removing bank account')
      })
    }
    else if (account.type === 'upi') {
      axios({
        method: "POST",
        url: process.env.REACT_APP_NEW_BASE_URL + "redeem/remove_upi/",
        headers: {
          Authorization: window.sessionStorage['token']
        },
        data: {
          upiId: account.upi,
          channel: window.sessionStorage['channel']
        }
      }).then((res) => {
        if (res.data.error) {
          if (res.data.error.message && res.data.error.message !== '') {
            if (res.data.error.statusCode !== 1000 && res.data.error.statusCode !== 1224) {
              setToastMessage({ message: res.data.error.message, status: false })
            }
          }
          else {
            setToastMessage({ message: 'DB Error', status: false })
          }
        }
        else {
          if (res.data.message && res.data.message !== '') {
            setToastMessage({ message: res.data.message, status: false })
          }
          if (res.data.statusCode === 1217) {

            WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemAccountDeleted", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, mode_selected: account.type } })
          }

        }
        setDeleteLoading(false)
        setFetchRedeemDetails(fetchRedeemDetails + 1)
      }).catch((e) => {
        setDeleteLoading(false)

        console.log('error in removing Upi account')
      })
    }

  }

  const createPaidInstantConfirmationPopUp = () => {
    let paidInstantPopUp = <div style={{ position: "absolute", width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ position: 'absolute', width: '100%', height: '100%', background: "rgba(0,0,0,0.5)" }} onClick={() => setShowPaidInstantConfirmation(false)}></div>
      <div className='redeemCancelContainer' style={{ position: 'absolute', width: "92%", borderRadius: "5px", display: 'flex', flexDirection: "column", alignItems: "center" }}>
        <div className='redeemCancelHeader' style={{ width: "100%", height: "43px", display: 'flex', alignItems: "center", justifyContent: "center", fontSize: "0.9rem", fontWeight: '700', borderRadius: "5px 5px 0px 0px" }}>Confirmation</div>
        <div className='standardText' style={{ margin: "10px 0px 5px 0px", fontSize: "0.9rem" }}>Are you sure you want to withdraw {RUPEE_SYMBOL}{amountEntered}?</div>
        <div className='colorRedOEM' style={{ margin: "10px 0px 10px 0px", fontSize: "0.9rem" }}>Processing Fee of {RUPEE_SYMBOL}{paidInstantYouGetValue.toFixed(2)} is applicable</div>

        <div style={{ width: '90%', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', marginTop: '10px', marginBottom: "10px" }}>

          <div className='RedeemCancelNoButton' style={{ width: '40%', height: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px', fontWeight: "700" }} onClick={() => {
            setShowPaidInstantConfirmation(false);
            WebToNativeMessage({
              type: "redeemCTEvent", eventName: "PF_c_paidInstant_goback",
              eventProperties:
              {
                Redeem_mode: (activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? "wallet" : activeRedeemMethod.type === 'bankAccount' ? "bank account" : activeRedeemMethod.type === 'upi' ? "upi" : "",

                username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered === '' ? "NA" : amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], tds_deducted: tdsInfo.tds === -1 ? "NA" : tdsInfo.tds, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", paidProcessingFee: paidInstantRedeemProcessingFee, redeem_expiry_type: "Yes", timestamp: new Date().getTime()
              }
            })
          }}>Go Back</div>

          <div className='RedeemCancelYesButton' style={{ width: '40%', height: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '4px', fontWeight: '700' }} onClick={e => {
            if (redeemGamePassData?.length > 0 || activeMissionsData?.activeMission?.length > 0 || challengesData?.length > 0
              || expiredLockedBonusData !== undefined) {
              setToShowGamePassOverLay(true);
              if (redeemGamePassData?.length > 0) {
                { console.log(">>>>>> >>> <<<<<< <<<<<<", paidInstantRedeemProcessingFee) }
                WebToNativeMessage({
                  type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_clickRedeem",
                  eventProperties:
                  {
                    Redeem_mode: (activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? "wallet" : activeRedeemMethod.type === 'bankAccount' ? "bank account" : activeRedeemMethod.type === 'upi' ? "upi" : "",

                    username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered === '' ? "NA" : amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], tds_deducted: tdsInfo.tds === -1 ? "NA" : tdsInfo.tds, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", paidProcessingFee: paidInstantRedeemProcessingFee, redeem_expiry_type: "Yes", timestamp: new Date().getTime(), TDSCashbackAmount: (Number(tdsCashbackAmount) > Number(tdsMaxCapAmount)) ? tdsMaxCapAmount : tdsCashbackAmount,
                  }
                })
                // WebToNativeMessage({
                //   type: "plotLineEvent", eventName: "PF_c_RedeemPlacement_clickRedeem",
                //   eventProperties:
                //   {
                //     Redeem_mode: (activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? "wallet" : activeRedeemMethod.type === 'bankAccount' ? "bank account" : activeRedeemMethod.type === 'upi' ? "upi" : "",

                //     username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered === '' ? "NA" : amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], tds_deducted: tdsInfo.tds === -1 ? "NA" : tdsInfo.tds, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", paidProcessingFee: paidInstantRedeemProcessingFee, redeem_expiry_type: "Yes", timestamp: new Date().getTime()
                //   }
                // })
                WebToNativeMessage({
                  type: "mixpanelEvent", eventName: "PF_c_RedeemPlacement_clickRedeem",
                  eventProperties:
                  {
                    Redeem_mode: (activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? "wallet" : activeRedeemMethod.type === 'bankAccount' ? "bank account" : activeRedeemMethod.type === 'upi' ? "upi" : "",

                    username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered === '' ? "NA" : amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], tds_deducted: tdsInfo.tds === -1 ? "NA" : tdsInfo.tds, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", paidProcessingFee: paidInstantRedeemProcessingFee, redeem_expiry_type: "Yes", timestamp: new Date().getTime(), TDSCashbackAmount: (Number(tdsCashbackAmount) > Number(tdsMaxCapAmount)) ? tdsMaxCapAmount : tdsCashbackAmount,
                  }
                })
                // WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_clickRedeem", eventProperties: {redeem_expiry_type:"Yes",timestamp:new Date().getTime() }})
                WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_viewgamepass_redeem", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime() } })
                WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_viewgamepass_redeem", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime() } })
              }


            }




            else {
              onContinueClick();//Issue for paidinstant
              setShowSmartRedeem(false);
              setShowSmartRedeemPopup(false)
              WebToNativeMessage({
                type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_clickRedeem",
                eventProperties:
                {
                  Redeem_mode: (activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? "wallet" : activeRedeemMethod.type === 'bankAccount' ? "bank account" : activeRedeemMethod.type === 'upi' ? "upi" : "",

                  username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered === '' ? "NA" : amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], tds_deducted: tdsInfo.tds === -1 ? "NA" : tdsInfo.tds, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", paidProcessingFee: paidInstantRedeemProcessingFee, redeem_expiry_type: "No", timestamp: new Date().getTime(), TDSCashbackAmount: (Number(tdsCashbackAmount) > Number(tdsMaxCapAmount)) ? tdsMaxCapAmount : tdsCashbackAmount,
                }
              })
              // WebToNativeMessage({
              //   type: "plotLineEvent", eventName: "PF_c_RedeemPlacement_clickRedeem",
              //   eventProperties:
              //   {
              //     Redeem_mode: (activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? "wallet" : activeRedeemMethod.type === 'bankAccount' ? "bank account" : activeRedeemMethod.type === 'upi' ? "upi" : "",

              //     username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered === '' ? "NA" : amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], tds_deducted: tdsInfo.tds === -1 ? "NA" : tdsInfo.tds, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", paidProcessingFee: paidInstantRedeemProcessingFee, redeem_expiry_type: "No", timestamp: new Date().getTime()
              //   }
              // })
              WebToNativeMessage({
                type: "mixpanelEvent", eventName: "PF_c_RedeemPlacement_clickRedeem",
                eventProperties:
                {
                  Redeem_mode: (activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? "wallet" : activeRedeemMethod.type === 'bankAccount' ? "bank account" : activeRedeemMethod.type === 'upi' ? "upi" : "",

                  username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered === '' ? "NA" : amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], tds_deducted: tdsInfo.tds === -1 ? "NA" : tdsInfo.tds, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", paidProcessingFee: paidInstantRedeemProcessingFee, redeem_expiry_type: "No", timestamp: new Date().getTime(), TDSCashbackAmount: (Number(tdsCashbackAmount) > Number(tdsMaxCapAmount)) ? tdsMaxCapAmount : tdsCashbackAmount,
                }
              })
              // WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_clickRedeem", eventProperties: {redeem_expiry_type:"No",timestamp:new Date().getTime() }})
            }
            setShowPaidInstantConfirmation(false)
          }}>Confirm</div>
        </div>
      </div>
    </div>

    return paidInstantPopUp
  }
  const createRedeemRecommendation = () => {



    let redeemRecommendation;
    redeemRecommendation = <div style={{ position: 'absolute', width: "100%", height: "100%", display: 'flex', alignItems: 'end', justifyContent: 'center' }}>
      <div style={{ position: 'absolute', width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)' }} className='modalScreen' onClick={() => { setOpenRedeemRecommendation(false) }}></div>
      <div style={{ position: 'absolute', width: '100%', height: "50%", color: 'black', display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: '100%', height: '12%', background: '#2C5391', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '5px 5px 0px 0px' }}>
          <div style={{ fontWeight: 700, fontSize: '1rem', color: '#FFFFFF' }}>Withdraw Recommendation</div>
          <img src={assets?.asets?.Cross} alt='close' style={{ position: 'absolute', right: '5%' }} onClick={() => { setOpenRedeemRecommendation(false) }} />
        </div>
        <div style={{ width: '100%', height: "73%", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: "space-evenly", background: '#F9F9F9', overflowY: 'scroll' }}>
          {/* tdsTag */}
          <div onClick={() => { setRecommendationSelection(redeemDetails.tdsFreeAmount) }} className='standardText' style={{ width: '90%', display: 'flex', alignItems: 'center', height: '25%', border: "1px solid #F2F2F2", boxShadow: '0px 0px 4px 0px #00000029', borderRadius: "4px", position: "relative" }}>
            <img alt="tdsTag" src={tdsTag} className='absolute' style={{ left: "-7px", top: "-14%" }} />
            <div style={{ flex: '0.1', height: "70%", display: 'flex', alignItems: 'center', justifyContent: "center", borderRight: "1px solid #bababa" }}>
              <img src={recommendationSelection === redeemDetails.tdsFreeAmount ? assets?.assets?.RadioActive : assets?.assets?.RadioInactive} alt='radiobutton' />
            </div>
            <div style={{ flex: '0.3', height: "70%", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-evenly', borderRight: "1px solid #bababa" }}>
              <span style={{ fontSize: '0.8rem', fontWeight: "500" }}>Withdraw</span>
              <span style={{ fontSize: '0.9rem', fontWeight: "700" }}>{RUPEE_SYMBOL}{redeemDetails.tdsFreeAmount}</span>
            </div>
            <div style={{ flex: '0.3', height: "70%", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-evenly', borderRight: "1px solid #bababa" }}>
              <span style={{ fontSize: '0.8rem', fontWeight: "500" }}>TDS</span>
              <span style={{ fontSize: '0.8rem', fontWeight: "700", color: "#196A29" }}>{RUPEE_SYMBOL}0.00</span>
            </div>
            <div style={{ flex: '0.3', height: "70%", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ width: '80%', height: '100%', background: "#196A291F", borderRadius: "4px", flexDirection: "column", display: 'flex', alignItems: "center", justifyContent: "space-evenly" }}>
                <span style={{ fontSize: '0.8rem', fontWeight: "500" }}>{VernacularContextData.getTransalatedKey("youget")}</span>
                <span style={{ fontSize: '0.9rem', fontWeight: "700" }}>{RUPEE_SYMBOL}{redeemDetails.tdsFreeAmount ? (redeemDetails.tdsFreeAmount).toFixed() : ""}</span>
              </div>
            </div>
          </div>

          <div onClick={() => { setRecommendationSelection(amountEntered) }} className="footerTdsDiv" style={{ width: '90%', display: 'flex', alignItems: 'center', height: '25%', border: "1px solid #F2F2F2", boxShadow: '0px 0px 4px 0px #00000029', borderRadius: "4px" }}>
            <div style={{ flex: '0.1', height: "70%", display: 'flex', alignItems: 'center', justifyContent: "center", borderRight: "1px solid #bababa" }}>
              <img src={recommendationSelection === amountEntered ? assets?.assets?.RadioActive : assets?.assets?.RadioInactive} alt='radiobutton' />
            </div>
            <div style={{ flex: '0.3', height: "70%", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-evenly', borderRight: "1px solid #bababa" }}>
              <span style={{ fontSize: '0.8rem', fontWeight: "500" }}>Redeem</span>
              <span style={{ fontSize: '0.9rem', fontWeight: "700" }}>{RUPEE_SYMBOL}{tdsInfo.amount}</span>
            </div>
            <div style={{ flex: '0.3', height: "70%", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-evenly', borderRight: "1px solid #bababa" }}>
              <span style={{ fontSize: '0.8rem', fontWeight: "500" }}>TDS</span>
              <span className='colorRedOEM' style={{ fontSize: '0.8rem', fontWeight: "700" }}>{RUPEE_SYMBOL}{tdsInfo.tds}</span>
            </div>
            <div style={{ flex: '0.3', height: "70%", display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
              <div style={{ width: '80%', height: '100%', background: "#196A291F", borderRadius: "4px", flexDirection: "column", display: 'flex', alignItems: "center", justifyContent: "space-evenly" }}>
                <span style={{ fontSize: '0.8rem', fontWeight: "500" }}>{VernacularContextData.getTransalatedKey("youget")}</span>
                <span style={{ fontSize: '0.9rem', fontWeight: "700" }}>{RUPEE_SYMBOL}{Number(tdsInfo.youGet) + Number(tdsCashbackAmount)}</span>
              </div>
            </div>
          </div>
          <div style={{ width: "90%", height: "10%", display: 'flex', justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ color: "#707070", fontSize: '0.9rem' }}>{redeemDetails?.tdsFreeAmount > 0 && `${'30% TDS on withdrawing above' + ' ' + RUPEE_SYMBOL + redeemDetails?.tdsFreeAmount}`}</div>
            <div style={{ color: '#196A29', textDecoration: "underline", fontSize: "0.9rem", fontWeight: "700" }} onClick={() => {
              setShowIframe(true);
              WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_TDS_ViewPolicyPopUp", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_location: 'Redeem Recommendation' } })
            }}>Know More</div>
          </div>
        </div>
        <div style={{ width: "100%", height: "15%", background: '#F9F9F9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {activeRedeemMethod && <div onClick={(e) => {
            setOpenLinkWallet('redeemRecommendation')
              && e.preventDefault() && e.stopPropagation()
          }} style={{ width: "90%", height: "70%", background: 'linear-gradient(180deg, #42BE40 0%, #196A29 100%)', color: '#FFFFFF', borderRadius: "4px", textAlign: "center", display: 'flex', alignItems: 'center', fontSize: "1rem", fontWeight: "700", justifyContent: 'center' }}>Redeem</div>
          }
        </div>
      </div>
    </div>
    return redeemRecommendation
  }

  const onOtpInputChange = (elRefs, i) => {
    elRefs.current.value = onlyNumberInput(elRefs);
    maxCharRestriction(elRefs, 1);
    // const onOtpInputChange = (elRefs, i) => {
    //     elRefs.current.value = onlyNumberInput(elRefs);
    //     maxCharRestriction(elRefs, 1);

    const inputValue = { ...value };
    if (!inputValue[i]) {
      inputValue[i] = elRefs.current.value;
    }

    setValue(inputValue);
    setEmailVerifyOtp(inputValue)
    console.log(value)
  };
  //     const inputValue = { ...value };
  //     if (!inputValue[i]) {
  //         inputValue[i] = elRefs.current.value;
  //     }

  //     setValue(inputValue);
  //     setEmailVerifyOtp(inputValue)
  //     console.log(value)
  // };

  // const onBackspacePressHandler = (event, i) => {
  //     onOtpInputChange(elRefs[i], i);
  //     if (event.key === "Backspace") {
  //         if (i !== 0) {
  //             elRefs[i - 1].current.focus();
  //         }
  //         const { [i]: _, ...values } = value; // to remove the input value from particular index
  //         setValue(values);
  //         setEmailVerifyOtp(values)
  //     }
  // };

  const [otp, setOTP] = useState(['', '', '', '', '', '']);
  const otpInputRefs = [];

  const handleInputChange = (event, index) => {
    const { value, key } = event.target;

    const newOTP = [...otp];
    newOTP[index] = value.replace(/[^0-9]/g, "").slice(0, 1);

    if (index < 5 && value !== '') {
      otpInputRefs[index + 1].focus();
    }
    setOTP(newOTP);
    setEmailVerifyOtp(newOTP)

  };

  const handleBackspace = (event, index) => {
    if (event.keyCode === 8 && index > 0 && otp[index] === '') {
      otpInputRefs[index - 1].focus();
    }
  };

  const handleInputClick = (index) => {

    if (Object.values(otp).join('').length === 6) {
      otpInputRefs[5].focus()
      otpInputRefs[5].setSelectionRange(otpInputRefs[5].value.length, otpInputRefs[5].value.length)
      return
    }
    // Find the first unfilled input and focus on it
    for (let i = 0; i < otp.length; i++) {
      // if(otp[i]!==''){
      //     otpInputRefs[i].setSelectionRange(otpInputRefs[i].value.length, otpInputRefs[i].value.length)
      // }
      if (otp[i] === '') {
        otpInputRefs[i].focus();

        break;
      }
    }
  };


  const createOtpInputFields = () => {
    return <OtpInputWrapper>{otp.map((digit, index) => (
      <OtpInput
        isoemaps={isoemps}
        key={index}
        type="tel"
        placeholder='.'
        value={digit}
        onFocus={() => {
          isAndroid && setBottom('35%');
          if (otp[index] !== '') {
            otpInputRefs[index].setSelectionRange(otpInputRefs[index].value.length, otpInputRefs[index].value.length)
          }
        }}
        onBlur={() => setBottom('0%')}
        onChange={(e) => handleInputChange(e, index)}
        onKeyDown={(e) => handleBackspace(e, index)}
        onPaste={(e) => {
          e.preventDefault()
          return false;
        }} onCopy={(e) => {
          e.preventDefault()
          return false;
        }}
        onKeyUp={(e) => {
          if (index === 5 && e.key === 'Enter') {
            otpInputRefs[index].blur()
            if (Object.values(emailVerifyOtp).join("").length === 6) {
              verifyEmail()
            }
          }
        }}
        ref={(ref) => otpInputRefs.push(ref)}
        maxLength={1}
        onClick={() => {
          handleInputClick()
        }}
      />
    ))}</OtpInputWrapper>;
  };


  const createAllRedeemMethodsPopUp = () => {

    const RedeemMethodOption = (tile) => {

      const shouldEnable = () => {
        if (tile.type === 'bankAccount') {
          if (tile.bankStatus === 'approved') {
            return true
          }
          return false
        }
        else if (tile.type === 'upi') {
          if (tile.upiState === 'approved') {
            return true
          }
          return false
        }
        return true
      }

      const bankAccountEdited = (bankName) => {
        if (bankName === 'HDFC Bank') {
          return 'HDFC'
        }
        else if (bankName.toLowerCase() === 'Kotak Mahindra Bank Ltd'.toLowerCase()) {
          return 'Kotak'
        }
        else if (bankName.toLowerCase() === 'ICICI Bank'.toLowerCase()) {
          return 'ICICI'
        }
        else if (bankName.toLowerCase() === 'State Bank of India'.toLowerCase()) {
          return 'SBI'
        }
        else if (bankName.toLowerCase() === 'Bank of Baroda'.toLowerCase()) {
          return 'BOB'
        }
        else if (bankName.toLowerCase() === 'Bank of India'.toLowerCase()) {
          return 'BOI'
        }
        else if (bankName.toLowerCase() === 'Punjab National Bank'.toLowerCase()) {
          return 'PNB'
        }
        else if (bankName.toLowerCase() === 'United Bank of India'.toLowerCase()) {
          return 'UBI'
        }
        else if (bankName.toLowerCase() === 'Central Bank of India'.toLowerCase()) {
          return 'CBI'
        }
        else {
          return bankName.slice(0, 12) + '...'
        }

      }

      return <div id="redeemMethodSections" className='redeemMethodSections' style={{ width: "95%", ...(openRemoveTag === tile ? { minHeight: "40%" } : { minHeight: "20%" }), margin: '2% 0%', display: 'flex', flexDirection: "column", justifyContent: "center", alignItems: 'center' }}>
        <div id={tile.name} key={tile.type === 'amazonPay' ? tile.name : tile.id} style={{ width: '95%', ...(openRemoveTag === tile ? { height: "50%" } : { height: "100%" }), display: 'flex', alignItems: 'center' }}>
          <div style={{ width: '10%', height: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => { shouldEnable() && setSelectedRedeemMethod(tile) }}><img style={{ height: "40%" }} src={!shouldEnable() ? RadioDeactive : selectedRedeemMethod === tile ? assets?.assets?.RadioActive : assets?.assets?.RadioInactive} /></div>
          <div style={{ width: '10%', height: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => { shouldEnable() && setSelectedRedeemMethod(tile) }}><img style={{ height: "40%" }} src={tile.type === 'upi' ? upiIcon : tile.type === 'amazonPay' ? amazonPayIcon : tile.type === 'bankAccount' ? assets?.assets?.bankIcon : tile.type === 'paytmWallet' ? paytmIcon : ''} /></div>
          <div className='redeemMethodSectionsText' style={{ ...((tile?.bankStatus === 'processing' || tile?.upiState === 'processing') ? { width: "45%" } : { width: "70%" }), display: 'flex', flexDirection: "column", fontSize: "0.9rem", fontWeight: "700" }} onClick={() => { shouldEnable() && setSelectedRedeemMethod(tile) }}>
            <div>{tile.type === 'bankAccount' ? bankAccountEdited(tile.bankName) : tile.type === 'upi' ? tile.upi : `${tile.name + ' ' + 'xxxxxx' + tile.id.slice(6)}`}</div>
            {tile.type === 'bankAccount' && <div>{'x'.repeat(tile.accountNumber.length - 4) + tile.accountNumber.slice(tile.accountNumber.length - 4)}</div>}
          </div>
          {
            (tile?.bankStatus === 'processing' || tile?.upiState === 'processing') &&
            <div className="validationPendingDiv" style={{ height: '20px', paddingLeft: "10px", paddingRight: "10px", display: 'flex', fontSize: '0.55rem', alignItems: "center", justifyContent: "center", fontWeight: '700', borderRadius: '24px' }}><span style={{ width: '95%', height: '100%', display: "flex", alignItems: 'center', justifyContent: "center" }}>Validation Pending</span></div>}
          {openRemoveTag !== tile && <div
            onClick={() => {
              setOpenRemoveTag(tile)
            }}
            style={{ width: '10%', height: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img style={{ height: "50%" }} src={assets?.assets?.DeleteIcon} />
          </div>}
        </div>
        {openRemoveTag === tile && <div style={{ width: "95%", height: "50%", display: "flex", alignItems: 'center', justifyContent: "center" }}>
          <div className='DeleteDiv' style={{ width: "95%", height: '100%', display: 'flex', alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ color: '#707070', fontSize: "0.8rem", width: "70%", height: '100%', display: 'flex', alignItems: 'center' }}>Are you sure you want to delete?</div>
            <div style={{ width: "30%", fontSize: "0.8rem", height: "50%", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div className='noClickButtonText' onClick={() => setOpenRemoveTag(undefined)} style={{ width: "35%", height: '100%', display: 'flex', alignItems: "center", justifyContent: 'space-between' }}>
                <img src={assets?.assets?.CancelDeleteIcon} style={{ ...(isTablet ? { width: "23.5%" } : { width: "40%" }) }} alt='cancelDelete' />
                <span>No</span>
              </div>
              <div id={`${tile.name}_delete`} className='colorOemBorder' onClick={() => handleRemoveRedeemMethod(tile)} style={{ width: "35%", height: "100%", display: 'flex', alignItems: "center", justifyContent: 'space-between' }}>
                <img src={assets?.assets?.DeleteIcon} style={{ ...(isTablet ? { width: "23.5%" } : { width: "40%" }) }} alt='Delete' />
                <span>Yes</span>
              </div>
            </div>
          </div>
        </div>}
      </div>
    }

    let allRedeemMethods;
    allRedeemMethods = <div style={{ ...(isTablet ? { position: "absolute" } : { position: "fixed" }), width: "100%", height: "100%", display: 'flex', alignItems: 'end', justifyContent: 'center' }}>
      <div style={{ position: 'absolute', width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)', pointerEvents: 'none' }} onClick={(e) => { e.preventDefault(); e.stopPropagation() }} className='modalScreen'></div>
      <div style={{ position: 'absolute', width: '100%', height: "40%", color: 'black', display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#f9f9f9', borderRadius: '5px 5px 0px 0px', bottom: 0 }} className='redeem-pop-up-animation-default'>
        <div className='redeemAccountBottomSheet' style={{ width: '100%', height: '15%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '5px 5px 0px 0px' }}>
          <div id="choose_withdraw_Account" className='redeemMethodHeaderText' style={{ fontWeight: 700, fontSize: '1rem' }}>Choose Withdraw Account</div>
          <img src={assets?.assets?.Cross} alt='close' style={{ position: 'absolute', right: '5%' }} onClick={() => { setOpenAllRedeemOptions(false); setSelectedRedeemMethod(activeRedeemMethod); setOpenRemoveTag(undefined) }} />
        </div>
        <div className='redeemAccountBottomDiv1' style={{ width: '100%', height: "65%", display: 'flex', flexDirection: 'column', alignItems: 'center', overflowY: 'scroll' }}>
          {deleteLoading &&
            <div style={{ position: "absolute", width: "100%", height: "100%", background: 'rgba(0,0,0,0.5)' }}><Loading /></div>}
          {redeemDetails?.allRedeemOptions?.map((redeemOption) => {
            return RedeemMethodOption(redeemOption)
          })}

          <div id="setupAccount"className='redeemMethodSections' style={{ width: '95%', minHeight: '20%', margin: '2% 0%', display: 'flex', alignItems: 'center', justifyContent: "center" }} onClick={() => {
            setOpenAllRedeemOptions(false); setOpenAddRedeemPopUp(true)
            WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_View_RedeemMode_bottomsheet", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Change Redeem' } })
          }}>
            <div style={{ width: "95%", height: "100%", display: 'flex', alignItems: "center", justifyContent: "center" }}>

              <div style={{ width: '10%', height: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}><img style={{ height: "40%" }} src={assets.assets.AddAccountIcon} /></div>
              <div style={{ width: '88%', fontSize: "0.9rem", fontWeight: '700', marginLeft: "2%" }}> Setup another withdraw account</div>
            </div>
          </div>
        </div>
        <div className='redeemSelectionDiv' style={{ width: "100%", height: "20%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {activeRedeemMethod &&
            <div className={(activeRedeemMethod !== undefined ? isoemps ? "redeemSelectionTextYellow" : "redeemSelectionTextGreen" : "redeemSelectionTextGrey")} onClick={() => activeRedeemMethod !== undefined && handleRedeemOptionChange(selectedRedeemMethod)} style={{ width: "90%", height: "70%", borderRadius: "4px", textAlign: "center", display: 'flex', alignItems: 'center', fontSize: "1rem", fontWeight: "700", justifyContent: 'center' }}>Select</div>
          }
        </div>
      </div>
    </div>
    return allRedeemMethods
  }


  const createAddUpiPopUp = () => {

    const verifyUpi = () => {
      let status;
      setIsUpiLoading(true)
      if (!isUpiVerified) {
        status = false
      }
      else {
        status = true
      }
      axios({
        method: "POST",
        url: process.env.REACT_APP_NEW_BASE_URL + "redeem/add_upi/",
        headers: {
          Authorization: window.sessionStorage["token"]
        },
        data: {
          upi: upiIdEntered.toLowerCase(),
          confirmUpi: upiIdEntered.toLowerCase(),
          otp: '',
          token: window.sessionStorage['upitoken'],
          submit: status,
          channel: window.sessionStorage['channel']
        },
      }).then((res) => {
        console.log(res)
        if (res.data.error) {
          setUpiValidationError(res.data.error.message)
          setIsUpiLoading(false)
        }
        else {
          if (res.data !== '') {
            if (!isUpiVerified) {
              if (res.data.statusCode === 1214) {
                setUpiValidationError('UPI ID already exists in system.')
              }
              else {
                setIsUpiVerified(true)
                setUpiName(res.data.nameAtBank)
              }

            }
            else {
              if (res.data.upiState === 'approved') {
                setOpenAddUpiPopUp(false)
                setIsUpiVerified(false)
                setUpiIdEntered('')
                setToastMessage({ message: 'Withdraw Account Added', status: true })
                if (isKYCVerificationPage) {
                  WebToNativeMessage({ type: "addBankSuccess" })
                }
                setFetchRedeemDetails(fetchRedeemDetails + 1)
              }
              else {
                setUpiResponse(res.data)
                setShowAddUpiStatus(true)
              }
            }
          }
          else {
            setUpiValidationError('Something went wrong. Please try again.')
          }
          setIsUpiLoading(false)
        }
      }).catch((e) => {
        console.log('error in validation upi details')
        setIsUpiLoading(false)
      })
    }

    let addUpiPopUp;
    addUpiPopUp = <div style={{ position: 'absolute', width: "100%", height: "100%", display: 'flex', alignItems: 'end', justifyContent: 'center' }}>
      <div style={{ position: 'absolute', width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)' }} className='modalScreen'></div>
      <div style={{ position: 'absolute', width: '100%', height: "40%", fontSize: "0.9rem", fontWeight: "500", display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: 'center', bottom: bottom, transition: 'bottom 300ms ease' }} className='redeem-pop-up-animation-default'>
        <div className='redeemAccountBottomSheet' style={{ width: '100%', height: '15%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '5px 5px 0px 0px' }}>
          <div className='redeemMethodHeaderText' style={{ fontWeight: 700, fontSize: '1rem' }}>{VernacularContextData.getTransalatedKey("addupiid")}</div>
          {!showAddUpiStatus ?
            <>
              <img id="BackButton" src={assets?.assets?.navarrow} alt='close' style={{ position: 'absolute', left: '5%', height: "30px" }} onClick={() => {
                setOpenAddUpiPopUp(false); setOpenAddRedeemPopUp(true); setUpiValidationError(''); setUpiIdEntered(''); setIsUpiVerified(false); if (upiResponse !== undefined) {
                  setUpiResponse(undefined); setShowAddUpiStatus(false); setFetchRedeemDetails(fetchRedeemDetails + 1);
                }
              }} />
              <img id="CloseButton" src={assets?.assets?.Cross} alt='close' style={{ position: 'absolute', right: "5%" }} onClick={() => {
                setOpenAddUpiPopUp(false); setUpiValidationError(''); setUpiIdEntered(''); setIsUpiVerified(false); if (upiResponse !== undefined) { setUpiResponse(undefined); setShowAddUpiStatus(false); setFetchRedeemDetails(fetchRedeemDetails + 1) };

              }} />

            </>
            :
            <img id="CloseButton" src={assets?.assets?.Cross} alt='close' style={{ position: 'absolute', right: "5%" }} onClick={() => {
              setOpenAddUpiPopUp(false); setUpiValidationError(''); setUpiIdEntered(''); setIsUpiVerified(false); if (upiResponse !== undefined) { setUpiResponse(undefined); setShowAddUpiStatus(false); setFetchRedeemDetails(fetchRedeemDetails + 1) };
              // if (isKYCVerificationPage && upiResponse?.upiState === 'processing') {
              //   WebToNativeMessage({ type: "addBankSuccess" })
              // }
            }} />

          }
        </div>
        {isUpiLoading &&
          <div style={{ position: "absolute", width: "100%", height: "100%", background: 'rgba(0,0,0,0.5)' }}><Loading /></div>
        }
        {showAddUpiStatus ? <>
          <div className='redeemAccountBottomDiv1' style={{ width: "100%", height: "65%", display: "flex", alignItems: "center", justifyContent: "space-evenly", flexDirection: "column" }}>
            <div style={{ width: "100%", height: '40%' }}>
              <Lottie style={{ width: "100%", height: '100%' }} autoPlay={true} animationData={upiResponse.upiState === 'processing' ? pendingAnimation : redeemFailed} loop={true} />
            </div>
            {upiResponse.upiState === 'processing' ?
              <>
                <span className='standardText' style={{ fontSize: '0.9rem', fontWeight: '700' }}>Thank you</span>
                <span className='standardText' style={{ textAlign: "center" }}>Your request has been received</span>
                <span className='standardText' style={{ textAlign: "center" }}>We will notify you once verification is completed</span>
                <span className='standardText' style={{ textAlign: "center" }}>This may take upto 4 Hours</span>
              </>
              :
              <>
                <span className='standardText' style={{ fontSize: '0.9rem', fontWeight: '700' }}>Verification failed</span>
                <span className='standardText' style={{ textAlign: "center" }}>There was a name mismatch between your Bank Account name and KYC name</span>
                <span className='standardText' style={{ textAlign: "center" }}>Please check and try again</span>
              </>
            }
          </div>
          {upiResponse.upiState === 'processing' ?
            <div className='bottomButtonBackground' style={{ width: "100%", height: "20%", display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => { setOpenAddUpiPopUp(false); setUpiIdEntered(''); setIsUpiVerified(false); if (upiResponse !== undefined) { setUpiResponse(undefined); setShowAddUpiStatus(false); setFetchRedeemDetails(fetchRedeemDetails + 1) } }}>
              <div className='AddBankSheetCTA' style={{ width: "95%", height: "75%", borderRadius: "4px", fontSize: "1rem", fontWeight: "700", display: "flex", alignItems: 'center', justifyContent: "center" }} >Go Back</div>
            </div>
            :
            <div className='bottomButtonBackground' style={{ width: "100%", height: "20%", display: 'flex', alignItems: 'center', justifyContent: 'space-evenly' }}>
              <>
                <div className='needHelpCTA' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '45%', height: '80%', fontSize: '1rem', fontWeight: '700' }} ><img style={{ marginRight: '1%' }} src={assets?.assets?.needHelpIcon} onClick={() => {
                  WebToNativeMessage({ type: "openContactUs" });
                  WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_contactus_pageload", eventProperties: { click_location: 'Redeem Account Validation' } })
                }} alt='needHelp' /> Need help</div>
                <div className='AddBankSheetCTA' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '45%', height: '80%', borderRadius: "4px", fontSize: '1rem', fontWeight: '700' }} onClick={() => { setShowAddUpiStatus(false); setIsUpiVerified(false); setUpiIdEntered('') }}> Retry</div>

              </>

            </div>
          }

        </>
          :
          <>
            <div className='redeemAccountBottomDiv1' style={{ width: '100%', height: "65%", display: 'flex', alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
              <div className='PanText' style={{ fontSize: "0.9rem", fontWeight: "500" }}>{VernacularContextData.getTransalatedKey("enterupiidlinkedtoyourbankaccount")}</div>
              <div className='inputFieldData' style={{ width: "75%", height: "20%", display: 'flex', alignItems: "center" }}>
                <input id="enterupiid" style={{ width: "100%", height: "95%", background: "transparent" }} disabled={isUpiVerified} placeholder={VernacularContextData.getTransalatedKey("enterupiid")} ref={upiInputRef} onKeyUp={(e) => {
                  console.log('re'); if (e.key === 'Enter') {
                    upiInputRef.current.blur()
                  }
                }} value={upiIdEntered} onFocus={() => isAndroid && setBottom('40%')} onBlur={() => setBottom('0%')} onPaste={(e) => {
                  e.preventDefault()
                  return false;
                }} onCopy={(e) => {
                  e.preventDefault()
                  return false;
                }} onChange={(e) => {
                  e.target.value = e.target.value.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
                  e.target.value = e.target.value.replace(/\s/g, '')
                  setUpiIdEntered(e.target.value);
                  setIsUpiVerified(false);
                  console.log(e.target.value)
                }} />
              </div>

              <div className='colorRedOEM' style={{ width: "75%", marginTop: "2%" }}>{upiValidationError}</div>

              {(isUpiVerified && upiName !== undefined) ?

                <div style={{ width: "75%", marginTop: "3%" }}><span id="panName" className='PanText' style={{}}>{VernacularContextData.getTransalatedKey("BankA/CName")} :</span><span className='PanData' style={{ marginLeft: "2%" }}>{upiName}</span></div>
                :
                <div id="NotePoint" className='NoteText' style={{ width: '75%', marginTop: '3%' }}> {VernacularContextData.getTransalatedKey("note")}: {VernacularContextData.getTransalatedKey("youcanonlylinkupiidwithyourname")} </div>
              }
              <div style={{ width: "75%", marginTop: '2%' }}><span className='PanText' style={{}}>{VernacularContextData.getTransalatedKey("kycname")} :</span><span id="panName" className='PanData' style={{ marginLeft: "2%" }}>{redeemDetails.panName}</span></div>

            </div>

            <div className='bottomButtonBackground' style={{ width: "100%", height: "20%", display: 'flex', alignItems: "center", justifyContent: 'center' }} >
              {isUpiVerified ?
                <div style={{ width: "90%", height: "70%", display: 'flex', alignItems: "center", justifyContent: "space-between" }}>
                  <div className='EditUPIActionCTA' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '45%', height: '100%', borderRadius: "4px", fontSize: '1rem', fontWeight: '700' }} onClick={() => {
                    setIsUpiVerified(false);
                    WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemAccount_clickEditUPIID", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType } })
                  }}> {VernacularContextData.getTransalatedKey("editupiid")}</div>
                  <div onClick={() => {
                    verifyUpi();
                    WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemAccount_validationRequested", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], mode_selected: 'upi' } })
                  }} className='AddUPIActionCTA' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '45%', height: '100%', borderRadius: "4px", fontSize: '1rem', fontWeight: '700' }}> {VernacularContextData.getTransalatedKey("addupiid")}</div>

                </div>
                :
                <div id={isUpiVerified ? 'Add' : 'verifybutton'} className={(!(upiIdEntered === '' || upiValidationError !== undefined) ? "botttomActionButtonGreen" : "botttomActionButtonGrey")} onClick={() => { !(upiIdEntered === '' || upiValidationError !== undefined) && verifyUpi() }} style={{ width: "90%", height: "70%", borderRadius: "4px", textAlign: "center", display: 'flex', alignItems: 'center', fontSize: "1rem", fontWeight: "700", justifyContent: 'center' }}>{isUpiVerified ? VernacularContextData.getTransalatedKey("add") : VernacularContextData.getTransalatedKey("verify")}</div>
              }
            </div>
          </>
        }
      </div>
    </div>
    return addUpiPopUp
  }


  const [otpTimer, setOtpTimer] = useState(60)
  const [enableResend, setEnableResend] = useState(false)
  const [intervalstate, setIntervalState] = useState(undefined)

  const updateTimer = () => {
    console.log("update timer method called")
    let counter = 60;
    const interval = setInterval(() => {
      counter--;
      setOtpTimer(counter)
      if (counter === 0) {
        clearInterval(interval);
        setOtpTimer(0)
        setEnableResend(true)
      }

    }, 1000);
    setIntervalState(interval)
  }


  useEffect(() => {
    if (sentEmailVerifyOtp === true) {
      WebToNativeMessage({ type: "reactOTPRequest" })
      updateTimer()
    }
  }, [sentEmailVerifyOtp])

  const verifyEmail = (resend) => {
    setEmailLoading(true)
    axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "a23kyc/verify_email/",
      headers: {
        Authorization: window.sessionStorage['token']
      },
      data: {
        email: emailEntered,
        otp: resend ? '' : Object.values(emailVerifyOtp).join(""),
        verify: false
      },
    }).then((response => {
      if (response.data.error) {
        setEmailValidationError(response.data.error.message)
        setEmailLoading(false)
      }
      else {
        if (sentEmailVerifyOtp === false || resend === true) {
          setSentEmailVerifyOtp(true)
          setEmailValidationError(undefined)
        }
        else {
          if (response.data.statusCode === 3112) {
            setEmailValidationError('Invalid OTP')
          }
          else {
            setSentEmailVerifyOtp(false)
            setOpenAddEmailPopUp(false)
            setEmailEntered('')
            setToastMessage({ message: response.data.message, status: true })
            WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemVerification_EmailVerified", eventProperties: { redeemable_amount: profileData.win, username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, Wallet_balance: window.sessionStorage["totalBalance"] } })
            setFetchRedeemDetails(fetchRedeemDetails + 1)
          }
        }
        setEmailLoading(false)
      }
      console.log(response, 'verifyemail')
    }))
      .catch((e) => {
        console.log('error in getting profile details', e)
        setEmailLoading(false)
        setToastMessage({ message: 'Something went wrong. Please try again later.', status: false })
      })
  }


  // const createRedeemOtpScreen


  const createAddEmailPopUp = () => {



    const maskEmail = (email) => {
      if (sentEmailVerifyOtp) {
        let split = email.split('@')
        return email.substr(0, 3) + 'x'.repeat(4) + "@" + split[1]
      }
      return ''
    }

    let addEmailPopUp = <div style={{ position: 'absolute', width: "100%", height: "100%", display: 'flex', alignItems: 'end', justifyContent: 'center' }}>
      <div style={{ position: 'absolute', width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)' }} className='modalScreen'></div>
      <div style={{ position: 'absolute', width: '100%', height: "40%", color: 'black', display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: 'center', bottom: bottom, transition: 'bottom 300ms ease' }} className='redeem-pop-up-animation-default'>
        <div className='redeemAccountBottomSheet' style={{ width: '100%', height: '15%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '5px 5px 0px 0px' }}>
          <div className='redeemMethodHeaderText' style={{ fontWeight: 700, fontSize: '1rem' }}>Verify Email ID</div>
          <img src={assets?.assets?.Cross} alt='close' style={{ position: 'absolute', right: '5%' }} onClick={() => { console.log('cross clicked'); setOpenAddEmailPopUp(false); setEmailEntered(''); setEmailValidationError('') }} />
        </div>

        <div className='redeemAccountBottomDiv1' style={{ width: '100%', height: "65%", display: 'flex', alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
          {emailLoading &&
            <div style={{ position: "absolute", width: "100%", height: "100%", background: 'rgba(0,0,0,0.5)' }}><Loading /></div>}
          <div className='emailText' style={{ fontSize: "0.9rem", fontWeight: "500" }}>Enter your Email ID</div>
          <div className='emailInput' style={{ width: "75%", height: "20%", display: 'flex', alignItems: "center" }}>
            <input style={{ width: "100%", height: "95%", background: "transparent" }} ref={emailInputRef}
              onPaste={(e) => {
                e.preventDefault()
                return false;
              }} onCopy={(e) => {
                e.preventDefault()
                return false;
              }}
              onKeyUp={(e) => {
                console.log('re'); if (e.key === 'Enter') {
                  emailInputRef.current.blur()
                }
              }} onFocus={() => isAndroid && setBottom('40%')} onBlur={() => setBottom('0%')} value={emailEntered} onChange={(e) => {
                e.target.value = e.target.value.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
                e.target.value = e.target.value.replace(/\s/g, '');
                setEmailEntered(e.target.value);
                setEmailValidationError('')
              }} />
          </div>
          <div className='colorRedOEM' style={{ width: "75%", marginTop: '2%' }}>{emailValidationError}</div>
          <div className='emailText' style={{ width: "75%", height: "10%", fontSize: "0.8rem", marginTop: "5%" }}>Note: Email ID can be changed later in Profile Settings</div>
        </div>

        <div className='FooterRedeemDiv' style={{ width: "100%", height: "20%", display: 'flex', alignItems: "center", justifyContent: 'center' }} >
          <div className='SendOTPCTA' onClick={() => {
            if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailEntered)) {
              verifyEmail()
            }
            else {
              setEmailValidationError('Invalid Email ID')
            }
            WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_click_RedeemVerification_VerifyEmail", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType } })
          }

          } style={{ width: "90%", height: "70%", borderRadius: "4px", textAlign: "center", display: 'flex', alignItems: 'center', fontSize: "1rem", fontWeight: "700", justifyContent: 'center' }}>Send OTP</div>
        </div>
      </div>
    </div>;

    let addEmailOtp = <div style={{ position: 'absolute', width: "100%", height: "100%", display: 'flex', alignItems: 'end', justifyContent: 'center' }}>
      <div style={{ position: 'absolute', width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)' }} className='modalScreen'></div>
      <div style={{ position: 'absolute', width: '100%', height: "40%", color: 'black', display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: 'center', bottom: bottom, transition: 'bottom 300ms ease', background: "#f9f9f9", borderRadius: "5px 5px 0px 0px" }} className='redeem-pop-up-animation-default'>
        <div className='redeemAccountBottomSheet' style={{ width: '100%', height: '15%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '5px 5px 0px 0px' }}>
          <div className='redeemMethodHeaderText' style={{ fontWeight: 700, fontSize: '1rem' }}>{VernacularContextData.getTransalatedKey("enterotp")}</div>
          <img id="BackButton" src={assets?.assets?.navarrow} alt='close' style={{ position: 'absolute', left: '5%', width: '8%', height: "8%" }} onClick={() => {
            setSentEmailVerifyOtp(false); setEmailVerifyOtp(['', '', '', '', '', '']); setOTP(['', '', '', '', '', '']); setEmailValidationError('');
            clearInterval(intervalstate);
            setOtpTimer(60)
          }} />
          <img id="CloseButton" src={assets?.assets?.Cross} alt='' style={{ position: 'absolute', right: '5%' }} onClick={() => {
            clearInterval(intervalstate);
            setOtpTimer(60); setOpenAddEmailPopUp(false); setSentEmailVerifyOtp(false); setEmailVerifyOtp(['', '', '', '', '', '']); setEmailValidationError(''); setEmailEntered('')
          }} />
        </div>

        <div className='redeemAccountBottomDiv1' style={{ width: '100%', height: "65%", display: 'flex', alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
          {emailLoading &&
            <div style={{ position: "absolute", width: "100%", height: "100%", background: 'rgba(0,0,0,0.5)' }}><Loading /></div>}
          {/**<div style={{ color: "#4F5153", fontSize: "0.9rem", fontWeight: "500", marginBottom: "2%", textAlign: 'center' }}>OTP sent. Please enter</div> */}
          <div className='emailText' style={{ fontSize: "0.9rem", fontWeight: "500", marginBottom: "4%", textAlign: 'center' }}>{VernacularContextData.getTransalatedKey("otphassent")} <span className='emailDataText' >{maskEmail(emailEntered)}</span></div>
          <div className='otpInputBorder' style={{ width: "75%", height: "20%", display: 'flex', alignItems: "center", justifyContent: "center", marginBottom: "2%" }}>
            {/**<input style={{ width: "100%", height: "95%", background: "transparent",letterSpacing:'8' }} type='number' maxLength={6} ref={emailOtpRef} onFocus={()=>setBottom('25%')} onBlur={()=>setBottom('0%')} onKeyUp={(e)=>{console.log('re');if(e.key === 'Enter'){
                            emailOtpRef.current.blur()
                        }}} value={emailVerifyOtp} onChange={(e) => {setEmailVerifyOtp(e.target.value);setEmailValidationError('')}} /> */}
            {createOtpInputFields()}
          </div>
          <div className='colorRedOEM' style={{ width: "75%", marginTop: "2%" }}>{emailValidationError}</div>
          <div style={{ width: '75%', display: 'flex', fontSize: '0.9rem', alignItems: 'center', justifyContent: 'center' }}>

            {(otpTimer !== 0 && !enableResend) ?
              <div className='resendOTPText' style={{ width: "75%", textAlign: 'center' }}>{VernacularContextData.getTransalatedKey("resendotp")} {otpTimer}s </div>
              :
              <div className='resendOTPData' onClick={() => { enableResend && verifyEmail(true); updateTimer(); setEnableResend(false); setEmailVerifyOtp(['', '', '', '', '', '']); setOTP(['', '', '', '', '', '']); WebToNativeMessage({ type: 'reactOTPRequest' }) }} style={{ color: "#58B6C6", textAlign: 'center', textDecoration: "underline" }}>{VernacularContextData.getTransalatedKey("resendotp")}</div>
            }
            {/**                    <div style={{ width: "75%",display:"flex",alignItems:'center',justifyContent:'center',...(enableResend ? {color:"rgb(25, 106, 41)"} : {color:"#707070"})}} onClick={()=>{enableResend && verifyEmail(true);updateTimer();setEnableResend(false);setEmailVerifyOtp(['', '', '', '', '', ''])}}>Resend OTP</div>
 */}
          </div>


        </div>

        <div className='redeemAccountBottomDiv1' style={{ width: "100%", height: "20%", display: 'flex', alignItems: "center", justifyContent: 'center' }} >
          <div className={(Object.values(emailVerifyOtp).join("").length === 6 ? isoemps ? "RedeemActionButtonYellow" : "RedeemActionButtonGreen" : "RedeemActionButtonGrey")} onClick={() => Object.values(emailVerifyOtp).join("").length === 6 && verifyEmail()} style={{ width: "90%", height: "70%", borderRadius: "4px", textAlign: "center", display: 'flex', alignItems: 'center', fontSize: "1rem", fontWeight: "700", justifyContent: 'center' }}>Verify</div>
        </div>
      </div>
    </div>;

    return sentEmailVerifyOtp ? addEmailOtp : addEmailPopUp
  }

  const createVerifyMobileAlert = () => {
    let alert;
    alert = <div style={{ position: 'absolute' }}>
      <div className="relative absolute--fill flex justify-center items-center center left-1 right-1 white ph2 w6 ">
        <img className="absolute black nt4  left-0 top-0 right-0 h3 w3 center white flex justify-center items-center  z-9999 " src={a23logo} alt="not available" ></img>
        <div className="center br2 ba pa1 b--black-10 flex flex-column" style={{ backgroundColor: "#fffdea", color: "#032146", bordercolor: "#EABF6979", paddingTop: "1rem" }}
        >
          <div className="db pt2 f6 mt3 center">

            <img
              className="absolute top-0 right-0 pa2 mr2"
              src={close}
              alt="no "
              onClick={() => setShowVerifyMobileAlert(false)}
              style={{ width: "1.5rem" }}
            ></img>

            <div className="w-100 db f6 tc pa1">
              <h4 className=" mt0 mb2 fw6 f5 text-bold " style={{ color: "#032146" }} >{VERIFY_KYC_ALERT.VERIFY_KYC_REDEEM} </h4>
              <p className=" f6 mb3 text-medium "> &nbsp; &nbsp; {REDEEMPAGE_STRINGS.KEY_REDEEM_MOBILE_VERIFY_TEXT} </p>
            </div>

            <div className="center tc text-medium"><button className='center ph2 btn btn-green btn-green-login pv2' onClick={() =>
              //  WebToNativeMessage({ type: "openMyAccount", token: window.sessionStorage["token"] })}//   type:"verifyPAN"//New changes
              WebToNativeMessage({ type: "openMyAccount", token: window.sessionStorage["token"] })}
              style={{ height: "auto" }} type='submit'>{REDEEMPAGE_STRINGS.KEY_REDEEM_MOBILE_VERIFY_BTN_TEXT}

            </button></div>


            <div className="center tc">&nbsp;</div>


          </div>
        </div>
      </div>
    </div>
    return alert;
  }


  const handleLinkWallet = (type, from, list) => {
    if (window.sessionStorage["mobile"] !== "undefined") {
      if ((type === `${LINKWALLET_STRINGS.KEY_PAYTMWALLET_TV}` || type === `${LINKWALLET_STRINGS.KEY_AMAZONPAY_TV}`)) {
        if (profileData.mobileVerified) {
          console.log('sid here1')
          setOpenLinkWallet(type)
          setOpenAddRedeemPopUp(false)
          // setOpenLinkWallet(`${type}`)
          //   this.props.toggleModalAction(true, <LinkWallet walletType={type} openSelectedScreen={() => this.openSelectedScreen(type)} />, true)
        } else {
          console.log('sid here2')
          setOpenAddRedeemPopUp(false)
          setShowVerifyMobileAlert(true)
          //   this.props.toggleModalAction(true, <VerifyMobile />, true);
        }

        // this.props.toggleModalAction(true, <LinkWallet />, true)
      } else if (type === `${LINKWALLET_STRINGS.KEY_BANKACCOUNT_TV}` || type === `${LINKWALLET_STRINGS.KEY_UPI_TV}`) {

        // if (profileData.panApproved) {
        if (redeemDetails?.kycStatus?.toLocaleLowerCase() === "approved" || redeemDetails?.isIdVerified?.toLocaleLowerCase() === "approved") {
          console.log('sid here3')
          setOpenLinkWallet(type)
          setOpenAddRedeemPopUp(false)
          //   this.props.toggleModalAction(true, <LinkWallet walletType={type} openSelectedScreen={() => this.openSelectedScreen(type)} />, true)
        } else {
          console.log('sid here 4')
          //   this.props.toggleModalAction(true, <VerifyKyc panApproved={this.state.panApproved} />, true)
        }
      }
    } else {
      console.log('sid here 5')
      setShowVerifyMobileAlert(true)
      //   this.props.toggleAlertAction(true, `${REDEEMPAGE_STRINGS.KEY_MOBILE_UNDEFINED_MSG_TV}`)
    }
  };



  const createGSTPopup = () => {
    let gstPopupBG = <div style={{ position: "absolute", width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.8)", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div className='redeemLimitContainer' style={{ position: "absolute", ...(isTablet ? { width: "55%" } : { width: "90%" }), height: "40%", borderRadius: "6px", display: "flex" }}>
        <img className="absolute top-0 right-0 pa2 mr2" src={assets?.assets?.Cross2} alt="no " onClick={() => WebToNativeMessage({ type: 'closeClient' })} style={{ width: "1.2rem" }} ></img>
        <div style={{ width: "100%", height: "95%", marginTop: "5%", backgroundColor: "", display: "flex", flexDirection: "column", alignItems: "center" }} >
          <div id="cautionImage" style={{ display: "flex", justifyContent: "center", backgroundColor: "", width: "100%", height: "18%" }}>
            <img src={assets?.assets?.cancelRequesticon} alt="no " style={{ width: "" }}  >
            </img>
          </div>
          <div id="title" style={{ width: "100%", height: "10%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "5%" }}>
            <span className='limitText' style={{ fontWeight: "700", fontSize: "14px" }}>Withdraw Request Limit Reached</span>
          </div>

          {((Number(requestsPerDayLimits) - Number(userRequestsPerDayLimits)) <= 0) ? <div id="messageDiv" style={{ display: "flex", justifyContent: "center", backgroundColor: "", width: "90%", height: "40%", margin: "5px", textAlign: "center", alignItems: "center" }}>
            <p className='standardText' style={{ fontSize: "14px" }}> As per Withdraw policy, you have reached max withdraw requests allowed per day. Kindly place a request tomorrow. </p>
          </div>
            :
            <div id="messageDiv" style={{ display: "flex", justifyContent: "center", backgroundColor: "", width: "90%", height: "40%", margin: "5px", textAlign: "center", alignItems: "center" }}>
              <p className='standardText' style={{ fontSize: "14px" }}>
                {/* You can not place more than {maxAllowedRedeem} redeems at a time. Please wait till your pending redeems are completed/cancelled. */}
                As per withdraw policy, no more than {maxAllowedRedeem} withdraws are allowed to be in pending state. Kindly wait until one of your withdraws are processed or cancel any of your pending withdraws.
              </p>
            </div>}


          <div id="knowMoreDiv" style={{ display: "flex", whiteSpace: "nowrap", justifyContent: "center", backgroundColor: "", width: "25%", height: "10%", margin: "5px", textAlign: "center", alignItems: "center" }} onClick={() => {
            window.sessionStorage.setItem('policyBack', 'redeem');
            WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPolicy_PageView", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Redeem Limit Exceeded Pop Up' } })
            WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_RedeemPolicy_PageView", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Redeem Limit Exceeded Pop Up' } })
            // ; history.push("/redeeminfo/")
            WebToNativeMessage({ type: 'openRedeemPolicy' });
          }} >
            <p className='knowMoreLinkDiv' style={{ fontSize: "16px", fontWeight: "500", whiteSpace: "nowrap" }}>Know more</p>
          </div>
          <div id="buttonDiv" style={{ display: "flex", justifyContent: "center", backgroundColor: "", width: "82%", minHeight: "45px", margin: "10px", textAlign: "center", alignItems: "center", marginBottom: "10px", paddingBottom: "5px" }}>
            <button className='trackPendingRedeemsCTA' style={{ width: "100%", minHeight: "38px", borderRadius: '4px', fontWeight: "700", marginBottom: "8px" }} onClick={() => {
              WebToNativeMessage(
                {
                  type: "redeemCTEvent", eventName: "PF_c_RedeemHistory_pageload", eventProperties: {
                    Click_Location: "Track Pending Redeem(s)",
                    acelevel: window.sessionStorage["aceLevel"],
                    channel: window.sessionStorage["channel"],
                    subscriptionType: window.sessionStorage["subscriptionType"],
                    username: window.sessionStorage["screenName"],
                    count_pendingRedeem: profileData.totalPendingRedeems,
                    Source: 'Redeem Page'
                  }

                })
              WebToNativeMessage(
                {
                  type: "mixpanelEvent", eventName: "PF_c_RedeemHistory_pageload", eventProperties: {
                    Click_Location: "Track Pending Redeem(s)",
                    acelevel: window.sessionStorage["aceLevel"],
                    channel: window.sessionStorage["channel"],
                    subscriptionType: window.sessionStorage["subscriptionType"],
                    username: window.sessionStorage["screenName"],
                    count_pendingRedeem: profileData.totalPendingRedeems,
                    Source: 'Redeem Page'
                  }

                })
              history.push("/redeemhistory/")
            }}>
              Track Pending Redeem(s)
            </button>
          </div>
        </div>
      </div>
    </div>
    return gstPopupBG
  }

  const createLimitExhaustPopup = () => {
    let gstPopupBG = <div style={{ position: "absolute", width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.8)", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div style={{ position: "absolute", width: "90%", height: "35%", backgroundColor: "#ffffff", borderRadius: "6px", display: "flex" }}>
        <img className="absolute top-0 right-0 pa2 mr2" src={Cross2} alt="no " onClick={() => setToShowGSTPopup(false)} style={{ width: "1.2rem" }} ></img>
        <div style={{ width: "100%", height: "95%", marginTop: "5%", backgroundColor: "", display: "flex", flexDirection: "column", alignItems: "center" }} >
          <div id="cautionImage" style={{ display: "flex", justifyContent: "center", backgroundColor: "", width: "100%", height: "18%" }}>
            <img src={assets?.assets?.cancelRequesticon} alt="no " style={{ width: "" }}  >
            </img>
          </div>
          <div id="title" style={{ width: "100%", height: "10%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "5%" }}>
            <span className='standardText' style={{ fontWeight: "700", fontSize: "14px" }}>Withdraw request limit exhausted</span>
          </div>
          <div id="messageDiv" style={{ display: "flex", justifyContent: "center", backgroundColor: "", width: "90%", height: "40%", margin: "5px", textAlign: "center", alignItems: "center" }}>
            <p className='standardText' style={{ fontSize: "14px" }}>You can not place more than {maxAllowedRedeem} redeems at a time. Please wait till your pending redeems are completed/cancelled. </p>
          </div>
          <div id="knowMoreDiv" style={{ display: "flex", justifyContent: "center", backgroundColor: "", width: "25%", height: "10%", margin: "5px", textAlign: "center", alignItems: "center", borderBottom: "1px solid #91cfde" }} onClick={() => {
            window.sessionStorage.setItem('policyBack', 'redeem');
            WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPolicy_PageView", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Withdraw Limit Exceeded Pop Up' } })
            WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_RedeemPolicy_PageView", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Withdraw Limit Exceeded Pop Up' } })
            // ; history.push("/redeeminfo/")
            WebToNativeMessage({ type: 'openRedeemPolicy' });
          }} >
            <p className='standardText' style={{ fontSize: "16px", fontWeight: "500" }}>Know more</p>
          </div>
          <div id="buttonDiv" style={{ display: "flex", justifyContent: "center", backgroundColor: "", width: "85%", height: "15%", margin: "10px", textAlign: "center", alignItems: "center" }}>
            <button className='trackPendingRedeemsCTA' style={{ width: "100%", height: "100%", borderRadius: '4px', fontWeight: "700", marginBottom: "8px" }} onClick={() => {
              WebToNativeMessage(
                {
                  type: "redeemCTEvent", eventName: "PF_c_RedeemHistory_pageload", eventProperties: {
                    Click_Location: "Track Pending Redeem(s)",
                    acelevel: window.sessionStorage["aceLevel"],
                    channel: window.sessionStorage["channel"],
                    subscriptionType: window.sessionStorage["subscriptionType"],
                    username: window.sessionStorage["screenName"],
                    count_pendingRedeem: profileData.totalPendingRedeems,
                    Source: 'Redeem Page'
                  }

                })
              WebToNativeMessage(
                {
                  type: "mixpanelEvent", eventName: "PF_c_RedeemHistory_pageload", eventProperties: {
                    Click_Location: "Track Pending Redeem(s)",
                    acelevel: window.sessionStorage["aceLevel"],
                    channel: window.sessionStorage["channel"],
                    subscriptionType: window.sessionStorage["subscriptionType"],
                    username: window.sessionStorage["screenName"],
                    count_pendingRedeem: profileData.totalPendingRedeems,
                    Source: 'Redeem Page'
                  }

                })
              history.push("/redeemhistory/")
            }}>
              Track Pending Redeem(s)
            </button>
          </div>
        </div>
      </div>
    </div>
    return gstPopupBG
  }

  const createTDSOverlay = () => {
    let overlay = <div className="TDSPopup" style={{ width: "100%", height: "100%", position: "fixed", backgroundColor: "rgba(0,0,0,0.5)", bottom: "0px", zIndex: "4", display: showTaxPopUp ? "flex" : "none", justifyContent: "center" }} onClick={
      () => {
        // alert()
        // this.setState({
        //     showTaxPopup: false
        // })
      }
    }>
      <div style={{ width: "100%", height: "100%", position: "absolute", backgroundColor: "", top: "0px", zIndex: "4", borderTopLeftRadius: "9px", borderTopRightRadius: "9px", maxWidth: "600px" }} onClick={
        () => {
          // alert()
          setShowTaxPopUp(false)
        }
      }>

      </div>
      <div className="animateDiv" style={{ width: "100%", height: "50%", position: "", display: "flex", flexDirection: "column", bottom: "-50%", zIndex: "5", borderTopLeftRadius: "15px", borderTopRightRadius: "15px", maxWidth: "600px" }} onClick={
        (e) => {
          console.log("Pointer events", e);
          // alert();
          e.stopPropagation();
        }
      }>

        <img
          src={assets?.assets?.Cross}
          style={{ width: "14px", height: "14px", position: "absolute", top: "16px", right: "10px", zIndex: "55" }}
          onClick={
            () => {
              // alert()
              setShowTaxPopUp(false)
            }
          }
        // onClick={() => this.handleBackBtnClick({ type: "closeClient" })}
        />

        {/* <div id="header" className='tdsDivHeader' style={{ width: "100%", height: "10%", display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "8px", borderTopRightRadius: "8px", pointerEvents: "none" }}>
          <span style={{ fontSize: "18px", fontWeight: "700" }}>{enablebonusReleasedLastXDays ? 'Taxable Withdrawals' : 'Taxable Net Winnings'}</span>
        </div> */}


        <div style={{ width: "95%", marginLeft: "2.5%", marginRight: "2.5%", height: "10%", display: "flex", backgroundColor: "", position: "", bottom: "", justifyContent: "center", alignItems: "center" }}>


          <div style={{ display: "flex", textAlign: "start", justifyContent: "flex-start", alignItems: "", width: "65%" }}>
            <span className='standardTextMedium' style={{ fontSize: "11px" }}>Calculated from  <span className='standardTextMedium' style={{ fontSize: "11px", fontWeight: "800", paddingLeft: "4px" }}>{profileData?.currentFinYear}</span></span>
            {/* <span className='standardTextMedium' style={{ fontSize: "14px", fontWeight: "800", paddingLeft: "4px" }}>{profileData?.currentFinYear}</span> */}
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", textAlign: "start", marginLeft: "10px", width: "35%" }}>

            <span className='KnowMoreDiv' style={{ width: 'fit-content', fontSize: "11px", textDecoration: "underline" }} onClick={() => {
              setShowTaxPopUp(false)
              setShowIframe(true);
              // WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_TDS_ViewPolicyPopUp", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_location: 'Redeem Placement Page' } })
              WebToNativeMessage({ type: "redeemCTEvent", eventName: "pf_c_know_more_about_tds_netTaxableWinnings", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], winnings: profileData.taxableRunningNetWin, walletbalance: profileData.total } })

            }}>Know More About TDS </span>
          </div>
        </div>

        <div style={{ backgroundColor: "", width: "100%", height: "80%", display: "flex", justifyContent: "center", alignItems: "center", position: "", top: "", flexDirection: "column" }}>
          <div className='tdsSectionsDiv' style={{ width: "94%", height: "70%", borderRadius: "8px", position: "", left: "3%", right: "3%", top: "", display: "flex", flexDirection: "column" }}>
            <div className='tdssectionDivHighlight' style={{ width: "100%", height: "34%", borderTopLeftRadius: "8px", borderTopRightRadius: "8px", display: "flex", flexDirection: "column" }}>
              <div style={{ width: "100%", height: "65%", backgroundColor: "", display: "flex", alignItems: "center", fontWeight: "bold" }}>
                {/* <div style={{ width: "60%", height: "100%", display: "flex", alignItems: "center" }}>
                  <span className='standardText' style={{ fontSize: "14px", paddingLeft: "16px" }}>{enablebonusReleasedLastXDays ? 'Taxable Withdraw Amount' : 'Taxable Net Winnings'}
                  </span>
                </div> */}

                <div style={{ width: "40%", height: "100%", display: "flex", alignItems: "center", paddingRight: "16px", justifyContent: "flex-end" }}>
                  <span className='standardTextDark' style={{ fontSize: "18px", paddingLeft: "16px", fontWeight: "bold" }}>  &#8377;
                    {Number(profileData?.taxableRunningNetWin).toFixed(2)}</span>

                </div>

              </div>
              <div style={{ width: "100%", height: "35%", backgroundColor: "", display: "flex" }}>
                <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "" }}>
                  <span className='standardTextLight' style={{ fontSize: "10px", paddingLeft: "16px" }}>Total Withdrawals <span className='colorRedOEM' style={{}}>*</span> - {enablebonusReleasedLastXDays ? 'TDS Paid Redeemed Amount' : 'TDS Paid Net Winnings'}</span>
                </div>
              </div>
            </div>


            {/* <span style={{ fontSize: "14px", color: "#032146", paddingLeft: "16px" }}>Cumulative of all profits and losses</span> */}

            {/* Commented for new tds changes */}

            {/* <div style={{ width: "100%", height: "30%" }}>
                      <div style={{ width: "100%", height: "65%", backgroundColor: "", display: "flex", alignItems: "center", fontWeight: "bold" }}>
                          <div style={{ width: "60%", height: "100%", display: "flex", alignItems: "center" }}>
                              <span style={{ fontSize: "14px", color: "#032146", paddingLeft: "16px" }}>Net Winnings (YTD)</span>
                          </div>

                          <div style={{ width: "40%", height: "100%", display: "flex", alignItems: "center", paddingRight: "16px", justifyContent: "flex-end" }}>
                              <span style={{ fontSize: "18px", color: "#032146", paddingLeft: "16px", fontWeight: "bold" }}>  &#8377;
                                  {Number(this.state.netWinnings).toFixed(2)}   </span>

                          </div>

                      </div>
                      <div style={{ width: "100%", height: "35%", backgroundColor: "", display: "flex" }}>
                          <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "" }}>
                           
                              <span style={{ fontSize: "14px", color: "#032146", paddingLeft: "16px" }}>Total Withdrawals - Total Deposits</span>
                          </div>
                      </div>
                  </div> */}

            {/* <div style={{ width: "94%", height: "1px", backgroundColor: "#bababa", marginLeft: "3%" }}>

                  </div> */}




            <div className='tdsSectionBorder' style={{ width: "100%", height: "33%", paddingBottom: '1%' }}>
              <div style={{ width: "100%", height: "65%", backgroundColor: "", display: "flex", alignItems: "center", fontWeight: "bold" }}>
                <div style={{ width: "60%", height: "100%", display: "flex", alignItems: "center" }}>
                  <span className='standardText' style={{ fontSize: "14px", paddingLeft: "16px" }}>{enablebonusReleasedLastXDays ? 'TDS Paid Redeemed Amount' : 'TDS Paid Net Winnings'}</span>
                </div>

                <div style={{ width: "40%", height: "100%", display: "flex", alignItems: "center", paddingRight: "16px", justifyContent: "flex-end" }}>
                  <span className='standardTextDark' style={{ fontSize: "18px", paddingLeft: "16px", fontWeight: "bold" }}>  &#8377;
                    {Number(profileData?.tdsPaidNetWinning).toFixed(2)}</span>
                  {/* taxedNetWinning */}

                </div>

              </div>
              <div style={{ width: "100%", height: "35%", backgroundColor: "", display: "flex" }}>
                <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "" }}>
                  <span className='standardTextLight' style={{ fontSize: "10px", paddingLeft: "16px", marginTop: "1%", marginBottom: "5%" }}>{enablebonusReleasedLastXDays ? 'Redeemed Amount' : 'Winnings'} on which TDS was paid</span>
                </div>
              </div>
            </div>
            <div style={{ width: "100%", height: "33%", borderBottomLeftRadius: "8px", borderBottomRightRadius: "8px", marginTop: "0%", marginBottom: '1%' }}>
              <div style={{ width: "100%", height: "65%", backgroundColor: "", display: "flex", alignItems: "center", fontWeight: "bold" }}>
                <div style={{ width: "60%", height: "100%", display: "flex", alignItems: "center" }}>
                  <span className='standardText' style={{ fontSize: "14px", paddingLeft: "16px" }}>{`Opening Balance (${profileData?.fyYearString})`}</span>
                </div>

                <div style={{ width: "40%", height: "100%", display: "flex", alignItems: "center", paddingRight: "16px", justifyContent: "flex-end" }}>
                  <span className='standardTextDark' style={{ fontSize: "18px", paddingLeft: "16px", fontWeight: "bold" }}>  &#8377;
                    {Number(profileData?.openingBalanceFinYear).toFixed(2)}</span>
                  {/* taxedNetWinning */}

                </div>

              </div>
              <div style={{ width: "100%", height: "35%", backgroundColor: "", display: "flex" }}>
                <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "" }}>
                  <span className='standardTextLight' style={{ fontSize: "10px", paddingLeft: "16px", marginTop: "1%", marginBottom: "5%" }}>Opening balance for the current year</span>
                </div>
              </div>
            </div>




          </div>


          {/* <div style={{ width: "94%", height: "15%", display: "flex", flexDirection: "column", alignItems: "center", backgroundColor: "", position: "absolute", bottom: "-5%", justifyContent: "flex-end", paddingRight: "16px" }}>


            <div style={{ width: "100%", textAlign: "start" }}>
              <span className='standardTextMedium' style={{ fontSize: "14px" }}>Calculated from </span>
              <span className='standardTextMedium' style={{ fontSize: "14px", fontWeight: "800", paddingLeft: "4px" }}>{profileData?.currentFinYear}</span>
            </div>
            <div style={{ width: "100%", height: "50%", display: "flex", flexDirection: "column", justifyContent: "flex-end", textAlign: "start" }}>

              <span className='KnowMoreDiv' style={{ width: 'fit-content', fontSize: "12px", textDecoration: "underline" }} onClick={() => {
                setShowTaxPopUp(false)
                setShowIframe(true);
                // WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_TDS_ViewPolicyPopUp", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_location: 'Redeem Placement Page' } })
                WebToNativeMessage({ type: "redeemCTEvent", eventName: "pf_c_know_more_about_tds_netTaxableWinnings", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], winnings: profileData.taxableRunningNetWin, walletbalance: profileData.total } })

              }}>Know More About TDS </span>
            </div>
          </div> */}

          {/* {!enablebonusReleasedLastXDays && <div style={{ width: "100%", height: "15%", fontSize: '0.75rem', display: "flex", alignItems: "center", position: "", bottom: "-31%", justifyContent: "flex-start", marginLeft: "5%", fontWeight: "bold" }}>
            <span className='standardTextLight' style={{}}><span className='colorRedOEMstar' style={{}}>*</span> Total Deposits - <span style={{ fontWeight: '400' }}>Deposits in FY + Opening Balance of FY</span></span>
          </div>} */}


          {<div className='footertaxableDiv' style={{ width: "100%", height: "20%", backgroundColor: "", position: "", bottom: "0px", paddingTop: "" }}>
            <div style={{ width: "100%", height: "auto", backgroundColor: "", display: "flex", alignItems: "center", fontWeight: "bold" }}>
              <div style={{ width: "60%", height: "100%", display: "flex", alignItems: "center" }}>
                <span className='standardText' style={{ fontSize: "14px", paddingLeft: "16px" }}> Total TDS Paid</span>
              </div>

              <div style={{ width: "40%", height: "100%", display: "flex", alignItems: "center", paddingRight: "16px", paddingTop: "0.8rem", justifyContent: "flex-end" }}>
                <span className='standardTextDark' style={{ fontSize: "18px", paddingLeft: "16px", fontWeight: "bold" }}>  &#8377;
                  {Number(profileData?.totalTaxPaid).toFixed(2)}</span>
                {/* totalTaxPaid */}
                {/* <img id="download"
                              src={DownloadIcon}
                              style={{ width: "75px", height: "30px", position: "absolute", top: "", right: "10px", zIndex: "55" }}
                              onClick={
                                  () => {

                                  }
                              }
                          /> */}
              </div>
            </div>
            <div style={{ width: "100%", height: "auto", backgroundColor: "", display: "flex" }}>
              <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "" }}>
                <span className='standardTextLight' style={{ fontSize: "12px", paddingLeft: "16px" }}>30% of TDS paid on {enablebonusReleasedLastXDays ? 'Withdraw Amount' : 'Winnings'}</span>
              </div>
            </div>
          </div>}


          {(sessionStorage.getItem("tdsHistoryPageAvailable") && sessionStorage.getItem("tdsHistoryPageAvailable") === "true") || (tdsRefundUrl !== "") ? <div className='footertaxableDiv' style={{ width: "100%", height: "20%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <div style={{ width: "100%", height: "50%", display: "flex", alignItems: "center" }}>
              <span id="wt_total_tds_paid" style={{ fontSize: "12px", paddingLeft: "16px" }} className="standardTextLight"
              // style={{ fontSize: "14px", color: "#032146", paddingLeft: "16px" }}
              > Download Reports ( <span>{tdsRefundFinYear} )</span></span>
            </div>

            <div style={{ width: "100%", height: "50%", display: "flex", flexDirection: "", alignItems: "center", justifyContent: "" }}>

              {((sessionStorage.getItem("tdsHistoryPageAvailable"))) && <div style={{ width: "50%", height: "100%", display: "flex", alignItems: "center", paddingLeft: "5%" }}>
                <span className="smt" onClick={() => {
                  //openTDSHistoryPage

                  // PF_DownloadTDS_click
                  WebToNativeMessage({ type: 'openTDSHistoryPage' })



                  WebToNativeMessage({
                    type: "redeemCTEvent", eventName: "PF_DownloadTDS_click", eventProperties: {
                      Source: "Redeem",
                      acelevel: window.sessionStorage["aceLevel"],
                      channel: window.sessionStorage["channel"],
                      subscriptionType: window.sessionStorage["subscriptionType"],
                      username: window.sessionStorage["screenName"],
                      count_pendingRedeem: profileData.totalPendingRedeems,

                      tdsRefundConfig: tdsRefundConfig,
                      tdsRefundEligibility: tdsRefundEligibility,
                      tdsRefundAmount: tdsRefundAmount,
                      timestamp: new Date().getTime()
                    }
                  })

                  WebToNativeMessage({
                    type: "plotlineEvent", eventName: "PF_DownloadTDS_click", eventProperties: {
                      Source: "Redeem",
                      acelevel: window.sessionStorage["aceLevel"],
                      channel: window.sessionStorage["channel"],
                      subscriptionType: window.sessionStorage["subscriptionType"],
                      username: window.sessionStorage["screenName"],
                      count_pendingRedeem: profileData.totalPendingRedeems,

                      tdsRefundConfig: tdsRefundConfig,
                      tdsRefundEligibility: tdsRefundEligibility,
                      tdsRefundAmount: tdsRefundAmount,
                      timestamp: new Date().getTime()
                    }
                  })

                  WebToNativeMessage({
                    type: "mixpanelEvent", eventName: "PF_DownloadTDS_click", eventProperties: {
                      Source: "Redeem",
                      acelevel: window.sessionStorage["aceLevel"],
                      channel: window.sessionStorage["channel"],
                      subscriptionType: window.sessionStorage["subscriptionType"],
                      username: window.sessionStorage["screenName"],
                      count_pendingRedeem: profileData.totalPendingRedeems,

                      tdsRefundConfig: tdsRefundConfig,
                      tdsRefundEligibility: tdsRefundEligibility,
                      tdsRefundAmount: tdsRefundAmount,
                      timestamp: new Date().getTime()
                    }
                  })
                }} >{tdshistoryReportHyperlinkName}</span>
              </div>}


              <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", paddingLeft: "5%" }}>
                <span className="smt" onClick={() => {
                  WebToNativeMessage({ downloadUrl: tdsRefundUrl })


                  WebToNativeMessage({
                    type: "redeemCTEvent", eventName: "PF_annualsummary_click", eventProperties: {
                      Source: "Redeem",
                      acelevel: window.sessionStorage["aceLevel"],
                      channel: window.sessionStorage["channel"],
                      subscriptionType: window.sessionStorage["subscriptionType"],
                      username: window.sessionStorage["screenName"],
                      count_pendingRedeem: profileData.totalPendingRedeems,

                      tdsRefundConfig: tdsRefundConfig,
                      tdsRefundEligibility: tdsRefundEligibility,
                      tdsRefundAmount: tdsRefundAmount,
                      timestamp: new Date().getTime()
                    }
                  })

                  WebToNativeMessage({
                    type: "plotlineEvent", eventName: "PF_annualsummary_click", eventProperties: {
                      Source: "Redeem",
                      acelevel: window.sessionStorage["aceLevel"],
                      channel: window.sessionStorage["channel"],
                      subscriptionType: window.sessionStorage["subscriptionType"],
                      username: window.sessionStorage["screenName"],
                      count_pendingRedeem: profileData.totalPendingRedeems,

                      tdsRefundConfig: tdsRefundConfig,
                      tdsRefundEligibility: tdsRefundEligibility,
                      tdsRefundAmount: tdsRefundAmount,
                      timestamp: new Date().getTime()
                    }
                  })

                  WebToNativeMessage({
                    type: "mixpanelEvent", eventName: "PF_annualsummary_click", eventProperties: {
                      Source: "Redeem",
                      acelevel: window.sessionStorage["aceLevel"],
                      channel: window.sessionStorage["channel"],
                      subscriptionType: window.sessionStorage["subscriptionType"],
                      username: window.sessionStorage["screenName"],
                      count_pendingRedeem: profileData.totalPendingRedeems,

                      tdsRefundConfig: tdsRefundConfig,
                      tdsRefundEligibility: tdsRefundEligibility,
                      tdsRefundAmount: tdsRefundAmount,
                      timestamp: new Date().getTime()
                    }
                  })





                }}>{itrReportHyperlinkName}</span>
              </div>
            </div>



          </div> : ""}





          {/* {!enablebonusReleasedLastXDays && <div style={{ width: "100%", height: "15%", fontSize: '0.75rem', display: "flex", alignItems: "center", position: "absolute", bottom: "-31%", justifyContent: "flex-end", paddingRight: "16px", fontWeight: "bold" }}> */}
          {/* <span style={{ color: '#032146' }}><span style={{ color: 'red' }}>*</span> YTD - <span style={{ fontWeight: 'bold' }}>Year to Date</span></span> */}
          {/* <span className='standardTextLight' style={{}}><span className='colorRedOEMstar' style={{}}>*</span> Total Deposits - <span style={{ fontWeight: '400' }}>Deposits in FY + Opening Balance of FY</span></span> */}
          {/* </div>} */}



        </div>

        {/* <div className='footertaxableDiv' style={{ width: "100%", height: "16%", backgroundColor: "", position: "absolute", bottom: "0px", paddingTop: "10px" }}>
          <div style={{ width: "100%", height: "auto", backgroundColor: "", display: "flex", alignItems: "center", fontWeight: "bold" }}>
            <div style={{ width: "60%", height: "100%", display: "flex", alignItems: "center" }}>
              <span className='standardText' style={{ fontSize: "14px", paddingLeft: "16px" }}> Total TDS Paid</span>
            </div>

            <div style={{ width: "40%", height: "100%", display: "flex", alignItems: "center", paddingRight: "16px", paddingTop: "0.8rem", justifyContent: "flex-end" }}>
              <span className='standardTextDark' style={{ fontSize: "18px", paddingLeft: "16px", fontWeight: "bold" }}>  &#8377;
                {Number(profileData?.totalTaxPaid).toFixed(2)}</span>
            
            </div>
          </div>
          <div style={{ width: "100%", height: "auto", backgroundColor: "", display: "flex" }}>
            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "" }}>
              <span className='standardTextLight' style={{ fontSize: "12px", paddingLeft: "16px" }}>30% of TDS paid on {enablebonusReleasedLastXDays ? 'Redeem Amount' : 'Winnings'}</span>
            </div>
          </div>
        </div> */}


      </div>
    </div>

    return overlay
  }

  const createKnowMoreBottomUp = () => {

    let overlay1 = <div className="TDSPopup" style={{ width: "100%", height: "100%", position: "fixed", backgroundColor: "rgba(0,0,0,0.5)", bottom: "0px", zIndex: "4", display: knowMoreBottomUP ? "flex" : "none", justifyContent: "center" }} onClick={
      () => {

      }
    }>
      <div style={{ width: "100%", height: "100%", position: "absolute", backgroundColor: "", top: "0px", zIndex: "4", borderTopLeftRadius: "9px", borderTopRightRadius: "9px", maxWidth: "600px" }} onClick={
        () => {
          setKnowMoreBottomUp(false)
        }
      }>

      </div>
      <div className="animateDiv" style={{ width: "100%", height: "30%", position: "", display: "flex", flexDirection: "column", bottom: "-30%", zIndex: "5", borderTopLeftRadius: "15px", borderTopRightRadius: "15px", maxWidth: "600px" }} onClick={
        (e) => {
          console.log("Pointer events", e);
          e.stopPropagation();
        }
      }>

        <img
          src={assets?.assets?.Cross}
          style={{ width: "14px", height: "14px", position: "absolute", top: "16px", right: "10px", zIndex: "55" }}
          onClick={
            () => {
              setKnowMoreBottomUp(false)
            }
          }
        />

        <div id="header" className='tdsDivHeader' style={{ width: "100%", height: "16%", display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "8px", borderTopRightRadius: "8px", pointerEvents: "none" }}>
          <span style={{ fontSize: "18px", fontWeight: "700" }}>No TDS Withdrawal</span>
        </div>


        <div className='knowMoreBottomUpVideoDiv' >

        </div>

      </div>
    </div>

    return overlay1
  }

  const createOverLay = () => {
    let overLay = <div style={{ width: "100%", overflow: 'hidden' }}>
      <div style={{ width: "100%", height: "100%", position: "absolute", display: 'flex', backgroundColor: "rgba(0,0,0,0.5)", bottom: "0px", zIndex: "4", justifyContent: "center" }} >
        <div style={{ width: "100%", height: "100%", position: "absolute", backgroundColor: "", top: "0px", borderTopLeftRadius: "9px", borderTopRightRadius: "9px" }} onClick={
          () => {
            setToShowStandardAndInstantBottomSheet(false);
            setXTime(clearInterval(xTime));
          }
        }>



        </div>
        <div className="overLayAnimation" style={{ width: "100%", height: Number(lifetimeInstantRedeemsLeft) > 0 ? "50%" : "58%", position: "absolute", bottom: "-50%", zIndex: "5", borderTopLeftRadius: "15px", borderTopRightRadius: "15px", maxWidth: "600px" }} >
          <img
            src={assets?.assets?.Cross}
            style={{ width: "14px", height: "14px", position: "absolute", top: "16px", right: "15px", zIndex: "55" }}
            onClick={
              () => {
                setToShowStandardAndInstantBottomSheet(false)
                setXTime(clearInterval(xTime))
                WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_clickinSelectRedeemType", eventProperties: { username: window.sessionStorage['screenName'], button_clicked: 'back', disabled_mode: !standardRedeemFlag ? 'standard' : !insantReedemFlag ? 'instant' : 'none', mode_selected: standardSelected ? "Standard" : "Instant", Redeem_Amount: amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], redeem_mode: activeRedeemMethod.type } })
              }
            } />
          {/* // onClick={() => this.handleBackBtnClick({ type: "closeClient" })} */}
          {/* /> */}
          {/* {console.log("New date", new Date())} */}

          <div id="header" style={{ width: "100%", height: "15%", maxHeight: "40px", fontWeight: '700', backgroundColor: "#2C5391", display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "8px", borderTopRightRadius: "8px", PointerEvent: "none" }} onClick={() => {
            // alert()
          }}>
            {/* <img src={navarrow} style={{ position: 'absolute', left: '5%', width: '8%' }} onClick={() => {
              // alert()&&
              setToShowStandardAndInstantBottomSheet(false)
            }}></img> */}
            {/* <span style={{ fontSize: "18px", color: "#fafafa" }}>Select Redeem Type</span> */}
            <span style={{ fontSize: "18px", color: "#fafafa" }}>Select Withdraw Type</span>
          </div>
          {/* {console.log("standard selected",standardSelected)} */}

          {(Number(lifetimeInstantRedeemsLeft) > 0 ?

            <div style={{ backgroundColor: "#f9f9f9", width: "100%", height: "65%", display: "flex", justifyContent: "space-evenly", alignItems: "center", flexDirection: "column" }}>
              <div id="instant_redeem" style={{ width: "85%", height: "25%", maxHeight: "60px", backgroundColor: instantSelected ? "rgba(3, 33, 70, 0.1)" : "", border: "1px solid #032146", borderRadius: "6px", display: "flex", alignItems: 'center', justifyContent: 'center', marginTop: "5%", opacity: showInstantErrorToolTip || !insantReedemFlag ? "0.4" : "1" }} onClick={() => {//, opacity: instantSelected ? "1" : "0.4"
                if (showInstantErrorToolTip || Number(dailyInstant) <= 0 || !insantReedemFlag) {
                  return
                }
                setStandardSelected(false);
                setInstantSelected(true);



              }}>

                {/* {console.log("Neee yenkamma >>>>>>", instantSelected)} */}
                <div id="radioButton2" style={{ width: "15%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <div className='radioButtoncss1' style={{ width: "18px", height: "18px", borderRadius: "18px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div className='radioButtoncss2' style={{ width: "10px", height: "10px", borderRadius: "15px", display: instantSelected ? "flex" : "none", justifyContent: "center", alignItems: "center", }}>

                    </div>
                  </div>
                </div>
                <div style={{ width: "81%", height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>

                    <span className='standardText' style={{ fontSize: "14px", fontWeight: "600" }}>Instant</span>
                    {
                      // (!standardRedeemFlag && Number(lifetimeInstantRedeemsLeft) > 0 ) ? <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}>
                      //  <span  style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{lifetimeInstantRedeemsLeft}</span>  out of  <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{lifetimeInstantRedeemsConfigCount}</span> left
                      // </span>:

                      // <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}> <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{dailyInstant}</span> left for today | <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{monthlyInstant} </span>left for {new Date().toLocaleString("en-US", { month: "long", }).substring(0, 3)}</span>
                      <img src={assets?.assets?.powerIcon} style={{ width: "10px", height: "20px", paddingLeft: "5px" }}>
                      </img>
                    }

                  </div>
                  {/* <span style={{ fontSize: "14px", color: "#032146", fontWeight: "600" }}>Instant</span> */}
                  {
                    // (!standardRedeemFlag && Number(lifetimeInstantRedeemsLeft) > 0 ) ? <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}>
                    //  <span  style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{lifetimeInstantRedeemsLeft}</span>  out of  <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{lifetimeInstantRedeemsConfigCount}</span> left
                    // </span>:

                    // <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}> <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{dailyInstant}</span> left for today | <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{monthlyInstant} </span>left for {new Date().toLocaleString("en-US", { month: "long", }).substring(0, 3)}</span>
                  }
                </div>
                {/* <img src={PowerButton} style={{ width: "12px", height: "22px" }}>
                </img> */}
              </div>

              {(!standardRedeemFlag && Number(lifetimeInstantRedeemsLeft) > 0) ?


                <div id="gold" style={{ width: "80%", height: "2%", display: "flex", alignItems: "center", justifyContent: "flex-start", marginBottom: "", marginTop: "" }}>
                  {
                    // <span style={{ fontSize: "10px", color: "#032146", fontWeight: "600", marginLeft: "2%", marginTop: "5px" }}>You have been offered instant processing on first {lifetimeInstantRedeemsConfigCount} redeems.</span>
                  }

                </div>

                :


                (showInstantErrorToolTip || Number(monthlyInstant) === 0 || !insantReedemFlag || Number(dailyInstant) === 0) && <div id="gold" style={{ width: "80%", height: "2%", display: "flex", alignItems: "center", justifyContent: "flex-start", marginBottom: "4%", marginTop: "2%" }}>
                  {
                    // (Number(monthlyInstant) === 0) ? <span style={{ fontSize: "12px", color: "#032146", fontWeight: "600", marginLeft: "2%", marginTop: "5px" }}>Instant redeem request limit exhausted for the month</span> :
                    //  (Number(dailyInstant) === 0) ? <span style={{ fontSize: "10px", color: "#032146", fontWeight: "600", marginLeft: "2%", marginTop: "5px" }}>Instant redeem request limit exhausted for the day</span> :
                    (!insantReedemFlag) ? <span className='standardText' style={{ fontSize: "12px", fontWeight: "600", marginLeft: "2%", marginTop: "5px" }}>As per our Responsible Gaming Policy, We have disabled your Instant Withdraws</span> :
                      //  (!standardRedeemFlag && Number(lifetimeInstantRedeemsLeft) > 0) ? <span style={{ fontSize: "10px", color: "#032146", fontWeight: "600", marginLeft: "2%", marginTop: "5px" }}>You have been offered instant processing on first {lifetimeInstantRedeemsLeft} redeems.</span> : 
                      (showInstantErrorToolTip) ? <span className='standardText' style={{ fontSize: "12px", fontWeight: "300", marginLeft: "2%", width: "100%", marginTop: "5px" }}>Instant withdraw allowed upto <span className='standardText' style={{ fontSize: "12px", fontWeight: "700", marginTop: "5px" }}>&#8377; {autoApprovalLimit}</span>  </span> : ""}

                </div>}


              <div id="standard_redeem" style={{ width: "85%", height: "25%", maxHeight: "60px", backgroundColor: standardSelected ? "rgba(3, 33, 70, 0.1)" : "", border: "1px solid #032146", borderRadius: "6px", display: "flex", alignItems: 'center', justifyContent: 'center', opacity: (!standardRedeemFlag) ? "0.4" : "1" }} onClick={() => {//, opacity: standardSelected ? "1" : "0.4"
                // const [standardSelected,setStandardSelected] = useState(true);
                // const [instantSelected,setInstantSelected] = useState(false);
                if (!standardRedeemFlag || (Number(requestsPerDayLimits) - Number(userRequestsPerDayLimits)) <= 0) {

                  return
                }
                setStandardSelected(true);
                setInstantSelected(false);


              }}>

                <div id="radioButton1" style={{ width: "15%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <div className='radioButtoncss1' style={{ width: "18px", height: "18px", border: "1px solid #032146", borderRadius: "18px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div className='radioButtoncss2' style={{ width: "10px", height: "10px", backgroundColor: "#032146", borderRadius: "15px", display: standardSelected ? "flex" : "none", justifyContent: "center", alignItems: "center" }}>

                    </div>
                  </div>
                </div>

                <div style={{ width: "81%", height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>
                  {/* <span style={{ fontSize: "14px", color: "#032146", fontWeight: "600" }}>Standard</span> */}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span className='standardText' style={{ fontSize: "14px", fontWeight: "600" }}>Standard</span>
                    <img src={assets?.assets?.TimerIcon} style={{ width: "13px", height: "13px", paddingLeft: "5px" }}>
                    </img>
                  </div>
                  <span className='standardText' style={{ fontSize: "12px", fontWeight: "400" }}>{dailyStandardMsg}</span>
                  {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}>Processing Time upto 4 hours</span> dailyStandardMsg */}
                  {/* {(!standardRedeemFlag && Number(lifetimeInstantRedeemsLeft) > 0 ) ?  "":<span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}>Upto <span style={{ fontSize: "12px", color: "#032146", fontWeight: "600" }}>{Number(requestsPerDayLimits) - Number(userRequestsPerDayLimits)}</span> left for today</span> } */}
                </div>
                {/* <img src={TimerIcon} style={{ width: "15px", height: "15px" }}>
                </img> */}

              </div>




              {/* {  console.log("standard selected or 2",instantSelected)} */}

              {/* {(!standardRedeemFlag && Number(lifetimeInstantRedeemsLeft) > 0) ? */}
              {/* <div id="instant" style={{ width: "85%", height: "25%", maxHeight: "60px", backgroundColor: instantSelected ? "rgba(3, 33, 70, 0.1)" : "", border: "1px solid #032146", borderRadius: "6px", display: "flex", alignItems: 'center', justifyContent: 'center', marginTop: "-2%", opacity: insantReedemFlag ? "1" : "0.4" }} onClick={() => {//, opacity: instantSelected ? "1" : "0.4"

                if (!insantReedemFlag) {
                  return
                }

                setStandardSelected(false);
                setInstantSelected(true);



              }}>
                <div id="radioButton2" style={{ width: "15%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <div style={{ width: "18px", height: "18px", border: "1px solid #032146", borderRadius: "18px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: "10px", height: "10px", backgroundColor: "#032146", borderRadius: "15px", display: instantSelected ? "flex" : "none", justifyContent: "center", alignItems: "center", }}>

                    </div>
                  </div>
                </div>
                <div style={{ width: "75%", height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>
                  <span style={{ fontSize: "14px", color: "#032146", fontWeight: "600" }}>Instant</span>
                  <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}>
                    <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{lifetimeInstantRedeemsLeft}</span>  out of  <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{lifetimeInstantRedeemsConfigCount}</span> left
                  </span> */}
              {/* :<span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}> <span  style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{dailyInstant}</span> left for today | <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{monthlyInstant} </span>left for {new Date().toLocaleString("en-US", { month: "long", }).substring(0, 3)}</span>} */}
              {/* </div>
                <img src={PowerButton} style={{ width: "12px", height: "22px" }}>
                </img>
              </div>

              : */}






              {/* } */}




              {/* , backgroundColor: "#E6C683" */}

              {/* || (!standardRedeemFlag && Number(lifetimeInstantRedeemsLeft) > 0 ) */}

              {/* 1.Instant redeem is allowed only till {RUPEE_SYMBOL}{autoApprovalLimit} */}
              {(Number(lifetimeInstantRedeemsLeft) > 0) ? <div id="note" style={{ width: "85%", height: "20%", backgroundColor: "", borderRadius: "6px", marginTop: "10px" }}>
                <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>
                  <span className='standardText' style={{ fontSize: "12px", fontWeight: "400" }}>Note :</span>
                  {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%", marginTop: "5px" }}>1. Instant redeem usually takes 15-30 mins to credit the amount.</span> */}
                  <span className='standardText' style={{ fontSize: "12px", fontWeight: "400", width: "100%", marginTop: "5px" }}>1. You can withdraw a maximum {RUPEE_SYMBOL}{autoApprovalLimit} per instant withdraw.</span>
                  <span className='standardText' style={{ fontSize: "12px", fontWeight: "400", width: "100%", marginTop: "5px" }}>2. Each withdraw (standard/instant) is reviewed to ensure fair gameplay. For a few cases, the processing time might be longer.</span>
                  {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%",marginTop:"5px"  }}>3. Standard redeems will be initiated after few hours.  <span style={{ textDecoration: "underline", color: "#58B6C6", marginLeft: "2%", fontSize: "0.8rem" }} onClick={() => {
          history.push("/redeeminfo/")
            }}>Learn More</span></span> */}
                  {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%" }}>2.Processing time may vary in some cases.<span style={{ textDecoration: "underline", color: "#58B6C6", marginLeft: "1%" }} onClick={() => {
                  window.sessionStorage.setItem('policyBack', 'redeem');
                  WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPolicy_PageView", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Redeem Limit Exceeded Pop Up' } })
                    ; history.push("/redeeminfo/")
                }}>Learn More</span></span> */}
                </div>
              </div>
                :
                <div id="note" style={{ width: "85%", height: "20%", backgroundColor: "", borderRadius: "6px", marginTop: "10px" }}>
                  <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>
                    <span className='standardText' style={{ fontSize: "12px", fontWeight: "400" }}>Note :</span>
                    {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%", marginTop: "5px" }}>1. Instant redeem usually takes 15-30 mins to credit the amount.</span> */}
                    <span className='standardText' style={{ fontSize: "12px", fontWeight: "400", width: "100%", marginTop: "5px" }}>1. You can withdraw a maximum {RUPEE_SYMBOL}{autoApprovalLimit} per instant withdraw.</span>
                    {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%", marginTop: "5px" }}>3. Standard redeems will be initiated after few hours.  <span style={{ textDecoration: "underline", color: "#58B6C6", marginLeft: "2%", fontSize: "0.8rem" }} onClick={() => {
                      history.push("/redeeminfo/")
                    }}>Learn More</span></span> */}
                    <span className='standardText' style={{ fontSize: "12px", fontWeight: "400", width: "100%", marginTop: "5px" }}>2. Each withdraw (standard/instant) is reviewed to ensure fair gameplay. For a few cases, the processing time might be longer.</span>
                    {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%" }}>2.Processing time may vary in some cases.<span style={{ textDecoration: "underline", color: "#58B6C6", marginLeft: "1%" }} onClick={() => {
                  window.sessionStorage.setItem('policyBack', 'redeem');
                  WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPolicy_PageView", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Redeem Limit Exceeded Pop Up' } })
                    ; history.push("/redeeminfo/")
                }}>Learn More</span></span> */}
                  </div>
                </div>}

              {/* {showInstantErrorToolTip && <div id="gold" style={{ width: "90%", height: "10%", backgroundColor: "#E6C683", display: "flex", alignItems: "center", justifyContent: "space-around" }}>
              <span style={{ fontSize: "14px", color: "#032146", fontWeight: "600", marginLeft: "5%" }}>Instant redeem allowed till &#8377; {autoApprovalLimit} </span>
              <img
                src={BlueClose}
                style={{ width: "14px", height: "14px", }}
                onClick={
                  () => {
                    // setToShowStandardAndInstantBottomSheet(false)
                    setShowInstantErrorToolTip(false)
                  }
                }
              />
            </div>} */}

            </div>


            :

            <div style={{ backgroundColor: "#f9f9f9", width: "100%", height: "70%", display: "flex", justifyContent: "space-evenly", alignItems: "center", flexDirection: "column" }}>
              <div id="standard_redeem" style={{ width: "85%", height: "25%", maxHeight: "60px", backgroundColor: standardSelected ? "rgba(3, 33, 70, 0.1)" : "", border: "1px solid #032146", borderRadius: "6px", display: "flex", alignItems: 'center', justifyContent: 'center', opacity: (!standardRedeemFlag) ? "0.4" : "1", marginTop: "2%" }} onClick={() => {//, opacity: standardSelected ? "1" : "0.4"
                // const [standardSelected,setStandardSelected] = useState(true);
                // const [instantSelected,setInstantSelected] = useState(false);
                if (!standardRedeemFlag || (Number(requestsPerDayLimits) - Number(userRequestsPerDayLimits)) <= 0) {

                  return
                }
                setStandardSelected(true);
                setInstantSelected(false);


              }}>

                <div id="radioButton1" style={{ width: "15%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <div className='radioButtoncss1' style={{ width: "18px", height: "18px", border: "1px solid #032146", borderRadius: "18px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div className='radioButtoncss2' style={{ width: "10px", height: "10px", backgroundColor: "#032146", borderRadius: "15px", display: standardSelected ? "flex" : "none", justifyContent: "center", alignItems: "center" }}>

                    </div>
                  </div>
                </div>

                <div style={{ width: "81%", height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <span className='standardText' style={{ fontSize: "14px", fontWeight: "600" }}>Standard</span>
                    <img src={assets?.assets?.TimerIcon} style={{ width: "13px", height: "13px", paddingLeft: "5px" }}>
                    </img>
                  </div>
                  <span className='standardText' style={{ fontSize: "12px", fontWeight: "400" }}>{dailyStandardMsg}</span>
                  {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}>Processing Time: upto 4 hours</span> */}
                  {/* {(!standardRedeemFlag && Number(lifetimeInstantRedeemsLeft) > 0 ) ?  "":<span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}>Upto <span style={{ fontSize: "12px", color: "#032146", fontWeight: "600" }}>{Number(requestsPerDayLimits) - Number(userRequestsPerDayLimits)}</span> left for today</span> } */}
                </div>
                {/* <img src={TimerIcon} style={{ width: "15px", height: "15px" }}>
                </img> */}

              </div>

              {/* {  console.log("standard selected or 2",instantSelected)} */}

              {/* {(!standardRedeemFlag && Number(lifetimeInstantRedeemsLeft) > 0) ? */}
              {/* <div id="instant" style={{ width: "85%", height: "25%", maxHeight: "60px", backgroundColor: instantSelected ? "rgba(3, 33, 70, 0.1)" : "", border: "1px solid #032146", borderRadius: "6px", display: "flex", alignItems: 'center', justifyContent: 'center', marginTop: "-2%", opacity: insantReedemFlag ? "1" : "0.4" }} onClick={() => {//, opacity: instantSelected ? "1" : "0.4"

                if (!insantReedemFlag) {
                  return
                }

                setStandardSelected(false);
                setInstantSelected(true);



              }}>
                <div id="radioButton2" style={{ width: "15%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <div style={{ width: "18px", height: "18px", border: "1px solid #032146", borderRadius: "18px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: "10px", height: "10px", backgroundColor: "#032146", borderRadius: "15px", display: instantSelected ? "flex" : "none", justifyContent: "center", alignItems: "center", }}>

                    </div>
                  </div>
                </div>
                <div style={{ width: "75%", height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>
                  <span style={{ fontSize: "14px", color: "#032146", fontWeight: "600" }}>Instant</span>
                  <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}>
                    <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{lifetimeInstantRedeemsLeft}</span>  out of  <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{lifetimeInstantRedeemsConfigCount}</span> left
                  </span> */}
              {/* :<span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}> <span  style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{dailyInstant}</span> left for today | <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{monthlyInstant} </span>left for {new Date().toLocaleString("en-US", { month: "long", }).substring(0, 3)}</span>} */}
              {/* </div>
                <img src={PowerButton} style={{ width: "12px", height: "22px" }}>
                </img>
              </div>

              : */}

              {/* {console.log(">>>>>>>>>>>>>>>>>>IIII", showInstantErrorToolTip)} */}

              <div id="instant_redeem" style={{ width: "85%", height: "25%", maxHeight: "60px", backgroundColor: instantSelected ? "rgba(3, 33, 70, 0.1)" : "", border: !insantReedemFlag || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || Number(dailyInstant) <= 0 ? "1px solid rgba(3,33,70,0.4)" : "1px solid rgba(3,33,70,1)", borderRadius: "6px", display: "flex", alignItems: 'center', justifyContent: 'center', marginTop: "-2%" }} onClick={() => {//, opacity: instantSelected ? "1" : "0.4"

                if ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D")) {
                  if (showInstantErrorToolTip || Number(dailyInstant) <= 0 || !insantReedemFlag) {
                    return
                  }
                } else {
                  if (showInstantErrorToolTip || (hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability)) || !insantReedemFlag) {
                    return
                  }
                }

                setStandardSelected(false);
                setInstantSelected(true);



              }}>
                <div id="radioButton2" style={{ width: "15%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "center", opacity: !insantReedemFlag || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0) ? "0.4" : "1" }}>
                  <div className='radioButtoncss1' style={{ width: "18px", height: "18px", borderRadius: "18px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div className='radioButtoncss2' style={{ width: "10px", height: "10px", borderRadius: "15px", display: instantSelected ? "flex" : "none", justifyContent: "center", alignItems: "center", }}>

                    </div>
                  </div>
                </div>
                {/* <div style={{ width: "75%", height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}> */}
                <div style={{ width: "50%", height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>

                  <div style={{ display: "flex", alignItems: "center", opacity: !insantReedemFlag || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0) ? "0.4" : "1" }}>

                    <span className='standardText' style={{ fontSize: "14px", fontWeight: "600" }}>Instant</span>
                    {
                      // (!standardRedeemFlag && Number(lifetimeInstantRedeemsLeft) > 0 ) ? <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}>
                      //  <span  style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{lifetimeInstantRedeemsLeft}</span>  out of  <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{lifetimeInstantRedeemsConfigCount}</span> left
                      // </span>:

                      // <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}> <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{dailyInstant}</span> left for today | <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{monthlyInstant} </span>left for {new Date().toLocaleString("en-US", { month: "long", }).substring(0, 3)}</span>
                      <img src={assets?.assets?.powerIcon} style={{ width: "10px", height: "20px", paddingLeft: "5px" }}>
                      </img>
                    }

                  </div>
                  {console.log("hourlyDailyInstantFlag >>>>>>>", nextInstantRedeemAvailability)}
                  {console.log("fsdfjksdfjksdkjfsdfjksdkjfsdlkf", nextInstantRedeemAvailability.split(":")[0])}
                  {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{dailyInstant} </span><span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}>left for today</span> */}
                  {(!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") ? <span className='leftForText' style={{ fontSize: "12px", fontWeight: "400" }}> <span className='leftForText' style={{ fontSize: "12px", fontWeight: "700" }}>{dailyInstant}</span> left for today | <span className='leftForText' style={{ fontSize: "12px", fontWeight: "700" }}>{monthlyInstant} </span>left for {new Date().toLocaleString("en-US", { month: "long", }).substring(0, 3)}</span> : (nextInstantRedeemAvailability === "N" || !nextInstantRedeemAvailability) ? "" : <div style={{ display: "flex", alignItems: "center" }}>
                    <span className='standardText' style={{ fontSize: "12px", fontWeight: "600", paddingRight: "5px" }}>Unlocks in <span className='colorRedOEM' style={{ fontSize: "12px", fontWeight: "600" }}>{nextInstantRedeemAvailability && nextInstantRedeemAvailability.split(":")[0] + " hrs" + " : "}</span><span className='colorRedOEM' style={{ fontSize: "12px", fontWeight: "600" }}>{(nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] === "1") ? (nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] + " min") : (nextInstantRedeemAvailability && nextInstantRedeemAvailability.toString().split(":")[1] + " mins")}</span></span>
                  </div>}
                </div>
                <div style={{ width: "30%", height: "100%", display: "flex", justifyContent: "flex-end", alignItems: "center", opacity: !insantReedemFlag || showInstantErrorToolTip || ((hourlyDailyInstantFlag === "H" && (nextInstantRedeemAvailability !== "N" || !nextInstantRedeemAvailability))) || ((!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") && Number(dailyInstant) <= 0) ? "0.4" : "1" }}>
                  <span className='leftForText' style={{ fontSize: "12px", fontWeight: "700", paddingRight: "5px", display: (!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") ? "none" : "block" }}>{monthlyInstant} </span><span className='leftForText' style={{ fontSize: "12px", fontWeight: "400", display: (!hourlyDailyInstantFlag || hourlyDailyInstantFlag === "D") ? "none" : "block" }}>left for {new Date().toLocaleString("en-US", { month: "long", }).substring(0, 3)}</span>
                </div>

                {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400" }}> <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{dailyInstant}</span> left for today | <span style={{ fontSize: "12px", color: "#032146", fontWeight: "700" }}>{monthlyInstant} </span>left for {new Date().toLocaleString("en-US", { month: "long", }).substring(0, 3)}</span> */}
                {/* <img src={PowerButton} style={{ width: "12px", height: "22px" }}>
                </img> */}
              </div>



              {/* } */}




              {/* , backgroundColor: "#E6C683" */}

              {/* || (!standardRedeemFlag && Number(lifetimeInstantRedeemsLeft) > 0 ) */}
              {(Number(lifetimeInstantRedeemsLeft) > 0) ?


                <div id="gold" style={{ width: "80%", height: "2%", display: "flex", alignItems: "center", justifyContent: "flex-start", marginBottom: "", marginTop: "-4%" }}>
                  {
                    <span className='standardText' style={{ fontSize: "12px", fontWeight: "600", marginLeft: "2%", marginTop: "5px" }}>You have been offered instant processing on first {lifetimeInstantRedeemsConfigCount} redeems.</span>
                  }

                </div>

                :


                (showInstantErrorToolTip || Number(monthlyInstant) === 0 || !insantReedemFlag || Number(dailyInstant) === 0) && <div id="gold" style={{ width: "80%", height: "2%", display: "flex", alignItems: "center", justifyContent: "flex-start", marginBottom: "", marginTop: "" }}>
                  {(Number(monthlyInstant) === 0) ? <span className='standardText' style={{ fontSize: "12px", fontWeight: "600", marginLeft: "2%", marginTop: "5px" }}>Instant withdraw request limit exhausted for the month</span> :
                    //  (Number(dailyInstant) === 0) ? <span style={{ fontSize: "12px", color: "#032146", fontWeight: "600", marginLeft: "2%", marginTop: "5px" }}>Instant redeem request limit exhausted for the day</span> :
                    (showInstantErrorToolTip) ? <span className='standardText' style={{ fontSize: "12px", fontWeight: "300", marginLeft: "2%", width: "100%", marginTop: "5px" }}>Instant withdraw allowed upto <span className='standardText' style={{ fontSize: "12px", fontWeight: "700", marginTop: "5px" }}>&#8377; {autoApprovalLimit}</span>  </span> :
                      (Number(dailyInstant) === 0) ? <span className='standardText' style={{ fontSize: "12px", fontWeight: "600", marginLeft: "2%", marginTop: "5px" }}></span> :
                        (!insantReedemFlag) ? <span className='standardText' style={{ fontSize: "12px", fontWeight: "600", marginLeft: "2%", marginTop: "5px" }}>As per our Responsible Gaming Policy, We have disabled your Instant Withdraws</span> : (Number(lifetimeInstantRedeemsLeft) > 0) ? <span className='standardText' style={{ fontSize: "12px", fontWeight: "600", marginLeft: "2%", marginTop: "5px" }}>You have been offered instant processing on first {lifetimeInstantRedeemsLeft} withdraws.</span> : ""}

                </div>}
              {/* 1.Instant redeem is allowed only till {RUPEE_SYMBOL}{autoApprovalLimit} */}
              {(Number(lifetimeInstantRedeemsLeft) > 0) ? <div id="note" style={{ width: "85%", height: "20%", backgroundColor: "", borderRadius: "6px", marginTop: "10px" }}>
                <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>
                  <span className='standardText' style={{ fontSize: "12px", fontWeight: "400" }}>Note :</span>
                  {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%", marginTop: "5px" }}>1. Instant redeem usually takes 15-30 mins to credit the amount.</span> */}
                  <span className='standardText' style={{ fontSize: "12px", fontWeight: "400", width: "100%", marginTop: "5px" }}>Each withdraw (standard/instant) is reviewed to ensure fair gameplay. For a few cases, the processing time might be longer.</span>
                  {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%",marginTop:"5px"  }}>3. Standard redeems will be initiated after few hours.  <span style={{ textDecoration: "underline", color: "#58B6C6", marginLeft: "2%", fontSize: "0.8rem" }} onClick={() => {
          history.push("/redeeminfo/")
            }}>Learn More</span></span> */}
                  {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%" }}>2.Processing time may vary in some cases.<span style={{ textDecoration: "underline", color: "#58B6C6", marginLeft: "1%" }} onClick={() => {
                  window.sessionStorage.setItem('policyBack', 'redeem');
                  WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPolicy_PageView", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Redeem Limit Exceeded Pop Up' } })
                    ; history.push("/redeeminfo/")
                }}>Learn More</span></span> */}
                </div>
              </div>
                :
                <div id="note" style={{ width: "85%", height: "20%", backgroundColor: "", borderRadius: "6px", marginTop: "10px" }}>
                  {Number(nextAvailabilityHours) > 0 ? <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>
                    <span className='standardText' style={{ fontSize: "12px", fontWeight: "400" }}>Note :</span>
                    {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%", marginTop: "5px" }}>1. Instant redeem usually takes 15-30 mins to credit the amount.</span> */}
                    <span className='standardText' style={{ fontSize: "12px", fontWeight: "400", width: "100%", marginTop: "5px" }}>1. You can withdraw a maximum {RUPEE_SYMBOL}{autoApprovalLimit} per instant withdraw.</span>
                    {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%", marginTop: "5px" }}>3. Standard redeems will be initiated after few hours.  <span style={{ textDecoration: "underline", color: "#58B6C6", marginLeft: "2%", fontSize: "0.8rem" }} onClick={() => {
                      history.push("/redeeminfo/")
                    }}>Learn More</span></span> */}

                    <span className='standardText' style={{ fontSize: "12px", fontWeight: "400", width: "100%", marginTop: "5px" }}>2. Only 1 instant withdraw is allowed every {nextAvailabilityHours} hours.</span>
                    <span className='standardText' style={{ fontSize: "12px", fontWeight: "400", width: "100%", marginTop: "5px" }}>3. Each withdraw (standard/instant) is reviewed to ensure fair gameplay. For a few cases, the processing time might be longer.</span>
                    {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%" }}>2.Processing time may vary in some cases.<span style={{ textDecoration: "underline", color: "#58B6C6", marginLeft: "1%" }} onClick={() => {
                  window.sessionStorage.setItem('policyBack', 'redeem');
                  WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPolicy_PageView", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Redeem Limit Exceeded Pop Up' } })
                    ; history.push("/redeeminfo/")
                }}>Learn More</span></span> */}
                  </div> :

                    <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "flex-start", flexDirection: "column" }}>
                      <span className='standardText' style={{ fontSize: "12px", fontWeight: "400" }}>Note :</span>
                      {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%", marginTop: "5px" }}>1. Instant redeem usually takes 15-30 mins to credit the amount.</span> */}
                      <span className='standardText' style={{ fontSize: "12px", fontWeight: "400", width: "100%", marginTop: "5px" }}>1. You can withdraw a maximum {RUPEE_SYMBOL}{autoApprovalLimit} per instant withdraw.</span>
                      {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%", marginTop: "5px" }}>3. Standard redeems will be initiated after few hours.  <span style={{ textDecoration: "underline", color: "#58B6C6", marginLeft: "2%", fontSize: "0.8rem" }} onClick={() => {
                      history.push("/redeeminfo/")
                    }}>Learn More</span></span> */}

                      {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%", marginTop: "5px" }}>2. Only 1 instant redeem is allowed every {nextAvailabilityHours} hours.</span> */}
                      <span className='standardText' style={{ fontSize: "12px", fontWeight: "400", width: "100%", marginTop: "5px" }}>2. Each withdraw (standard/instant) is reviewed to ensure fair gameplay. For a few cases, the processing time might be longer.</span>
                      {/* <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%" }}>2.Processing time may vary in some cases.<span style={{ textDecoration: "underline", color: "#58B6C6", marginLeft: "1%" }} onClick={() => {
                  window.sessionStorage.setItem('policyBack', 'redeem');
                  WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPolicy_PageView", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, click_location: 'Redeem Limit Exceeded Pop Up' } })
                    ; history.push("/redeeminfo/")
                }}>Learn More</span></span> */}
                    </div>

                  }
                </div>

              }

              {/* {showInstantErrorToolTip && <div id="gold" style={{ width: "90%", height: "10%", backgroundColor: "#E6C683", display: "flex", alignItems: "center", justifyContent: "space-around" }}>
              <span style={{ fontSize: "14px", color: "#032146", fontWeight: "600", marginLeft: "5%" }}>Instant redeem allowed till &#8377; {autoApprovalLimit} </span>
              <img
                src={BlueClose}
                style={{ width: "14px", height: "14px", }}
                onClick={
                  () => {
                    // setToShowStandardAndInstantBottomSheet(false)
                    setShowInstantErrorToolTip(false)
                  }
                }
              />
            </div>} */}

            </div>)}

          <div id="button" style={{ width: "100%", height: Number(lifetimeInstantRedeemsLeft) > 0 ? "25%" : "20%", backgroundColor: "#f9f9f9", borderRadius: "6px", display: "flex", flexDirection: "column", marginBottom: "-5%" }}>
            {/* <div style={{ width: "50%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <button style={{ width: "80%", height: "60%", color: "#196A29", border: "1px solid #196A29", borderRadius: '4px', fontWeight: "700" }} onClick={
                () => {
                  // setToShowStandardAndInstantBottomSheet(false)
                      WebToNativeMessage({ type: "closeClient" })
                }
              }>
                Cancel
              </button>
            </div> */}
            <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <button style={{ width: "80%", height: "60%", color: "#ffffff", background: 'linear-gradient(180deg, #42BE40 0%, #196A29 100%)', border: "none", borderRadius: '4px', fontWeight: "700" }} onClick={() => {
                onContinueClick();
                WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_clickinSelectRedeemType", eventProperties: { username: window.sessionStorage['screenName'], button_clicked: 'Continue', disabled_mode: !standardRedeemFlag ? 'standard' : !insantReedemFlag ? 'instant' : 'none', mode_selected: standardSelected ? "Standard" : "Instant", Redeem_Amount: amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], redeem_mode: activeRedeemMethod.type } })
              }}>
                Continue
              </button>
            </div>
            <div style={{ color: '#58b6c6', textDecoration: "underline", fontSize: "0.9rem", fontWeight: "700", textAlign: "center", marginBottom: "5%" }} onClick={() => {
              // setShowIframe(true);
              // WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_OTPVerified", eventProperties: { username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered, channel: window.sessionStorage["channel"],verifiedORcancel:'Back to Lobby', aceLevel: window.sessionStorage["aceLevel"],verifiedORcancel:'verified', subscription_type: window.sessionStorage["subscriptionType"], redeem_mode: activeRedeemMethod.type } })
              // WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_TDS_ViewPolicyPopUp", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], click_location: 'Redeem Recommendation' } })
              WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_clickinSelectRedeemType", eventProperties: { username: window.sessionStorage['screenName'], button_clicked: 'Back to Lobby', disabled_mode: !standardRedeemFlag ? 'standard' : !insantReedemFlag ? 'instant' : 'none', mode_selected: standardSelected ? "Standard" : "Instant", Redeem_Amount: amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], redeem_mode: activeRedeemMethod.type } })
              WebToNativeMessage({ type: "closeClient" })
            }}>Back to Lobby</div>


          </div>

        </div>
      </div>
    </div>

    return overLay
  }

  const createAddRedeemMethod = () => {

    let addRedeemMethod;

    const RedeemMethodTile = (tile) => {
      console.log(tile)
      let redeemTile;
      redeemTile = <div className='addredeemMethodSections' key={tile.type} style={{ width: '95%', margin: "2% 0%", height: "17%", display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderRadius: "4px" }}
        onClick={() => {
          WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemMode_Clicked", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, subscription_type: profileData.subscriptionType, mode_selected: tile.type } })

          if (tile.list.length === tile.maximum) {
            setToastMessage({ message: `${VernacularContextData.getTransalatedKey("youcanaddmaximum")} ${tile.maximum} ${tile.type === 'upi' ? VernacularContextData.getTransalatedKey("upiid") : tile.type === 'amazonPay' ? VernacularContextData.getTransalatedKey("amazonpaywallet") : tile.type === 'paytmWallet' ? VernacularContextData.getTransalatedKey("paytmwallet") : tile.type === 'bankAccount' ? VernacularContextData.getTransalatedKey("bankaccount") : ''} ${VernacularContextData.getTransalatedKey("peraccount")}, ${VernacularContextData.getTransalatedKey("pleasetryothermode")}`, status: false })
          }
          else {
            handleLinkWallet(tile.type)
          }
        }}
      >
        <div style={{ width: '15%', height: "100%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}><img style={{ height: "50%" }} src={tile.type === 'upi' ? upiIcon : tile.type === 'amazonPay' ? amazonPayIcon : tile.type === 'bankAccount' ? assets.assets.bankIcon : tile.type === 'paytmWallet' ? paytmIcon : ''} /></div>
        <div style={{ width: '85%' }}>{tile.type === 'upi' ? VernacularContextData.getTransalatedKey("upiid") : tile.type === 'amazonPay' ? VernacularContextData.getTransalatedKey("amazonpaywallet") : tile.type === 'bankAccount' ? VernacularContextData.getTransalatedKey("bankaccount") : tile.type === 'paytmWallet' ? VernacularContextData.getTransalatedKey("paytmwallet") : ''}</div>
      </div>
      return redeemTile;
    }

    addRedeemMethod = <div style={{ ...(isTablet ? { position: "absolute" } : { position: 'fixed' }), width: "100%", height: "100%", display: 'flex', alignItems: 'end', justifyContent: 'center' }}>
      <div style={{ position: 'absolute', width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)' }} className='modalScreen' onClick={() => setOpenAddRedeemPopUp(false)}></div>
      <div style={{ position: 'absolute', width: '100%', height: "40%", color: 'black', display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#f9f9f9', borderRadius: '5px 5px 0px 0px', bottom: 0 }} className='redeem-pop-up-animation-default'>
        <div className='redeemAccountBottomSheet' style={{ width: '100%', height: '15%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '5px 5px 0px 0px' }}>
          <div className='redeemMethodHeaderText' style={{ fontWeight: 700, fontSize: '1rem' }}>{isKYCVerificationPage ? VernacularContextData.getTransalatedKey("addbankaccount") : VernacularContextData.getTransalatedKey("addwithdrawaccount")}</div>
          <img src={assets?.assets?.Cross} alt='close' style={{ position: 'absolute', right: '5%' }} onClick={() => setOpenAddRedeemPopUp(false)} />
        </div>
        <div className='redeemAccountBottomDiv1' style={{ width: '100%', height: "85%", display: 'flex', flexDirection: 'column', alignItems: 'center', overflowY: "scroll" }}>
          {redeemDetails.redeemOptions.map((redeemOption) => {
            return RedeemMethodTile(redeemOption)
          })}
        </div>
        {showRedeemMethodError !== undefined &&
          <div style={{ position: 'absolute', width: "90%", height: "10%", bottom: '3%', background: '#F9F9F9', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ width: "100%", height: "100%", background: '#4F5153', color: "#FFFFFF", borderRadius: "4px", display: 'flex', alignItems: 'center', fontSize: "0.8rem", fontWeight: "700", justifyContent: "center" }}>{showRedeemMethodError}</div>
          </div>
        }
      </div>
    </div>

    return addRedeemMethod
  }

  const handleRefreshPage = () => {

    resetProps()
    setFetchRedeemDetails(fetchRedeemDetails + 1)
  }

  const eventTrigger = (type, ActionType) => {
    console.log("Split percentage", smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)], smartRedeemAmountArray.indexOf(selectedSliderValue));
    WebToNativeMessage({
      type: type,
      eventName: "PF_c_smartredeem_pageaction",
      eventProperties: {
        SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2],
        TotalBonusPercentage: bonusConfig?.levelDetails[0]?.bonusPercent,
        InstantBonusPercentage: bonusConfig?.levelDetails[0]?.instantBonusPercentage,
        LockedBonusPercentage: bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
        Redeem_Amount: amountEntered,
        MostSelectedAmount: smartRedeemPercentConfig[mostSelected], //smartRedeemAmountArray[mostSelected],
        // BonusAmount: totalBonus,
        BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
        AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
        AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
        TDSAmount:
          calculateSmartTDS(
            amountEntered - selectedSliderValue
          ) > 0
            ? calculateSmartTDS(
              amountEntered - selectedSliderValue
            )
            : 0,
        Redeem_type_selected: standardSelected
          ? "Standard"
          : instantSelected
            ? "Instant"
            : "Others",
        Redeem_mode: activeRedeemMethod.type,
        subscription_type:
          window.sessionStorage["subscriptionType"],
        username: profileData.screenName,
        channel: window.sessionStorage["channel"],
        aceLevel: profileData.currentAceLevelName,
        timestamp: new Date().getTime(),
        ActionType: ActionType,
        smartUI: smartRedeemNewUIFlag ? "Yes" : "No"
      },
    });
  }

  const createToastMessage = () => {
    let toastMesage;
    toastMesage = <div className='toastmessageDiv' onClick={(e) => e.preventDefault()} style={{ position: 'absolute', borderRadius: "0px", width: "100%", height: "8%", bottom: "0%", display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.8rem', fontWeight: "700", ...(toastMessage.status ? { background: isoemps ? "#E9DFCE" : 'green' } : { background: isoemps ? "#E9DFCE" : '#fd735c' }) }}>
      <div style={{ width: "90%", marginLeft: "2.5%", height: "100%", display: 'flex', alignItems: "center", justifyContent: "center" }}>{toastMessage.message}
      </div>
      <span style={{ width: "5%", marginRight: "2.5%", fontSize: "1.2rem" }} onClick={() => setToastMessage(undefined)} >&times;</span>
    </div>
    return toastMesage
  }

  const handleSubmitBankDetails = async () => {

    try {
      if (addBankInfo.accountNumber === '' || addBankInfo.accountNumber.length < 3) {
        console.log("Enter Valid Account Number");
        setAddBankAccountError(VernacularContextData.getTransalatedKey("entervalidaccountnumber"))
        return false
      }
      else if (addBankInfo.reAccountNumber === '' || addBankInfo.reAccountNumber.length < 3) {
        console.log("Enter Valid re Account Number");
        setAddBankAccountError(VernacularContextData.getTransalatedKey("entervalidreaccountnumber"))
        return false
      }
      else if (addBankInfo.accountNumber !== addBankInfo.reAccountNumber && (addBankInfo.accountNumber !== null && addBankInfo.reAccountNumber !== null)) {
        console.log('account number and re-account number didnt match')
        setAddBankAccountError(VernacularContextData.getTransalatedKey("accountnumberandreaccountnumberdidntmatch"))
        return false
      }
      else if (addBankInfo.ifscCode.length < 11) {
        console.log("Enter Valid IFSCCode");
        setAddBankAccountError(VernacularContextData.getTransalatedKey("entervalidifsccode"))
        return false
      }

      else {
        setBankDetailsLoading(true)
        setAddBankAccountError(undefined)
        WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemAccount_validationRequested", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], mode_selected: 'bankaccount' } })
        await axios({
          method: "POST",
          url: process.env.REACT_APP_NEW_BASE_URL + "a23kyc/submitbankdetailsforvalidation/",
          headers: {
            Authorization: window.sessionStorage['token']
          },
          data: {
            // token: token,
            account_number: addBankInfo.accountNumber,
            account_name: "Not Available",
            ifsc: addBankInfo.ifscCode
          },
        }).then(res => {
          console.log('bank details :: ', res)
          if (res.data.error) {
            setAddBankAccountError(res.data.error.message)
            setBankDetailsLoading(false)
            setShowBankAcntStatus(true)
            setAddBankResponse(res.data)
          }
          else {
            // setToastMessage('BANK ACCOUNT ADDED SUCCESSFULLY')
            setBankDetailsLoading(false)
            // setOpenBankAccountPopUp(false)
            if (res.data.bankStatus === 'approved') {
              setToastMessage({ message: 'Withdraw Method Added', status: true })
              setOpenBankAccountPopUp(false)
              if (isKYCVerificationPage) {
                WebToNativeMessage({ type: "addBankSuccess" })
              }
              setFetchRedeemDetails(fetchRedeemDetails + 1)
            }
            else {
              if (res.data.statusCode === 3135) {
                setAddBankAccountError(VernacularContextData.getTransalatedKey("bankaccountnumberalreadyexistsinsystempleaseenteradifferentbankaccountnumber"))
              }
              else {
                setShowBankAcntStatus(true)
                setAddBankResponse(res.data)
              }
            }

            // setFetchRedeemDetails(fetchRedeemDetails+1)
          }
        })

      }
    } catch (error) {
      console.log(error)
    }

  }

  const verifyIfscCode = async () => {
    setBankDetailsLoading(true)
    axios({
      method: "POST",
      url: process.env.REACT_APP_NEW_BASE_URL + "a23kyc/verify_ifsc/",
      headers: {
        Authorization: window.sessionStorage['token']
      },
      data: {
        // token: token,
        ifscVal: addBankInfo.ifscCode
      },
    }).then(res => {
      if (res.data.error) {
        setAddBankAccountError(res.data.error)
        return false
      }
      else if (res.data.message === ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_SUCCESS_MSG) {
        setIsIfscVerified(true)
      }
      else {
        if (res.data.statusCode === 3134) {
          setAddBankAccountError(res.data.message)
        }
        else {
          setAddBankAccountError(VernacularContextData.getTransalatedKey("ifscdoesntexistpleaseentercorrectifsc"))
        }

        setIsIfscVerified(false)
      }
      setBankDetailsLoading(false)

    }).catch((e) => {
      setBankDetailsLoading(false)
      console.log(e)
    })

  }

  const createAddBankAccountPopUp = () => {
    let addBankAccount;
    addBankAccount = <div style={{ position: 'absolute', width: "100%", height: "100%", display: 'flex', alignItems: 'end', justifyContent: 'center' }}>
      <div style={{ position: 'absolute', width: '100%', height: '100%', background: 'rgba(0,0,0,0.8)' }} className='modalScreen'></div>
      <div style={{ position: 'absolute', width: '100%', height: "40%", color: 'black', display: "flex", flexDirection: 'column', alignItems: 'center', justifyContent: 'center', bottom: bottom, transition: 'bottom 300ms ease' }} className='redeem-pop-up-animation-default'>
        <div className='redeemAccountBottomSheet' style={{ width: '100%', height: '15%', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '5px 5px 0px 0px' }}>
          <div className='redeemMethodHeaderText' style={{ fontWeight: 700, fontSize: '1rem' }}>{VernacularContextData.getTransalatedKey("addbankaccount")}</div>
          {showBankAcntStatus ?
            <img id="CloseIcon" src={assets?.assets?.Cross} alt='close' style={{ position: 'absolute', right: "5%" }} onClick={() => {
              setAddBankInfo({ accountNumber: '', reAccountNumber: '', ifscCode: '' });
              setAddBankAccountError(undefined);
              if (addBankResponse !== undefined) {
                if (addBankResponse.bankStatus !== undefined) {
                  setFetchRedeemDetails(fetchRedeemDetails + 1)
                }
                setAddBankResponse(undefined);
                setShowBankAcntStatus(false);
              }
              // if(isKYCVerificationPage && addBankResponse?.bankStatus === 'processing'){
              //   WebToNativeMessage({type:"addBankSuccess"})
              // }
              setOpenBankAccountPopUp(false)
            }} />
            :
            <>
              <img id="Backbutton" src={assets?.assets?.navarrow} alt='close' style={{ position: 'absolute', left: '5%', width: '8%', height: "8%" }} onClick={() => {
                setAddBankInfo({ accountNumber: '', reAccountNumber: '', ifscCode: '' });
                setAddBankAccountError(undefined);
                if (addBankResponse !== undefined) {
                  if (addBankResponse.bankStatus !== undefined) {
                    setFetchRedeemDetails(fetchRedeemDetails + 1)
                  }
                  setAddBankResponse(undefined);
                  setShowBankAcntStatus(false);
                }
                else {
                  setOpenBankAccountPopUp(false);
                  setOpenAddRedeemPopUp(true)
                }
              }} />
              <img id="CloseIcon" src={assets?.assets?.Cross} alt='close' style={{ position: 'absolute', right: "5%" }} onClick={() => {

                setAddBankInfo({ accountNumber: '', reAccountNumber: '', ifscCode: '' });
                setAddBankAccountError(undefined);
                if (addBankResponse !== undefined) {
                  if (addBankResponse.bankStatus !== undefined) {
                    setFetchRedeemDetails(fetchRedeemDetails + 1)
                  }
                  setAddBankResponse(undefined);
                  setShowBankAcntStatus(false);
                }
                else {
                  setOpenBankAccountPopUp(false);
                  setOpenAddRedeemPopUp(true)
                }
              }} />

            </>
          }
          <img src={addBankResponse !== undefined ? assets?.assets?.Cross : assets?.assets?.navarrow} alt='close' style={{ ...(addBankResponse !== undefined ? { position: 'absolute', right: '5%' } : { position: 'absolute', left: '5%', width: '8%', height: "8%" }) }} onClick={() => {
            setAddBankInfo({ accountNumber: '', reAccountNumber: '', ifscCode: '' });
            setAddBankAccountError(undefined);
            if (addBankResponse !== undefined) {
              if (addBankResponse.bankStatus !== undefined) {
                setFetchRedeemDetails(fetchRedeemDetails + 1)
              }
              setAddBankResponse(undefined);
              setShowBankAcntStatus(false);
              setOpenBankAccountPopUp(false)
            }
            else {
              setOpenBankAccountPopUp(false);
              setOpenAddRedeemPopUp(true)
            }
          }} />
        </div>
        <div className='redeemAccountBottomDiv1' style={{ width: "100%", height: "85%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
          {bankDetailsLoading && <div style={{ position: "absolute", width: '100%', height: "85%", bottom: 0, background: "rgba(0,0,0,0.7)" }}><Loading /></div>}
          {showBankAcntStatus && addBankResponse !== undefined ? <>
            <div style={{ width: "90%", height: "78%", display: "flex", alignItems: "center", justifyContent: "space-evenly", flexDirection: "column" }}>
              <div style={{ width: "100%", height: '40%' }}>
                <Lottie style={{ width: "100%", height: '100%' }} autoPlay={true} animationData={addBankResponse.bankStatus === 'processing' ? pendingAnimation : redeemFailed} loop={true} />
              </div>
              {addBankResponse.bankStatus === 'processing' ?
                <>
                  <span className='standardText' style={{ fontSize: '0.9rem', fontWeight: '700' }}>Thank you</span>
                  <span className='standardText' style={{ textAlign: "center" }}>Your request has been received</span>
                  <span className='standardText' style={{ textAlign: "center" }}>We will notify you once verification is completed</span>
                  <span className='standardText' style={{ textAlign: "center" }}>This may take upto 4 Hours</span>
                </>
                :
                <>
                  <span className='standardText' style={{ fontSize: '0.9rem', fontWeight: '700' }}>Verification failed</span>
                  <span className='standardText' style={{ textAlign: "center" }}>There was a name mismatch between your Bank Account name and KYC name</span>
                  <span className='standardText' style={{ textAlign: "center" }}>Please check and try again</span>
                </>
              }
            </div>
            {addBankResponse.bankStatus === 'processing' ?
              <div style={{ width: "95%", height: "22%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className='AddBankSheetCTA' style={{ width: "100%", height: "75%", borderRadius: "4px", fontSize: "1rem", fontWeight: "700", display: "flex", alignItems: 'center', justifyContent: "center" }} onClick={() => {
                  setOpenBankAccountPopUp(false); setAddBankResponse(undefined); setFetchRedeemDetails(fetchRedeemDetails + 1);
                  // if (isKYCVerificationPage) {
                  //   WebToNativeMessage({ type: "addBankSuccess" })
                  // }
                }}>Go Back</div>
              </div>
              :
              <div style={{ width: "95%", height: "22%", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <>
                  <div className='needHelpCTA' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '45%', height: '80%', fontSize: '1rem', fontWeight: '700' }} onClick={() => {
                    WebToNativeMessage({ type: "openContactUs" });
                    WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_contactus_pageload", eventProperties: { click_location: 'Withdraw Account Validation' } })

                  }} >
                    <img style={{ marginRight: '1%' }} src={assets?.assets?.needHelpIcon} alt='needHelp' />Need help

                  </div>
                  <div onClick={() => { setShowBankAcntStatus(false); setAddBankAccountError(undefined); setAddBankResponse(undefined); setAddBankInfo({ accountNumber: '', reAccountNumber: '', ifscCode: '' }) }} className='AddBankSheetCTA' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '45%', height: '80%', borderRadius: "4px", fontSize: '1rem', fontWeight: '700' }}>Retry</div>
                </>

              </div>
            }

          </> :
            <>
              <div style={{ width: "90%", height: "80%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                <div className='inputFieldData' style={{ width: '100%', height: "20%", display: 'flex', alignItems: "center", justifyContent: "center" }}>
                  <input id="enteraccountnumber" ref={acntNumberRef}
                    onPaste={(e) => {
                      e.preventDefault()
                      return false;
                    }} onCopy={(e) => {
                      e.preventDefault()
                      return false;
                    }}
                    onKeyUp={(e) => {
                      console.log('re'); if (e.key === 'Enter') {
                        acntNumberRef.current.blur()
                      }
                    }} onFocus={() => { isAndroid && setBottom('40%') }} onBlur={() => setBottom('0%')} type='password' style={{ width: "100%", height: "90%", background: 'transparent' }} placeholder={VernacularContextData.getTransalatedKey("enteraccountnumber")} value={addBankInfo.accountNumber} onChange={(e) => {
                      if (new RegExp(/^[0-9\b]+$/).test(e.target.value) || e.target.value === "") {
                        setAddBankInfo({ accountNumber: e.target.value, reAccountNumber: addBankInfo.reAccountNumber, ifscCode: addBankInfo.ifscCode }); setAddBankAccountError(undefined)
                      }

                    }} />
                </div>
                <div className='inputFieldData' style={{ width: '100%', height: "20%", display: 'flex', alignItems: "center", justifyContent: "center" }}>
                  <input id="reenteraccountnumber"
                    onPaste={(e) => {
                      e.preventDefault()
                      return false;
                    }} onCopy={(e) => {
                      e.preventDefault()
                      return false;
                    }}
                    ref={reacntNumberRef} onFocus={() => { isAndroid && setBottom('35%') }} onBlur={() => setBottom('0%')} onKeyUp={(e) => {
                      console.log('re'); if (e.key === 'Enter') {
                        reacntNumberRef.current.blur()
                      }
                    }} type='tel' style={{ width: "100%", height: "90%", background: 'transparent' }} placeholder={VernacularContextData.getTransalatedKey("reenteraccountnumber")} value={addBankInfo.reAccountNumber} onChange={(e) => {
                      e.target.value = e.target.value.replace(/[^0-9 ]+/g, '') // fix for PL-3616
                      setAddBankInfo({ accountNumber: addBankInfo.accountNumber, reAccountNumber: e.target.value, ifscCode: addBankInfo.ifscCode }); setAddBankAccountError(undefined)
                    }} />
                </div>
                <div className='inputFieldData' style={{ width: '100%', height: "20%", display: 'flex', alignItems: "center", justifyContent: "center" }}>
                  <input id="ifsccodeentryfield"
                    onPaste={(e) => {
                      e.preventDefault()
                      return false;
                    }} onCopy={(e) => {
                      e.preventDefault()
                      return false;
                    }}
                    ref={ifscRef} onFocus={() => { isAndroid && setBottom('40%') }} onBlur={() => setBottom('0%')} onKeyUp={(e) => {
                      console.log('re'); if (e.key === 'Enter') {
                        ifscRef.current.blur()
                      }
                    }} type='text' style={{ width: "100%", height: "90%", background: 'transparent' }} placeholder={VernacularContextData.getTransalatedKey("ifsccode")} value={addBankInfo.ifscCode} onChange={(e) => {
                      if ((new RegExp(/[^A-Za-z0-9]+$/).test(e.target.value) === false && e.target.value.length < 12) || e.target.value === '') {
                        e.target.value = e.target.value.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '')
                        setAddBankInfo({ accountNumber: addBankInfo.accountNumber, reAccountNumber: addBankInfo.reAccountNumber, ifscCode: e.target.value.toUpperCase() }); setAddBankAccountError(undefined)
                      }
                    }} />
                </div>
                {addBankAccountError !== undefined &&
                  <div className='colorRedOEM' style={{ width: "100%", height: "10%", fontSize: "0.8rem", marginTop: "1%", marginBottom: "1%" }}>{addBankAccountError}</div>
                }
                {(isIfscVerified && addBankAccountError === undefined) &&
                  <div style={{ width: "100%", height: "10%", color: '#196A29', fontSize: "0.8rem", marginTop: "1%", marginBottom: "1%" }}>{VernacularContextData.getTransalatedKey("ifscvalidationsuccessfulpleaseproceed")}</div>
                }
                <div id="NotePoint" className='NoteText' style={{ width: "100%", height: "10%", fontSize: "0.8rem", marginTop: "1%" }}>{VernacularContextData.getTransalatedKey("note")}: {VernacularContextData.getTransalatedKey("bankaccountnameandkycnameshouldmatch")}</div>
                <div style={{ width: "100%", height: "10%", fontSize: '0.8rem' }}><span className='PanText' color='#707070'>{VernacularContextData.getTransalatedKey("kycname")} :</span><span id="panNamebank" className='PanData' style={{ marginLeft: "2%" }}>{redeemDetails.panName}</span></div>
              </div>
              <div style={{ width: "95%", height: "20%", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div id="addbankbutton" className={((isIfscVerified && addBankAccountError === undefined && addBankInfo.accountNumber !== '' && addBankInfo.reAccountNumber !== '') ? isoemps ? "AddBankSheetCTAYellow" : "AddBankCTAGreen" : "AddBankCTAGrey")} style={{ width: "100%", height: "75%", borderRadius: "4px", fontSize: "1rem", fontWeight: "700", display: "flex", alignItems: 'center', justifyContent: "center" }} onClick={() => {

                  isIfscVerified && handleSubmitBankDetails()

                }}>{VernacularContextData.getTransalatedKey("addbank")}</div>
              </div>
            </>}
        </div>

      </div>
    </div>
    return addBankAccount
  }

  const getNoteText = () => {
    // let noteTxt = 'Note: The following offers will expire on placing the redeem';
    // let noteTxt = 'Note: The following offers will end for you, if you place redeem.'
    let noteTxt = 'Note: The following offers will expires, if you place withdraw.'
    noteTxt = 'The following offers will expire for you if you place a withdraw request'
    // if (activeMissionsData?.activeMission) {
    //   console.log(`%c Mission at Note Came 1 `, debugLogStyle, activeMissionsData)
    //   let mission = activeMissionsData.activeMission[0]
    //   console.log(`%c Mission at Note `, debugLogStyle, mission)
    //   if (mission?.expireEventText !== "")
    //     noteTxt = mission.expireEventText
    // }
    return noteTxt
  }

  const createMissionCards = () => {
    console.log(`%c Hello `, debugLogStyle, activeMissionsData?.activeMission)
    let missionContainer =
      <>
        {!isBundledMission ?
          activeMissionsData?.activeMission?.length > 0 && activeMissionsData?.activeMission?.map((item, index) => {
            console.log(`%c At Mission Render >>> ITem >>> `, debugLogStyle, item)
            return (
              <MissionCard key={index + 'mis'} isBundleMission={false} missionData={item} />
            )
          })
          :
          <MissionCard key='missin' isBundleMission={isBundledMission} missionData={activeMissionsData?.activeMission[0]} />
        }
      </>


    return missionContainer
  }

  const openSelectedScreen = (w_type) => {
    if (w_type === 'redeemRecommendation') {
      handleRedeemRequestSent(recommendationSelection);
      console.log("open selected screen")
      WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemRecommendation_clickRedeem", eventProperties: { username: window.sessionStorage['screenName'], Redeem_Amount: recommendationSelection, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], option_selected: recommendationSelection === redeemDetails.tdsFreeAmount ? 'TDS Free' : 'TDS' } })
    }
    else if (w_type === 'redeem') {
      handleRedeemRequestSent(amountEntered);
      console.log("open selected screen 2")
      WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_OTPVerified", eventProperties: { username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], verifiedORcancel: 'verified', subscription_type: window.sessionStorage["subscriptionType"], redeem_mode: activeRedeemMethod.type } })


    }
    else if (w_type === `${LINKWALLET_STRINGS.KEY_BANKACCOUNT_TV}`) {
      //this.props.toggleAlertAction(false)
      // props.history.push({ pathname: '/addbankaccount/', data: { } })
      setOpenBankAccountPopUp(true)
    } else if (w_type === `${LINKWALLET_STRINGS.KEY_UPI_TV}`) {
      //   this.props.toggleModalAction(true, <VerifyUPI walletType={w_type} updateRedeemDetails={() => this.updateRedeemDetailsForUPI(w_type)} />, true)
      //this.props.history.push({pathname:'/addupi/',data:{upitoken:window.localStorage["upitoken"]}})
      setOpenAddUpiPopUp(true)
    } else {
      const response = JSON.parse(sessionStorage.getItem('walletresponse'));
      WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemAccount_validationRequested", eventProperties: { username: window.sessionStorage['screenName'], channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], mode_selected: w_type } })
      console.log("wallet Response:::", response)
      if (isKYCVerificationPage) {
        if (sessionStorage.getItem('walletResponseStatusCode') === '1210') {
          WebToNativeMessage({ type: 'addBankSuccess' })
        }
      }
      if (response && response !== '') {
        setToastMessage({ message: response, status: true })
      }

      // if (props.userState?.wallet_type_data.message !== "") {
      //     // this.props.toggleAlertAction(true, this.props.userState.wallettypedata.message, 2000, "bg-green")
      //     setToastMessage(props.userState?.wallet_type_data.message)
      // }
      setOpenLinkWallet(undefined)
      // handleRefreshPage()
      setFetchRedeemDetails(fetchRedeemDetails + 1)
      //   this.handleRedeemAPICall()
    }
    //this.setState({isAddBank:true,isRedeem:false})
  }

  const RedeemHistoryPageLoadCT = () => {
    WebToNativeMessage(
      {
        type: "redeemCTEvent", eventName: "PF_c_RedeemHistory_pageload", eventProperties: {
          Click_Location: "History Icon",
          acelevel: window.sessionStorage["aceLevel"],
          channel: window.sessionStorage["channel"],
          subscriptionType: window.sessionStorage["subscriptionType"],
          username: window.sessionStorage["screenName"],
          count_pendingRedeem: profileData.totalPendingRedeems,
          Source: 'Redeem Page'
        }

      })
    WebToNativeMessage(
      {
        type: "mixpanelEvent", eventName: "PF_c_RedeemHistory_pageload", eventProperties: {
          Click_Location: "History Icon",
          acelevel: window.sessionStorage["aceLevel"],
          channel: window.sessionStorage["channel"],
          subscriptionType: window.sessionStorage["subscriptionType"],
          username: window.sessionStorage["screenName"],
          count_pendingRedeem: profileData.totalPendingRedeems,
          Source: 'Redeem Page'
        }

      })
    history.push("/redeemhistory/")
  }



  //createConfirmPop

  const createSmartRedeemConfirmPopup = () => {
    let gamePassOverLay = <div style={{ width: "100%", backgroundColor: "", overflow: 'hidden' }}>
      <div style={{ width: "100%", height: "100%", position: "absolute", display: 'flex', bottom: "0px", zIndex: "4", justifyContent: "center", overflow: "hidden" }}  >

        <div style={{ width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.8)" }} onClick={() => {
          setShowSmartRedeemPopup(false);
          setShowSmartRedeemPopup(false)
        }}>

        </div>


        <div className="overLayAnimation" style={{ width: "100%", height: "50%", position: "absolute", zIndex: "5", borderTopLeftRadius: "15px", borderTopRightRadius: "15px", maxWidth: "600px" }} >


          <div style={{ width: "15%", height: "25%", maxHeight: "50px", backgroundColor: "", position: "absolute", display: "flex", zIndex: "55", justifyContent: "center", alignItems: "center", right: "5px" }} onClick={
            () => {
              setShowSmartRedeemPopup(false);
              setShowSmartRedeemPopup(false)
              WebToNativeMessage({
                type: "redeemCTEvent", eventName: "PF_c_smartredeem_confirmation", eventProperties: {
                  SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2]//smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)]
                  , TotalBonusPercentage: bonusConfig?.levelDetails[0]?.bonusPercent,
                  InstantBonusPercentage: bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                  LockedBonusPercentage: bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                  Redeem_Amount: amountEntered,
                  MostSelectedAmount: smartRedeemPercentConfig[mostSelected],
                  // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                  // BonusAmount: totalBonus,
                  BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                  AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                  AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                  TDSAmount: calculateSmartTDS(amountEntered - selectedSliderValue) > 0 ? calculateSmartTDS(amountEntered - selectedSliderValue) : 0,
                  Redeem_type_selected: standardSelected ? "Standard" : instantSelected ? "Instant" : "Others",
                  Redeem_mode: activeRedeemMethod.type,
                  subscription_type: window.sessionStorage['subscriptionType'],
                  username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime(), ActionType: "Back",
                  smartUI: smartRedeemNewUIFlag ? "New" : "Old"
                }
              })
              WebToNativeMessage({
                type: "mixpanelEvent", eventName: "PF_c_smartredeem_confirmation", eventProperties: {
                  SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2],//smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)],
                  TotalBonusPercentage: bonusConfig?.levelDetails[0]?.bonusPercent,
                  InstantBonusPercentage: bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                  LockedBonusPercentage: bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                  Redeem_Amount: amountEntered,
                  MostSelectedAmount: smartRedeemPercentConfig[mostSelected],
                  // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                  // BonusAmount: totalBonus,
                  BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                  AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                  AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                  TDSAmount: calculateSmartTDS(amountEntered - selectedSliderValue) > 0 ? calculateSmartTDS(amountEntered - selectedSliderValue) : 0,
                  Redeem_type_selected: standardSelected ? "Standard" : instantSelected ? "Instant" : "Others",
                  Redeem_mode: activeRedeemMethod.type,
                  subscription_type: window.sessionStorage['subscriptionType'],
                  username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime(), ActionType: "Back",
                  smartUI: smartRedeemNewUIFlag ? "New" : "Old"
                }
              })
            }
          }>
            <img id="Close_gamepasspopup_redeempage"
              src={assets?.assets?.Cross}
              style={{ width: "15px", height: "15px", zIndex: "55" }}
            />
          </div>


          <div id="header" className='redeemAccountBottomSheet' style={{ width: "100%", height: "25%", maxHeight: "50px", fontWeight: '700', display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "8px", borderTopRightRadius: "8px", PointerEvent: "none" }} onClick={() => {
          }}>

            <span className='redeemMethodHeaderText' style={{ fontSize: "18px" }}>
              Transfer the amount?
            </span>
          </div>

          {/* border: 1px solid #3A4C7140 */}
          <div id="holder" style={{ width: "100%", height: "45%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div id="12" className='transferAmountSectionDiv' style={{ width: "94%", height: "100%", display: "flex", borderRadius: "8px", marginTop: "5%", flexDirection: "column" }}>

              <div id="23" className='paymentSectionDiv' style={{ width: "100%", height: "15%", display: "flex", borderTopLeftRadius: "8px", borderTopRightRadius: "8px" }}>
                <div style={{ width: "100%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center", marginLeft: "5%" }}>
                  <img src={upindicator} style={{ width: "10px", height: "10px" }}></img>
                  <span style={{ fontSize: "0.7rem", fontWeight: "700", marginLeft: "5%" }}>Payment Method</span>
                </div>

                <div style={{ width: "100%", height: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                  <span style={{ fontSize: "0.7rem", fontWeight: "700", marginRight: "8%" }}>{VernacularContextData.getTransalatedKey("youget")}</span>
                </div>
              </div>

              {/*  */}

              {selectedRedeemMethod !== undefined && redeemDetails.allRedeemOptions?.length > 0 ?
                <div id="34" style={{ width: "100%", height: "40%", display: "flex", backgroundColor: "", borderBottom: "1px solid #3463AF33", paddingTop: "4%", paddingBottom: "4%" }}>
                  <div style={{ width: "100%", marginLeft: "4%", height: "100%", display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: "" }}>
                    <div className='standardText' style={{ display: 'flex', width: '80%', height: "50%", fontWeight: "700", fontSize: "0.85rem", alignItems: 'center' }}>
                      <img src={activeRedeemMethod.type === 'upi' ? upiIcon : activeRedeemMethod.type === 'amazonPay' ? amazonPayIcon : activeRedeemMethod.type === 'bankAccount' ? assets.assets.bankIcon : activeRedeemMethod.type === 'paytmWallet' ? paytmIcon : ''} />
                      <div style={{ display: 'flex', flexDirection: "column" }}>
                        <div><span style={{ marginRight: "5px" }}>To</span>{activeRedeemMethod.type === 'bankAccount' ? activeRedeemMethod.bankName : activeRedeemMethod.type === 'upi' ? activeRedeemMethod.upi : `${activeRedeemMethod.name + ' ' + 'xxxxxx' + activeRedeemMethod.id.slice(6)}`}</div>
                        {activeRedeemMethod.type === 'bankAccount' && <div> <span style={{ marginRight: "5px" }}>To</span>{'x'.repeat(activeRedeemMethod.accountNumber.length - 4) + activeRedeemMethod.accountNumber.slice(activeRedeemMethod.accountNumber.length - 4)}</div>}
                      </div>
                      {(activeRedeemMethod?.bankStatus === 'processing' || activeRedeemMethod?.upiState === 'processing') &&
                        <div className='nowrap' style={{ width: '30%', height: '50%', marginLeft: '2%', display: 'flex', fontSize: '0.55rem', alignItems: "center", justifyContent: "center", color: '#CD7F32', fontWeight: '700', borderRadius: '24px', background: '#FFB30033' }}>
                          <span style={{ width: '95%', height: '100%', display: "flex", alignItems: 'center', justifyContent: "center" }}>Validation Pending</span>
                        </div>}
                    </div>

                  </div>
                  {console.log("chee nee brathuku >>>", amountEntered, playBalanceAmt)}
                  {!smartRedeemNewUIFlag ? <div style={{ width: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "flex-end" }}>

                    <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-end", backgroundColor: "", marginRight: "8%" }}>
                      <span id={`to${activeRedeemMethod.type}`} className='amountData' style={{ fontSize: "1.2rem", fontWeight: "700", marginLeft: "5px", fontFamily: "Conto" }}>
                        {RUPEE_SYMBOL}<span>{(Number(amountEntered) - Number(selectedSliderValue)) <= 0 ? 0 : (Number(amountEntered) - Number(selectedSliderValue) - (calculateSmartTDS(amountEntered - selectedSliderValue) > 0 ? calculateSmartTDS(amountEntered - selectedSliderValue) : 0))}</span>
                      </span>

                      {calculateSmartTDS(amountEntered - selectedSliderValue) > 0 ? <div id = "tdsdeducted"className='tdsDeductedDiv' style={{ width: "100%", padding: "5px", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "4px" }}>
                        <span id = "tdsAmount"className='tdsDeductedText' style={{ fontSize: "12px", fontWeight: "900" }}>
                          <span>{RUPEE_SYMBOL}</span> {calculateSmartTDS(amountEntered - selectedSliderValue)} TDS is deducted
                        </span>
                      </div> : ""}

                    </div>
                  </div>

                    :

                    <div style={{ width: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "flex-end" }}>

                      <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-end", backgroundColor: "", marginRight: "8%" }}>
                        <span className='amountData' style={{ fontSize: "1.2rem", fontWeight: "700", marginLeft: "5px", fontFamily: "Conto" }}>
                          {RUPEE_SYMBOL}
                          {/* basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2] */}
                          <span>{basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] - (calculateSmartTDS(amountEntered - smartRedeemAmountArray[0]) > 0 ? calculateSmartTDS(amountEntered - smartRedeemAmountArray[0]) : 0)
                            : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] - (calculateSmartTDS(amountEntered - smartRedeemAmountArray[1]) > 0 ? calculateSmartTDS(amountEntered - smartRedeemAmountArray[1]) : 0) :
                              Number(amountEntered) - smartRedeemAmountArray[2] - (calculateSmartTDS(amountEntered - smartRedeemAmountArray[2]) > 0 ? calculateSmartTDS(amountEntered - smartRedeemAmountArray[2]) : 0)

                          }</span>
                        </span>

                        {calculateSmartTDS(amountEntered - playBalanceAmt) > 0 ? <div id = "tdsdeducted"className='tdsDeductedDiv' style={{ width: "100%", padding: "5px", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: "4px" }}>
                          <span className='tdsDeductedText' style={{ fontSize: "12px", fontWeight: "900" }}>
                            <span>{RUPEE_SYMBOL}</span> {calculateSmartTDS(amountEntered - Number(basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]).toFixed(2))} TDS is deducted
                          </span>
                        </div> : ""}

                      </div>
                    </div>

                  }
                </div>

                :
                <div style={{ width: "92%", height: "65%", display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: "0.9rem", fontWeight: '500', color: "#9C9D9F",paddingBottom:"2%" }}>{VernacularContextData.getTransalatedKey("nowithdrawaccountavailable")}</div>
              }


              <div style={{ backgroundColor: "", display: "flex", width: "100%", height: "40%", }}>
                <div style={{ width: "60%", height: "100%", backgroundColor: "", display: "flex", justifyContent: "", alignItems: "center", marginLeft: "5%" }}>
                  <img src={assets?.assets?.walletIcon1} style={{ width: "18px", height: "18px", marginTop: "-6px" }}></img>
                  <span className='standardText' style={{ fontSize: "0.8rem", fontWeight: "600", marginLeft: "5px" }}>
                    {/* To your A23 wallet* */}

                    To Play Balance
                  </span>

                </div>
                {console.log("Pl >>>>>>>>>>> play", playBalanceAmt, instantBonus, smartRedeemNewUIFlag)}

                {!smartRedeemNewUIFlag ? <div style={{ width: "40%", height: "100%", backgroundColor: "", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-end", marginRight: "4%" }}>
                  <span id = "includeBonusAmount"className='amountData' style={{ fontSize: "1.2rem", fontWeight: "700", marginLeft: "5px", fontFamily: "Conto" }}>
                    {RUPEE_SYMBOL}<span>{(Number(playBalanceAmt) + Number(instantBonus))}</span>
                  </span>
                  {/* background: #EABF6966; */}

                  {Number(instantBonus) > 0 ? <div id = "includeBonusText"className='includeBonusText' style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "3px" }}>
                    <span style={{ color: "#000000", fontSize: "12px", fontWeight: "900", marginLeft: "5px" }}>
                      <span>{RUPEE_SYMBOL} {Number(instantBonus) ? Number(instantBonus).toFixed(2) : ""}</span>  Instant Bonus Included
                    </span>
                  </div> : ""}
                </div>

                  :

                  <div style={{ width: "40%", height: "100%", backgroundColor: "", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-end", marginRight: "4%" }}>
                    <span id = "includeBonusAmount"className='amountData' style={{ fontSize: "1.2rem", fontWeight: "700", marginLeft: "5px", fontFamily: "Conto" }}>
                      {RUPEE_SYMBOL}<span>{Number(Number(playBalanceAmt) + (basicSelected ? Number(instantBonusArr[0]) : saverSelected ? instantBonusArr[1] : instantBonusArr[2])).toFixed(2)}</span>
                    </span>
                    {/* background: #EABF6966; */}



                    {(basicSelected ? Number(instantBonusArr[0]) > 0 : saverSelected ? instantBonusArr[1] > 0 : instantBonusArr[2] > 0) ? <div id = "includeBonusText"className='includeBonusText' style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "5px", whiteSpace: "nowrap" }}>
                      <span style={{ color: "#000000", fontSize: "12px", fontWeight: "900", }}>
                        <span>{RUPEE_SYMBOL} {Number(basicSelected ? Number(instantBonusArr[0]) : saverSelected ? instantBonusArr[1] : instantBonusArr[2]).toFixed(2)}</span>  Instant Bonus Included
                      </span>
                    </div> : ""}
                  </div>
                }

              </div>

            </div>
          </div>

          <div style={{ width: "100%", display: "flex", flexDirection: "column", backgroundColor: "", position: "absolute", bottom: "5px", gap: "10px", justifyContent: "center", alignItems: "center" }}>

            <div
              // className="ph5 pv3 nowrap"
              id="ContinueCTA_redeempage1"
              className='redeemCTAButtonWhite'
              style={{
                width: "85%",
                height: "35px",
                // background: (basicRedeemSelected || smartRedeemSelected ) ? "linear-gradient(180deg, #35A753 0%, #276E3A 100%)":"linear-gradient(180deg, grey 0%, grey 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "4px",
                fontWeight: "700",
                fontSize: "0.9rem",

              }}
              onClick={() => {
                //  alert()
                setToShowGamePassOverLay(false);
                setShowSmartRedeem(false);
                setShowSmartRedeemPopup(false);

                WebToNativeMessage({
                  type: "redeemCTEvent", eventName: "PF_c_smartredeem_confirmation", eventProperties: {
                    SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2]//smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)]
                    , TotalBonusPercentage: bonusConfig?.levelDetails[0]?.bonusPercent,
                    InstantBonusPercentage: bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                    LockedBonusPercentage: bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                    Redeem_Amount: amountEntered,
                    MostSelectedAmount: smartRedeemPercentConfig[mostSelected],
                    // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                    // BonusAmount: totalBonus,
                    BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                    AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                    AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                    TDSAmount: calculateSmartTDS(amountEntered - selectedSliderValue) > 0 ? calculateSmartTDS(amountEntered - selectedSliderValue) : 0,
                    Redeem_type_selected: standardSelected ? "Standard" : instantSelected ? "Instant" : "Others",
                    Redeem_mode: activeRedeemMethod.type,
                    subscription_type: window.sessionStorage['subscriptionType'],
                    username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime(), ActionType: "Back",
                    smartUI: smartRedeemNewUIFlag ? "New" : "Old"
                  }
                })
                WebToNativeMessage({
                  type: "mixpanelEvent", eventName: "PF_c_smartredeem_confirmation", eventProperties: {
                    SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2]//smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)]
                    , TotalBonusPercentage: bonusConfig?.levelDetails[0]?.bonusPercent,
                    InstantBonusPercentage: bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                    LockedBonusPercentage: bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                    Redeem_Amount: amountEntered,
                    MostSelectedAmount: smartRedeemPercentConfig[mostSelected],
                    // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                    // BonusAmount: totalBonus,
                    BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                    AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                    AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                    TDSAmount: calculateSmartTDS(amountEntered - selectedSliderValue) > 0 ? calculateSmartTDS(amountEntered - selectedSliderValue) : 0,
                    Redeem_type_selected: standardSelected ? "Standard" : instantSelected ? "Instant" : "Others",
                    Redeem_mode: activeRedeemMethod.type,
                    subscription_type: window.sessionStorage['subscriptionType'],
                    username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime(), ActionType: "Back",
                    smartUI: smartRedeemNewUIFlag ? "New" : "Old"
                  }
                })

              }}
            >
              Go Back
            </div>

            <div
              className='redeemCTAButtonGreen'
              // className="ph5 pv3 nowrap"
              id="ContinueCTA_redeempage1"
              style={{
                width: "85%",
                height: "35px",
                // background: (basicRedeemSelected || smartRedeemSelected ) ? "linear-gradient(180deg, #35A753 0%, #276E3A 100%)":"linear-gradient(180deg, grey 0%, grey 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "4px",
                fontWeight: "700",
                fontSize: "0.9rem",
                // position: "absolute",
                // bottom: "5px",

              }}
              onClick={() => {




                setButtonText("RedeemWithBonus")
                setToShowGamePassOverLay(false);
                setShowSmartRedeem(false);
                setShowSmartRedeemPopup(false);
                setShowBonusMissOutPopup(false);
                onContinueClick("RedeemWithBonus");


                // console.log("Naaa naaaa naaaa naaaa", smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)])


                WebToNativeMessage({
                  type: "redeemCTEvent", eventName: "PF_c_smartredeem_confirmation", eventProperties: {
                    SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2]//smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)]
                    , TotalBonusPercentage: bonusConfig?.levelDetails[0]?.bonusPercent,
                    InstantBonusPercentage: bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                    LockedBonusPercentage: bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                    Redeem_Amount: amountEntered,
                    MostSelectedAmount: smartRedeemPercentConfig[mostSelected],
                    // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                    // BonusAmount: totalBonus,
                    BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                    AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                    AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                    TDSAmount: calculateSmartTDS(amountEntered - selectedSliderValue) > 0 ? calculateSmartTDS(amountEntered - selectedSliderValue) : 0,
                    Redeem_type_selected: standardSelected ? "Standard" : instantSelected ? "Instant" : "Others",
                    Redeem_mode: activeRedeemMethod.type,
                    subscription_type: window.sessionStorage['subscriptionType'],
                    username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime(), ActionType: "SmartRedeem",
                    smartUI: smartRedeemNewUIFlag ? "New" : "Old"
                  }
                })
                WebToNativeMessage({
                  type: "mixpanelEvent", eventName: "PF_c_smartredeem_confirmation", eventProperties: {
                    SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2]//smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)]
                    , TotalBonusPercentage: bonusConfig?.levelDetails[0]?.bonusPercent,
                    InstantBonusPercentage: bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                    LockedBonusPercentage: bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                    Redeem_Amount: amountEntered,
                    MostSelectedAmount: smartRedeemPercentConfig[mostSelected],
                    // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                    // BonusAmount: totalBonus,
                    BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                    AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                    AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                    TDSAmount: calculateSmartTDS(amountEntered - selectedSliderValue) > 0 ? calculateSmartTDS(amountEntered - selectedSliderValue) : 0,
                    Redeem_type_selected: standardSelected ? "Standard" : instantSelected ? "Instant" : "Others",
                    Redeem_mode: activeRedeemMethod.type,
                    subscription_type: window.sessionStorage['subscriptionType'],
                    username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime(), ActionType: "SmartRedeem",
                    smartUI: smartRedeemNewUIFlag ? "New" : "Old"
                  }
                })


              }}
            >
              {/* Continue to Redeem */}
              {/* Transfer */}
              Continue
            </div>







            <div style={{ width: "90%", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", marginBottom: "5px" }}>

              <span style={{ color: "#707070", fontSize: "10px" }}>
                *Amount transferred to A23 Wallet is used for playing cash games.
                This amount cannot be moved back & is not withdrawable.
              </span>

            </div>

          </div>

        </div>
      </div>
    </div>

    return gamePassOverLay;
  }

  const createSmartRedeemOverlay = () => {
    let gamePassOverLay = (
      <div id="smtCont" style={{ width: "100%", backgroundColor: "", overflow: "hidden" }}>
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            display: "flex",
            background: "var(--Color-Greys-Black, #000000)",
            bottom: "0px",
            zIndex: "4",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <div
            className="overLayAnimation"
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: "5",
              borderTopLeftRadius: "15px",
              borderTopRightRadius: "15px",
              maxWidth: "600px",
            }}
          >
            <div
              style={{
                width: "15%",
                height: "25%",
                maxHeight: "50px",
                backgroundColor: "",
                position: "absolute",
                display: "flex",
                zIndex: "55",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                id="Close_gamepasspopup_redeempage"
                src={assets?.assets?.navarrow}
                style={{ width: "30px", height: "30px", zIndex: "55" }}
                onClick={() => {
                  // totalBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.bonusPercent) / 100) * (parseInt(amountArray[selectedIndex])), parseInt(bonusConfig.maxBonus));
                  // totalInstantBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.instantBonusPercentage) / 100) * totalBonus, parseInt(bonusConfig.maxInstantBonus));
                  // totalLockedBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.lockedBonusPercentage) / 100) * totalBonus, parseInt(bonusConfig.maxLockedBonusAmount));

                  setShowSmartRedeem(false);
                  setShowSmartRedeemPopup(false)
                  setSmartRedeemAmountArray([]);
                  setSmartRedeemValueArr([]);
                  setInstantBonusArr([]);
                  setLockedBonusArr([]);
                  WebToNativeMessage({
                    type: "redeemCTEvent",
                    eventName: "PF_c_smartredeem_backclick",
                    eventProperties: {
                      SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2],//smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)],
                      TotalBonusPercentage:
                        bonusConfig?.levelDetails[0]?.bonusPercent,
                      InstantBonusPercentage:
                        bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                      LockedBonusPercentage:
                        bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                      Redeem_Amount: amountEntered,
                      MostSelectedAmount:
                        smartRedeemPercentConfig[mostSelected],
                      // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                      // BonusAmount: totalBonus,
                      BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                      AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                      AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                      TDSAmount:
                        calculateSmartTDS(amountEntered - selectedSliderValue) >
                          0
                          ? calculateSmartTDS(
                            amountEntered - selectedSliderValue
                          )
                          : 0,
                      Redeem_type_selected: standardSelected
                        ? "Standard"
                        : instantSelected
                          ? "Instant"
                          : "Others",
                      Redeem_mode: activeRedeemMethod.type,
                      subscription_type:
                        window.sessionStorage["subscriptionType"],
                      username: profileData.screenName,
                      channel: window.sessionStorage["channel"],
                      aceLevel: profileData.currentAceLevelName,
                      timestamp: new Date().getTime(),
                      smartUI: smartRedeemNewUIFlag ? "New" : "Old"

                    },
                  });

                  WebToNativeMessage({
                    type: "plotLineEvent",
                    eventName: "PF_c_smartredeem_backclick",
                    eventProperties: {
                      SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2],//smartRedeemPercentConfig[ smartRedeemAmountArray.indexOf(selectedSliderValue) ],
                      TotalBonusPercentage:
                        bonusConfig?.levelDetails[0]?.bonusPercent,
                      InstantBonusPercentage:
                        bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                      LockedBonusPercentage:
                        bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                      Redeem_Amount: amountEntered,
                      MostSelectedAmount:
                        smartRedeemPercentConfig[mostSelected],
                      // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                      // BonusAmount: totalBonus,
                      BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                      AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                      AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                      TDSAmount:
                        calculateSmartTDS(amountEntered - selectedSliderValue) >
                          0
                          ? calculateSmartTDS(
                            amountEntered - selectedSliderValue
                          )
                          : 0,
                      Redeem_type_selected: standardSelected
                        ? "Standard"
                        : instantSelected
                          ? "Instant"
                          : "Others",
                      Redeem_mode: activeRedeemMethod.type,
                      subscription_type:
                        window.sessionStorage["subscriptionType"],
                      username: profileData.screenName,
                      channel: window.sessionStorage["channel"],
                      aceLevel: profileData.currentAceLevelName,
                      timestamp: new Date().getTime(),
                      smartUI: smartRedeemNewUIFlag ? "New" : "Old"
                    },
                  });
                  WebToNativeMessage({
                    type: "mixpanelEvent",
                    eventName: "PF_c_smartredeem_backclick",
                    eventProperties: {
                      SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2],//smartRedeemPercentConfig[ smartRedeemAmountArray.indexOf(selectedSliderValue) ],
                      TotalBonusPercentage:
                        bonusConfig?.levelDetails[0]?.bonusPercent,
                      InstantBonusPercentage:
                        bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                      LockedBonusPercentage:
                        bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                      Redeem_Amount: amountEntered,
                      MostSelectedAmount:
                        smartRedeemPercentConfig[mostSelected],
                      // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                      // BonusAmount: totalBonus,
                      BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                      AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                      AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                      TDSAmount:
                        calculateSmartTDS(amountEntered - selectedSliderValue) >
                          0
                          ? calculateSmartTDS(
                            amountEntered - selectedSliderValue
                          )
                          : 0,
                      Redeem_type_selected: standardSelected
                        ? "Standard"
                        : instantSelected
                          ? "Instant"
                          : "Others",
                      Redeem_mode: activeRedeemMethod.type,
                      subscription_type:
                        window.sessionStorage["subscriptionType"],
                      username: profileData.screenName,
                      channel: window.sessionStorage["channel"],
                      aceLevel: profileData.currentAceLevelName,
                      timestamp: new Date().getTime(), smartUI: smartRedeemNewUIFlag ? "New" : "Old"
                    },
                  });
                }}
              />
            </div>

            <div
              id="header"
              className='smHeader'
              style={{
                width: "100%",
                height: "25%",
                maxHeight: "50px",
                fontWeight: "700",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
                PointerEvent: "none",
              }}
              onClick={() => { }}
            >
              <span style={{ fontSize: "18px", color: "#fafafa" }}>Withdraw</span>
              <span
                style={{
                  fontSize: "18px",
                  zIndex: "55",
                  height: "25%",
                  color: "#fafafa",
                  width: "15%",
                  maxHeight: "50px",
                  position: "absolute",
                  right: "0",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => {
                  WebToNativeMessage({ type: "smartRedeemPolicy" });
                  eventTrigger('redeemCTEvent', "FAQ");
                  eventTrigger('plotLineEvent', "FAQ");
                  eventTrigger('mixpanelEvent', "FAQ");
                }}
              >
                <img src={faqsIcon}></img>
              </span>
            </div>

            <div
              className='smContainer'
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {/* backgroundImage:"url("+SmartBanner+")" */}

              <div
                style={{
                  width: "100%",
                  // height: "135px",
                  // height: "18%",
                  height: "20%",
                  backgroundImage: "url(" + assets?.assets?.smartRedeemBanner + ")",
                  // background: "var(--Color-Greys-Black, #000000)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover"
                }}
                onClick={() => {
                  // WebToNativeMessage({ type: 'smartRedeemPolicy' })
                  // WebToNativeMessage({
                  //   type: 'openWebviewWithUrl',
                  //   // url: "https://www.youtube.com/embed/unefZ5aVptI?autoplay=1&mute=0&controls=1&origin=https%3A%2F%2Fqaweb.qapfgames.com&playsinline=1&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&fs=0&enablejsapi=1&widgetid=3",
                  //   url: "https://qaweb.qapfgames.com/mapp-smart-redeem.html?src=mapp&platformapp=Y&header=N",
                  //   clickLocation: 'Redeem',
                  // })
                  // console.log("came into openWebview>> ")
                  if (isPlaying !== true) {
                    setIsPlaying(true);
                  }
                  eventTrigger('redeemCTEvent', "Video");
                  eventTrigger('plotLineEvent', "Video");
                  eventTrigger('mixpanelEvent', "Video");
                }} >
                {/* https://pfqa.inffdev.com/banners/Banner3.svg */}
                {/* process.env.REACT_APP_BANNERS */}

                {/* {console.log("Bannnrs enti",process.env.REACT_APP_BANNERS)} */}
                {/* <img
                  // src={process.env.REACT_APP_BANNER}
                  style={{width:"100%",height:"100%"}}
                  // src={smartRedeemBanner}
                  onClick={() => {
                    // WebToNativeMessage({ type: 'smartRedeemPolicy' })
                    // WebToNativeMessage({
                    //   type: 'openWebviewWithUrl',
                    //   // url: "https://www.youtube.com/embed/unefZ5aVptI?autoplay=1&mute=0&controls=1&origin=https%3A%2F%2Fqaweb.qapfgames.com&playsinline=1&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&fs=0&enablejsapi=1&widgetid=3",
                    //   url: "https://qaweb.qapfgames.com/mapp-smart-redeem.html?src=mapp&platformapp=Y&header=N",
                    //   clickLocation: 'Redeem',
                    // })
                    setIsPlaying(true);
                    eventTrigger('redeemCTEvent', "Video");
                    eventTrigger('plotLineEvent', "Video");
                    eventTrigger('mixpanelEvent', "Video");
                  }}
                ></img> */}
                {console.log("FullscreenVideoPlayer from >>", isPlaying)}
                {<FullscreenVideoPlayer
                  isPlaying={isPlaying}
                  closeVideoScreen={closeVideoScreen}
                  // setIsPlaying={setIsPlaying}
                  videoRef={videoRef}
                  videoUrl={!smartRedeemNewUIFlag ? process.env.REACT_APP_SMART_REDEEM_VIDEO_URL : process.env.REACT_APP_SMART_REDEEM_VIDEO_NEW_URL} // Replace with your video URL
                // videoUrl="https://www.youtube.com/embed/sN9o7kMN1_8"
                />}
                {/* Heading */}
                {/* <div style={{ width: "100%", height: "20%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "" }}>
                <span style={{ fontSize: "12px", color: "#91CFDE" }}>Move winnings to Wallet</span>
              </div> */}

                {/* <div style={{ width: "100%", height: "20%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "", marginTop: "5%" }}> */}
                {/* <img src={smartRedeemImg} style={{ width: "25px", height: "25px", marginRight: "5px" }}></img>
                <span style={{ fontSize: "24px", color: "#cfcfcf", fontWeight: "900" }}>{smartRedeemHeading}</span>
              </div>

              <div style={{ width: "100%", height: "10%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "" }}>
                <span style={{ fontSize: "14px", color: "#91CFDE", fontWeight: "700", marginLeft: "10%", marginTop: "5%" }}>& Earn extra cash with</span>
              </div> */}

                {/* <div style={{ width: "95%", height: "10%", display: "flex", justifyContent: "flex-end", alignItems: "center", backgroundColor: "", marginTop: "1%", marginBottom: "2%",marginRight:"5px" }} onClick={() => {
                WebToNativeMessage({ type: 'smartRedeemPolicy' })
              }}>
                <span style={{ fontSize: "12px", color: "#FFB834", fontWeight: "700", marginLeft: "10%", textDecoration: "underline" }} onClick={() => {
                  // WebToNativeMessage({ type: 'smartRedeemPolicy' })
                }} >What is smart redeem?</span>
              </div> */}
              </div>

              {/* major ui */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  overflow: "",
                }}
              >
                {/* blue one */}
                <div
                  style={{
                    width: "99%",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    minHeight: "20%",
                    background: "",
                    marginTop: "5%",
                  }}
                >
                  <div
                    style={{
                      width: "95%",
                      display: "flex",
                      backgroundColor: "",
                      justifyContent: "flex-start",
                    }}
                  >
                    {/* <img src={subtract} style={{width:"60px"}} /> */}
                    <div
                      style={{
                        textAlign: "center",
                        paddingLeft: "5%",
                        paddingRight: "10%",
                        paddingTop: "2%",
                        paddingBottom: "2%",
                        height: "25px",
                        backgroundImage: "url(" + assets?.assets?.subtract + ")",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span
                        className='smTextColor'
                        style={{
                          fontSize: "0.8rem",
                          fontWeight: "800",
                        }}
                      >
                        MOVE <span>{RUPEE_SYMBOL}</span>
                        {amountEntered}
                      </span>
                    </div>
                  </div>

                  <div
                    className='smMoveContanier'
                    style={{
                      width: "95%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    {/* , borderBottom: "1px solid #3463AF33" */}
                    {selectedRedeemMethod !== undefined &&
                      redeemDetails.allRedeemOptions?.length > 0 ? (
                      <div
                        className='smMoveSection'
                        style={{
                          width: "100%",
                          height: "40%",
                          display: "flex",
                          padding: "2%",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            backgroundColor: "",
                          }}
                        >
                          <div
                            className='smMoveText'
                            style={{
                              display: "flex",
                              width: "80%",
                              height: "50%",
                              fontWeight: "700",
                              fontSize: "0.85rem",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={
                                activeRedeemMethod.type === "upi"
                                  ? upiIcon
                                  : activeRedeemMethod.type === "amazonPay"
                                    ? amazonPayIcon
                                    : activeRedeemMethod.type === "bankAccount"
                                      ? assets.assets.bankIcon
                                      : activeRedeemMethod.type === "paytmWallet"
                                        ? paytmIcon
                                        : ""
                              }
                              style={{ width: "25px", height: "25px" }}
                            />
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div
                                id="bank"
                                style={{
                                  marginLeft: "5px",
                                  fontSize: "0.9rem",
                                  fontWeight: "700",
                                }}
                              >
                                <span style={{ marginRight: "5px" }}>To</span>
                                {activeRedeemMethod.type === "bankAccount"
                                  ? activeRedeemMethod.bankName
                                  : activeRedeemMethod.type === "upi"
                                    ? activeRedeemMethod.upi
                                    : `${activeRedeemMethod.name +
                                    " " +
                                    "xxxxxx" +
                                    activeRedeemMethod.id.slice(6)
                                    }`}
                              </div>
                              {activeRedeemMethod.type === "bankAccount" && (
                                <div>
                                  {" "}
                                  <span style={{ marginRight: "5px" }}>To</span>
                                  {"x".repeat(
                                    activeRedeemMethod.accountNumber.length - 4
                                  ) +
                                    activeRedeemMethod.accountNumber.slice(
                                      activeRedeemMethod.accountNumber.length -
                                      4
                                    )}
                                </div>
                              )}
                            </div>
                            {(activeRedeemMethod?.bankStatus === "processing" ||
                              activeRedeemMethod?.upiState ===
                              "processing") && (
                                <div
                                  className="nowrap"
                                  style={{
                                    width: "30%",
                                    height: "50%",
                                    marginLeft: "2%",
                                    display: "flex",
                                    fontSize: "0.55rem",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#CD7F32",
                                    fontWeight: "700",
                                    borderRadius: "24px",
                                    background: "#FFB30033",
                                  }}
                                >
                                  <span
                                    style={{
                                      width: "95%",
                                      height: "100%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    Validation Pending
                                  </span>
                                </div>
                              )}
                          </div>
                          {/* <div id="change" style={{ color: '#58B6C6', textDecoration: 'underline', fontSize: "0.85rem" }}
onClick={() => { setOpenAllRedeemOptions(true); onClickofChangeRedeemMethod() }}>Change</div> */}
                        </div>

                        <div
                          style={{
                            width: "100%",
                            minHeight: "50px",
                            backgroundColor: "",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "flex-end",
                              backgroundColor: "",
                            }}
                          >
                            <span id={`to${activeRedeemMethod.type}`}
                              className='amountData'
                              style={{
                                fontSize: "1.2rem",
                                fontWeight: "700",
                                marginLeft: "5px",
                              }}
                            >
                              {RUPEE_SYMBOL}
                              <span>
                                {amountEntered - selectedSliderValue <= 0
                                  ? 0
                                  : amountEntered - selectedSliderValue - (calculateSmartTDS(amountEntered - selectedSliderValue) > 0 ? calculateSmartTDS(amountEntered - selectedSliderValue) : 0)}
                              </span>
                            </span>

                            {/* {console.log( "my pitchi >>>>>>",redTDSAmount,selectedSliderValue,redeemDetails.tdsFreeAmount,
                              calculateSmartTDS(
                                amountEntered - selectedSliderValue
                              )
                            )} */}
                            {/* {console.log("my pitchi >>>>>>>> 1",tdsInfo.tds,redeemDetails.tdsFreeAmount,greesTDSAmount,redTDSAmount,selectedSliderValue )} */}
                            {/* {console.log("my pitchi >>>>>>>> 2",redTDSAmount )} */}
                            {calculateSmartTDS(
                              amountEntered - selectedSliderValue
                            ) > 0 ? (
                              <div id = "tdsdeducted"
                                className='tdsDeductedDiv'
                                style={{
                                  padding: "5px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  borderRadius: "4px"
                                }}
                              >
                                <span
                                  className='tdsDeductedText'
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "900",
                                    borderRadius: "2px",
                                  }}
                                >
                                  <span>{RUPEE_SYMBOL}</span>{" "}
                                  {calculateSmartTDS(
                                    amountEntered - selectedSliderValue
                                  )}{" "}
                                  TDS is deducted
                                </span>
                              </div>
                            ) : tdsInfo.tds > 0 &&
                              Number(redeemDetails.tdsFreeAmount) > 0 &&
                              greesTDSAmount > redTDSAmount ? (
                              <div
                                className='tdsDeductedDivGreen'
                                style={{
                                  padding: "5px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <span
                                  className='tdsDeductedTextGreen'
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "900",
                                    borderRadius: "2px",
                                  }}
                                >
                                  <span>{RUPEE_SYMBOL}</span> {0} TDS is deducted</span>
                              </div>
                            ) : (
                              ""
                            )}

                            {/* {( Number(redeemDetails.tdsFreeAmount) > 0 )? <div style={{ padding:"5px", background: "#42BE4026", display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <span style={{ color: "#196a29", fontSize: "12px", fontWeight: "900", borderRadius: "2px" }}>
                              <span>{RUPEE_SYMBOL}</span> {0} TDS is deducted
                            </span>
                          </div> : ""} */}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div
                        style={{
                          width: "92%",
                          height: "65%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "0.9rem",
                          fontWeight: "500",
                          color: "#9C9D9F"
                          ,paddingBottom:"2%"
                        }}
                      >
                        {/* No Withdraw Account available */}
                        {VernacularContextData.getTransalatedKey("nowithdrawaccountavailable")}
                      </div>
                    )}

                    <div
                      className='smDividerLine'
                      style={{
                        width: "86%",
                        height: "1px",
                      }}
                    ></div>

                    {/* <img src={plusIcon1} style={{ width: "24px", height: "24px", marginTop: "-12px" }}></img> */}
                    {/* selectedSliderValue */}
                    <div
                      style={{
                        backgroundColor: "",
                        display: "flex",
                        width: "100%",
                        height: "40%",
                        padding: "2%",
                        paddingTop: "4%",
                      }}
                    >
                      <div
                        style={{
                          width: "60%",
                          height: "100%",
                          backgroundColor: "",
                          display: "flex",
                          justifyContent: "",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={assets.assets.walletIcon1}
                          style={{
                            width: "25px",
                            height: "25px",
                            marginTop: "-8px",
                          }}
                        ></img>
                        <span
                          className='standardText'
                          style={{
                            fontSize: "0.9rem",
                            fontWeight: "700",
                            marginLeft: "5px",
                          }}
                        >
                          To your A23 wallet*
                        </span>
                      </div>

                      <div
                        style={{
                          width: "40%",
                          height: "100%",
                          backgroundColor: "",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <span id="toWallet"
                          className='amountData'
                          style={{
                            fontSize: "1.2rem",
                            fontWeight: "700",
                            marginLeft: "5px",
                          }}
                        >
                          {/* {RUPEE_SYMBOL}<span>{((selectedSliderValue > amountEntered) || selectedSliderValue === amountEntered) ? amountEntered : selectedSliderValue}</span> */}
                          {RUPEE_SYMBOL}
                          <span>{selectedSliderValue}</span>
                        </span>
                      </div>
                    </div>

                    {/* <div style={{width:"100%",height:"40%",backgroundColor:"",display:"flex"}}>
  <Slider defaultValue={4} sliderData={[1,2,3,4,6,7]}/>
  </div> */}

                    <div
                      style={{
                        width: "90%",
                        padding: "5%",
                        paddingRight: "5%",
                        marginTop: "6%",
                        marginBottom: "10%",
                      }}
                    >
                      <Slider
                        min={0}
                        max={smartRedeemAmountArray.length - 1}
                        step={1}
                        sliderData={smartRedeemAmountArray}
                        // mostSelected={smartRedeemAmountArray[mostSelected]}
                        // defaultValue={selectedIndex} 
                        selectedIndex={selectedIndex}
                        zeroTDS={(tdsInfo.tds && redeemDetails?.tdsFreeAmount > 0) ? smartRedeemAmountArray[zeroTDSValueIndex] : "undefined"}
                        onChange={(val) => {
                          setSelectedSliderValue(val);
                          // console.log("chi chi ne brathuku", val);
                          setPlayBalanceAmt(val);
                          // totalBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.bonusPercent) / 100) * (parseInt(amountArray[selectedIndex])), parseInt(bonusConfig.maxBonus));
                          // totalInstantBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.instantBonusPercentage) / 100) * totalBonus, parseInt(bonusConfig.maxInstantBonus));
                          // totalLockedBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.lockedBonusPercentage) / 100) * totalBonus, parseInt(bonusConfig.maxLockedBonusAmount));


                          let totalBonus = Math.min(
                            (parseInt(
                              bonusConfig?.levelDetails[0]?.bonusPercent
                            ) /
                              100) *
                            parseInt(val),
                            parseInt(bonusConfig.maxBonus)
                          );
                          let totalInstantBonus = Math.min(
                            (parseInt(
                              bonusConfig?.levelDetails[0]?.instantBonusPercentage
                            ) /
                              100) *
                            totalBonus,
                            parseInt(bonusConfig.maxInstantBonus)
                          );
                          let totalLockedBonus = Math.min(
                            (parseInt(
                              bonusConfig?.levelDetails[0]?.lockedBonusPercentage
                            ) /
                              100) *
                            totalBonus,
                            parseInt(bonusConfig.maxLockedBonusAmount)
                          );

                          setTotalBonus(totalBonus);
                          setInstantBonus(totalInstantBonus);
                          setLockedBonus(totalLockedBonus);

                          // console.log(calculateSmartTDS(amountEntered - val), "nee thali")
                          // if(calculateSmartTDS(amountEntered - val) > val){
                          //   setTdsRed(calculateSmartTDS(amountEntered - val))
                          // }
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* {((instantBonus > 0) || (lockedBonus > 0)) ? <img src={plusIcon1} style={{ width: "25px", height: "25px", marginTop: "4%" }}></img> : ""} */}

                {/* gold */}
                {instantBonus > 0 || lockedBonus > 0 ? (
                  <div
                    style={{
                      width: "99%",
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "column",
                      background: "",
                      marginTop: "5%",
                    }}
                  >
                    <div
                      style={{
                        width: "95%",
                        display: "flex",
                        backgroundColor: "",
                        justifyContent: "flex-start",
                      }}
                    >
                      {/* <img src={subtract} style={{width:"60px"}} /> */}
                      <div
                        style={{
                          textAlign: "center",
                          paddingLeft: "5%",
                          paddingRight: "10%",
                          height: "25px",
                          paddingTop: "2%",
                          paddingBottom: "2%",
                          backgroundImage: "url(" + assets?.assets?.subtractGold + ")",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                          backgroundSize: "cover",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span
                          // className='smTextColor'
                          className='earnExtraText'
                          style={{
                            fontSize: "0.8rem",
                            fontWeight: "800",
                          }}
                        >
                          EARN EXTRA
                        </span>
                      </div>
                    </div>

                    <div
                      className='EarnExtraContainer'
                      style={{
                        width: "95%",
                        display: "flex",
                        borderRadius: "0px 6px 6px 6px",
                        flexDirection: "column",
                      }}
                    >
                      {instantBonus > 0 ? (
                        <div
                          className={lockedBonus > 0 ? 'instantBonusBorderDiv' : ""}
                          style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            paddingTop: "3%",
                            paddingBottom: "3%",
                            paddingLeft: "2%",
                            paddingRight: "2%",
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              height: "100%",
                              backgroundColor: "",
                              display: "flex",
                              justifyContent: "",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={assets.assets.instantrupee}
                              style={{ width: "20px", height: "20px" }}
                            ></img>
                            <span
                              className="EarnSectionBonusText"
                              style={{
                                fontSize: "0.8rem",
                                fontWeight: "700",
                                marginLeft: "5px",
                              }}
                            >
                              Instant Bonus
                            </span>
                          </div>

                          <div
                            style={{
                              width: "40%",
                              height: "100%",
                              backgroundColor: "",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                            }}
                          >
                            <span id='instantBonusAmount'
                              className='amountData'
                              style={{
                                fontSize: "1.2rem",
                                fontWeight: "700",
                                marginLeft: "5px",
                              }}
                            >
                              {RUPEE_SYMBOL}
                              <span>{Number(instantBonus).toFixed(2)}</span>
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      {lockedBonus > 0 ? (
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            paddingLeft: "2%",
                            paddingTop: "3%",
                            paddingBottom: "3%",
                            paddingRight: "2%",
                          }}
                        >
                          <div
                            style={{
                              width: "60%",
                              height: "100%",
                              backgroundColor: "",
                              display: "flex",
                              justifyContent: "",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={assets.assets.instantrupee}
                              style={{ width: "20px", height: "20px" }}
                            ></img>
                            <span
                              className="EarnSectionBonusText"
                              style={{
                                fontSize: "0.8rem",
                                fontWeight: "700",
                                marginLeft: "5px",
                              }}
                            >
                              Locked Bonus
                            </span>
                          </div>

                          <div
                            style={{
                              width: "40%",
                              height: "100%",
                              backgroundColor: "",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "flex-end",
                            }}
                          >
                            <span id="lockedBonusAmount"
                              className='amountData'
                              style={{
                                fontSize: "1.2rem",
                                fontWeight: "700",
                                marginLeft: "5px",
                              }}
                            >
                              {RUPEE_SYMBOL}
                              <span>{Number(lockedBonus).toFixed(2)}</span>
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>

              {/* Button Div */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "",
                  position: "absolute",
                  bottom: "5px",
                  gap: "10px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  // className="ph5 pv3 nowrap"
                  id="ContinueCTA_redeempage"
                  className='redeemCTAButtonGreen'
                  style={{
                    width: "85%",
                    height: "35px",
                    // background: (basicRedeemSelected || smartRedeemSelected ) ? "linear-gradient(180deg, #35A753 0%, #276E3A 100%)":"linear-gradient(180deg, grey 0%, grey 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "4px",
                    fontWeight: "700",
                    fontSize: "0.9rem",
                    marginBottom: "5px",
                    // position: "absolute",
                    // bottom: "5px",
                  }}
                  onClick={() => {
                    // alert();
                    console.log(
                      "Smart redeem percent value",
                      smartRedeemPercentConfig[mostSelected]
                    );
                    //                 if(!basicRedeemSelected || !smartRedeemSelected){
                    // return
                    //                 }
                    // WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_viewgamepassClick_redeem", eventProperties: { button_clicked: " Continue to Redeem", username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime() } })
                    setButtonText("RedeemWithBonus");
                    // setToShowGamePassOverLay(false);
                    // setShowSmartRedeem(false);
                    if (transferLayoutFlag) {
                      const actionType = playBalanceAmt > 0 ? "Smart Withdraw" : "Basic Withdraw";
                      if (playBalanceAmt > 0) {
                        setShowSmartRedeemPopup(true);
                        eventTrigger('redeemCTEvent', actionType);
                        eventTrigger('plotLineEvent', actionType);
                        eventTrigger('mixpanelEvent', actionType);


                      } else {

                        if (!smartRedeemNewUIFlag && smartRedeemEnabled && isoemps) {
                          setShowSmartRedeem(false);
                          setShowSmartRedeemPopup(false);
                          onContinueClick("RedeemWithoutBonus");
                          eventTrigger('redeemCTEvent', actionType);
                          eventTrigger('plotLineEvent', actionType);
                          eventTrigger('mixpanelEvent', actionType);
                        } else {

                          // console.log(" showBonusMissOutPopup >>>>",showBonusMissOutPopup);
                          let evtProperties = {
                            SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2],//smartRedeemPercentConfig[ smartRedeemAmountArray.indexOf(selectedSliderValue) ],
                            TotalBonusPercentage:
                              bonusConfig?.levelDetails[0]?.bonusPercent,
                            InstantBonusPercentage:
                              bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                            LockedBonusPercentage:
                              bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                            Redeem_Amount: amountEntered,
                            AmountToBank: amountEntered - (calculateSmartTDS(amountEntered) > 0 ? calculateSmartTDS(amountEntered) : 0),
                            // Redeem_Amount: amountEntered - (calculateSmartTDS(amountEntered) >0 ? calculateSmartTDS(amountEntered) : 0),
                            MostSelectedAmount:
                              smartRedeemPercentConfig[mostSelected],
                            // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                            // BonusAmount: totalBonus,
                            BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                            AmountToWallet: 0,
                            //               AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                            // AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                            TDSAmount:
                              calculateSmartTDS(amountEntered) >
                                0
                                ? calculateSmartTDS(
                                  amountEntered
                                )
                                : 0,
                            Redeem_type_selected: standardSelected
                              ? "Standard"
                              : instantSelected
                                ? "Instant"
                                : "Others",
                            Redeem_mode: activeRedeemMethod.type,
                            subscription_type:
                              window.sessionStorage["subscriptionType"],
                            username: profileData.screenName,
                            channel: window.sessionStorage["channel"],
                            aceLevel: profileData.currentAceLevelName,
                            timestamp: new Date().getTime(),
                            smartUI: smartRedeemNewUIFlag ? "New" : "Old"
                          }

                          //Smartredeem_Bonuspopup_clicked
                          WebToNativeMessage({
                            type: "redeemCTEvent", eventName: "Smartredeem_Bonuspopup_viewed", eventProperties: evtProperties
                          })
                          WebToNativeMessage({
                            type: "plotLineEvent", eventName: "Smartredeem_Bonuspopup_viewed", eventProperties: evtProperties
                          })
                          WebToNativeMessage({
                            type: "mixpanelEvent", eventName: "Smartredeem_Bonuspopup_viewed", eventProperties: evtProperties
                          })

                          setShowBonusMissOutPopup(true);
                          // if(!showBonusMissOutPopup){
                          // setShowBonusMissOutPopup(true);
                          // }

                          // alert();
                          eventTrigger('redeemCTEvent', actionType);
                          eventTrigger('plotLineEvent', actionType);
                          eventTrigger('mixpanelEvent', actionType);


                        }



                        // Come here to check
                        // setShowSmartRedeem(false);
                        // setShowSmartRedeemPopup(false);
                        // onContinueClick("RedeemWithoutBonus");
                        // eventTrigger('redeemCTEvent', actionType);

                      }
                    } else {
                      console.log("dghghghghghghghgg nee");
                      setShowSmartRedeem(false);
                      setShowSmartRedeemPopup(false)
                      onContinueClick("RedeemWithBonus");
                    }

                    // onContinueClick("RedeemWithBonus");
                  }}
                >
                  {/* Continue to Redeem */}
                  {amountEntered - selectedSliderValue > 0
                    ? "Withdraw"
                    : "Transfer"}
                </div>

                <div
                  // className="ph5 pv3 nowrap"
                  id="ContinueCTA_redeempage"
                  className='redeemCTAButtonWhite'
                  style={{
                    width: "85%",
                    height: "35px",
                    // background: (basicRedeemSelected || smartRedeemSelected ) ? "linear-gradient(180deg, #35A753 0%, #276E3A 100%)":"linear-gradient(180deg, grey 0%, grey 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "4px",
                    fontWeight: "700",
                    fontSize: "0.9rem",
                  }}
                  onClick={() => {
                    //                 if(!basicRedeemSelected || !smartRedeemSelected){
                    // return
                    //                 }

                    // setButtonText("RedeemWithoutBonus")
                    // setToShowGamePassOverLay(false);
                    setShowSmartRedeem(false);
                    setShowSmartRedeemPopup(false);
                    onContinueClick("RedeemWithoutBonus");
                    const actionType = playBalanceAmt > 0 ? "Smart Withdraw" : "Basic Withdraw";
                    eventTrigger('redeemCTEvent', actionType);
                    eventTrigger('mixpanelEvent', actionType);

                  }}
                >
                  {/* Continue to Redeem */}
                  Withdraw without bonus
                </div>

                <div
                  style={{
                    width: "90%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    marginBottom: "5px",
                  }}
                >
                  <span style={{ color: "#707070", fontSize: "10px" }}>
                    *Amount transferred to A23 Wallet is used for playing cash
                    games. This amount cannot be moved back & is not withdrawable.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );




    return gamePassOverLay;
  }

  const createNewSmartRedeemConfirmPopup = () => {
    // let redeemableAmt = showRedeemStatusData.tdsAmount !== undefined ? showRedeemStatusData.winningBucket + showRedeemStatusData.tdsAmount : showRedeemStatusData.winningBucket
    let status =
      <div id="newModel3" style={{ position: "absolute", top: "0px", left: "0px", backgroundColor: "rgba(0,0,0,0.4)", width: "100%", height: "100%", zIndex: "9999", display: "flex", justifyContent: "center", alignItems: "flex-end" }}>
        <div id="tileContainersActionPopup" style={{ position: 'absoute', ...(isTablet ? { width: "50%", left: "25%" } : { width: "100%" }), display: 'flex', flexDirection: "column", alignItems: 'center', justifyContent: 'center', background: "#f9f9f9", borderRadius: '5px', boxShadow: '0px 0px 4px 0px #00000040', zIndex: "15" }}>
          <div style={{ display: "flex", alignItems: "center", position: "", top: "0", justifyContent: "center", color: "#FFFFFF", fontWeight: "700", background: "#2C5391", width: "100%", height: "50px", borderRadius: "4px 4px 0px 0px", marginBottom: "10px" }}>
            {/* Redeem Cancellation */}
            {/* Miss out on bonus? */}
            Withdraw the amount ?
            <img src={assets?.assets?.Cross} alt='close' style={{ position: 'absolute', right: '3%' }} onClick={() => {
              let evtProperties = {
                SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2],//smartRedeemPercentConfig[ smartRedeemAmountArray.indexOf(selectedSliderValue) ],
                TotalBonusPercentage:
                  bonusConfig?.levelDetails[0]?.bonusPercent,
                InstantBonusPercentage:
                  bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                LockedBonusPercentage:
                  bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                Redeem_Amount: amountEntered,
                AmountToBank: amountEntered - (calculateSmartTDS(amountEntered) > 0 ? calculateSmartTDS(amountEntered) : 0),
                // Redeem_Amount: amountEntered - (calculateSmartTDS(amountEntered) >0 ? calculateSmartTDS(amountEntered) : 0),
                MostSelectedAmount:
                  smartRedeemPercentConfig[mostSelected],
                // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                // BonusAmount: totalBonus,
                BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                AmountToWallet: 0,
                //               AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                // AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                TDSAmount:
                  calculateSmartTDS(amountEntered) >
                    0
                    ? calculateSmartTDS(
                      amountEntered
                    )
                    : 0,
                Redeem_type_selected: standardSelected
                  ? "Standard"
                  : instantSelected
                    ? "Instant"
                    : "Others",
                Redeem_mode: activeRedeemMethod.type,
                subscription_type:
                  window.sessionStorage["subscriptionType"],
                username: profileData.screenName,
                channel: window.sessionStorage["channel"],
                aceLevel: profileData.currentAceLevelName,
                timestamp: new Date().getTime(),
                smartUI: smartRedeemNewUIFlag ? "New" : "Old",
                Buttonclicked: "Close"

              }

              //Smartredeem_Bonuspopup_clicked
              WebToNativeMessage({
                type: "redeemCTEvent", eventName: "Smartredeem_Bonuspopup_clicked", eventProperties: evtProperties
              })
              WebToNativeMessage({
                type: "plotLineEvent", eventName: "Smartredeem_Bonuspopup_clicked", eventProperties: evtProperties
              })
              WebToNativeMessage({
                type: "mixpanelEvent", eventName: "Smartredeem_Bonuspopup_clicked", eventProperties: evtProperties
              })
              setShowBonusMissOutPopup(false)
            }} />
          </div>

          {/* <div style={{ width: "95%", backgroundColor: "", display: "flex", justifyContent: "space-between", alignItems: "center", border: "2px solid  rgba(58, 76, 113, 0.25)", borderRadius: "8px", paddingLeft: "10px", paddingRight: "10px", paddingTop: "15px", paddingBottom: "15px" }}>
        <span style={{ color: "#032146", fontSize: "16px", fontWeight: "600" }}>Credited to winnings</span>

        <span style={{ color: "#032146", fontSize: "20px", fontWeight: "bold" }}>  {RUPEE_SYMBOL}</span>
      </div> */}


          {selectedRedeemMethod !== undefined && redeemDetails.allRedeemOptions?.length > 0 ?
            <div id="redeemActDiv" style={{ width: "90%", paddingTop: "15px", paddingBottom: "15px", display: "flex", backgroundColor: "", border: "1px solid rgba(58,76,113,0.25)", borderRadius: "5px" }}>
              <div style={{ width: "100%", marginLeft: "4%", height: "100%", display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: "" }}>
                <div style={{ display: 'flex', width: '80%', height: "50%", color: "#032146", fontWeight: "700", fontSize: "0.85rem", alignItems: 'center' }}>
                  <img src={activeRedeemMethod.type === 'upi' ? upiIcon : activeRedeemMethod.type === 'amazonPay' ? amazonPayIcon : activeRedeemMethod.type === 'bankAccount' ? assets?.assets?.bankIcon : activeRedeemMethod.type === 'paytmWallet' ? paytmIcon : ''} />
                  <div style={{ display: 'flex', flexDirection: "column" }}>
                    <div style={{ fontWeight: "700" }}><span style={{ marginRight: "5px", fontWeight: "700" }}>To</span>{activeRedeemMethod.type === 'bankAccount' ? activeRedeemMethod.bankName : activeRedeemMethod.type === 'upi' ? activeRedeemMethod.upi : `${activeRedeemMethod.name + ' ' + 'xxxxxx' + activeRedeemMethod.id.slice(6)}`}</div>
                    {activeRedeemMethod.type === 'bankAccount' && <div style={{ fontWeight: "700" }}> <span style={{ marginRight: "5px", fontWeight: "700" }}>To</span>{'x'.repeat(activeRedeemMethod.accountNumber.length - 4) + activeRedeemMethod.accountNumber.slice(activeRedeemMethod.accountNumber.length - 4)}</div>}
                  </div>
                  {(activeRedeemMethod?.bankStatus === 'processing' || activeRedeemMethod?.upiState === 'processing') &&
                    <div className='nowrap' style={{ width: '30%', height: '50%', marginLeft: '2%', display: 'flex', fontSize: '0.55rem', alignItems: "center", justifyContent: "center", color: '#CD7F32', fontWeight: '700', borderRadius: '24px', background: '#FFB30033' }}>
                      <span style={{ width: '95%', height: '100%', display: "flex", alignItems: 'center', justifyContent: "center" }}>Validation Pending</span>
                    </div>}
                </div>

              </div>
              {/* {console.log("chee nee brathuku >>>", amountEntered, selectedSliderValue)} */}
              <div style={{ width: "100%", backgroundColor: "", display: "flex", alignItems: "center", justifyContent: "flex-end" }}>

                {
                  // (Number(amountEntered) - Number(selectedSliderValue)) <= 0 ? 0 :
                  <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-end", backgroundColor: "", marginRight: "8%" }}>
                    <span style={{ color: "#080D1A", fontSize: "1.2rem", fontWeight: "700", marginLeft: "5px", fontFamily: "Conto" }}>
                      {RUPEE_SYMBOL}<span>{(Number(amountEntered) - (calculateSmartTDS(amountEntered) > 0 ? calculateSmartTDS(amountEntered) : 0))}</span>
                    </span>

                    {calculateSmartTDS(amountEntered) > 0 ? <div style={{ width: "100%", padding: "5px", background: "#C6282826", display: "flex", justifyContent: "center", alignItems: "center" }}>
                      <span style={{ color: "#C62828", fontSize: "12px", fontWeight: "900" }}>
                        <span>{RUPEE_SYMBOL}</span> {calculateSmartTDS(amountEntered)} TDS is deducted
                      </span>
                    </div> : ""}

                  </div>}
              </div>
            </div>

            :
            <div style={{ width: "92%", height: "65%", display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: "0.9rem", fontWeight: '500', color: "#9C9D9F" }}>No Withdrawable Account available</div>
          }

          {smartRedeemNewUIFlag ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center", background: "#C6282826", borderRadius: "10px", padding: "10px", marginTop: "4%" }}>
            <img src={RedAlertIcon} style={{ width: "14px", height: "14px", marginRight: "5px", }}></img>
            <span style={{ fontSize: "16px", color: "#032146" }}>you are missing out on <span style={{ fontSize: "16px", fontWeight: "700", fontFamily: "Conto", color: "#032146" }}>{RUPEE_SYMBOL}{formatNumber(newSmartRedeemValueArr[2])}</span> </span>
          </div>
            :
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", background: "#C6282826", borderRadius: "10px", padding: "10px", marginTop: "4%" }}>
              <img src={RedAlertIcon} style={{ width: "14px", height: "14px", marginRight: "5px", }}></img>
              <span style={{ fontSize: "16px", color: "#032146" }}>you are missing out on <span style={{ fontSize: "16px", fontWeight: "700", fontFamily: "Conto", color: "#032146" }}> {RUPEE_SYMBOL}{calBonus(Number(amountEntered).toFixed(2))} </span></span>
            </div>

          }

          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingTop: "15px" }}>
            <img src={UnionIcon} style={{ width: "16px", height: "16px", marginRight: "5px", }}></img>
            <span style={{ fontSize: "14px", color: "#032146" }}>{smartRedeemOnlineCountMessage}</span>
          </div>

          <div id="btnContainer" style={{ width: "95%", height: "120px", backgroundColor: "", display: "flex", flexDirection: "column", justifyContent: "center", marginTop: "10px", marginBottom: "10px" }}>
            <div style={{ width: "100%", height: "35%", border: "1px solid #196A29", background: '#ffffff', color: '#196A29', display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold", borderRadius: "5px", marginBottom: "10px" }} onClick={() => {
              let evtProperties = {
                SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2],//smartRedeemPercentConfig[ smartRedeemAmountArray.indexOf(selectedSliderValue) ],
                TotalBonusPercentage:
                  bonusConfig?.levelDetails[0]?.bonusPercent,
                InstantBonusPercentage:
                  bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                LockedBonusPercentage:
                  bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                Redeem_Amount: amountEntered,
                AmountToBank: amountEntered - (calculateSmartTDS(amountEntered) > 0 ? calculateSmartTDS(amountEntered) : 0),
                // Redeem_Amount: amountEntered - (calculateSmartTDS(amountEntered) >0 ? calculateSmartTDS(amountEntered) : 0),
                MostSelectedAmount:
                  smartRedeemPercentConfig[mostSelected],
                // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                // BonusAmount: totalBonus,
                BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                AmountToWallet: 0,
                //               AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                // AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                TDSAmount:
                  calculateSmartTDS(amountEntered) >
                    0
                    ? calculateSmartTDS(
                      amountEntered
                    )
                    : 0,
                Redeem_type_selected: standardSelected
                  ? "Standard"
                  : instantSelected
                    ? "Instant"
                    : "Others",
                Redeem_mode: activeRedeemMethod.type,
                subscription_type:
                  window.sessionStorage["subscriptionType"],
                username: profileData.screenName,
                channel: window.sessionStorage["channel"],
                aceLevel: profileData.currentAceLevelName,
                timestamp: new Date().getTime(),
                smartUI: smartRedeemNewUIFlag ? "New" : "Old",
                Buttonclicked: "Go Back"

              }

              //Smartredeem_Bonuspopup_clicked
              WebToNativeMessage({
                type: "redeemCTEvent", eventName: "Smartredeem_Bonuspopup_clicked", eventProperties: evtProperties
              })
              WebToNativeMessage({
                type: "plotLineEvent", eventName: "Smartredeem_Bonuspopup_clicked", eventProperties: evtProperties
              })
              WebToNativeMessage({
                type: "mixpanelEvent", eventName: "Smartredeem_Bonuspopup_clicked", eventProperties: evtProperties
              })
              setShowBonusMissOutPopup(false);

            }}>
              Go Back
            </div>

            <div style={{ width: "100%", height: "35%", background: 'linear-gradient(180deg, #42BE40 0%, #196A29 100%)', color: '#FFFFFF', display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "bold", borderRadius: "5px" }} onClick={() => {


              if (redeemGamePassData?.length > 0 || activeMissionsData?.activeMission?.length > 0 || challengesData?.length > 0
                || expiredLockedBonusData !== undefined) {
                setToShowGamePassOverLay(true);
                setShowBonusMissOutPopup(false);
                if (redeemGamePassData?.length > 0) {
                  { console.log(">>>>>> >>> <<<<<< <<<<<<", paidInstantRedeemProcessingFee) }
                  WebToNativeMessage({
                    type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_clickRedeem",
                    eventProperties:
                    {
                      Redeem_mode: (activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? "wallet" : activeRedeemMethod.type === 'bankAccount' ? "bank account" : activeRedeemMethod.type === 'upi' ? "upi" : "",

                      username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered === '' ? "NA" : amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], tds_deducted: tdsInfo.tds === -1 ? "NA" : tdsInfo.tds, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", paidProcessingFee: paidInstantRedeemProcessingFee, redeem_expiry_type: "Yes", timestamp: new Date().getTime(), TDSCashbackAmount: (Number(tdsCashbackAmount) > Number(tdsMaxCapAmount)) ? tdsMaxCapAmount : tdsCashbackAmount,
                    }
                  })
                  // WebToNativeMessage({
                  //   type: "plotLineEvent", eventName: "PF_c_RedeemPlacement_clickRedeem",
                  //   eventProperties:
                  //   {
                  //     Redeem_mode: (activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? "wallet" : activeRedeemMethod.type === 'bankAccount' ? "bank account" : activeRedeemMethod.type === 'upi' ? "upi" : "",

                  //     username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered === '' ? "NA" : amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], tds_deducted: tdsInfo.tds === -1 ? "NA" : tdsInfo.tds, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", paidProcessingFee: paidInstantRedeemProcessingFee, redeem_expiry_type: "Yes", timestamp: new Date().getTime()
                  //   }
                  // })
                  WebToNativeMessage({
                    type: "mixpanelEvent", eventName: "PF_c_RedeemPlacement_clickRedeem",
                    eventProperties:
                    {
                      Redeem_mode: (activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? "wallet" : activeRedeemMethod.type === 'bankAccount' ? "bank account" : activeRedeemMethod.type === 'upi' ? "upi" : "",

                      username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered === '' ? "NA" : amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], tds_deducted: tdsInfo.tds === -1 ? "NA" : tdsInfo.tds, Redeemable_amount: redeemDetails.redeemableAmount, Redeem_type_selected: standardSelected ? "standard" : instantSelected ? "instant" : paidInstantSelected ? "paidInstant" : "nan", paidProcessingFee: paidInstantRedeemProcessingFee, redeem_expiry_type: "Yes", timestamp: new Date().getTime(), TDSCashbackAmount: (Number(tdsCashbackAmount) > Number(tdsMaxCapAmount)) ? tdsMaxCapAmount : tdsCashbackAmount,
                    }
                  })
                  // WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_clickRedeem", eventProperties: {redeem_expiry_type:"Yes",timestamp:new Date().getTime() }})
                  WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_viewgamepass_redeem", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime() } })
                  WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_viewgamepass_redeem", eventProperties: { username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime() } })
                }


              } else {
                setShowSmartRedeem(false);
                setShowSmartRedeemPopup(false);
                setShowBonusMissOutPopup(false);

                onContinueClick("RedeemWithoutBonus");
                eventTrigger('redeemCTEvent', "Basic Redeem");


                let evtProperties = {
                  SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2],//smartRedeemPercentConfig[ smartRedeemAmountArray.indexOf(selectedSliderValue) ],
                  TotalBonusPercentage:
                    bonusConfig?.levelDetails[0]?.bonusPercent,
                  InstantBonusPercentage:
                    bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                  LockedBonusPercentage:
                    bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                  Redeem_Amount: amountEntered,
                  AmountToBank: amountEntered - (calculateSmartTDS(amountEntered) > 0 ? calculateSmartTDS(amountEntered) : 0),
                  MostSelectedAmount:
                    smartRedeemPercentConfig[mostSelected],
                  // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                  // BonusAmount: totalBonus,
                  BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                  AmountToWallet: 0,
                  //               AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                  // AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                  TDSAmount:
                    calculateSmartTDS(amountEntered) >
                      0
                      ? calculateSmartTDS(
                        amountEntered
                      )
                      : 0,
                  Redeem_type_selected: standardSelected
                    ? "Standard"
                    : instantSelected
                      ? "Instant"
                      : "Others",
                  Redeem_mode: activeRedeemMethod.type,
                  subscription_type:
                    window.sessionStorage["subscriptionType"],
                  username: profileData.screenName,
                  channel: window.sessionStorage["channel"],
                  aceLevel: profileData.currentAceLevelName,
                  timestamp: new Date().getTime(),
                  smartUI: smartRedeemNewUIFlag ? "New" : "Old",
                  Buttonclicked: " Proceed Without Bonus"

                }

                //Smartredeem_Bonuspopup_clicked
                WebToNativeMessage({
                  type: "redeemCTEvent", eventName: "Smartredeem_Bonuspopup_clicked", eventProperties: evtProperties
                })
                WebToNativeMessage({
                  type: "plotLineEvent", eventName: "Smartredeem_Bonuspopup_clicked", eventProperties: evtProperties
                })
                WebToNativeMessage({
                  type: "mixpanelEvent", eventName: "Smartredeem_Bonuspopup_clicked", eventProperties: evtProperties
                })
              }




            }}>
              Proceed Without Bonus
            </div>

          </div>

        </div>
      </div>


    return status
  }

  const createNewSmartRedeemOverlay = () => {
    // { console.log("Smart redeem amt array 1", smartRedeemPercentConfig) }
    // { console.log("Smart redeem amt array", smartRedeemAmountArray) }
    // { console.log("dabididibidey 1 ertrthrtyrty fghtyyuiuykuyi", newSmartRedeemValueArr) }
    // { console.log("Smart redeem amt array3", mostSelected) }
    let gamePassOverLay = (
      <div id="smtCont" style={{ width: "100%", backgroundColor: "", overflow: "hidden" }}>
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            display: "flex",
            background: "var(--Color-Greys-Black, #000000)",
            bottom: "0px",
            zIndex: "4",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <div
            className="overLayAnimation"
            style={{
              width: "100%",
              height: "100%",
              position: "absolute",
              backgroundColor: "#f9f9f9",
              zIndex: "5",
              borderTopLeftRadius: "15px",
              borderTopRightRadius: "15px",
              maxWidth: "600px",
            }}
          >
            <div
              style={{
                width: "15%",
                height: "25%",
                maxHeight: "50px",
                backgroundColor: "",
                position: "absolute",
                display: "flex",
                zIndex: "55",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                id="Close_gamepasspopup_redeempage"
                src={assets?.assets?.navarrow}
                style={{ width: "30px", height: "30px", zIndex: "55" }}
                onClick={() => {
                  // totalBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.bonusPercent) / 100) * (parseInt(amountArray[selectedIndex])), parseInt(bonusConfig.maxBonus));
                  // totalInstantBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.instantBonusPercentage) / 100) * totalBonus, parseInt(bonusConfig.maxInstantBonus));
                  // totalLockedBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.lockedBonusPercentage) / 100) * totalBonus, parseInt(bonusConfig.maxLockedBonusAmount));

                  setShowSmartRedeem(false);
                  setShowSmartRedeemPopup(false)
                  setSmartRedeemAmountArray([]);
                  setSmartRedeemValueArr([]);
                  setInstantBonusArr([]);
                  setLockedBonusArr([]);
                  WebToNativeMessage({
                    type: "redeemCTEvent",
                    eventName: "PF_c_smartredeem_backclick",
                    eventProperties: {
                      SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2],//smartRedeemPercentConfig[ smartRedeemAmountArray.indexOf(selectedSliderValue) ],
                      TotalBonusPercentage:
                        bonusConfig?.levelDetails[0]?.bonusPercent,
                      InstantBonusPercentage:
                        bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                      LockedBonusPercentage:
                        bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                      Redeem_Amount: amountEntered,
                      MostSelectedAmount:
                        smartRedeemPercentConfig[mostSelected],
                      // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                      // BonusAmount: totalBonus,
                      BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                      AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                      AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                      TDSAmount:
                        calculateSmartTDS(amountEntered - selectedSliderValue) >
                          0
                          ? calculateSmartTDS(
                            amountEntered - selectedSliderValue
                          )
                          : 0,
                      Redeem_type_selected: standardSelected
                        ? "Standard"
                        : instantSelected
                          ? "Instant"
                          : "Others",
                      Redeem_mode: activeRedeemMethod.type,
                      subscription_type:
                        window.sessionStorage["subscriptionType"],
                      username: profileData.screenName,
                      channel: window.sessionStorage["channel"],
                      aceLevel: profileData.currentAceLevelName,
                      timestamp: new Date().getTime(),
                      smartUI: smartRedeemNewUIFlag ? "New" : "Old"
                    },
                  });

                  WebToNativeMessage({
                    type: "plotLineEvent",
                    eventName: "PF_c_smartredeem_backclick",
                    eventProperties: {
                      SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2],//smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)],
                      TotalBonusPercentage:
                        bonusConfig?.levelDetails[0]?.bonusPercent,
                      InstantBonusPercentage:
                        bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                      LockedBonusPercentage:
                        bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                      Redeem_Amount: amountEntered,
                      MostSelectedAmount:
                        smartRedeemPercentConfig[mostSelected],
                      // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                      // BonusAmount: totalBonus,
                      BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                      AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                      AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                      TDSAmount:
                        calculateSmartTDS(amountEntered - selectedSliderValue) >
                          0
                          ? calculateSmartTDS(
                            amountEntered - selectedSliderValue
                          )
                          : 0,
                      Redeem_type_selected: standardSelected
                        ? "Standard"
                        : instantSelected
                          ? "Instant"
                          : "Others",
                      Redeem_mode: activeRedeemMethod.type,
                      subscription_type:
                        window.sessionStorage["subscriptionType"],
                      username: profileData.screenName,
                      channel: window.sessionStorage["channel"],
                      aceLevel: profileData.currentAceLevelName,
                      timestamp: new Date().getTime(),
                      smartUI: smartRedeemNewUIFlag ? "New" : "Old"
                    },
                  });
                }}
              />
            </div>

            <div
              id="header"
              style={{
                width: "100%",
                height: "25%",
                maxHeight: "50px",
                fontWeight: "700",
                backgroundColor: "#2C5391",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
                PointerEvent: "none",
              }}
              onClick={() => { }}
            >
              {/* <span style={{ fontSize: "18px", color: "#fafafa" }}>Smart Redeem</span> */}
              <span style={{ fontSize: "18px", color: "#fafafa" }}>Wallet Booster</span>
              <span
                style={{
                  fontSize: "18px",
                  zIndex: "55",
                  height: "25%",
                  color: "#fafafa",
                  width: "15%",
                  maxHeight: "50px",
                  position: "absolute",
                  right: "0",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => {
                  WebToNativeMessage({ type: "smartRedeemPolicy" });
                  eventTrigger('redeemCTEvent', "FAQ");
                  eventTrigger('plotLineEvent', "FAQ");
                }}
              >
                <img src={faqsIcon}></img>
              </span>
            </div>
            {/* Main Cont */}
            <div
              style={{
                width: "100%",
                height: "100%",
                backgroundColor: "",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }} >
              {/* banner cont */}
              <div
                style={{
                  width: "100%",
                  // height: "18%",
                  height: "18%",
                  // height: "135px",
                  backgroundImage: "url(" + assets?.assets?.smartRedeemBanner + ")",
                  // background: "var(--Color-Greys-Black, #000000)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  marginBottom: "5px"

                }}
                onClick={() => {
                  if (!isPlaying) {
                    setIsPlaying(true);
                  }
                  eventTrigger('redeemCTEvent', "Video");
                  eventTrigger('plotLineEvent', "Video");
                }}
              >

                {/* <img
                  src={smartRedeemBanner} 
                  style={{width:"100%",height:"100%"}}
                  onClick={() => {

                    setIsPlaying(true);
                    eventTrigger('redeemCTEvent', "Video");
                    eventTrigger('plotLineEvent', "Video");
                  }}
                ></img> */}
                <FullscreenVideoPlayer
                  isPlaying={isPlaying}
                  closeVideoScreen={closeVideoScreen}
                  // setIsPlaying={setIsPlaying}
                  videoRef={videoRef}
                  videoUrl={!smartRedeemNewUIFlag ? process.env.REACT_APP_SMART_REDEEM_VIDEO_URL : process.env.REACT_APP_SMART_REDEEM_VIDEO_NEW_URL} // Replace with your video URL
                // videoUrl="https://www.youtube.com/embed/sN9o7kMN1_8"
                />

              </div>
              {/* banner cont end */}

              <div id="reqAmtDiv" style={{ marginTop: "10px", width: "100%", paddingTop: "10px", paddingBottom: "10px", backgroundColor: "rgba(52, 99, 175, 0.2)", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <span style={{ fontSize: "16px", color: "#032146", fontWeight: "600" }}>
                  Withdraw Amount  :  <span style={{ fontSize: "17px", color: "#032146", fontWeight: "bold" }}>{RUPEE_SYMBOL}{amountEntered}</span>
                </span>
              </div>


              {/* Selection Container */}

              <div id="selectionContainer" style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "94%", backgroundColor: "", marginTop: "2%" }}>

                <div id="basic" ref={basicRef} style={{
                  border: basicSelected ? "1px solid rgba(52, 99, 175, 0.4)" : "1px solid rgba(52, 99, 175, 0.2)",
                  borderRadius: "8px", display: "flex", justifyContent: "", alignItems: "", width: "33%", height: basicSelected ? "90%" : "75%", margin: "4px", flexDirection: "column", backgroundColor: basicSelected ? "rgba(179,201,238,0.1)" : ""//"rgba(52, 99, 175, 0.1)"
                }} onClick={() => {
                  setSaverSelected(false);
                  setBasicSelected(true);
                  setUSaverSelected(false);

                  setToolTipTimer(clearInterval(toolTipTimer));
                  setShowToolTip(false);
                  setPlayBalanceAmt(smartRedeemAmountArray[0]);
                  calBonus(smartRedeemAmountArray[0]);
                  setBonus(smartRedeemAmountArray[0]);



                }}>

                  <div id="basicHeader" style={{
                    background: "rgba(52, 99, 175, 0.2)", width: "100%", height: "30%", paddingTop: "10px", paddingBottom: "10px", display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px"
                  }}>
                    {/* <span style={{ color: "#032146", fontSize: "14px", fontWeight: "700", fontFamily: "Conto" }}>No Bonus</span> */}
                    <span style={{ color: "#032146", fontSize: "14px", fontWeight: "700", fontFamily: "Conto" }}>Basic</span>
                    {/* BASIC */}
                  </div>

                  <div id='txtCont' style={{ width: "100%", height: "70%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", paddingTop: "5px", paddingBottom: "5px" }}>
                    <span style={{ color: "#032146", fontSize: "14px", fontWeight: "600", marginTop: "10px", marginBottom: "5px", fontFamily: "Conto" }}>Get</span>

                    <span style={{ color: "#032146", fontSize: "26px", fontWeight: "900", textAlign: "center", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", marginTop: "5px", marginBottom: "5px", fontFamily: "Conto" }}>{RUPEE_SYMBOL}{Math.floor((Number(amountEntered) + Number(newSmartRedeemValueArr[0])) - ((calculateSmartTDS(amountEntered - smartRedeemAmountArray[0]) > 0 ? calculateSmartTDS(amountEntered - smartRedeemAmountArray[0]) : 0)))}</span>
                  </div>
                  {/* Conditionallly rendering */}
                  {/* {basicSelected && <div id="noBonusBottom" style={{
                    background: "rgba(52, 99, 175, 0.2)", width: "100%", height: "25%", paddingTop: "5px", paddingBottom: "5px", display: "flex", justifyContent: "center", alignItems: "center", borderBottomRightRadius: "8px",
                    borderBottomLeftRadius: "8px"
                  }}>
                    <span style={{ color: "#032146", fontSize: "12px", fontWeight: "600" }}>NO BONUS</span>
                  </div>} */}

                  {/* <div id="arrowContainer" style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                <img src={BasicPointer}></img>
                </div> */}

                </div>

                {/* Saver */}
                {console.log("offset height", saverRef)}

                <div id="saver" ref={saverRef} style={{
                  border: saverSelected ? "1px solid #E39E14" : "1px solid rgba(52, 99, 175, 0.2)", backgroundColor: saverSelected ? "rgba(227,158,20,0.2)" : "",
                  borderRadius: "8px", display: "flex", justifyContent: "", alignItems: "", width: "33%", height: saverSelected ? "90%" : "75%", margin: "4px", flexDirection: "column"
                }} onClick={() => {
                  setSaverSelected(true);
                  setBasicSelected(false);
                  setUSaverSelected(false);
                  setToolTipTimer(clearInterval(toolTipTimer));
                  setShowToolTip(false);
                  setPlayBalanceAmt(smartRedeemAmountArray[1]);
                  calBonus(smartRedeemAmountArray[1]);
                  setBonus(smartRedeemAmountArray[1]);

                }}>

                  <div id="saverHeader" style={{
                    background: "linear-gradient(93.83deg, #EDBC5A 1.45%, #E39E14 100.59%)", width: "100%", height: "30%", paddingTop: "10px", paddingBottom: "10px", display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px"
                  }}>
                    {/* <span style={{ color: "#032146", fontSize: "14px", fontWeight: "700", fontFamily: "Conto" }}>Popular</span> */}
                    <span style={{ color: "#032146", fontSize: "14px", fontWeight: "700", fontFamily: "Conto" }}>Booster</span>
                    {/* SAVER */}
                  </div>

                  <div id='txtCont1' style={{ width: "100%", height: "70%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", paddingTop: "5px", paddingBottom: "5px" }}>
                    <span style={{ color: "#032146", fontSize: "14px", fontWeight: "600", marginTop: "10px", marginBottom: "5px", fontFamily: "Conto" }}>Get</span>

                    <span style={{ color: "#032146", fontSize: "26px", fontWeight: "900", textAlign: "center", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", marginTop: "5px", marginBottom: "5px", fontFamily: "Conto" }}>{RUPEE_SYMBOL}{Math.floor((Number(amountEntered) + Number(newSmartRedeemValueArr[1])) - (calculateSmartTDS(amountEntered - smartRedeemAmountArray[1]) > 0 ? calculateSmartTDS(amountEntered - smartRedeemAmountArray[1]) : 0))}</span>
                  </div>
                  {console.log("calculateSmartTDS(amountEntered - smartRedeemAmountArray[1]) > 0", calculateSmartTDS(amountEntered - smartRedeemAmountArray[2]))}
                  {/* {(tdsInfo.tds > 0 && Number(redeemDetails.tdsFreeAmount) > 0 )   && <div style={{width:"100%",position:"",height:"25px",display:"flex",justifyContent:"center",alignItems:"center" ,marginTop:saverSelected ? "8%" :"-8%"}}> <img src={NoTds} style={{position:"",width:"50px",height:"20px"}}></img> </div>} */}
                  {(tdsInfo.tds > 0 && Number(redeemDetails.tdsFreeAmount) > 0 && calculateSmartTDS(amountEntered - smartRedeemAmountArray[1]) <= 0) && <div style={{ width: "100%", position: "", height: "25%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: saverSelected ? "8%" : "-8%" }}> <img src={NoTds} style={{ position: "", width: "50%", height: "90%" }}></img> </div>}
                  {/* Conditionally render */}

                  {/* {saverSelected && <div id="saverBottom" style={{
                    background: "linear-gradient(93.83deg, rgba(237, 188, 90, 0.3) 1.45%, rgba(227, 158, 20, 0.3) 100.59%)"
                    , width: "100%", height: "25%", paddingTop: "5px", paddingBottom: "5px", display: "flex", justifyContent: "center", alignItems: "center", borderBottomRightRadius: "8px",
                    borderBottomLeftRadius: "8px"
                  }}>
                    <span style={{ color: "#032146", fontSize: "12px", fontWeight: "600" }}>MOST SELECTED</span>
                  </div>} */}

                </div>

                {/* Ultra saver */}

                {console.log("offset height", usRef)}

                <div id="ultraSaver" ref={usRef} style={{
                  border: uSaverSelected ? "1px solid #032146" : "1px solid rgba(52, 99, 175, 0.2)",
                  borderRadius: "8px", display: "flex", justifyContent: "", alignItems: "", width: "33%", height: uSaverSelected ? "90%" : "75%", margin: "4px", flexDirection: "column", backgroundColor: uSaverSelected ? "rgba(52, 99, 175, 0.2)" : "",
                }} onClick={() => {
                  setSaverSelected(false);
                  setBasicSelected(false);
                  setUSaverSelected(true);
                  setToolTipTimer(clearInterval(toolTipTimer));
                  setShowToolTip(false);
                  // basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]
                  setPlayBalanceAmt(smartRedeemAmountArray[2])
                  calBonus(smartRedeemAmountArray[2]);
                  setBonus(smartRedeemAmountArray[2]);
                }}>
                  {/* {(tdsInfo.tds > 0 && Number(redeemDetails.tdsFreeAmount) > 0 )   && <img src={NoTds} style={{position:"absolute",width:"50px",height:"20px"}}></img>} */}
                  <div id="ultraSaverHeader" style={{
                    background: "linear-gradient(101.46deg, #132033 26.87%, rgba(27, 49, 81, 0.85) 65.02%, #132033 81.37%)"

                    //  background: "linear-gradient(93.83deg, #EDBC5A 1.45%, #E39E14 100.59%)"
                    , width: "100%", height: "30%", paddingTop: "10px", paddingBottom: "10px", display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "8px",
                    borderTopRightRadius: "8px"
                  }}>
                    {/* <span style={{ color: "#f2f2f2", fontSize: "14px", fontWeight: "700", fontFamily: "Conto" }}>Max Bonus</span> */}
                    <span style={{ color: "#f2f2f2", fontSize: "14px", fontWeight: "700", fontFamily: "Conto" }}>Max Booster</span>
                    {/* ULTRA SAVER */}
                  </div>

                  <div id='txtCont2' style={{ width: "100%", height: "70%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", paddingTop: "5px", paddingBottom: "5px" }}>
                    <span style={{ color: "#032146", fontSize: "14px", fontWeight: "600", marginTop: "10px", marginBottom: "5px", fontFamily: "Conto" }}>Get</span>

                    <span style={{ color: "#032146", fontSize: "26px", fontWeight: "900", textAlign: "center", textUnderlinePosition: "from-font", textDecorationSkipInk: "none", marginTop: "5px", marginBottom: "5px", fontFamily: "Conto" }}>{RUPEE_SYMBOL}{Math.floor((Number(amountEntered) + Number(newSmartRedeemValueArr[2])) - (calculateSmartTDS(amountEntered - smartRedeemAmountArray[2]) > 0 ? calculateSmartTDS(amountEntered - smartRedeemAmountArray[2]) : 0))}</span>
                  </div>
                  {/* && calculateSmartTDS(amountEntered - smartRedeemAmountArray[2]) <= 0  */}
                  {console.log("222222222222 22222 ", calculateSmartTDS(amountEntered - smartRedeemAmountArray[2]))}
                  {(tdsInfo.tds > 0 && Number(redeemDetails.tdsFreeAmount) > 0 && (calculateSmartTDS(amountEntered - smartRedeemAmountArray[2]) <= 0)) && <div style={{ width: "100%", position: "", height: "25%", display: "flex", justifyContent: "center", alignItems: "center", marginTop: uSaverSelected ? "8%" : "-8%" }}> <img src={NoTds} style={{ position: "", width: "50%", height: "90%" }}></img> </div>}

                  {/* {uSaverSelected && <div id="ultraSaverBottom" style={{
                    background: "linear-gradient(101.46deg, rgba(19, 32, 51, 0.2) 26.87%, rgba(27, 49, 81, 0.17) 65.02%, rgba(19, 32, 51, 0.2) 81.37%)"

                    , width: "100%", height: "25%", paddingTop: "5px", paddingBottom: "5px", display: "flex", justifyContent: "center", alignItems: "center", borderBottomRightRadius: "8px",
                    borderBottomLeftRadius: "8px"
                  }}>
                    <span style={{ color: "#032146", fontSize: "12px", fontWeight: "600" }}>Highest Bonus</span>
                  </div>} */}
                </div>
                {/* Details Container */}
              </div>
              {/* Selection container end */}

              {/* {console.log("basic ref")} */}

              {/* <div id="ptCnt" style={{ width: "100%" }}> */}
              <div id="arrowContainer" style={{ width: "100%", display: "flex", height: "21px" }}>
                <img src={basicSelected ? BasicPointer : saverSelected ? MostSelectedPointer : USSelectedPointer} style={{ width: "30px", position: "absolute", left: style1.left + "px" }}></img>
              </div>
              {/* </div> */}

              {/* border: 1px solid rgba(74, 115, 186, 0.3) */}
              <div id="selCont" style={{
                width: "96%",
                //  height: "30%",
                border: "1px solid rgba(74, 115, 186, 0.3)", borderRadius: "8px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#ffffff"
              }} >
                <div id="12"
                  style={{
                    width: "99%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {/* , borderBottom: "1px solid #3463AF33" */}
                  {selectedRedeemMethod !== undefined &&
                    redeemDetails.allRedeemOptions?.length > 0 ? (
                    <div id="123"
                      style={{
                        width: "90%",
                        height: "70px",
                        display: "flex",
                        backgroundColor: "",
                        justifyContent: "center",
                        alignItems: "center",
                        // paddingTop: "5%",
                        //  paddingBottom: "5%",
                        // padding: "2%",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: "",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            width: "80%",
                            height: "50%",
                            color: "#032146",
                            fontWeight: "700",
                            fontSize: "0.85rem",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src={
                              activeRedeemMethod.type === "upi"
                                ? upiIcon
                                : activeRedeemMethod.type === "amazonPay"
                                  ? amazonPayIcon
                                  : activeRedeemMethod.type === "bankAccount"
                                    ? assets?.assets?.bankIcon
                                    : activeRedeemMethod.type === "paytmWallet"
                                      ? paytmIcon
                                      : ""
                            }
                            style={{ width: "25px", height: "25px" }}
                          />
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              id="bank"
                              style={{
                                marginLeft: "5px",
                                fontSize: "0.9rem",
                                fontWeight: "700",
                              }}
                            >
                              <span style={{ marginRight: "5px" }}>To</span>
                              {activeRedeemMethod.type === "bankAccount"
                                ? activeRedeemMethod.bankName
                                : activeRedeemMethod.type === "upi"
                                  ? activeRedeemMethod.upi
                                  : `${activeRedeemMethod.name +
                                  " " +
                                  "xxxxxx" +
                                  activeRedeemMethod.id.slice(6)
                                  }`}
                            </div>
                            {activeRedeemMethod.type === "bankAccount" && (
                              <div>
                                {" "}
                                <span style={{ marginRight: "5px" }}>To</span>
                                {"x".repeat(
                                  activeRedeemMethod.accountNumber.length - 4
                                ) +
                                  activeRedeemMethod.accountNumber.slice(
                                    activeRedeemMethod.accountNumber.length -
                                    4
                                  )}
                              </div>
                            )}
                          </div>
                          {(activeRedeemMethod?.bankStatus === "processing" ||
                            activeRedeemMethod?.upiState ===
                            "processing") && (
                              <div
                                className="nowrap"
                                style={{
                                  width: "30%",
                                  height: "50%",
                                  marginLeft: "2%",
                                  display: "flex",
                                  fontSize: "0.55rem",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#CD7F32",
                                  fontWeight: "700",
                                  borderRadius: "24px",
                                  background: "#FFB30033",
                                }}
                              >
                                <span
                                  style={{
                                    width: "95%",
                                    height: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  Validation Pending
                                </span>
                              </div>
                            )}
                        </div>
                        {/* <div id="change" style={{ color: '#58B6C6', textDecoration: 'underline', fontSize: "0.85rem" }}
onClick={() => { setOpenAllRedeemOptions(true); onClickofChangeRedeemMethod() }}>Change</div> */}
                      </div>

                      <div
                        style={{
                          width: "100%",
                          // minHeight: "50px",
                          backgroundColor: "",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "flex-end",
                            backgroundColor: "",
                          }}
                        >
                          <span
                            style={{
                              color: "#080D1A",
                              fontSize: "26px",
                              fontWeight: "900",
                              fontFamily: "Conto",
                              marginLeft: "5px",
                            }}
                          >
                            {RUPEE_SYMBOL}
                            <span>
                              {basicSelected ? amountEntered - smartRedeemAmountArray[0] <= 0 ? 0 : amountEntered - smartRedeemAmountArray[0] - calculateSmartTDS(
                                //amountEntered - selectedSliderValue
                                basicSelected ? amountEntered - smartRedeemAmountArray[0] :
                                  saverSelected ? amountEntered - smartRedeemAmountArray[1] :
                                    amountEntered - smartRedeemAmountArray[2]
                              ) :
                                saverSelected ? amountEntered - smartRedeemAmountArray[1] <= 0 ? 0 : amountEntered - smartRedeemAmountArray[1] - calculateSmartTDS(
                                  //amountEntered - selectedSliderValue
                                  basicSelected ? amountEntered - smartRedeemAmountArray[0] :
                                    saverSelected ? amountEntered - smartRedeemAmountArray[1] :
                                      amountEntered - smartRedeemAmountArray[2]
                                ) :
                                  amountEntered - smartRedeemAmountArray[2] <= 0 ? 0 : amountEntered - smartRedeemAmountArray[2] - calculateSmartTDS(
                                    //amountEntered - selectedSliderValue
                                    basicSelected ? amountEntered - smartRedeemAmountArray[0] :
                                      saverSelected ? amountEntered - smartRedeemAmountArray[1] :
                                        amountEntered - smartRedeemAmountArray[2]
                                  )
                              }
                            </span>
                          </span>



                          {calculateSmartTDS(
                            // amountEntered - selectedSliderValue
                            basicSelected ? amountEntered - smartRedeemAmountArray[0] :
                              saverSelected ? amountEntered - smartRedeemAmountArray[1] :
                                amountEntered - smartRedeemAmountArray[2]
                          ) > 0 ? (
                            <div
                              style={{
                                padding: "5px",
                                background: "#C6282826",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "4px"
                              }}
                            >
                              <span
                                style={{
                                  color: "#C62828",
                                  fontSize: "12px",
                                  fontWeight: "900",
                                  borderRadius: "2px",
                                }}
                              >
                                <span>{RUPEE_SYMBOL}</span>{" "}
                                {calculateSmartTDS(
                                  //amountEntered - selectedSliderValue
                                  basicSelected ? amountEntered - smartRedeemAmountArray[0] :
                                    saverSelected ? amountEntered - smartRedeemAmountArray[1] :
                                      amountEntered - smartRedeemAmountArray[2]
                                )}{" "}
                                TDS is deducted
                              </span>
                            </div>
                          ) : tdsInfo.tds > 0 &&
                            Number(redeemDetails.tdsFreeAmount) > 0 &&
                            greesTDSAmount > redTDSAmount ? (
                            <div
                              style={{
                                padding: "5px",
                                background: "#42BE4026",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <span
                                style={{
                                  color: "#196a29",
                                  fontSize: "12px",
                                  fontWeight: "900",
                                  borderRadius: "2px",
                                }}
                              >
                                <span>{RUPEE_SYMBOL}</span> 0 TDS is
                                deducted
                              </span>
                            </div>
                          ) : (
                            ""
                          )}


                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        width: "92%",
                        height: "65%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "0.9rem",
                        fontWeight: "500",
                        color: "#9C9D9F",
                        paddingBottom:"2%"
                      }}
                    >
                      {/* No Withdraw Account available */}
                      {VernacularContextData.getTransalatedKey("nowithdrawaccountavailable")}
                    </div>
                  )}

                  <div
                    style={{
                      backgroundColor: "#3463AF33",
                      width: "86%",
                      height: "1px",
                    }}
                  ></div>

                  <img src={assets?.assets?.plusIcon1} style={{ width: "24px", height: "24px", marginTop: "-12px" }}></img>
                  {/* selectedSliderValue */}
                  <div id="34"
                    style={{
                      backgroundColor: "",
                      display: "flex",
                      width: "90%",
                      height: "75px",
                      justifyContent: "center",
                      alignItems: "center",

                      // padding: "2%",
                      // paddingTop: "5%",
                      // paddingBottom: "5%"
                    }}
                  >
                    <div
                      style={{
                        width: "60%",
                        height: "100%",
                        backgroundColor: "",
                        display: "flex",
                        justifyContent: "",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={assets?.assets?.walletIcon1}
                        style={{
                          width: "25px",
                          height: "25px",
                          marginTop: "-8px",
                        }}
                      ></img>
                      <span
                        style={{
                          color: "rgb(3,33,70)",
                          fontSize: "0.9rem",
                          fontWeight: "700",
                          marginLeft: "5px",
                        }}
                      >
                        {/* To your A23 wallet* */}
                        To Play Balance
                      </span>
                    </div>

                    <div
                      style={{
                        width: "40%",
                        height: "100%",
                        backgroundColor: "",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span
                        style={{
                          color: "rgb(3,33,70)",
                          fontSize: "26px",
                          fontWeight: "900",
                          fontFamily: "Conto",
                          marginLeft: "5px",
                        }}
                      >
                        {/* {RUPEE_SYMBOL}<span>{((selectedSliderValue > amountEntered) || selectedSliderValue === amountEntered) ? amountEntered : selectedSliderValue}</span> */}
                        {RUPEE_SYMBOL}
                        {/* <span>{selectedSliderValue}</span> */}
                        <span>{basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]}</span>
                      </span>
                    </div>
                  </div>

                  <div
                    style={{
                      backgroundColor: "#3463AF33",
                      width: "86%",
                      height: "1px",
                    }}
                  ></div>

                  <img src={assets?.assets?.plusIcon1} style={{ width: "24px", height: "24px", marginTop: "-12px" }}></img>

                  <div id="341"
                    style={{
                      backgroundColor: "",
                      display: "flex",
                      width: "90%",
                      height: "75px",
                      justifyContent: "center",
                      alignItems: "center",

                      // padding: "2%",
                      // paddingTop: "5%",
                      // paddingBottom: "5%"
                    }}
                  >
                    <div
                      style={{
                        width: "60%",
                        height: "100%",
                        backgroundColor: "",
                        display: "flex",
                        justifyContent: "",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={assets?.assets?.instantrupee}
                        style={{
                          width: "25px",
                          height: "25px",
                          // marginTop: "-8px",
                        }}
                      ></img>
                      <span
                        style={{
                          color: "rgb(3,33,70)",
                          fontSize: "0.9rem",
                          fontWeight: "700",
                          marginLeft: "5px",
                        }}
                      >
                        Extra Bonus
                      </span>

                      {/* {console.log("instant arrrr",instantBonusArr[0])} */}

                      {/* {console.log("Locked arrrr",lockedBonusArr[0])} */}

                      {/* {console.log("dabididibidey dfrfgdffghjhjghj",instantBonusArr)} */}
                      {/* {console.log("dabididibidey 1 dgnhhgjghkjkhjlk",lockedBonusArr)} */}

                      <div style={{ backgroundColor: "", display: "flex", flexDirection: "column" }}>

                        <img ref={infooIconRef} src={InfooIcon} style={{ width: "20px", height: "20px", marginLeft: "10px" }} onClick={() => {
                          setToolTipTimer(clearInterval(toolTipTimer));
                          setShowToolTip(true);
                          setToolTipTimer(setTimeout(() => {
                            setShowToolTip(false);
                          }, 3000))

                        }}></img>


                        <div style={{ backgroundColor: "#E6C683", display: showToolTip ? "flex" : "none", justifyContent: "center", alignItems: "center", padding: "10px", height: "55px", position: "absolute", zIndex: "2", marginTop: "25px", borderRadius: "5px", textAlign: "left", flexDirection: "column", left: infooIconRef.current ? (infooIconRef.current.offsetLeft) + "px" : "" }}>
                          <img src={Polygon} style={{
                            width: "30px", height: "15px", top: "-7px", position: "absolute",
                            left: "3%"
                            // left: standardIconRef.current ? (standardIconRef.current.offsetLeft)/2-20+"px" :""
                          }}></img>
                          <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%" }}>{"Instant Bonus :    "}{basicSelected ? Number(instantBonusArr[0]).toFixed(2) : saverSelected ? Number(instantBonusArr[1]).toFixed(2) : Number(instantBonusArr[2]).toFixed(2)}</span>
                          <span style={{ fontSize: "12px", color: "#032146", fontWeight: "400", width: "100%" }}>{"Locked Bonus  :    "}{basicSelected ? Number(lockedBonusArr[0]).toFixed(2) : saverSelected ? Number(lockedBonusArr[1]).toFixed(2) : Number(lockedBonusArr[2]).toFixed(2)}</span>
                          {/* <img src={BlueCross} style={{ marginTop: "-20px", marginLeft: "10px" }} onClick={() => {
                            setToolTipTimer(clearInterval(toolTipTimer));
                            setShowToolTip(false);


                          }}></img> */}
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "40%",
                        height: "100%",
                        backgroundColor: "",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                        justifyContent: "center"
                        // alignItems: "center",
                        // justifyContent: "flex-end",

                      }}
                    >
                      <span
                        style={{
                          color: "rgb(3,33,70)",
                          fontSize: "26px",
                          fontWeight: "900",
                          fontFamily: "Conto",
                          marginLeft: "5px",
                        }}
                      >

                        {RUPEE_SYMBOL}
                        {/* <span>{basicSelected ? Number(newSmartRedeemValueArr[0]).toFixed(2) : saverSelected ? Number(newSmartRedeemValueArr[1]).toFixed(2) : Number(newSmartRedeemValueArr[2]).toFixed(2)}</span> */}
                        <span>{basicSelected ? formatNumber(newSmartRedeemValueArr[0]) : saverSelected ? formatNumber(newSmartRedeemValueArr[1]) : formatNumber(newSmartRedeemValueArr[2])}</span>
                      </span>


                      {
                        ((basicSelected && newSmartRedeemValueArr[0] === 0) || (saverSelected && newSmartRedeemValueArr[1] === 0) || (uSaverSelected && newSmartRedeemValueArr[2] === 0)) && <div
                          style={{
                            padding: "5px 10px 5px 10px",
                            background: "#C6282826",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center", borderRadius: "4px"
                          }}
                        >

                          {/* RedAlertIcon */}
                          <img src={RedAlertIcon} style={{ width: "14px", height: "14px", marginRight: "5px", marginTop: "-4px" }}></img>
                          <span
                            style={{
                              color: "#C62828",
                              fontSize: "12px",
                              fontWeight: "900",
                              borderRadius: "2px",
                            }}
                          >

                            No Bonus
                          </span>
                        </div>}
                    </div>
                  </div>

                </div>
              </div>


              {/* Button Div */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "",
                  position: "absolute",
                  bottom: "5px",
                  gap: "10px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {console.log("transferLayoutFlag >>>>>>", transferLayoutFlag, playBalanceAmt)}
                <div
                  // className="ph5 pv3 nowrap"
                  id="ContinueCTA_redeempage"
                  style={{
                    width: "85%",
                    height: "40px",
                    // background: (basicRedeemSelected || smartRedeemSelected ) ? "linear-gradient(180deg, #35A753 0%, #276E3A 100%)":"linear-gradient(180deg, grey 0%, grey 100%)",
                    background: "linear-gradient(180deg, #42BE40 0%, #196A29 100%)",//"#196A29",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "4px",
                    color: "#f9f9f9",
                    fontWeight: "700",
                    fontSize: "0.9rem",
                    // border: "1px solid #196A29",
                    marginBottom: "5px",
                    // position: "absolute",
                    // bottom: "5px",
                  }}
                  onClick={() => {
                    // console.log(
                    //   "Smart redeem percent value",
                    //   smartRedeemPercentConfig[mostSelected]
                    // );

                    setButtonText("RedeemWithBonus");

                    if (transferLayoutFlag) {
                      const actionType = playBalanceAmt > 0 ? "Smart Withdraw" : "Basic Withdraw";
                      if ((basicSelected && newSmartRedeemValueArr[0] > 0) || (saverSelected && newSmartRedeemValueArr[1] > 0) || (uSaverSelected && newSmartRedeemValueArr[2] > 0)) {
                        // if (playBalanceAmt > 0) {
                        setShowSmartRedeemPopup(true);
                        eventTrigger('redeemCTEvent', actionType);
                        eventTrigger('plotLineEvent', actionType);
                        eventTrigger('mixpanelEvent', actionType);
                      } else {

                        // alert();



                        setShowBonusMissOutPopup(true);
                        // Come here to check
                        // setShowSmartRedeem(false);
                        // setShowSmartRedeemPopup(false);
                        // onContinueClick("RedeemWithoutBonus");
                        // eventTrigger('redeemCTEvent', actionType);


                        console.log(" showBonusMissOutPopup >>>>", amountEntered, calculateSmartTDS(amountEntered));
                        let evtProperties = {
                          SplitSelected: !smartRedeemNewUIFlag ? smartRedeemPercentConfig[smartRedeemAmountArray.indexOf(selectedSliderValue)] : smartRedeemPercentConfig[basicSelected ? 0 : saverSelected ? 1 : 2],//smartRedeemPercentConfig[ smartRedeemAmountArray.indexOf(selectedSliderValue) ],
                          TotalBonusPercentage:
                            bonusConfig?.levelDetails[0]?.bonusPercent,
                          InstantBonusPercentage:
                            bonusConfig?.levelDetails[0]?.instantBonusPercentage,
                          LockedBonusPercentage:
                            bonusConfig?.levelDetails[0]?.lockedBonusPercentage,
                          Redeem_Amount: amountEntered,
                          AmountToBank: amountEntered - (calculateSmartTDS(amountEntered) > 0 ? calculateSmartTDS(amountEntered) : 0),
                          MostSelectedAmount:
                            smartRedeemPercentConfig[mostSelected],
                          // MostSelectedAmount:smartRedeemAmountArray[mostSelected],
                          // BonusAmount: totalBonus,
                          BonusAmount: totalBonus ? Number(totalBonus).toFixed(2) : 0,
                          AmountToWallet: 0,
                          //               AmountToWallet: !smartRedeemNewUIFlag ? selectedSliderValue : (basicSelected ? smartRedeemAmountArray[0] : saverSelected ? smartRedeemAmountArray[1] : smartRedeemAmountArray[2]),
                          // AmountToBank: !smartRedeemNewUIFlag ? (amountEntered - selectedSliderValue) : (basicSelected ? Number(amountEntered) - smartRedeemAmountArray[0] : saverSelected ? Number(amountEntered) - smartRedeemAmountArray[1] : Number(amountEntered) - smartRedeemAmountArray[2]),
                          TDSAmount:
                            calculateSmartTDS(amountEntered) >
                              0
                              ? calculateSmartTDS(
                                amountEntered
                              )
                              : 0,
                          Redeem_type_selected: standardSelected
                            ? "Standard"
                            : instantSelected
                              ? "Instant"
                              : "Others",
                          Redeem_mode: activeRedeemMethod.type,
                          subscription_type:
                            window.sessionStorage["subscriptionType"],
                          username: profileData.screenName,
                          channel: window.sessionStorage["channel"],
                          aceLevel: profileData.currentAceLevelName,
                          timestamp: new Date().getTime(),
                          smartUI: smartRedeemNewUIFlag ? "New" : "Old"
                        }

                        //Smartredeem_Bonuspopup_clicked
                        WebToNativeMessage({
                          type: "redeemCTEvent", eventName: "Smartredeem_Bonuspopup_viewed", eventProperties: evtProperties
                        })
                        WebToNativeMessage({
                          type: "plotLineEvent", eventName: "Smartredeem_Bonuspopup_viewed", eventProperties: evtProperties
                        })
                        WebToNativeMessage({
                          type: "mixpanelEvent", eventName: "Smartredeem_Bonuspopup_viewed", eventProperties: evtProperties
                        })

                        eventTrigger('redeemCTEvent', actionType);
                        eventTrigger('plotLineEvent', actionType);
                        eventTrigger('mixpanelEvent', actionType);
                      }
                    } else {
                      setShowSmartRedeem(false);
                      setShowSmartRedeemPopup(false)
                      onContinueClick("RedeemWithBonus");
                    }

                  }}
                >
                  {/* Continue to Redeem */}
                  {/* {amountEntered - selectedSliderValue > 0
                    ? "Redeem"
                    : "Transfer"} */}

                  {basicSelected ? amountEntered - smartRedeemAmountArray[0] > 0 ? "Withdraw" : "Transfer" :
                    saverSelected ? amountEntered - smartRedeemAmountArray[1] > 0 ? "Withdraw" : "Transfer" :
                      amountEntered - smartRedeemAmountArray[2] > 0 ? "Withdraw" : "Transfer"
                  }
                </div>


                {/*  Redeem without bonus */}
                <div
                  style={{
                    width: "90%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    marginBottom: "5px",
                  }}
                >
                  <span style={{ color: "#707070", fontSize: "10px" }}>
                    *Amount transferred to A23 Wallet is used for playing cash
                    games. This amount cannot be moved back & is not withdrawable.
                  </span>
                </div>
              </div>


            </div>

          </div>
        </div>

        {/* {console.log("Neee kjndsfjkndsfkjndsfkjndsfjkndsf 12345678",basicRef.current.current)} */}
      </div>


    );




    return gamePassOverLay;
  }

  const setBonus = (val) => {
    let totalBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.bonusPercent) / 100) * parseInt(val), parseInt(bonusConfig.maxBonus));
    let totalInstantBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.instantBonusPercentage) / 100) * totalBonus, parseInt(bonusConfig.maxInstantBonus));
    let totalLockedBonus = parseInt(bonusConfig?.levelDetails[0]?.lockedBonusPercentage) > 0 ? Math.min((parseInt(bonusConfig?.levelDetails[0]?.lockedBonusPercentage) / 100) * totalBonus, parseInt(bonusConfig.maxLockedBonusAmount)) : 0;


    setTotalBonus(formatNumber(totalBonus));
    setInstantBonus(formatNumber(totalInstantBonus));
    setLockedBonus(formatNumber(totalLockedBonus));
  }

  const calBonus = (val) => {

    let totalBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.bonusPercent) / 100) * parseInt(val), parseInt(bonusConfig.maxBonus));
    let totalInstantBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.instantBonusPercentage) / 100) * totalBonus, parseInt(bonusConfig.maxInstantBonus));
    let totalLockedBonus = parseInt(bonusConfig?.levelDetails[0]?.lockedBonusPercentage) > 0 ? Math.min((parseInt(bonusConfig?.levelDetails[0]?.lockedBonusPercentage) / 100) * totalBonus, parseInt(bonusConfig.maxLockedBonusAmount)) : 0;


    // setTotalBonus(totalBonus);
    // setInstantBonus(totalInstantBonus);
    // setLockedBonus(totalLockedBonus);

    return formatNumber(totalBonus)
  }

  const calculateBonus = (val) => {

    setInstantBonusArr([]);
    setLockedBonusArr([]);

    let totalBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.bonusPercent) / 100) * parseInt(val), parseInt(bonusConfig.maxBonus));
    let totalInstantBonus = Math.min((parseInt(bonusConfig?.levelDetails[0]?.instantBonusPercentage) / 100) * totalBonus, parseInt(bonusConfig.maxInstantBonus));
    let totalLockedBonus = parseInt(bonusConfig?.levelDetails[0]?.lockedBonusPercentage) > 0 ? Math.min((parseInt(bonusConfig?.levelDetails[0]?.lockedBonusPercentage) / 100) * totalBonus, parseInt(bonusConfig.maxLockedBonusAmount)) : 0;

    console.log("sense1", totalInstantBonus);
    console.log("sense2", totalLockedBonus);
    console.log("sense3", instantBonusArr);

    setInstantBonusArr(instantBonusArr.push(totalInstantBonus));
    setLockedBonusArr(lockedBonusArr.push(totalLockedBonus));

    console.log("sense4", totalInstantBonus);
    console.log("sense5", totalLockedBonus);
    console.log("sense6", instantBonusArr);

    let total = (Number(totalInstantBonus) + Number(totalLockedBonus));

    setTotalBonus(totalBonus);
    setInstantBonus(totalInstantBonus);
    setLockedBonus(totalLockedBonus);

    console.log("arrr 1 eew", totalInstantBonus);
    console.log("arrr 2v efwefewf", lockedBonusArr);
    console.log("arrr 3 wefwefewf", instantBonusArr);


    return total
  }

  const formatNumber = (num) => {

    if (!Number.isInteger(num)) {

      return num.toFixed(2); // Round to 2 decimal places if not an integer

    }

    return num; // Return the number as is if it's an integer

  }





  const createGamePassOverLay = () => {

    let gamePassOverLay = <div style={{ width: "100%", backgroundColor: "red", overflow: 'hidden' }}>
      <div style={{ width: "100%", height: "100%", position: "absolute", display: 'flex', backgroundColor: "rgba(0,0,0,0.5)", bottom: "0px", zIndex: "4", justifyContent: "center" }} >
        <div style={{ width: "100%", height: "20%", position: "absolute", backgroundColor: "", top: "0px", borderTopLeftRadius: "9px", borderTopRightRadius: "9px" }} onClick={
          () => {
            setToShowGamePassOverLay(false);

          }
        }>



        </div>

        <div className="overLayAnimation" style={{ width: "100%", height: "80%", position: "absolute", bottom: "-60%", zIndex: "5", borderTopLeftRadius: "15px", borderTopRightRadius: "15px", maxWidth: "600px" }} >
          <img id="Close_gamepasspopup_redeempage"
            src={assets?.assets?.Cross}
            style={{ width: "14px", height: "14px", position: "absolute", top: "16px", right: "15px", zIndex: "55" }}
            onClick={
              () => {
                setToShowGamePassOverLay(false);
                //  alert("on close click");
              }
            } />
          {/* // onClick={() => this.handleBackBtnClick({ type: "closeClient" })} */}
          {/* /> */}
          {/* {console.log("New date", new Date())} */}

          <div id="header" className='redeemAccountBottomSheet' style={{ width: "100%", height: "25%", maxHeight: "50px", fontWeight: '700', display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "8px", borderTopRightRadius: "8px", PointerEvent: "none" }} onClick={() => {
            // alert()
          }}>
            {/* <img src={navarrow} style={{ position: 'absolute', left: '5%', width: '8%' }} onClick={() => {
              // alert()&&
              setToShowStandardAndInstantBottomSheet(false)
            }}></img> //Game Pass Expiry */}
            <span className='redeemMethodHeaderText' style={{ fontSize: "18px" }}>

              {/* { activeMissionsData && activeMissionsData?.activeMission?.length > 0  ? 'Confirmation' :'PlayPass Expiry'} */}
              Alert!
            </span>
          </div>

          <div className='suggestionMessageDiv' id="suggestioinMessage" style={{
            width: "100%", height: "7%", textAlign: "left", display: "flex", alignItems: "center",
            marginTop: "8px", marginBottom: '12px',
            paddingLeft: '12px',
            //  marginLeft: '4%',
            //  border: "1px solid #c62828" 
          }}>
            {/* <span style={{ fontSize: "15px", color: "#c62828", marginLeft: "10px" }}>The following PlayPasses will expire on placing the Redeem.</span> */}
            {/* <div style={{ width: "2%", height: "100%", backgroundColor: "#c62828" }}></div> */}

            <img src={assets?.assets?.warningIcon} style={{ width: "1.5rem", height: "1.5rem", paddingLeft: "5px", paddingRight: '8px' }} />

            <span style={{ fontSize: "12px", marginLeft: "5px", fontWeight: "700", marginRight: "5px" }}>
              {/* Note: The following PlayPass(es) will expire on placing the redeem */}
              {getNoteText()}
            </span>
            {/* Note: The following PlayPass(es) will expire on placing the redeem */}
          </div>




          <div id="Gamepass_card_redeempage" style={{
            width: "100%",
            // height: activeMissionsData && activeMissionsData.activeMission && activeMissionsData.activeMission.length > 0 ?
            //   "40%" : '65%', 
            height: '70%',

            backgroundColor: "", display: "flex", flexDirection: "column", justifyContent: "", alignItems: "center", overflow: "scroll", gap: "10px"
          }}>

            {challengesData && challengesData.length > 0 ?
              <div className='ExpirySectionHeaderText' style={{
                display: 'flex', justifyContent: 'flex-start', width: '94%',
                fontWeight: '700', marginLeft: '3%', marginBottom: '0.25rem', marginTop: '0.5rem'
              }}> Challenges </div> : ''}
            {createChallengeCards()}

            {checkTotalLockedBonusAmountFlag() ? <> <div className='ExpirySectionHeaderText' style={{
              display: 'flex', justifyContent: 'flex-start', width: '94%',
              fontWeight: '700', marginLeft: '3%', marginBottom: '0.25rem', marginTop: '0.5rem'
            }}>Locked Bonus </div> {createLockedBonusComponents()} </>
              : ''}


            {activeMissionsData && activeMissionsData.activeMission && activeMissionsData.activeMission.length > 0 ?
              <div className='ExpirySectionHeaderText' style={{
                display: 'flex', justifyContent: 'flex-start', width: '94%',
                fontWeight: '700', marginLeft: '3%', marginBottom: '1rem'
              }}> Missions </div> : ''}
            {createMissionCards()}
            <div className='ExpirySectionHeaderText' style={{
              display: 'flex', justifyContent: 'flex-start', width: '94%',
              fontWeight: '700', marginLeft: '3%', marginBottom: '1rem', marginTop: '1rem'
            }}>


              {redeemGamePassData && redeemGamePassData.length > 0 ? 'PlayPass' : ''}
            </div>



            {redeemGamePassData && redeemGamePassData.map((item, index) => {

              return (
                <GamePassCard GamePassData={item} />
              )
            })}
          </div>


          {/* {console.log("dmdmdmdmdmdmdmdmdmdmdmdmdmdmdmdmdmdmdmdmdmdmdmdmdmdmdmd", window.sessionStorage["channel"])} */}
          {(window.sessionStorage["channel"] === "APS" || window.sessionStorage["channel"] === "GAPS" || window.sessionStorage["channel"] === "PAPS" || window.sessionStorage["channel"] === "IPS" || window.sessionStorage["channel"] === "PIPS" || window.sessionStorage["channel"] === "A23APS" || window.sessionStorage["channel"] === "A23IPS" || isoemps) ?
            <div style={{
              width: "100%",
              height: "6%", display: "flex", flexDirection: "row",
              justifyContent: "space-evenly", backgroundColor: "", marginTop: isTablet ? '2%' : "5%", marginBottom: "5%"
            }}>
              <div
                // className="ph5 pv3 nowrap"
                id="ContinueCTA_redeempage"
                className='redeemCTAButtonWhite'
                style={{
                  width: "45%",
                  // height: "60%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "4px",
                  fontWeight: "700",
                  fontSize: "0.9rem",

                }}
                onClick={() => {
                  //PF_c_viewgamepassClick_redeem

                  //                  username
                  // Acelevel
                  // channel
                  // timestamp


                  // button_clicked
                  // username
                  // Acelevel
                  // channel
                  // timestamp
                  WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_viewgamepassClick_redeem", eventProperties: { button_clicked: " Continue to Redeem", username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime() } })
                  WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_viewgamepassClick_redeem", eventProperties: { button_clicked: " Continue to Redeem", username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime() } })
                  setToShowGamePassOverLay(false);
                  setShowSmartRedeemPopup(false);
                  setShowSmartRedeem(false);
                  onContinueClick();


                }}
              >
                {/* Continue Redeem */}
                Continue Withdraw
              </div>
              <div
                // className="ph5 pv3 nowrap"
                className='redeemCTAButtonGreen'
                id="GoToGamepass_redeempage"//"cancel_redeem"
                style={{
                  width: "45%",
                  // height: "60%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "4px",
                  fontWeight: "700",
                  fontSize: "0.9rem",
                }}
                onClick={(e) => {

                  //Need to add the call back
                  //PF_c_viewgamepassClick_redeem
                  /* if(activeMissionsData && activeMissionsData?.activeMission?.length > 0 ){
                    setToShowGamePassOverLay(false);
                  }else{
                    WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_viewgamepassClick_redeem", eventProperties: {button_clicked:" RummyGamePass", username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName,timestamp:new Date().getTime() } })
                    WebToNativeMessage({ type: "RummyGamePass" });
                  } */
                  WebToNativeMessage({ type: "gotoLobby" });

                  // WebToNativeMessage({ type: "closeClient" })


                }}

              >
                {/* Go to Game Pass */}
                {/* { activeMissionsData && activeMissionsData?.activeMission?.length > 0  ? 'Cancel Redeem' : 'Go to PlayPass'} */}
                Go to Lobby
              </div>
            </div> :
            <div style={{ width: "100%", height: "6%", display: "flex", flexDirection: "row", justifyContent: "space-evenly", backgroundColor: "", marginTop: "5%", marginBottom: "5%" }}>

              <div
                // className="ph5 pv3 nowrap"
                className='redeemCTAButtonGreen'
                id="ContinueCTA_redeempage"
                style={{
                  width: "95%",
                  // height: "60%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "4px",
                  fontWeight: "700",
                  fontSize: "0.9rem",

                }}
                onClick={() => {
                  //PF_c_viewgamepassClick_redeem

                  //                  username
                  // Acelevel
                  // channel
                  // timestamp


                  // button_clicked
                  // username
                  // Acelevel
                  // channel
                  // timestamp
                  WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_viewgamepassClick_redeem", eventProperties: { button_clicked: " Continue to Redeem", username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime() } })
                  WebToNativeMessage({ type: "mixpanelEvent", eventName: "PF_c_viewgamepassClick_redeem", eventProperties: { button_clicked: " Continue to Redeem", username: profileData.screenName, channel: window.sessionStorage["channel"], aceLevel: profileData.currentAceLevelName, timestamp: new Date().getTime() } })
                  setToShowGamePassOverLay(false);
                  onContinueClick();


                }}
              >
                {/* Continue Redeem */}
                Continue Withdraw
              </div>
            </div>
          }

        </div>

      </div>
    </div>


    return gamePassOverLay;

  }

  const createTdsCashBackOverLay = () => {
    let overlay = <div style={{ width: "100%", backgroundColor: "red", overflow: 'hidden' }}>
      <div style={{ width: "100%", height: "100%", position: "absolute", display: 'flex', backgroundColor: "rgba(0,0,0,0.5)", bottom: "0px", zIndex: "4", justifyContent: "center", justifyContent: "center" }} >
        <div style={{ width: "100%", height: "20%", position: "absolute", backgroundColor: "", top: "0px", borderTopLeftRadius: "9px", borderTopRightRadius: "9px" }} onClick={
          () => {
            // setToShowGamePassOverLay(false);
            setShowTdsCashbackBottomSheet(false);
            //To close the TDS Cash Back Overlay

          }
        }>
        </div>

        <div className="overLayAnimation" style={{ width: "100%", height: "50%", position: "absolute", bottom: "-50%", zIndex: "5", borderTopLeftRadius: "15px", borderTopRightRadius: "15px", maxWidth: "600px" }} >

          <img id="Close_gamepasspopup_redeempage"
            src={assets?.assets?.Cross}
            style={{ width: "14px", height: "14px", position: "absolute", top: "16px", right: "15px", zIndex: "55" }}
            onClick={
              () => {
                setShowTdsCashbackBottomSheet(false);
              }
            } />


          <div id="header" className='redeemAccountBottomSheet' style={{ width: "100%", height: "25%", maxHeight: "50px", fontWeight: '700', display: "flex", justifyContent: "center", alignItems: "center", borderTopLeftRadius: "8px", borderTopRightRadius: "8px", PointerEvent: "none" }} onClick={() => {
            // alert()
          }}>

            <span className='redeemMethodHeaderText' style={{ fontSize: "18px" }}>
              TDS Cashback
            </span>
          </div>


          <div className="tdsCashBackBottomSheetGrid" >
            <div className='tdsCashBackBottomSheetGridItem'>
              {/* Header */}
              <div className='tdsCashBackBottomSheetGridItemHeader'>
                <div className="tdsCashBackTitleSection">
                  <span >Title</span>
                </div>

                <div className="tdsCashBackAmountSection">
                  <span >Amount</span>
                </div>

              </div>

              {/* Header End */}



              {/*  */}

              <div className='tdsCashBackBottomSheetGridItemContent1'>
                <div className="tdsCashBackTitleSection1">
                  <span >Total TDS</span>
                </div>

                <div className="tdsCashBackAmountSection1">
                  <span >{RUPEE_SYMBOL} {Number(tdsInfo.tds) > 0 ? tdsInfo.tds : 0}</span>
                </div>

              </div>

              {/*  */}

              <div className='tdsCashBackBottomSheetGridItemContent1'>
                <div className="tdsCashBackTitleSection1">
                  <span >TDS on cash games winnings</span>
                </div>
                {console.log("What is final cashback value >>>>", finalCashbackValue)}

                <div className="tdsCashBackAmountSection1">
                  <span >{RUPEE_SYMBOL} {(Number(finalCashbackValue) > 0 && amountEntered > 0) ? Number(finalCashbackValue).toFixed(2) : 0}</span>
                  {/* {( tdsTnyWinningsEnabled && (cummilativeTrnyWinnings) > 0) ?
                 <span >{RUPEE_SYMBOL} {Number(finalCashbackValue) > 0 ? finalCashbackValue : 0 }</span> : 
                 <span >{RUPEE_SYMBOL} {Number(finalCashbackValue) > 0 ? finalCashbackValue : 0 }</span>} */}
                  {/* <span >{RUPEE_SYMBOL} <span>{((standardSelected && tdsInfo.tds > 0 ) ? ((tdsInfo.tds * standardTypePercentage)/100) .toFixed(2) : (instantSelected && tdsInfo.tds > 0 )?( (tdsInfo.tds * instantTypePercentage)/100) .toFixed(2) : 0)}</span></span>} */}
                </div>

              </div>


              {/*  */}


              <div className='tdsCashBackBottomSheetGridItemContent1'>
                <div className="tdsCashBackTitleSection1">
                  <span >TDS on tourney net winnings</span>
                </div>

                <div className="tdsCashBackAmountSection1">
                  {/* {console.log("tds info >>>>>> drjhbdrbhjdfgjbhdgjh", tdsInfo.tds, finalCashbackValue)} */}
                  {RUPEE_SYMBOL} {((Number(tdsInfo.tds) <= 0 ? 0 : Number(tdsInfo.tds)) - (Number(finalCashbackValue) <= 0 ? 0 : Number(finalCashbackValue))) > 0 ? ((Number(tdsInfo.tds) <= 0 ? 0 : Number(tdsInfo.tds)) - (Number(finalCashbackValue) <= 0 ? 0 : Number(finalCashbackValue))).toFixed(2) : 0}
                  {/* {(Number(finalCashbackValue) > 0 && Number(tdsInfo.tds) > 0) ? (Number(tdsInfo.tds) - Number(finalCashbackValue)) : 0} */}
                  {/* {( tdsTnyWinningsEnabled && (cummilativeTrnyWinnings) > 0) ? } */}
                  {/* {( tdsTnyWinningsEnabled && (cummilativeTrnyWinnings) > 0) ? <span >{RUPEE_SYMBOL} {( (tdsInfo.tds && tdsCashbackAmount )  &&  Number(tdsInfo.tds) - Number(tdsCashbackAmount)) > 0 ? (tdsInfo.tds - tdsCashbackAmount).toFixed(2) : 0 }</span> : 0} */}
                </div>

              </div>

              {/* Bottom div  */}



              <div className="tdsCashbackBottomContent">
                <div className='internalContent' >
                  <span className='internalContentText'>{(standardSelected && applicableForStandard) ? standardTypePercentage : (instantSelected && applicableForInstant) ? instantTypePercentage : 0}% TDS cashback</span>
                  {(tdsTnyWinningsEnabled && (cummilativeTrnyWinnings) > 0) ? <span className="internalContextText2" style={{ fontSize: "0.8rem" }}>(Not applicable on tourney winnings)</span> : ""}
                </div>

                <div className="internalContextAmountText" style={{ width: "40%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "0.8rem" }}>
                  {/* <span >{RUPEE_SYMBOL} {standardSelected ? ((tdsCashbackAmount * standardTypePercentage)/100).toFixed(2) : instantSelected ? ((tdsCashbackAmount * instantTypePercentage)/100).toFixed(2): 0} </span> */}
                  {/* <span>{RUPEE_SYMBOL}{tdsCashbackAmount}</span> */}
                  {tdsTnyWinningsEnabled ? <span >{RUPEE_SYMBOL} <span>{((standardSelected && finalCashbackValue > 0) ? ((finalCashbackValue * standardTypePercentage) / 100) > tdsMaxCapAmount ? tdsMaxCapAmount.toFixed(2) : ((finalCashbackValue * standardTypePercentage) / 100).toFixed(2) :

                    (instantSelected && finalCashbackValue > 0) ? ((finalCashbackValue * instantTypePercentage) / 100) > tdsMaxCapAmount ? tdsMaxCapAmount.toFixed(2) : ((finalCashbackValue * instantTypePercentage) / 100).toFixed(2) : 0)}
                  </span></span>

                    :
                    <span >{RUPEE_SYMBOL} <span>{((standardSelected && tdsInfo.tds > 0) ? ((tdsInfo.tds * standardTypePercentage) / 100) > tdsMaxCapAmount ? tdsMaxCapAmount.toFixed(2) : ((tdsInfo.tds * standardTypePercentage) / 100).toFixed(2) : (instantSelected && tdsInfo.tds > 0) ? ((tdsInfo.tds * instantTypePercentage) / 100).toFixed(2) > tdsMaxCapAmount ? tdsMaxCapAmount.toFixed(2) : ((tdsInfo.tds * instantTypePercentage) / 100).toFixed(2) : 0)}</span></span>
                  }
                </div>


              </div>

              {/*  */}



            </div>

            {/* bottom note */}
            {
              tdsTnyWinningsEnabled && (cummilativeTrnyWinnings) > 0 ?
                <div className='bottomNoteSection'>
                  <span className='noteText'>Note :</span>
                  <span className='noteText1' style={{ marginTop: "5px" }}>1.‘TDS Cashback’ is applicable up to  {tdsMaxCapAmount}, after successful processing of redeem.</span>
                  <span className='noteText1' style={{ marginTop: "5px" }}>2.At the time of processing, any tourney winnings will be subjected to reduction in TDS Cashback.</span>
                </div> :

                <div className='bottomNoteSection'>
                  <span className='noteText'>Note :</span>
                  <span className='noteText1' style={{ marginTop: "5px" }}>‘TDS Cashback’ is applicable up to  {tdsMaxCapAmount}, after successful processing of redeem.</span>
                  {/* <span className='noteText1' style={{ marginTop: "5px" }}>2.At the time of processing, any tourney winnings will be subjected to reduction in TDS Cashback.</span> */}
                </div>
            }

          </div>



        </div>
      </div>




    </div>

    return overlay;
  }
  return (disableRedeem ? <div id="disableRedeem1" className='standardText' style={{ position: "absolute", display: 'flex', width: "100%", height: "100%", alignItems: 'center', justifyContent: "center" }}>
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "90%", height: "35%", backgroundColor: "#ffffff", borderRadius: "6px", flexDirection: "column" }}>
      <div id="imageContainer" style={{ width: "100%", height: "12%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "", marginTop: "0%" }}>
        <img

          alt="caution"
          src={assets?.assets?.cancelRequesticon}
        // style={{ width: "40px", position: "absolute", left: '2%' }}
        // onClick={() => history.push("/walletinfo/")}
        />


      </div>

      <div id="emptyDiv" style={{ width: "100%", height: "15%", backgroundColor: "", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <span style={{ fontSize: "1.1rem", color: "#32146", fontWeight: "bold" }}>{title}</span>
      </div>
      <div id="messageContainerDiv" style={{ width: "100%", height: "35%", backgroundColor: "", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "5%" }}>
        <span className='standardText' style={{ width: "90%", height: "100%", fontSize: "0.85rem", fontWeight: "400", display: "flex", textAlign: "left" }}>{disableMessage}</span>

      </div>

      <div id="gotolobbyMain" style={{ width: "100%", height: "35px", display: 'flex', alignItems: "center", justifyContent: 'center', background: "#F9F9F9" }}
        onClick={() => WebToNativeMessage({ type: "goToLobby" })}
      >
        <div id="gotolobby" style={{ width: '90%', height: '100%', background: "linear-gradient(180deg, #42BE40 0%, #196A29 100%)", borderRadius: "4px", color: '#FFFFFF', fontSize: '1rem', fontWeight: '700', display: "flex", alignItems: "center", justifyContent: "center" }}  >
          Go To Lobby
          {/* {activeRedeemMethod !== undefined ? (!stdAndInstantCheck) || (!instantAvailabilityFlag && monthlyStandard <= 0) || ((nextStandardRedeemAvailability !== "N") && (nextInstantRedeemAvailability !== "N")) || (monthlyStandardExhausted && nextInstantRedeemAvailability !== "N") || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && nextStandardRedeemAvailability !== "N") || (monthlyInstant <= 0 && lifetimeInstantRedeemsLeft <= 0 && monthlyStandardExhausted) ? "Go To Lobby" : 'Redeem' : 'Setup Redeem Account'} */}
        </div>
      </div>
    </div>
  </div>
    :
    <div id="disableRedeem1" className='standardText' style={{
      display: 'flex', alignItems: 'center', justifyContent: "center", background: "rgba(21, 25, 31, 1)"
    }} >
      <div className='redeemPage' style={{
        position: 'sticky', overflow: "hidden",
        top: '0px',
        ...(isTablet ? { width: "60vw", } : { width: "100vw" }),
        // height: "100vh"
      }}>
        <div className='redeemContainer'>
          <div className='redeemHeader flex justify-around' >
            <img
              className='backBtn'
              alt="back btn"
              src={assets?.assets?.navarrow}
              style={{ width: "30px", position: "absolute", left: '2%' }}
              onClick={() => {
                if (window.sessionStorage["reactLocation"] === "loyaltyDashboard" || isKYCVerificationPage) {
                  if (isKYCVerificationPage) {
                    WebToNativeMessage(
                      {
                        type: "redeemCTEvent", eventName: "Pf_c_Tkyc_backctaclick", eventProperties: {
                          acelevel: window.sessionStorage["aceLevel"],
                          channel: window.sessionStorage["channel"],
                          subscriptionType: window.sessionStorage["subscriptionType"],
                          username: window.sessionStorage["screenName"],
                        }

                      })
                  }
                  WebToNativeMessage({ type: 'closeClient' });
                  window.sessionStorage.removeItem("reactLocation");
                }
                else {
                  history.push("/walletinfo/")
                }
              }
              }
            />
            <div> {isKYCVerificationPage && (redeemDetails?.kycStatus!=="approved"||redeemDetails?.isIdVerified!=="approved")? VernacularContextData.getTransalatedKey("KYCVerification") : VernacularContextData.getTransalatedKey("withdraw")} </div>
            {/* {
              redeemDetails !== undefined && redeemDetails.showHistoryIcon === true &&
              <img
                // className='backBtn'
                id="history_icon"
                alt="history_icon"
                src={historyicon}
                style={{ position: "absolute", right: '3%' }}
                onClick={() => RedeemHistoryPageLoadCT()}
              />} */}
          </div>

          {(redeemDetails !== undefined && profileData !== undefined) ? ((showVerificationPage() && highlightItem() !== "NA") || (isKYCVerificationPage && highlightItem() !== "NA")) ? createNewUserRedeemPage() : createRedeemPage() : <div
            // {(redeemDetails !== undefined && profileData !== undefined) ? ((showVerificationPage() &&highlightItem() !== "NA" ) || (isKYCVerificationPage && highlightItem() !== "NA") ) ? createRedeemPage() : createNewUserRedeemPage() : <div
            style={{
              // position: "absolute",
              width: "100%",
              height: "100%",
              display: 'flex',
              alignItems: "center",
              justifyContent: 'center',
              // backgroundColor:"red"//
            }}

            className='loadingCnt'
          ><Loading /></div>}
          {openAddEmailPopUp && createAddEmailPopUp()}
          {openAddRedeemPopUp && createAddRedeemMethod()}
          {openAllRedeemOptions && createAllRedeemMethodsPopUp()}
          {openAddUpiPopUp && createAddUpiPopUp()}
          {openAddBankAccountPopUp && createAddBankAccountPopUp()}
          {showVerifyMobileAlert && createVerifyMobileAlert()}
          {redeemDetails !== undefined && openRedeemRecommendation && createRedeemRecommendation()}
          {showIframe && createTdsIframe()}
          {openLinkWallet !== undefined && <LinkWallet walletType={openLinkWallet} handleCTEvent={(e) => {

            if (e === 'Back to Lobby') {
              WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_OTPVerified", eventProperties: { username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered, channel: window.sessionStorage["channel"], verifiedORcancel: 'Back to Lobby', aceLevel: window.sessionStorage["aceLevel"], subscription_type: window.sessionStorage["subscriptionType"], redeem_mode: activeRedeemMethod.type } })
            }
            else if (e === 'Verify') {
              WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_c_RedeemPlacement_OTPVerified", eventProperties: { username: window.sessionStorage['screenName'], Redeem_Amount: amountEntered, channel: window.sessionStorage["channel"], aceLevel: window.sessionStorage["aceLevel"], verifiedORcancel: 'verified', subscription_type: window.sessionStorage["subscriptionType"], redeem_mode: activeRedeemMethod.type } })
            }

          }} openSelectedScreen={(val) => {
            openSelectedScreen(val)
            // if(val!==LINKWALLET_STRINGS.KEY_BANKACCOUNT_TV && val!==LINKWALLET_STRINGS.KEY_UPI_TV){
            //   if (isKYCVerificationPage) {
            //     WebToNativeMessage({ type: "addBankSuccess" })
            //   }
            // }
          }} closePopUp={(event) => {
            // if (openLinkWallet === 'redeemRecommendation' || openLinkWallet === 'redeem') {
            //     setOpenLinkWallet(undefined)
            // }
            // else {
            //     setOpenLinkWallet(undefined)
            //     setOpenAddRedeemPopUp(true)
            // }
            // console.log(event, openLinkWallet, 'sid')
            if (event === 'back' && (openLinkWallet !== 'redeem' && openLinkWallet !== 'redeemRecommendation')) {
              setOpenAddRedeemPopUp(true)
              // console.log(event, openLinkWallet, 'sid2')
            }
            setOpenLinkWallet(undefined)
            // if(event!=='back' && (openLinkWallet !== 'redeem' && openLinkWallet !== 'redeemRecommendation')){
            //   if (isKYCVerificationPage) {
            //     WebToNativeMessage({ type: "addBankSuccess" })
            //   }
            // }


          }} />}
          {pendingRedeemsexceeded && toShowGSTPopup && createGSTPopup()}
          {limitExhaustPopup && toShowGSTPopup && createGSTPopup()}
          {showTaxPopUp && createTDSOverlay()}
          {knowMoreBottomUP && createKnowMoreBottomUp()}
          {/* {pendingRedeemsexceeded && toShowGSTPopup && createGSTPopup()} */}
          {/* {createGSTPopup()} */}
          {toastMessage !== undefined && createToastMessage()}
          {/* { createToastMessage()} */}
          {toShowStandardAndInstantBottomSheet && createOverLay()}




          {(showSmartRedeem && !smartRedeemNewUIFlag) && createSmartRedeemOverlay()}

          {/* //For test purpose render based on condition */}

          {(showSmartRedeem && smartRedeemNewUIFlag) && createNewSmartRedeemOverlay()}


          {showSmartRedeemPopup && createSmartRedeemConfirmPopup()}

          {showBonusMissOutPopup && createNewSmartRedeemConfirmPopup()}


          {/* {showBonusMissOutPopup && showSmartRedeemPopup && createNewSmartRedeemConfirmPopup} */}



          {showPaidInstantConfirmation && createPaidInstantConfirmationPopUp()}

          {toShowGamePassOverLay && createGamePassOverLay()}



          {/* {toastMessage !== undefined && createToastMessage()} */}

          {showTdsCashbackBottomSheet && createTdsCashBackOverLay()}




          {isLoading && <div style={{ position: "absolute", display: 'flex', alignItems: 'center', justifyContent: "center", width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', top: '0px', pointerEvents: "none" }} onClick={(e) => { e.preventDefault(); e.stopPropagation() }}><Loading /></div>}

          {console.log("showRedeemStatusData 3333333334455556", showRedeemStatus)}
          {showRedeemStatus && <RedeemStatus handleToggle={() => { WebToNativeMessage({ "type": "OpenNotificationPermission" }) }} checked={checked} redeemhistory={showRedeemStatusData} showRedeemStatusData={showRedeemStatusData} pendingRedeemCount={profileData.totalPendingRedeems} handleBackClick={() => { setShowRedeemStatus(false); setFetchRedeemDetails(fetchRedeemDetails + 1) }} amount={amountEntered} withdrawType={selectedWithdrawtype} channel={window.sessionStorage['channel']} bankAccountNumber={(activeRedeemMethod.type === 'amazonPay' || activeRedeemMethod.type === 'paytmWallet') ? activeRedeemMethod.id : activeRedeemMethod.type === 'bankAccount' ? activeRedeemMethod.accountNumber : activeRedeemMethod.type === 'upi' ? activeRedeemMethod.upi : ""} nameMethod={activeRedeemMethod.name} history={history} />
          }
        </div>

      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  userState: state.userState,
  networkStatus: state.userState.networkStatus,
});

export default connect(mapStateToProps)(Redeem);
// export default Redeem
